import { Component, Inject, ChangeDetectorRef, Output, EventEmitter, Injectable } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import {
  campanias,
  documentsType,
  PersonBeneficiary,
  Beneficiarios,
  QuotationPeopleeResponse,
  relationship
} from '../../../../models/cotizador/response/model.data.response';
import { ValidationService } from '../../../../utils/util.validation';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { SnackBarService } from '../../../../utils/util.SnackBarService';
import { Base } from '../../base';
import { IListTarifa } from '../../../../models/cotizador/IListTarifa';
import { IDataTarifa } from '../../../../models/cotizador/IDataTarifa';
import { NetworkingBeneficiary } from '../../../../services/beneficiario/beneficiario.service';
import { BeneficiariosModel } from '../../../../models/person-beneficiary.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../../../utils/util.storage.service';
import { MatTableDataSource } from '@angular/material/table';
import { QuotationPeopleeRequest } from '../../../../models/cotizador/request/model.data.request';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { LineaNegocio } from '../../../../models/cotizador-programas/lineas-negocio/consultar-lineas-negocio-response.model';
import { ConsultarLineasGruposProgramasService } from '../../../../services/cotizador-programas/consultar-lineas-grupos-programas.service';
import { PopUpConfirmacionComponent, PopUpConfirmacionData } from '../../../cotizador/pages/contratante-page/components/pop-up-confirmacion/pop-up-confirmacion.component';
import { ConsultarCiudadesService } from '../../../../services/cotizador-contratante/consultar-ciudades.service';
import { CiudadCem } from '../../../../models/cotizador-contratante/consultar-ciudades/consultar-ciudades-response.model';
import { ConsultarCoberturasRequest } from '../../../../models/cotizador-contratante/consultar-coberturas/request/consultar-coberturas-request.model';
import { PopUpMensajeComponent, PopUpMensajeData } from '../../../cotizador/pages/contratante-page/components/pop-up-mensaje/pop-up-mensaje.component';
import { ConsultarCoberturasService } from '../../../../services/cotizador-contratante/consultar-coberturas.service';
import { TipoViaItem } from '../../../../models/cotizador-contratante/consultar-tipo-via/response/consultar-tipo-via-response.model';
import { ConsultarHistorialService } from '../../../../services/cotizador-contratante/consultar-historial.service';
import { HistorialItem } from '../../../../models/cotizador-contratante/consultar-historial/response/consultar-historial-response.model';
import { ConsultarSubcuentasColectivosGruposService } from '../../../../services/cotizador-contratante/consultar-subcuentas-colectivos-grupos.service';
import { ConsultarProgramasInclusionService } from '../../../../services/cotizador-contratante/consultar-programas-inclusion.service';
import { ProgramaSeleccionStore, ProgramaItemStore } from '../../../../services/cotizador-contratante/programa-seleccion.store';
import {
  BeneficiarioLocalMatchKey,
  BeneficiarioLocalStorageService,
  DatosBeneficiarioLocal,
  ProgramasBeneficiarioEnvelope
} from '../../../../services/beneficiario/beneficiario-local-storage.service';
import { ValidacionesBeneficiarioLocalStorageService } from '../../../../services/beneficiario/validaciones-beneficiario-local-storage.service';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { catchError, concatMap, finalize, map } from 'rxjs/operators';
import {
  ConsultarTarifasColectivosGruposService
} from '../../../../services/cotizador-contratante/consultar-tarifas-colectivos-grupos.service';
import { ConsultarCotizacionService } from '../../../../services/cotizador-cotizacion/consultar-cotizacion.service';

// Interfaces y tipos
interface FormType {
  parentesco: { value: string; messages: string; required: boolean; };
  campaniaContratante: { value: string; messages: string; };
  contratanteTipoDocumento: { value: string; messages: string; required: boolean; };
  contratanteDocumento: { value: string; messages: string; required: boolean; };
  nombre: { value: string; messages: string; required: boolean; min: boolean; max: boolean; };
  nombreSegundo: { value: string; messages: string; required: boolean; min: boolean; max: boolean; };
  apellido: { value: string; messages: string; required: boolean; min: boolean; max: boolean; };
  apellidoSegundo: { value: string; messages: string; required: boolean; min: boolean; max: boolean; };
  genero: { value: string; messages: string; required: boolean; };
  fechaNacimiento: { value: string; messages: string; required: boolean; };
  contratanteTarifa: { value: string; messages: string; required: boolean; };
  tarifaInclusion: { value: string; messages: string; required: boolean; };
  position: { value: number; messages: string; required: boolean; };
  lineaNegocios: { value: string; messages: string; required: boolean; };
  programa: { value: string; messages: string; required: boolean; };
  tipoVia: { value: string; messages: string; required: boolean; };
  numero: { value: string; messages: string; required: boolean; };
  placaUno: { value: string; messages: string; required: boolean; };
  placaDos: { value: string; messages: string; required: boolean; };
  ciudad: { value: string; messages: string; required: boolean; };
  subcuenta: { value: string; messages: string; required: boolean; };
  tarifa: { value: string; messages: string; required: boolean; };
  tarifaAnexo: { value: string; messages: string; required: boolean; };
  campania: { value: string; messages: string; required: boolean; };
}

interface IListTarifaFull {
  tarifa: string;
  descripcion?: string;
  valorMensualBase?: number;
  valorMensualIva?: number;
  porcentajeIva?: number;
  esTarifaAsociado?: boolean;
}

interface Programa {
  id: string;
  codigo: string;
  nombre: string;
  lineaNegocio: 'MI' | 'SO' | 'CEM';
  color: string;
  imagen?: string;
  carnet?: string;
  grupoPrograma?: string;
  requiereAnexos?: boolean;
  planGroup?: string;
}

interface ProgramaSeleccionado {
  id: string;
  nombre: string;
  grupoPrograma?: string;
  subcuenta: string;
  tarifa: string;
  campana: string;
  campanaNombre?: string;
  tarifaAnexo?: string;
  requiereAnexo?: 'si' | 'no' | null;
  subcuentasDisponibles: string[];
  tarifasDisponibles: IListTarifa[];
  tarifasConsultaRealizada?: boolean;
  anexosDisponibles?: {
    plan_cod1: string;
    plan_cod2?: string;
    plan_desc: string;
    tari?: string;
    tope?: string;
    valor?: string;
    activo?: boolean;
  }[];
  __errors?: {
    subcuenta?: string;
    tarifa?: string;
    tarifaAnexo?: string;
    campana?: string;
  };
}

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date): string {
    const dd = ('0' + date.getDate()).slice(-2);
    const mm = ('0' + (date.getMonth() + 1)).slice(-2);
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  override parse(value: any): Date | null {
    if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [dd, mm, yyyy] = value.split('/').map(v => parseInt(v, 10));
      return new Date(yyyy, mm - 1, dd);
    }
    return value instanceof Date ? value : null;
  }

  override deserialize(value: any): Date | null {
    if (value instanceof Date) return value;
    if (typeof value === 'string') {
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [dd, mm, yyyy] = value.split('/').map(v => parseInt(v, 10));
        return new Date(yyyy, mm - 1, dd);
      }
      const norm = value.replace(/\//g, '-');
      const [yyyy, mm, dd] = norm.split('-').map(n => parseInt(n, 10));
      if (yyyy && mm && dd) return new Date(yyyy, mm - 1, dd);
    }
    return super.deserialize(value);
  }
}

export const FORMATO_DD_MM_AAAA = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

// Componente
@Component({
  selector: 'app-dialog-beneficiary',
  templateUrl: './dialog-beneficiary.component.html',
  styleUrls: ['./dialog-beneficiary.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: FORMATO_DD_MM_AAAA }
  ]
})
export class DialogBeneficiaryComponent extends Base {
  // Constantes
  readonly LINEA_MAP: Record<'MI' | 'SO' | 'CEM', string> = {
    MI: 'MEDICINA INTEGRAL',
    SO: 'SALUD ORAL',
    CEM: 'CEM'
  };

  readonly cemCoberturaUrl: string = 'https://oficinavirtualmp.coomeva.com.co/AdministradorContenido/#/visor';

  readonly MENSAJE_SIN_ANTECEDENTES_AFILMED = 'No se encontraron antecedentes registrados en AFILMED para este usuario.';
  readonly MENSAJE_NO_BENEFICIARIO_MI = 'Este usuario no puede ser beneficiario para la línea de negocio MI.';
  readonly MENSAJE_BLOQUEO_RETIRO = 'El sistema ha detectado que el cliente se retiró hace menos de 7 meses. Por políticas comerciales, no se permite realizar ventas nuevas en este caso.';

  readonly DOC_RANGE = { RC: { min: 0, max: 6 }, TI: { min: 7, max: 17 }, CC: { min: 18, max: 130 } };

  // Propiedades de formulario y datos básicos
  mostcampaniaContra = true;
  private permitirPersistenciaContratanteStorage = false;
  relationship: relationship[] = [];
  typeDocument!: Array<documentsType>;
  edad: number | null = null;

  form: FormType = {
    parentesco: { value: '', messages: '', required: true },
    campaniaContratante: { value: '', messages: '' },
    contratanteTipoDocumento: { value: '', messages: '', required: true },
    contratanteDocumento: { value: '', messages: '', required: true },
    nombre: { value: '', messages: '', required: true, min: true, max: true },
    nombreSegundo: { value: '', messages: '', required: false, min: false, max: true },
    apellido: { value: '', messages: '', required: true, min: true, max: true },
    apellidoSegundo: { value: '', messages: '', required: false, min: false, max: true },
    genero: { value: '', messages: '', required: true },
    fechaNacimiento: { value: '', messages: '', required: true },
    contratanteTarifa: { value: '', messages: '', required: false },
    tarifaInclusion: { value: '', messages: '', required: false },
    position: { value: 0, messages: '', required: false },
    lineaNegocios: { value: '', messages: '', required: true },
    programa: { value: '', messages: '', required: true },
    tipoVia: { value: '', messages: '', required: true },
    numero: { value: '', messages: '', required: true },
    placaUno: { value: '', messages: '', required: true },
    placaDos: { value: '', messages: '', required: true },
    ciudad: { value: '', messages: '', required: true },
    subcuenta: { value: '', messages: '', required: true },
    tarifa: { value: '', messages: '', required: true },
    tarifaAnexo: { value: '', messages: '', required: false },
    campania: { value: '', messages: '', required: true },
  };

  guardar = true;
  listDataCampania: Array<campanias> = [];
  listTarifa: Array<IListTarifa> = [];
  dataCampania: any;
  dataTarifa: any;
  tipoSolicitud: number = 0;
  maxDate!: string;
  minDate!: string;
  datePerson: string = '';

  // Propiedades de anexos y CEM
  requiereAnexo: 'si' | 'no' | null = null;
  anexoSeleccionado: string | null = null;
  anexoSeleccionadoId: string | null = null;
  listaAnexosDelPrograma: Array<{ id: string; plan_desc: string; valor?: string; activo?: boolean; }> = [];
  anexosSeleccionados: any[] = [];

  // Propiedades de líneas y programas
  lineasSeleccionadas: ('MI' | 'SO' | 'CEM')[] = [];
  lineasNegocioDisponibles: { codigo: 'MI' | 'SO' | 'CEM', nombre: string, lineaOriginal: LineaNegocio; }[] = [];
  programasDisponibles: Programa[] = [];
  programasSeleccionados: ProgramaSeleccionado[] = [];

  // Propiedades de datos y estado
  dataBeneficiary: PersonBeneficiary[] = [];
  dataSourceBeneficiary = new MatTableDataSource<PersonBeneficiary>([]);
  selectedIndex: number = 0;
  historialCliente: any[] = [];
  estadoEPS: any[] = [];
  ciudades: CiudadCem[] = [];
  tipoVias: TipoViaItem[] = [];
  coberturaCemValida: boolean = false;

  // Propiedades de configuración y flags
  esUsuario: boolean | null = null;
  formInit!: FormGroup;
  esInclusion: boolean = false;
  resetData: boolean = false;
  maxStepReached: number = 0;
  alertaEPSBeneficiario: { tipo: 'success' | 'error'; mensaje: string; }[] = [];
  public yaConsultoAdres: boolean = false;
  private _hidratadoDesdeContratante: boolean = false;
  private datosColectivoGA: any[] = [];
  private cuentaColectivoGA: number | null = null;
  public usarProgramasContratante: boolean = false;
  public tipoPlanLS: string | null = null;
  public tipoSolicitudLS: string | null = null;
  public debeMostrarSubcuenta: boolean = true;

  // Propiedades de navegación y snapshots
  tabHabilitado = {
    showResultTab: false,
    showProgramTab: false
  };

  private _isCampaInFlight = false;
  private campaniasConsultaRealizadaPorPrograma: Record<string, boolean> = {};
  private mapaDenoALabelPorPrograma: Map<string, Map<string, string>> = new Map();
  private _snapshotInicial: any = null;
  /** Edición: baseline una vez terminada la 1ra carga de programas */
  private _pendienteSnapshotTrasRehidratar = false;
  private _baselineEditTimer: ReturnType<typeof setTimeout> | null = null;
  private idCotizacionContext: number | null = null;
  private _autocargaProgramasContratanteAplicada = false;
  private cacheClavesCampaMap = new Map<string, string>();
  /** Identidad al abrir edición (match en LS) */
  private _matchBeneficiarioLocal: BeneficiarioLocalMatchKey | null = null;

  @Output() coberturaInvalida = new EventEmitter<void>();

  constructor(
    private networking: NetworkingBeneficiary,
    public dialog: MatDialog,
    private SnackBarService: SnackBarService,
    private storageService: StorageService,
    public dialogRef: MatDialogRef<DialogBeneficiaryComponent>,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private consultarLineasService: ConsultarLineasGruposProgramasService,
    private consultarCiudadesService: ConsultarCiudadesService,
    private consultarCoberturasService: ConsultarCoberturasService,
    private consultarHistorialService: ConsultarHistorialService,
    private consultarSubcuentasColectivosGruposService: ConsultarSubcuentasColectivosGruposService,
    private consultarProgramasInclusionService: ConsultarProgramasInclusionService,
    private programaSeleccionStore: ProgramaSeleccionStore,
    private beneficiarioLocalStorage: BeneficiarioLocalStorageService,
    private validacionesBeneficiarioLs: ValidacionesBeneficiarioLocalStorageService,
    private consultarTarifasColectivosGruposService: ConsultarTarifasColectivosGruposService,
    private consultarCotizacionService: ConsultarCotizacionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.initializeComponent();
  }

  ngOnInit(): void {
    this.limpiarDraftLocalStorage();
    this.setupFormAndData();
  }

  ngAfterViewInit(): void {
    Promise.resolve().then(() => {
      if (this.guardar === false || this.data?.[3]?.isEditMode) {
        return;
      }
      this.capturarSnapshotInicial();
    });
  }

  // init
  private initializeComponent(): void {
    this.getTypeDocument();
    this.processDialogData();
    this.setupCemBackup();
    this.setEsUsuario();
    this.setupDialogCloseHandler();
  }

  private processDialogData(): void {
    this.idCotizacionContext = null;

    // edición: data[3].idCotizacion manda
    if (this.data?.[3]?.isEditMode) {
      const idFromData = Number(this.data[3].idCotizacion);
      if (Number.isFinite(idFromData) && idFromData > 0) {
        this.idCotizacionContext = idFromData;
      }
    }

    if (!this.idCotizacionContext) {
      try {
        const raw = localStorage.getItem('cotizacion_precargada');
        if (raw) {
          const parsed = JSON.parse(raw);
          const id = Number(parsed?.idCotizacion);

          if (Number.isFinite(id) && id > 0) {
            this.idCotizacionContext = id;
          }
        }

        if (!this.idCotizacionContext) {
          const rawAlterno = localStorage.getItem('cotizacion_creada_desde_contratante');
          if (rawAlterno) {
            const parsedAlterno = JSON.parse(rawAlterno);
            const enRaiz = Number(parsedAlterno?.idCotizacion || 0);
            const enData = Number(parsedAlterno?.data?.idCotizacion || 0);
            const idAlterno = enRaiz > 0 ? enRaiz : enData;
            if (Number.isFinite(idAlterno) && idAlterno > 0) {
              this.idCotizacionContext = idAlterno;
            }
          }
        }
      } catch (err) {
      }
    }

    if (this.data?.[2]) {
      this.datePerson = this.data[2];
    }

    if (this.data?.[1] != null) {
      this.tipoSolicitud = this.data[1].tipo_solicitud;

      this.dataTarifa = {
        cuenta: this.data[1].cuenta,
        modelo_negocio: this.data[1].modelo_negocio
      };

      this.dataCampania = { ...this.data[1] };

      const cuentaCtx = Number(this.dataCampania?.cuenta);
      this.dataCampania.cuenta =
        Number.isFinite(cuentaCtx) && cuentaCtx > 0 ? cuentaCtx : 1;
    }

    if (this.data?.[0] != null) {
      this.loadBeneficiaryData(this.data[0]);
    }
  }

  private loadBeneficiaryData(raw: any): void {
    let result: Beneficiarios;
    const cfgRaw = (raw as any).programasConfig;
    const idsRaw = (raw as any).programIds;
    const usarProgramasContratanteRaw = (raw as any)?.usarProgramasContratante ?? (raw as any)?.programasConfig?.usarProgramasContratante ?? false;
    const cemRaw = { tipoVia: (raw as any).tipoVia, numero: (raw as any).numero, placaUno: (raw as any).placaUno, placaDos: (raw as any).placaDos, ciudad: (raw as any).ciudad, };
    if ('primer_nombre' in raw && 'num_documento' in raw && 'tipo_documento' in raw) {
      result = raw as Beneficiarios;
    } else {
      result = BeneficiariosModel.fromPersons(raw as PersonBeneficiary);
    }
    (result as any).subcuenta = (raw as any).subcuenta || '';
    if (cfgRaw) (result as any).programasConfig = cfgRaw;
    if (idsRaw) (result as any).programIds = idsRaw;
    Object.assign(result as any, cemRaw);
    (result as any).usarProgramasContratante = usarProgramasContratanteRaw === true;
    //this.usarProgramasContratante = false;
    this.usarProgramasContratante = usarProgramasContratanteRaw === true;
    this.populateFormFromResult(result);
    this.setAgeFromResult(result);
    this.guardar = false;
    this.capturarMatchBeneficiarioLocal(raw, result);
    this.processProgramConfigs(result);
  }

  private capturarMatchBeneficiarioLocal(raw: any, result: Beneficiarios): void {
    const localId = (
      this.data?.[3]?.localId ??
      raw?.localId ??
      (raw as any)?.local_id ??
      ''
    ).toString().trim();

    const tipoDocumento = (
      result?.tipo_documento ||
      raw?.tipo_documento ||
      raw?.tipoDocumento ||
      ''
    ).toString().trim();

    const numeroDocumento = (
      result?.num_documento ||
      raw?.num_documento ||
      raw?.numeroDocumento ||
      raw?.documento ||
      ''
    ).toString().trim();

    const parentesco = (
      result?.parentesco_id ||
      raw?.parentesco_id ||
      raw?.parentesco ||
      ''
    ).toString().trim();

    this._matchBeneficiarioLocal = {
      localId: localId || undefined,
      tipoDocumento: tipoDocumento || undefined,
      numeroDocumento: numeroDocumento || undefined,
      parentesco: parentesco || undefined
    };
  }

  private populateFormFromResult(result: Beneficiarios): void {
    this.form.tarifa.value = result.tarifa;
    this.form.parentesco.value = result.parentesco_id;
    this.form.contratanteTipoDocumento.value = result.tipo_documento;
    this.form.contratanteDocumento.value = result.num_documento;
    this.form.nombre.value = result.primer_nombre;
    this.form.nombreSegundo.value = result.segundo_nombre;
    this.form.apellido.value = result.primer_apellido;
    this.form.apellidoSegundo.value = result.segundo_apellido;
    const generoRaw = (result.genero || '').toString().toUpperCase().trim();
    this.form.genero.value = generoRaw === 'F' ? '1' : (generoRaw === 'M' ? '2' : generoRaw);
    this.form.fechaNacimiento.value = this.normalizeFechaForForm(
      result.fecha_nacimiento ?? (result as any).fechaNacimiento ?? (result as any).datebirth ?? ''
    );
    this.form.contratanteTarifa.value = result.tarifa;
    this.form.tarifaInclusion.value = `${result.descriptionTarifa}`;
    this.form.campania.value = result.campania;
    this.form.position.value = result.position;
    this.form.lineaNegocios.value = result.lineOfBusiness;
    this.form.lineaNegocios.value = (this.form.lineaNegocios.value || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .map(s => {
        const c = this.nombreToCodigoLinea(s);
        return c ? this.LINEA_MAP[c] : s;
      })
      .join(', ');
    this.form.programa.value = result.program;
    this.form.tipoVia.value = (result as any).tipoVia;
    this.form.numero.value = (result as any).numero;
    this.form.placaUno.value = (result as any).placaUno;
    this.form.placaDos.value = (result as any).placaDos;
    this.form.ciudad.value = (result as any).ciudad;
    this.form.subcuenta.value = result.subcuenta;
    this.form.tarifaAnexo.value = (result as any).tarifaAnexo;
  }

  private setAgeFromResult(result: Beneficiarios): void {
    const rawEdad = (result?.edad ?? '').toString().trim();
    if (rawEdad !== '') {
      const ageNum = Number(rawEdad);
      this.edad = Number.isFinite(ageNum) ? ageNum : null;
      return;
    }

    const fecha = (result?.fecha_nacimiento ?? '').toString().trim();
    const fechaDate = this.parseApiDateToDate(fecha);
    if (fechaDate) {
      this.calculeAge('change', { value: fechaDate } as any);
      return;
    }

    this.edad = null;
  }

  private processProgramConfigs(result: Beneficiarios): void {
    let cfg = (result as any).programasConfig;
    const esEdicionFila = this.data?.[0] != null;
    const esFlujoInclusion = localStorage.getItem('tipoSolicitud') === '2';

    if (esFlujoInclusion && esEdicionFila && cfg?.programas?.length) {
      const programaFila = (result.program || '').toString().trim().toUpperCase();
      const lineaFila = this.nombreToCodigoLinea((result.lineOfBusiness || '').toString());


      const programasFiltrados = cfg.programas.filter((p: any) => {
        const pId = (p.id || p.programa || p.codigo || '').toString().trim().toUpperCase();
        const pNombre = (p.nombre || p.nombrePrograma || p.description || p.programaDeno || '').toString().trim().toUpperCase();
        const filaProg = (result.program || '').toString().trim().toUpperCase();

        const tokensProg = filaProg.split(',').map(t => t.trim()).filter(Boolean);
        const idMatch = tokensProg.some(t => t === pId || pId === t);
        const nombreMatch = tokensProg.some(t => this.norm(t) === this.norm(pNombre));

        const filaLinea = (result.lineOfBusiness || '').toString().trim().toUpperCase();
        const pLinea = p.lineaNegocio;
        const lineaDeno = (pLinea === 'MI' || pLinea === 'SO' || pLinea === 'CEM') ? this.LINEA_MAP[pLinea as 'MI' | 'SO' | 'CEM'] : '';
        const lineaMatch = filaLinea ? (pLinea ? filaLinea.includes(pLinea) || filaLinea.includes(lineaDeno) : true) : true;

        return (idMatch || nombreMatch) && lineaMatch;
      });

      const seenFiltered = new Set<string>();
      const programasFiltradosUnicos = programasFiltrados.filter((p: any) => {
        const key = (p.id || p.programa || p.codigo || p.nombre || '').toString().trim().toUpperCase();
        if (seenFiltered.has(key)) return false;
        seenFiltered.add(key);
        return true;
      });


      if (programasFiltradosUnicos.length > 0) {
        const lineaDenoFila = (lineaFila === 'MI' || lineaFila === 'SO' || lineaFila === 'CEM') ? this.LINEA_MAP[lineaFila as 'MI' | 'SO' | 'CEM'] : '';

        cfg = {
          ...cfg,
          programas: programasFiltradosUnicos,
          lineasSeleccionadas: (result.lineOfBusiness || '').includes(',')
            ? programasFiltradosUnicos.map((p: any) => this.LINEA_MAP[p.lineaNegocio as 'MI' | 'SO' | 'CEM'])
            : (lineaDenoFila ? [lineaDenoFila] : cfg.lineasSeleccionadas)
        };
      }
    }

    if (cfg?.lineasSeleccionadas?.length) {
      const codigos = cfg.lineasSeleccionadas
        .map((ln: any) => this.nombreToCodigoLinea((ln ?? '').toString()))
        .filter((c: any) => c === 'MI' || c === 'SO' || c === 'CEM') as Array<'MI' | 'SO' | 'CEM'>;
      const unicos = Array.from(new Set(codigos));
      if (unicos.length) {
        this.lineasSeleccionadas = unicos;
        this.form.lineaNegocios.value = unicos.map((p: any) => this.LINEA_MAP[p as 'MI' | 'SO' | 'CEM']).join(', ');
      }
    }

    if ((!this.form.lineaNegocios.value || !this.form.lineaNegocios.value.toString().trim()) && cfg?.programas?.length) {
      const codigosDerivados = cfg.programas
        .map((p: any) => {
          const ln = (p?.lineaNegocio ?? p?.lineaNegocioNombre ?? '').toString();
          return this.nombreToCodigoLinea(ln);
        })
        .filter((c: any) => c === 'MI' || c === 'SO' || c === 'CEM') as Array<'MI' | 'SO' | 'CEM'>;
      const unicos = Array.from(new Set(codigosDerivados));
      if (unicos.length) {
        this.lineasSeleccionadas = unicos;
        this.form.lineaNegocios.value = unicos.map((p: any) => this.LINEA_MAP[p as 'MI' | 'SO' | 'CEM']).join(', ');
      }
    }

    if (cfg?.programas?.length) {
      const codigosDerivados = cfg.programas
        .map((p: any) => {
          const ln = (p?.lineaNegocio ?? p?.lineaNegocioNombre ?? p?.linea ?? '').toString();
          return this.nombreToCodigoLinea(ln);
        })
        .filter((c: any) => c === 'MI' || c === 'SO' || c === 'CEM') as Array<'MI' | 'SO' | 'CEM'>;
      const unicosProgramas = Array.from(new Set(codigosDerivados));
      const currentLineas = Array.isArray(this.lineasSeleccionadas) ? this.lineasSeleccionadas : [];
      const missingLineas = unicosProgramas.filter(l => !currentLineas.includes(l));
      if (missingLineas.length > 0) {
        const mergedLineas = Array.from(new Set([...currentLineas, ...unicosProgramas]));
        this.lineasSeleccionadas = mergedLineas;
        this.form.lineaNegocios.value = mergedLineas.map((p: any) => this.LINEA_MAP[p as 'MI' | 'SO' | 'CEM']).join(', ');
      }

      this.form.programa.value = cfg.programas.map((p: any) => p.id).join(', ');
      (this as any)._programasConfigPrevios = cfg.programas;
    } else if ((result as any).programIds?.length) {
      const ids: string[] = (result as any).programIds;
      this.form.programa.value = ids.join(', ');
      (this as any)._programasConfigPrevios = ids.map(id => ({ id, nombre: id }));
    } else if (result.program) {
      (this as any)._programasConfigPrevios = result.program
        .split(',')
        .map((tok: string) => tok.trim())
        .filter(Boolean)
        .map((tok: string) => ({ id: tok, nombre: tok }));
    }

    if (cfg?.anexos) {
      this.requiereAnexo = cfg.anexos.requiereAnexo ?? null;
      this.anexoSeleccionado = cfg.anexos.anexoSeleccionado ?? null;
      (this as any)._programasCfgAnexosPrevios = cfg.anexos;
    }

  }

  private setupCemBackup(): void {
    (this as any)._cemBackup = {
      tipoVia: this.form.tipoVia.value,
      numero: this.form.numero.value,
      placaUno: this.form.placaUno.value,
      placaDos: this.form.placaDos.value,
      ciudad: this.form.ciudad.value
    };
  }

  private setEsUsuario(): void {
    const esUsuarioDesdeMeta = this.data?.[3]?.esUsuarioContexto;
    const esUsuarioDesdePersona = this.data?.[0]?.esUsuario;
    this.esUsuario =
      typeof esUsuarioDesdeMeta === 'boolean'
        ? esUsuarioDesdeMeta
        : (typeof esUsuarioDesdePersona === 'boolean'
          ? esUsuarioDesdePersona
          : (this.data.esUsuario !== undefined ? this.data.esUsuario : null));
    if (this.esUsuario === null) {
      try {
        const raw = localStorage.getItem('datosRQ002_Contratante');
        if (raw) {
          const datos = JSON.parse(raw);
          if (typeof datos?.esUsuario === 'boolean') {
            this.esUsuario = datos.esUsuario;
          }
        }
      } catch (_) { }
    }
  }

  private setupDialogCloseHandler(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      // edición: snapshot al terminar de cargar programas
      if (this.guardar === false || this.data?.[3]?.isEditMode) {
        return;
      }
      this.capturarSnapshotInicial();
    });
  }

  private setupFormAndData(): void {
    const result: any = sessionStorage.getItem('type');
    if (result !== '' && result != null) {
      this.form.tarifaInclusion.required = false;
      this.form.contratanteTarifa.value = 'multiproducto';
      this.form.contratanteTarifa.required = false;
      this.mostcampaniaContra = false;
    }

    if (this.esFlujoInclusion) {
      if (this.guardar === true) {
        this.usarProgramasContratante = false;
      }
    }

    this.cargarContratanteDeLocalStorageSiAplica();
    if (this.esUsuario === null || this.esUsuario === undefined) {
      const esUsu = this.obtenerEsUsuarioDesdeLocal();
      if (esUsu !== null) this.esUsuario = esUsu;
    }
    this.cargarContextoPlanSolicitudDesdeLocalStorage();
    this.evaluarReglasPlanYSolicitud();

    this.selectedIndex = 0;
    this.tabHabilitado = { showResultTab: false, showProgramTab: false };
    this.yaConsultoAdres = false;
    this.estadoEPS = [];
    this.historialCliente = [];
    this.cargarAlertaEPSDesdeLocalStorageSiAplica();

    this.setDateLimits();
    this.search();
    const esEdicion = this.guardar === false || !!this.data?.[3]?.isEditMode;
    if (esEdicion) {
      this.habilitarTabsYPrecargarEdicion();
      this._pendienteSnapshotTrasRehidratar = true;
      if (this.esFlujoInclusion) {
        this.initFlujoInclusion();
        this.programarFinalizarBaselineEdicion(1000);
      } else if (this.esFlujoColectivoOGA === true && !this.esFlujoInclusion) {
        this.initFlujoColectivoGA();
        this.aplicarAutocargaProgramasContratanteSiCorresponde();
        this.programarFinalizarBaselineEdicion(1000);
      } else {
        void this.ensureProgramasYRehidratar();
        // fallback si no termina la rehidratación
        this.programarFinalizarBaselineEdicion(1500);
      }
    } else {
      this.capturarSnapshotInicial();
    }
    this.cargarLineasNegocio();
    this.cargarCiudades();
    this.cargarTiposVia();

  }

  /** Edición: habilita tabs y precarga Resultado búsqueda desde cache */
  private habilitarTabsYPrecargarEdicion(): void {
    this.tabHabilitado = { showResultTab: true, showProgramTab: true };
    this.yaConsultoAdres = true;
    this.maxStepReached = 2;
    this.selectedIndex = 0;
    this.precargarResultadosValidacionEdicion();
    this.cdRef.detectChanges();
  }

  /** ADRES + Historial desde LS (sin HTTP) */
  private precargarResultadosValidacionEdicion(): void {
    let tipoDoc = (this.form.contratanteTipoDocumento?.value || '').trim();
    let numDoc = (this.form.contratanteDocumento?.value || '').trim();
    if ((!tipoDoc || !numDoc) && (this.esUsuario === true || this.esBeneficiarioParentescoTitular())) {
      try {
        const rawDatos = localStorage.getItem('datosRQ002_Contratante');
        if (rawDatos) {
          const datos = JSON.parse(rawDatos) as { tipoDocumento?: string; numeroDocumento?: string; };
          tipoDoc = tipoDoc || (datos.tipoDocumento || '').trim();
          numDoc = numDoc || (datos.numeroDocumento || '').trim();
        }
      } catch (_) { /* ignore */ }
    }
    if (!tipoDoc || !numDoc) {
      this.estadoEPS = [];
      this.historialCliente = [];
      return;
    }
    const vista = this.validacionesBeneficiarioLs.obtenerVistaParaConsulta(tipoDoc, numDoc);
    if (vista) {
      this.estadoEPS = vista.estadoEPS || [];
      this.historialCliente = this.resolverHistorialClienteDesdeCache(
        vista.historialCliente || [],
        tipoDoc,
        numDoc,
        true
      );
    } else {
      this.estadoEPS = [];
      this.historialCliente = [];
    }
  }

  /** Si hay cache sin historial, muestra el mensaje informativo (no se guarda en LS) */
  private resolverHistorialClienteDesdeCache(
    historialDesdeVista: { tipo: string; mensaje: string }[],
    tipoDoc: string,
    numDoc: string,
    consultaEnCache: boolean
  ): { tipo: string; mensaje: string }[] {
    if (historialDesdeVista?.length) {
      return historialDesdeVista;
    }
    if (consultaEnCache || this.existeConsultaValidacionesEnCache(tipoDoc, numDoc)) {
      return [{ tipo: 'info', mensaje: this.MENSAJE_SIN_ANTECEDENTES_AFILMED }];
    }
    return [];
  }

  /** Historial a persistir (sin el mensaje "sin antecedentes") */
  private historialParaPersistir(): { tipo?: string; mensaje: string }[] {
    return (this.historialCliente || []).filter(
      t => (t?.mensaje || '').trim() !== this.MENSAJE_SIN_ANTECEDENTES_AFILMED
    );
  }

  /** Ya hay consulta ADRES/historial en cache para este doc */
  private existeConsultaValidacionesEnCache(tipoDoc: string, numDoc: string): boolean {
    const entryBenef = this.validacionesBeneficiarioLs.buscarPorDocumento(tipoDoc, numDoc);
    if (entryBenef?.fechaConsulta && Array.isArray(entryBenef.items) && entryBenef.items.length > 0) {
      return true;
    }
    try {
      const raw = localStorage.getItem('validaciones_contratante');
      if (!raw) {
        return false;
      }
      const stored = JSON.parse(raw) as {
        tipoDocumento?: string;
        idContratante?: string;
        fechaConsulta?: string;
        items?: unknown[];
      };
      if ((stored.tipoDocumento || '').trim() !== tipoDoc || (stored.idContratante || '').trim() !== numDoc) {
        return false;
      }
      return !!stored.fechaConsulta && Array.isArray(stored.items) && stored.items.length > 0;
    } catch {
      return false;
    }
  }

  private programarFinalizarBaselineEdicion(delayMs: number): void {
    if (this._baselineEditTimer) {
      clearTimeout(this._baselineEditTimer);
    }
    this._baselineEditTimer = setTimeout(() => {
      if (this._pendienteSnapshotTrasRehidratar) {
        this.finalizarBaselineEdicion();
      }
    }, delayMs);
  }

  /** Limpia keys viejas de drafts al abrir el modal */
  private limpiarDraftLocalStorage(): void {
    localStorage.removeItem('datosRQ003_Beneficiarios');
    localStorage.removeItem('datosRQ003_EleccionPrograma');
  }

  private setDateLimits(): void {
    const fechaActual = new Date().toLocaleDateString('es-CO').split(`/`);
    const mes = parseInt(fechaActual[1]) < 10 ? `0${fechaActual[1]}` : fechaActual[1];
    const dia = parseInt(fechaActual[0]) < 10 ? `0${fechaActual[0]}` : fechaActual[0];
    const fechaTemporalMax = (parseInt(fechaActual[2])) + '-' + mes + '-' + dia;
    const fechaTemporalMin = (parseInt(fechaActual[2]) - 130) + '-' + mes + '-' + dia;
    this.maxDate = fechaTemporalMax;
    this.minDate = fechaTemporalMin;
  }

  // Métodos de validación y utilidad
  private setMensajeUI(mensaje: string): void {
    const el = document.getElementById('lblMensaje');
    if (el) el.innerText = mensaje && mensaje !== 'undefined' && mensaje !== 'null' && mensaje !== '' ?
      mensaje : 'Ha ocurrido un error, por favor intente de nuevo.';
    else this.SnackBarService.alert('alert-danger', mensaje || 'Ha ocurrido un error, por favor intente de nuevo.');
  }

  private isEmpty(v: any): boolean {
    if (v === null || v === undefined) return true;
    if (typeof v === 'string') return v.trim() === '';
    if (typeof v === 'number') return Number.isNaN(v);
    if (v instanceof Date) return isNaN(v.getTime());
    return false;
  }

  private norm(s: any): string {
    return (s ?? '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  private normTxt(s: string | null | undefined): string {
    return (s || '').toString().trim().toUpperCase();
  }

  private codigoProgramaParaGuardar(ps: ProgramaSeleccionado): string {
    const codigoUi = String(ps.id || '').trim().toUpperCase();

    if (!this.esFlujoGruposAfinidad()) {
      return codigoUi;
    }

    const subcta = String(
      (ps as any).__subctaCodeSeleccionada ||
      (ps as any).__subctaFromColectivo ||
      this.getSubctaCodeFor(ps) ||
      ''
    ).trim();
    const cuenta = String(
      this.cuentaColectivoGA ??
      (ps as any).__cuentaFromColectivo ??
      ''
    ).trim();

    const fila = this.resolverFilaActivoAcParaTarifa(
      codigoUi,
      subcta,
      cuenta
    );

    let codigoAfilmed = String(
      fila?.plan_codi ?? fila?.PLAN_CODI ?? ''
    ).trim().toUpperCase();

    if (codigoAfilmed.endsWith('C')) {
      const familiar = this.elegirFilaAfinidad(
        (this.datosColectivoGA || []).filter((row: any) => this.coincidePlanCodiAfinidad(
          String(row?.plan_codi ?? row?.PLAN_CODI ?? ''),
          codigoUi
        )),
        codigoUi
      );
      const planFamiliar = String(
        familiar?.plan_codi ?? familiar?.PLAN_CODI ?? ''
      ).trim().toUpperCase();
      if (planFamiliar && !planFamiliar.endsWith('C')) {
        codigoAfilmed = planFamiliar;
      }
    }

    if (!subcta || !codigoAfilmed) {
      throw new Error(
        `No se pudo resolver el plan_codi de Afinidad para ${codigoUi}`
      );
    }

    return codigoAfilmed;
  }

  private resolveProgramaBase(programaSel: ProgramaSeleccionado): Programa | undefined {
    return this.programasDisponibles.find(p =>
      this.norm(p.id) === this.norm(programaSel.id)
      || this.norm(p.codigo) === this.norm((programaSel as any).__programaCodigo)
      || this.norm(p.nombre) === this.norm(programaSel.nombre)
      || this.norm(p.nombre) === this.norm(programaSel.id)
    );
  }

  private resolveProgramaCodigo(programaSel: ProgramaSeleccionado): string {
    const fromSel = ((programaSel as any).__programaCodigo || '').toString().trim();
    if (fromSel) return fromSel;

    const base = this.resolveProgramaBase(programaSel);
    return (base?.codigo || base?.id || programaSel.id || '').toString().trim();
  }

  private resolveProgramaCodigoOriginal(programaSel: ProgramaSeleccionado): string {
    const fromSel = ((programaSel as any).__programaCodigoOriginal || '').toString().trim();
    if (fromSel) return fromSel;

    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    const idBenPrograma = Number((programaSel as any).__idBenPrograma || 0);

    if (idBenPrograma > 0) {
      const cfgByIdBen = prevCfg.find(c =>
        Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenPrograma
      );
      const fromCfgByIdBen = (cfgByIdBen?.programa || cfgByIdBen?.id || '').toString().trim();
      if (fromCfgByIdBen) return fromCfgByIdBen;
    }

    const cfgById = prevCfg.find(c => this.norm(c?.id) === this.norm(programaSel.id));
    const fromCfgById = (cfgById?.programa || cfgById?.id || '').toString().trim();
    if (fromCfgById) return fromCfgById;

    return '';
  }

  private resolveProgramaCodigoParaConsulta(programaSel: ProgramaSeleccionado): string {
    return this.resolveProgramaCodigoOriginal(programaSel) || this.resolveProgramaCodigo(programaSel);
  }

  private resolveIdBenProgramaReemplazoSimple(programaSel: ProgramaSeleccionado): number {
    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    if (prevCfg.length !== 1) return 0;
    if ((this.programasSeleccionados || []).length !== 1) return 0;

    const yaTieneId = Number((programaSel as any).__idBenPrograma || 0);
    if (yaTieneId > 0) return 0;

    const previo = prevCfg[0] || {};
    const idPrevio = Number((previo as any)?.idBenPrograma ?? (previo as any)?.__idBenPrograma ?? 0);
    if (!(idPrevio > 0)) return 0;

    const codigoPrevio = ((previo as any)?.programa || (previo as any)?.id || '').toString().trim();
    const codigoActual = this.resolveProgramaCodigo(programaSel);
    if (!codigoPrevio || !codigoActual) return 0;

    if (this.norm(codigoPrevio) === this.norm(codigoActual)) return 0;

    return idPrevio;
  }

  private resolveIdSubcuenta(programaSel: ProgramaSeleccionado): number {
    const fromSel = Number((programaSel as any).__idSubcuenta || 0);
    if (Number.isFinite(fromSel) && fromSel > 0) return fromSel;

    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    const subcta = this.getSubctaCodeFor(programaSel);
    const programaCodigo = this.resolveProgramaCodigo(programaSel);

    const cfg = prevCfg.find(c => {
      const idCfg = Number((c as any)?.idSubcuenta ?? (c as any)?.__idSubcuenta ?? 0);
      if (!(idCfg > 0)) return false;

      const sameSubcta = subcta && this.norm((c as any)?.subcta) === this.norm(subcta);
      const sameId = this.norm(c?.id) === this.norm(programaSel.id);
      const samePrograma = this.norm((c as any)?.programa) === this.norm(programaCodigo);
      return !!sameSubcta || sameId || samePrograma;
    });

    const resolved = Number((cfg as any)?.idSubcuenta ?? (cfg as any)?.__idSubcuenta ?? 0);
    if (Number.isFinite(resolved) && resolved > 0) {
      (programaSel as any).__idSubcuenta = resolved;
      return resolved;
    }

    return 0;
  }

  private buildSubcuentasSeleccionadas(): Array<{ ps: ProgramaSeleccionado; subcta: string; nombreSubcuenta: string; planCodi: string; }> {
    const esFlujoColectivoBenef = this.esFlujoColectivoOGA && !this.esFlujoInclusion;

    return (this.programasSeleccionados || [])
      .map(ps => {
        const planCodiUi = (ps.id || '').toString().trim().toUpperCase();
        let planCodi = planCodiUi;
        if (!this.esFlujoInclusion && this.esFlujoGruposAfinidad()) {
          try {
            const afilmed = this.codigoProgramaParaGuardar(ps);
            if (afilmed && !afilmed.endsWith('C')) {
              planCodi = afilmed;
            }
          } catch {
            planCodi = planCodiUi;
          }
        }

        // inclusión: subcta del catálogo, no ACEMN de campañas
        if (this.esFlujoInclusion) {
          const resolved = this.resolverSubctaDesdeCatalogoInclusion(ps);
          if (!resolved) return null;
          return {
            ps,
            subcta: resolved.subcta,
            nombreSubcuenta: resolved.nombreSubcuenta,
            planCodi
          };
        }

        const subctaCode = ((ps as any).__subctaCodeSeleccionada || (ps as any).__subcuentaInclusionOriginal || this.getSubctaCodeFor(ps) || ps.subcuenta || '').toString().trim();
        if (!subctaCode) return null;

        const rawList: any[] = (ps as any).__subcuentasRaw || [];
        const match = rawList.find(r => (r?.subcta ?? r?.SUBCTA ?? '').toString().trim() === subctaCode);
        const rawDeno = (match?.deno ?? match?.DENO ?? ps.subcuenta ?? subctaCode).toString().trim();

        let nombreSubcuentaFinal = rawDeno;

        if (esFlujoColectivoBenef) {
          const esFraseLarga = !rawDeno || rawDeno.includes(' ') || rawDeno.length > 15 || rawDeno.toUpperCase().includes('CAMPAÑA') || rawDeno.toUpperCase().includes('NUMERO DE USUARIOS');
          if (esFraseLarga) {
            nombreSubcuentaFinal = `${planCodi}${subctaCode}`;
          } else {
            nombreSubcuentaFinal = rawDeno.toUpperCase();
          }
        }

        return {
          ps,
          subcta: subctaCode,
          nombreSubcuenta: nombreSubcuentaFinal || subctaCode,
          planCodi: planCodi
        };
      })
      .filter(Boolean) as Array<{ ps: ProgramaSeleccionado; subcta: string; nombreSubcuenta: string; planCodi: string; }>;
  }

  private buildProgramasRemovidosParaEliminar(): Array<{
    idBenPrograma: number;
    idSubcuenta: number;
    idCotizacionTarifa: number;
    idCotizacionTarifaAnexo: number;
    idCotizacionCampania: number;
    debeEliminarSubcuenta: boolean;
  }> {
    const prevCfg: any[] = Array.isArray((this as any)._programasConfigPrevios)
      ? (this as any)._programasConfigPrevios
      : [];

    if (!prevCfg.length) {
      return [];
    }

    const matchedPrevIndexes = new Set<number>();

    (this.programasSeleccionados || []).forEach((ps) => {
      const idBenProgramaActual = Number((ps as any).__idBenPrograma || 0) || this.resolveIdBenProgramaReemplazoSimple(ps);
      if (idBenProgramaActual > 0) {
        const idxById = prevCfg.findIndex((cfg) => Number((cfg as any)?.idBenPrograma ?? (cfg as any)?.__idBenPrograma ?? 0) === idBenProgramaActual);
        if (idxById >= 0) {
          matchedPrevIndexes.add(idxById);
          return;
        }
      }

      const codigoConsulta = this.resolveProgramaCodigoParaConsulta(ps);
      const codigoActual = this.resolveProgramaCodigo(ps);
      const idx = prevCfg.findIndex((cfg) => {
        const codigoPrevio = ((cfg as any)?.programa || cfg?.id || '').toString().trim();
        return (
          (!!codigoConsulta && this.norm(codigoPrevio) === this.norm(codigoConsulta))
          || (!!codigoActual && this.norm(codigoPrevio) === this.norm(codigoActual))
          || this.norm(cfg?.id) === this.norm(ps.id)
          || this.norm(cfg?.nombre) === this.norm(ps.nombre)
        );
      });

      if (idx >= 0) {
        matchedPrevIndexes.add(idx);
      }
    });

    const subcuentasActuales = this.shouldActualizarSubcuentas() ? this.buildSubcuentasSeleccionadas() : [];
    const idsSubcuentaActuales = new Set<number>(
      subcuentasActuales
        .map((ref) => this.resolveIdSubcuenta(ref.ps))
        .filter((id) => Number(id) > 0)
    );
    const subctasActuales = new Set<string>(
      subcuentasActuales
        .map((ref) => this.norm(ref.subcta))
        .filter(Boolean)
    );

    return prevCfg
      .filter((_cfg, index) => !matchedPrevIndexes.has(index))
      .map((cfg) => {
        const idSubcuenta = Number((cfg as any)?.idSubcuenta ?? (cfg as any)?.__idSubcuenta ?? 0);
        const subcta = ((cfg as any)?.subcta || '').toString().trim();
        const subctaNorm = this.norm(subcta);
        const debeEliminarSubcuenta = this.shouldActualizarSubcuentas()
          && idSubcuenta > 0
          && !idsSubcuentaActuales.has(idSubcuenta)
          && (!subctaNorm || !subctasActuales.has(subctaNorm));

        return {
          idBenPrograma: Number((cfg as any)?.idBenPrograma ?? (cfg as any)?.__idBenPrograma ?? 0),
          idSubcuenta,
          idCotizacionTarifa: Number((cfg as any)?.idCotizacionTarifa ?? (cfg as any)?.__idCotizacionTarifa ?? 0),
          idCotizacionTarifaAnexo: Number((cfg as any)?.idCotizacionTarifaAnexo ?? (cfg as any)?.__idCotizacionTarifaAnexo ?? 0),
          idCotizacionCampania: Number((cfg as any)?.idCotizacionCampania ?? (cfg as any)?.__idCotizacionCampania ?? 0),
          debeEliminarSubcuenta
        };
      })
      .filter((plan) =>
        plan.idBenPrograma > 0
        || plan.idCotizacionCampania > 0
        || plan.idCotizacionTarifa > 0
        || plan.idCotizacionTarifaAnexo > 0
        || (plan.debeEliminarSubcuenta && plan.idSubcuenta > 0)
      );
  }

  private eliminarProgramasRemovidosAntesDeActualizar() {
    const planes = this.buildProgramasRemovidosParaEliminar();
    if (!planes.length) {
      return of(true);
    }

    const subcuentasYaEliminadas = new Set<number>();
    let secuencia$: Observable<boolean> = of(true);

    planes.forEach((plan) => {
      secuencia$ = secuencia$.pipe(
        concatMap(() => plan.idCotizacionCampania > 0
          ? this.ejecutarDeleteSeguro$('campania', this.networking.eliminarCampania(plan.idCotizacionCampania))
          : of(true)),
        concatMap(() => plan.idCotizacionTarifa > 0
          ? this.ejecutarDeleteSeguro$('tarifa', this.networking.eliminarTarifa(plan.idCotizacionTarifa))
          : of(true)),
        concatMap(() => plan.idCotizacionTarifaAnexo > 0 && plan.idCotizacionTarifaAnexo !== plan.idCotizacionTarifa
          ? this.ejecutarDeleteSeguro$('tarifaAnexo', this.networking.eliminarTarifa(plan.idCotizacionTarifaAnexo))
          : of(true)),
        concatMap(() => {
          if (!plan.debeEliminarSubcuenta || !(plan.idSubcuenta > 0) || subcuentasYaEliminadas.has(plan.idSubcuenta)) {
            return of(true);
          }
          subcuentasYaEliminadas.add(plan.idSubcuenta);
          return this.ejecutarDeleteSeguro$('subcuenta', this.networking.eliminarSubcuenta(plan.idSubcuenta));
        }),
        concatMap(() => plan.idBenPrograma > 0
          ? this.ejecutarDeleteSeguro$('beneficiarioPrograma', this.networking.eliminarBeneficiarioPrograma(plan.idBenPrograma))
          : of(true))
      );
    });

    return secuencia$.pipe(map(() => true as boolean));
  }

  private ejecutarDeleteSeguro$(etiqueta: string, request$: Observable<any>): Observable<boolean> {
    return request$.pipe(
      map((resp: any) => {
        if (resp?.status === false) {
          const texto = [
            resp?.errorMessage,
            resp?.message,
            resp?.mensaje,
            resp?.detalle,
          ].filter(Boolean).join(' ').toUpperCase();
          const noEncontrado = texto.includes('NO EXISTE')
            || texto.includes('NO ENCONTRADO')
            || texto.includes('NOT FOUND')
            || texto.includes('REGISTRO NO ENCONTRADO');
        }
        return true;
      }),
      catchError((err: any) => {
        if (this.esErrorEndpointDeleteNoDisponible(err)) {
          return of(true);
        }
        const httpStatus = Number(err?.status || 0);
        const codeStatus = Number(err?.error?.codeStatus || err?.error?.statusCode || 0);
        const texto = [
          err?.error?.errorMessage,
          err?.error?.message,
          err?.error?.mensaje,
          err?.error?.detalle,
          err?.message,
        ].filter(Boolean).join(' ').toUpperCase();
        const noEncontrado = texto.includes('NO EXISTE')
          || texto.includes('NO ENCONTRADO')
          || texto.includes('NOT FOUND')
          || texto.includes('REGISTRO NO ENCONTRADO');
        if (noEncontrado && (httpStatus === 404 || codeStatus === 404 || httpStatus === 500)) {
          return of(true);
        }
        return throwError(() => err);
      })
    );
  }

  private esErrorEndpointDeleteNoDisponible(err: any): boolean {
    const status = Number(err?.status || err?.error?.statusCode || 0);
    const detalle = (err?.error?.detalle || err?.error?.message || err?.message || '').toString().toUpperCase();
    return status === 500 && detalle.includes('NO ENDPOINT DELETE');
  }

  private applyIdSubcuentaFromPayload(programaSel: ProgramaSeleccionado, payload: any): void {
    const idSubcuenta = Number(payload?.idSubcuenta ?? payload?.__idSubcuenta ?? 0);
    if (Number.isFinite(idSubcuenta) && idSubcuenta > 0) {
      (programaSel as any).__idSubcuenta = idSubcuenta;
    }

    const subcta = (payload?.subcta || '').toString().trim();
    if (subcta) {
      (programaSel as any).__subctaCodeSeleccionada = subcta;
    }
  }

  private hydrateIdsSubcuentaDesdeRespuesta(
    response: any,
    refs: Array<{ ps: ProgramaSeleccionado; subcta: string; planCodi: string; nombreSubcuenta: string; }>
  ): void {
    const data = response?.data;
    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.subcuentas)
        ? data.subcuentas
        : Array.isArray(data?.items)
          ? data.items
          : data
            ? [data]
            : [];

    items.forEach((item: any) => {
      const hit = refs.find(ref =>
        (item?.subcta && this.norm(ref.subcta) === this.norm(item.subcta))
        || (item?.planCodi && this.norm(ref.planCodi) === this.norm(item.planCodi))
      );
      if (hit) {
        this.applyIdSubcuentaFromPayload(hit.ps, item);
      }
    });
  }

  private resolveIdCotizacionTarifa(programaSel: ProgramaSeleccionado, esAnexo: boolean): number {
    const selKey = esAnexo ? '__idCotizacionTarifaAnexo' : '__idCotizacionTarifa';
    const idBenProgramaSel = Number((programaSel as any).__idBenPrograma || 0);
    const cfgKey = esAnexo ? 'idCotizacionTarifaAnexo' : 'idCotizacionTarifa';
    const cfgAltKey = esAnexo ? '__idCotizacionTarifaAnexo' : '__idCotizacionTarifa';

    // edición: si hay idBenPrograma, resolver por ese id
    if (idBenProgramaSel > 0) {
      const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
      const cfgByIdBen = prevCfg.find(c =>
        Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenProgramaSel
      );
      const idFromCfgByIdBen = Number((cfgByIdBen as any)?.[cfgKey] ?? (cfgByIdBen as any)?.[cfgAltKey] ?? 0);
      if (Number.isFinite(idFromCfgByIdBen) && idFromCfgByIdBen > 0) {
        (programaSel as any)[selKey] = idFromCfgByIdBen;
        return idFromCfgByIdBen;
      }

      try {
        const raw = localStorage.getItem('datosRQ002_Contratante');
        if (raw) {
          const parsed = JSON.parse(raw || '{}');
          const mapByIdKey = esAnexo ? 'idCotizacionTarifaAnexoPorIdBenPrograma' : 'idCotizacionTarifaPorIdBenPrograma';
          const rawByIdBenPrograma = (parsed as any)?.[mapByIdKey];
          if (rawByIdBenPrograma && typeof rawByIdBenPrograma === 'object' && !Array.isArray(rawByIdBenPrograma)) {
            const n = Number((rawByIdBenPrograma as any)?.[String(idBenProgramaSel)] ?? 0);
            if (Number.isFinite(n) && n > 0) {
              (programaSel as any)[selKey] = n;
              return n;
            }
          }
        }
      } catch (_) {
      }

      // con idBenPrograma no usar fallbacks ambiguos
      return 0;
    }

    const fromSel = Number((programaSel as any)[selKey] || 0);
    if (Number.isFinite(fromSel) && fromSel > 0) return fromSel;

    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    const idBenPrograma = idBenProgramaSel;
    const programaCodigo = this.resolveProgramaCodigo(programaSel);

    const cfg = prevCfg.find(c => {
      const sameIdBenPrograma = idBenPrograma > 0
        && Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenPrograma;
      const sameId = this.norm(c?.id) === this.norm(programaSel.id);
      const samePrograma = this.norm((c as any)?.programa) === this.norm(programaCodigo);
      return sameIdBenPrograma || sameId || samePrograma;
    });

    const resolved = Number((cfg as any)?.[cfgKey] ?? (cfg as any)?.[cfgAltKey] ?? 0);
    if (Number.isFinite(resolved) && resolved > 0) {
      (programaSel as any)[selKey] = resolved;
      return resolved;
    }

    // fallback: ids en datosRQ002_Contratante
    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (raw) {
        const parsed = JSON.parse(raw || '{}');
        const mapByIdKey = esAnexo ? 'idCotizacionTarifaAnexoPorIdBenPrograma' : 'idCotizacionTarifaPorIdBenPrograma';
        const rawByIdBenPrograma = (parsed as any)?.[mapByIdKey];
        if (idBenProgramaSel > 0 && rawByIdBenPrograma && typeof rawByIdBenPrograma === 'object' && !Array.isArray(rawByIdBenPrograma)) {
          const n = Number((rawByIdBenPrograma as any)?.[String(idBenProgramaSel)] ?? 0);
          if (Number.isFinite(n) && n > 0) {
            (programaSel as any)[selKey] = n;
            return n;
          }
        }

        const programaKey = (this.resolveProgramaCodigo(programaSel) || programaSel.id || '').toString().trim();
        const mapKey = esAnexo ? 'idCotizacionTarifaAnexoPorPrograma' : 'idCotizacionTarifaPorPrograma';
        const rawByPrograma = (parsed as any)?.[mapKey];
        let idFromMap = 0;
        if (rawByPrograma && typeof rawByPrograma === 'object' && !Array.isArray(rawByPrograma)) {
          const claves = [
            programaKey,
            (programaSel.id || '').toString().trim(),
            (this.resolveProgramaCodigo(programaSel) || '').toString().trim()
          ].filter(Boolean);

          for (const k of claves) {
            const n = Number((rawByPrograma as any)?.[k] ?? 0);
            if (Number.isFinite(n) && n > 0) {
              idFromMap = n;
              break;
            }
          }
        }

        if (Number.isFinite(idFromMap) && idFromMap > 0) {
          (programaSel as any)[selKey] = idFromMap;
          return idFromMap;
        }
      }
    } catch (_) {
    }

    return 0;
  }

  private findPrevCfgForPrograma(programaSel: ProgramaSeleccionado): any | null {
    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    const idBenPrograma = Number((programaSel as any).__idBenPrograma || 0);
    const programaCodigo = this.resolveProgramaCodigo(programaSel);

    const cfg = prevCfg.find(c => {
      const sameIdBenPrograma = idBenPrograma > 0
        && Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenPrograma;
      const sameId = this.norm(c?.id) === this.norm(programaSel.id);
      const samePrograma = this.norm((c as any)?.programa) === this.norm(programaCodigo);
      return sameIdBenPrograma || sameId || samePrograma;
    });

    return cfg ?? null;
  }

  private normalizeTarifaComparable(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    const fromParens = raw.match(/\(([^)]+)\)$/)?.[1]?.trim();
    return this.norm(fromParens || raw);
  }

  private buildTarifasSeleccionadasActualizar(onlyChanged = false): Array<{ ps: ProgramaSeleccionado; idBenPrograma: number; esAnexo: boolean; tari: string; nombreTarifa?: string; valorMensualBase?: number; valorMensualIva?: number; porcentajeIva?: number; esTarifaAsociado?: boolean; fueSeleccionada: boolean; }> {

    if (this.esFlujoInclusion) {
      const refsInclusion: Array<{
        ps: ProgramaSeleccionado;
        idBenPrograma: number;
        esAnexo: boolean;
        tari: string;
        nombreTarifa?: string;
        valorMensualBase?: number;
        valorMensualIva?: number;
        porcentajeIva?: number;
        esTarifaAsociado?: boolean;
        fueSeleccionada: boolean;
      }> = [];


      // código limpio de tarifa
      const extractPureCode = (val: string): string => {
        const str = (val || '').toString().trim().toUpperCase();
        if (str.includes(' - ')) {
          return str.split(' - ')[0].trim();
        }
        const match = str.match(/\(([^)]+)\)$/);
        if (match && match[1]) {
          return match[1].trim();
        }
        return str;
      };

      (this.programasSeleccionados || [])
        .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
        .forEach(ps => {
          const idBenPrograma = Number((ps as any).__idBenPrograma || 0);
          const cfgPrev = this.findPrevCfgForPrograma(ps);
          const tarifaRaw = (ps.tarifa || '').trim();
          const codDesdeTexto = extractPureCode(tarifaRaw);
          const codInclusionOriginal = extractPureCode(
            ((ps as any).__tarifaInclusionOriginal || '').toString()
          );

          const det = (ps.tarifasDisponibles as any[])?.find(t => {
            const tPure = extractPureCode(t?.tarifa || '');
            const pPure = extractPureCode(tarifaRaw);
            if (codInclusionOriginal && this.norm(tPure) === this.norm(codInclusionOriginal)) {
              return true;
            }
            return this.norm(tPure) === this.norm(pPure) ||
              this.norm(t?.tarifa) === this.norm(tarifaRaw) ||
              this.norm(t?.tarifa) === this.norm(codDesdeTexto);
          });

          const codTarifa = (
            codInclusionOriginal ||
            (det?.tarifa ? extractPureCode(det.tarifa) : '') ||
            codDesdeTexto ||
            ''
          ).trim();
          const tarifaProgramaCambio = (() => {
            if (!onlyChanged) return true;
            if (!(this.resolveIdCotizacionTarifa(ps, false) > 0)) return true;
            const prevTarifa = this.normalizeTarifaComparable(cfgPrev?.tarifa);
            const actualTarifa = this.normalizeTarifaComparable(codTarifa || ps.tarifa);
            return actualTarifa !== prevTarifa;
          })();

          if (codTarifa && tarifaProgramaCambio) {
            let valorBase = det?.valorMensualBase;
            let valorIva = det?.valorMensualIva ?? valorBase;
            let pctIva = det?.porcentajeIva;
            let esAsoc = det?.esTarifaAsociado;
            let nombreTarifaFinal = det?.descripcion ?? det?.description
              ?? (ps as any).__tarifaNombreOriginal
              ?? (tarifaRaw.includes(' - ') ? tarifaRaw : undefined);

            if ((!valorBase && !valorIva) && Array.isArray(ps.tarifasDisponibles)) {
              const detPorCodigo = (ps.tarifasDisponibles as any[]).find(t =>
                this.norm(extractPureCode(t?.tarifa || '')) === this.norm(codTarifa)
              );
              if (detPorCodigo) {
                valorBase = detPorCodigo.valorMensualBase;
                valorIva = detPorCodigo.valorMensualIva ?? detPorCodigo.valorMensualBase;
                pctIva = detPorCodigo.porcentajeIva;
                esAsoc = detPorCodigo.esTarifaAsociado;
                nombreTarifaFinal = nombreTarifaFinal
                  || detPorCodigo.descripcion
                  || detPorCodigo.description;
              }
            }


            refsInclusion.push({
              ps,
              idBenPrograma,
              esAnexo: false,
              tari: codTarifa,
              nombreTarifa: nombreTarifaFinal,
              valorMensualBase: valorBase ?? undefined,
              valorMensualIva: valorIva ?? undefined,
              porcentajeIva: pctIva ?? undefined,
              esTarifaAsociado: esAsoc ?? undefined,
              fueSeleccionada: true
            });
          }

          // anexos inclusión
          if (this.shouldShowTarifaAnexo(ps) && (ps.tarifaAnexo || '').trim() !== '') {
            const anexoDet = (ps.anexosDisponibles || []).find(an => this.matchAnexoSeleccion(an, ps.tarifaAnexo));
            const codTarifaAnexo = (anexoDet?.tari || ps.tarifaAnexo || '').toString().trim();
            const tarifaAnexoCambio = (() => {
              if (!onlyChanged) return true;
              if (!(this.resolveIdCotizacionTarifa(ps, true) > 0)) return true;
              const prevAnexo = this.normalizeTarifaComparable(cfgPrev?.tarifaAnexo ?? cfgPrev?.anexoCodigo);
              const actualAnexo = this.normalizeTarifaComparable(ps.tarifaAnexo || codTarifaAnexo);
              return actualAnexo !== prevAnexo;
            })();

            if (codTarifaAnexo && tarifaAnexoCambio) {
              const valorAnexoRaw = (anexoDet?.valor ?? '').toString().trim();
              const valorAnexoNum = valorAnexoRaw !== '' && Number.isFinite(Number(valorAnexoRaw)) ? Number(valorAnexoRaw) : undefined;
              refsInclusion.push({
                ps,
                idBenPrograma,
                esAnexo: true,
                tari: codTarifaAnexo,
                nombreTarifa: (anexoDet?.plan_desc || '').toString().trim() || undefined,
                valorMensualBase: undefined,
                valorMensualIva: valorAnexoNum,
                porcentajeIva: undefined,
                esTarifaAsociado: undefined,
                fueSeleccionada: true
              });
            }
          }
        });

      return refsInclusion;
    }

    const refs: Array<{ ps: ProgramaSeleccionado; idBenPrograma: number; esAnexo: boolean; tari: string; nombreTarifa?: string; valorMensualBase?: number; valorMensualIva?: number; porcentajeIva?: number; esTarifaAsociado?: boolean; fueSeleccionada: boolean; }> = [];
    (this.programasSeleccionados || [])
      .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
      .forEach(ps => {
        const idBenPrograma = Number((ps as any).__idBenPrograma || 0);
        const cfgPrev = this.findPrevCfgForPrograma(ps);
        const tarifaRaw = (ps.tarifa || '').trim();

        const codDesdeTexto = tarifaRaw.includes(' - ') ? tarifaRaw.split(' - ')[0].trim() : (tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw);
        const det = (ps.tarifasDisponibles as IListTarifaFull[])?.find(t => this.norm(t?.tarifa) === this.norm(tarifaRaw) || this.norm(t?.tarifa) === this.norm(codDesdeTexto));
        const codTarifa = (
          (det?.tarifa || tarifaRaw)
            .match(/\(([^()]+)\)\s*$/)?.[1]
          || codDesdeTexto
          || ''
        ).trim();

        const tarifaProgramaCambio = (() => {
          if (!onlyChanged) return true;
          const prevTarifa = this.normalizeTarifaComparable(cfgPrev?.tarifa);
          const actualTarifa = this.normalizeTarifaComparable(codTarifa || ps.tarifa);
          return actualTarifa !== prevTarifa;
        })();
        if (codTarifa && tarifaProgramaCambio) {
          let valorBase = det?.valorMensualBase;
          let valorIva = det?.valorMensualIva ?? valorBase;
          let nombreTarifaFinal = det?.descripcion ?? (tarifaRaw.includes(' - ') ? tarifaRaw : undefined);

          if (this.esFlujoColectivoOGA) {
            const filaColectivo = (this.datosColectivoGA || []).find((r: any) => {
              const rPlan = (r.plan_codi ?? r.PLAN_CODI ?? '').toString().trim().toUpperCase();
              return rPlan === (ps.id || '').trim().toUpperCase();
            });

            const valNum = Number(det?.valorMensualBase ?? det?.valorMensualIva ?? filaColectivo?.valor_tari ?? filaColectivo?.VALOR_TARI ?? 0);
            if (valNum > 0) {
              valorBase = valNum;
              valorIva = valNum;
            }
            if (!nombreTarifaFinal) {
              nombreTarifaFinal = (filaColectivo?.tari_deno || filaColectivo?.plan_deno || ps.nombre || '').toString().trim();
            }
          }

          refs.push({
            ps,
            idBenPrograma,
            esAnexo: false,
            tari: codTarifa,
            nombreTarifa: nombreTarifaFinal,
            valorMensualBase: valorBase,
            valorMensualIva: valorIva,
            porcentajeIva: det?.porcentajeIva ?? 0,
            esTarifaAsociado: det?.esTarifaAsociado ?? false,
            fueSeleccionada: true
          });

          // refs.push({ ps, idBenPrograma, esAnexo: false, tari: codTarifa, nombreTarifa: det?.descripcion ?? (tarifaRaw.includes(' - ') ? tarifaRaw : undefined), valorMensualBase: valorBase ?? undefined, valorMensualIva: valorIva ?? undefined, porcentajeIva: det?.porcentajeIva ?? undefined, esTarifaAsociado: det?.esTarifaAsociado ?? undefined, fueSeleccionada: true });

        }
        if (this.shouldShowTarifaAnexo(ps) && (ps.tarifaAnexo || '').trim() !== '') {
          const anexoDet = (ps.anexosDisponibles || []).find(an => this.matchAnexoSeleccion(an, ps.tarifaAnexo));
          const codTarifaAnexo = (anexoDet?.tari || ps.tarifaAnexo || '').toString().trim();
          const tarifaAnexoCambio = (() => {
            if (!onlyChanged) return true;
            const prevAnexo = this.normalizeTarifaComparable(cfgPrev?.tarifaAnexo ?? cfgPrev?.anexoCodigo);
            const actualAnexo = this.normalizeTarifaComparable(ps.tarifaAnexo || codTarifaAnexo);
            return actualAnexo !== prevAnexo;
          })();
          if (codTarifaAnexo && tarifaAnexoCambio) {
            const valorAnexoRaw = (anexoDet?.valor ?? '').toString().trim();
            const valorAnexoNum = valorAnexoRaw !== '' && Number.isFinite(Number(valorAnexoRaw)) ? Number(valorAnexoRaw) : undefined;
            refs.push({ ps, idBenPrograma, esAnexo: true, tari: codTarifaAnexo, nombreTarifa: (anexoDet?.plan_desc || '').toString().trim() || undefined, valorMensualBase: valorAnexoNum, valorMensualIva: valorAnexoNum, porcentajeIva: undefined, esTarifaAsociado: undefined, fueSeleccionada: true });
          }
        }
      });
    return refs;
  }

  private hydrateIdsCotizacionTarifaDesdeRespuesta(
    response: any,
    refs: Array<{
      ps: ProgramaSeleccionado;
      idBenPrograma: number;
      esAnexo: boolean;
      tari: string;
      nombreTarifa?: string;
      valorMensualBase?: number;
      valorMensualIva?: number;
      porcentajeIva?: number;
      esTarifaAsociado?: boolean;
      fueSeleccionada: boolean;
    }>
  ): void {
    const data = response?.data;
    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.tarifas)
        ? data.tarifas
        : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.programas)
            ? data.programas.flatMap((p: any) =>
              Array.isArray(p?.tarifas)
                ? p.tarifas.map((t: any) => ({ ...t, idBenPrograma: t?.idBenPrograma ?? p?.idBenPrograma }))
                : []
            )
            : data
              ? [data]
              : [];

    items.forEach((item: any) => {
      const idBenProgramaItem = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      const esAnexoItem = item?.esAnexo === true;
      const tariItem = (item?.tari || '').toString().trim();

      const hit = refs.find(ref =>
        (idBenProgramaItem > 0 && Number(ref.idBenPrograma) === idBenProgramaItem)
        && (item?.esAnexo == null || ref.esAnexo === esAnexoItem)
        && (!tariItem || this.norm(ref.tari) === this.norm(tariItem))
      ) || refs.find(ref =>
        ref.esAnexo === esAnexoItem && this.norm(ref.tari) === this.norm(tariItem)
      );

      if (hit) {
        this.applyIdCotizacionTarifaFromPayload(hit.ps, item);
      }
    });
  }

  private applyIdCotizacionTarifaFromPayload(programaSel: ProgramaSeleccionado, payload: any): void {
    const esAnexo = payload?.esAnexo === true;
    const key = esAnexo ? '__idCotizacionTarifaAnexo' : '__idCotizacionTarifa';
    const idCotizacionTarifa = Number(payload?.idCotizacionTarifa ?? payload?.id_cotizacion_tarifa ?? 0);
    if (Number.isFinite(idCotizacionTarifa) && idCotizacionTarifa > 0) {
      (programaSel as any)[key] = idCotizacionTarifa;
    }
  }

  private hydrateIdsCotizacionTarifaDesdeConsultarPrograma(programaSel: ProgramaSeleccionado, response: any): void {
    const data = response?.data;
    const tarifas = Array.isArray(data?.tarifas)
      ? data.tarifas
      : Array.isArray(data?.items)
        ? data.items
        : Array.isArray(data?.programas)
          ? data.programas.flatMap((p: any) => Array.isArray(p?.tarifas) ? p.tarifas : [])
          : Array.isArray(data)
            ? data
            : Array.isArray(data?.jsonRespuesta)
              ? data.jsonRespuesta
              : [];

    if (!tarifas.length) return;

    const tarifaRaw = (programaSel.tarifa || '').trim();
    const codDesdeTexto = tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
    const det = (programaSel.tarifasDisponibles as IListTarifaFull[])?.find(
      t => this.norm(t?.tarifa) === this.norm(codDesdeTexto)
    );
    const codTarifaPrograma = (det?.tarifa || codDesdeTexto || '').trim();

    const codTarifaAnexo = (() => {
      if (!this.shouldShowTarifaAnexo(programaSel) || !(programaSel.tarifaAnexo || '').trim()) return '';
      const anexoDet = (programaSel.anexosDisponibles || []).find(an => this.matchAnexoSeleccion(an, programaSel.tarifaAnexo));
      return (anexoDet?.tari || programaSel.tarifaAnexo || '').toString().trim();
    })();

    tarifas.forEach((t: any) => {
      const idTarifa = Number(t?.idCotizacionTarifa ?? t?.id_cotizacion_tarifa ?? 0);
      if (!(idTarifa > 0)) return;

      const esAnexo = t?.esAnexo === true;
      const tari = (t?.tari || '').toString().trim();

      if (!esAnexo && codTarifaPrograma && this.norm(tari) === this.norm(codTarifaPrograma)) {
        (programaSel as any).__idCotizacionTarifa = idTarifa;
      }

      if (esAnexo && codTarifaAnexo && this.norm(tari) === this.norm(codTarifaAnexo)) {
        (programaSel as any).__idCotizacionTarifaAnexo = idTarifa;
      }
    });
  }

  private resolveIdCotizacionCampania(programaSel: ProgramaSeleccionado): number {
    const idBenProgramaSel = Number((programaSel as any).__idBenPrograma || 0);

    // edición: resolver por idBenPrograma
    if (idBenProgramaSel > 0) {
      const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
      const cfgByIdBen = prevCfg.find(c =>
        Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenProgramaSel
      );
      const idFromCfgByIdBen = Number((cfgByIdBen as any)?.idCotizacionCampania ?? (cfgByIdBen as any)?.__idCotizacionCampania ?? 0);
      if (Number.isFinite(idFromCfgByIdBen) && idFromCfgByIdBen > 0) {
        (programaSel as any).__idCotizacionCampania = idFromCfgByIdBen;
        return idFromCfgByIdBen;
      }

      try {
        const raw = localStorage.getItem('datosRQ002_Contratante');
        if (raw) {
          const parsed = JSON.parse(raw || '{}');
          const rawByIdBenPrograma = (parsed as any)?.idCotizacionCampaniaPorIdBenPrograma;
          if (rawByIdBenPrograma && typeof rawByIdBenPrograma === 'object' && !Array.isArray(rawByIdBenPrograma)) {
            const n = Number((rawByIdBenPrograma as any)?.[String(idBenProgramaSel)] ?? 0);
            if (Number.isFinite(n) && n > 0) {
              (programaSel as any).__idCotizacionCampania = n;
              return n;
            }
          }
        }
      } catch (_) {
      }

      // con idBenPrograma solo match exacto
      return 0;
    }

    const fromSel = Number((programaSel as any).__idCotizacionCampania || 0);
    if (Number.isFinite(fromSel) && fromSel > 0) return fromSel;

    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    const idBenPrograma = Number((programaSel as any).__idBenPrograma || 0);
    const programaCodigo = this.resolveProgramaCodigo(programaSel);

    const cfg = prevCfg.find(c => {
      const sameIdBenPrograma = idBenPrograma > 0
        && Number((c as any)?.idBenPrograma ?? (c as any)?.__idBenPrograma ?? 0) === idBenPrograma;
      const sameId = this.norm(c?.id) === this.norm(programaSel.id);
      const samePrograma = this.norm((c as any)?.programa) === this.norm(programaCodigo);
      return sameIdBenPrograma || sameId || samePrograma;
    });

    const resolved = Number((cfg as any)?.idCotizacionCampania ?? (cfg as any)?.__idCotizacionCampania ?? 0);
    if (Number.isFinite(resolved) && resolved > 0) {
      (programaSel as any).__idCotizacionCampania = resolved;
      return resolved;
    }

    // fallback: ids en datosRQ002_Contratante
    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (raw) {
        const parsed = JSON.parse(raw || '{}');
        const rawByIdBenPrograma = (parsed as any)?.idCotizacionCampaniaPorIdBenPrograma;
        if (idBenProgramaSel > 0 && rawByIdBenPrograma && typeof rawByIdBenPrograma === 'object' && !Array.isArray(rawByIdBenPrograma)) {
          const n = Number((rawByIdBenPrograma as any)?.[String(idBenProgramaSel)] ?? 0);
          if (Number.isFinite(n) && n > 0) {
            (programaSel as any).__idCotizacionCampania = n;
            return n;
          }
        }

        const programaKey = (this.resolveProgramaCodigo(programaSel) || programaSel.id || '').toString().trim();
        const rawByPrograma = (parsed as any)?.idCotizacionCampaniaPorPrograma;
        let idFromMap = 0;
        if (rawByPrograma && typeof rawByPrograma === 'object' && !Array.isArray(rawByPrograma)) {
          const claves = [
            programaKey,
            (programaSel.id || '').toString().trim(),
            (this.resolveProgramaCodigo(programaSel) || '').toString().trim()
          ].filter(Boolean);

          for (const k of claves) {
            const n = Number((rawByPrograma as any)?.[k] ?? 0);
            if (Number.isFinite(n) && n > 0) {
              idFromMap = n;
              break;
            }
          }
        }

        if (Number.isFinite(idFromMap) && idFromMap > 0) {
          (programaSel as any).__idCotizacionCampania = idFromMap;
          return idFromMap;
        }
      }
    } catch (_) {
    }

    return 0;
  }

  private puedePersistirContratanteStorage(): boolean {
    return this.permitirPersistenciaContratanteStorage === true;
  }

  private guardarIdsCotizacionEnDatosContratante(): void {
    if (!this.puedePersistirContratanteStorage()) {
      return;
    }

    try {
      const rawDatos = localStorage.getItem('datosRQ002_Contratante');
      const datosActuales = rawDatos ? JSON.parse(rawDatos) : {};

      const tarifaPorPrograma: Record<string, number> = {};
      const tarifaAnexoPorPrograma: Record<string, number> = {};
      const campaniaPorPrograma: Record<string, number> = {};
      const tarifaPorIdBenPrograma: Record<string, number> = {};
      const tarifaAnexoPorIdBenPrograma: Record<string, number> = {};
      const campaniaPorIdBenPrograma: Record<string, number> = {};

      (this.programasSeleccionados || []).forEach(ps => {
        const programaKey = (this.resolveProgramaCodigo(ps) || ps.id || '').toString().trim();
        if (!programaKey) return;
        const idBenPrograma = Number((ps as any).__idBenPrograma || 0);

        const idTarifa = Number((ps as any).__idCotizacionTarifa || 0);
        const idTarifaAnexo = Number((ps as any).__idCotizacionTarifaAnexo || 0);
        const idCampania = Number((ps as any).__idCotizacionCampania || 0);

        if (idTarifa > 0) tarifaPorPrograma[programaKey] = idTarifa;
        if (idTarifaAnexo > 0) tarifaAnexoPorPrograma[programaKey] = idTarifaAnexo;
        if (idCampania > 0) campaniaPorPrograma[programaKey] = idCampania;
        if (idBenPrograma > 0 && idTarifa > 0) tarifaPorIdBenPrograma[String(idBenPrograma)] = idTarifa;
        if (idBenPrograma > 0 && idTarifaAnexo > 0) tarifaAnexoPorIdBenPrograma[String(idBenPrograma)] = idTarifaAnexo;
        if (idBenPrograma > 0 && idCampania > 0) campaniaPorIdBenPrograma[String(idBenPrograma)] = idCampania;
      });

      const firstTarifa = Object.values(tarifaPorPrograma).find(v => Number(v) > 0);
      const firstTarifaAnexo = Object.values(tarifaAnexoPorPrograma).find(v => Number(v) > 0);
      const firstCampania = Object.values(campaniaPorPrograma).find(v => Number(v) > 0);

      const merged = {
        ...(datosActuales || {}),
        ...(Number(firstTarifa || 0) > 0 ? { idCotizacionTarifa: Number(firstTarifa) } : {}),
        ...(Number(firstTarifaAnexo || 0) > 0 ? { idCotizacionTarifaAnexo: Number(firstTarifaAnexo) } : {}),
        ...(Number(firstCampania || 0) > 0 ? { idCotizacionCampania: Number(firstCampania) } : {}),
        idCotizacionTarifaPorPrograma: tarifaPorPrograma,
        idCotizacionTarifaAnexoPorPrograma: tarifaAnexoPorPrograma,
        idCotizacionCampaniaPorPrograma: campaniaPorPrograma,
        idCotizacionTarifaPorIdBenPrograma: tarifaPorIdBenPrograma,
        idCotizacionTarifaAnexoPorIdBenPrograma: tarifaAnexoPorIdBenPrograma,
        idCotizacionCampaniaPorIdBenPrograma: campaniaPorIdBenPrograma,
      };

      localStorage.setItem('datosRQ002_Contratante', JSON.stringify(merged));
    } catch {
      // no-op
    }
  }

  private persistirDatosContratanteEnLocalStorage(): void {
    if (!this.puedePersistirContratanteStorage()) {
      return;
    }
    // no titular: no escribir identidad en datosRQ002
    if (!this.esBeneficiarioParentescoTitular() && !this.esContextoContratanteReal()) {
      return;
    }

    try {
      const rawDatos = localStorage.getItem('datosRQ002_Contratante');
      const datosActuales = rawDatos ? JSON.parse(rawDatos) : {};
      const fechaNacimiento = this.mapDDMMYYYY_to_YYYYMMDD(this.form.fechaNacimiento?.value || '') || (datosActuales?.fechaNacimiento || '');
      const { tipoDocumento, numeroDocumento } = this.resolverDocumentoContratanteParaStorage(datosActuales);
      const payload = {
        ...(datosActuales || {}),
        tipoDocumento,
        numeroDocumento,
        primerNombre: (this.form.nombre?.value || '').toString().trim(),
        segundoNombre: (this.form.nombreSegundo?.value || '').toString().trim(),
        primerApellido: (this.form.apellido?.value || '').toString().trim(),
        segundoApellido: (this.form.apellidoSegundo?.value || '').toString().trim(),
        genero: (this.form.genero?.value || '').toString().trim(),
        fechaNacimiento,
        esUsuario: this.esUsuario === true || this.obtenerEsUsuarioDesdeLocal() === true,
        usarProgramasContratante: this.usarProgramasContratante === true,
        idBeneficiario: Number((this.data?.[0]?.id_beneficiario ?? this.data?.[0]?.idBeneficiario ?? 0) || (datosActuales?.idBeneficiario ?? 0) || 0) || undefined,
      };
      localStorage.setItem('datosRQ002_Contratante', JSON.stringify(payload));
    } catch {
      // no-op
    }
  }

  /** No pisar tipo/doc del contratante en datosRQ002 al guardar otro beneficiario */
  private resolverDocumentoContratanteParaStorage(datosActuales: any): { tipoDocumento: string; numeroDocumento: string } {
    if (this.esContextoContratanteReal()) {
      return {
        tipoDocumento: (this.form.contratanteTipoDocumento?.value || '').toString().trim(),
        numeroDocumento: (this.form.contratanteDocumento?.value || '').toString().trim(),
      };
    }

    let tipoDocumento = (datosActuales?.tipoDocumento ?? '').toString().trim();
    let numeroDocumento = (datosActuales?.numeroDocumento ?? '').toString().trim();
    if (tipoDocumento && numeroDocumento) {
      return { tipoDocumento, numeroDocumento };
    }

    try {
      const rawCreada = localStorage.getItem('cotizacion_creada_desde_contratante');
      if (rawCreada) {
        const creada = JSON.parse(rawCreada);
        tipoDocumento = tipoDocumento || (creada?.tipoDocumento ?? '').toString().trim();
        numeroDocumento = numeroDocumento || (creada?.numeroDocumento ?? '').toString().trim();
      }
    } catch {
      // no-op
    }

    if (!tipoDocumento || !numeroDocumento) {
      try {
        const rawProgramas = localStorage.getItem('programas_contratante');
        if (rawProgramas) {
          const programas = JSON.parse(rawProgramas);
          if (programas && typeof programas === 'object' && !Array.isArray(programas)) {
            tipoDocumento = tipoDocumento || (programas?.tipoDocumento ?? '').toString().trim();
            numeroDocumento = numeroDocumento || (programas?.numeroDocumento ?? '').toString().trim();
          }
        }
      } catch {
        // no-op
      }
    }

    return { tipoDocumento, numeroDocumento };
  }

  private esContextoContratanteReal(): boolean {
    const esUsuarioMeta = this.data?.[3]?.esUsuarioContexto;
    // si data[3] trae esUsuarioContexto, se respeta
    if (typeof esUsuarioMeta === 'boolean') {
      return esUsuarioMeta;
    }

    if (this.esUsuario === true || this.data?.[0]?.esUsuario === true || this.data?.[0]?.es_contratante === true) {
      return true;
    }

    const esUsuarioContexto =
      this.obtenerEsUsuarioDesdeLocal() === true;
    const tipoDocForm = (this.form.contratanteTipoDocumento?.value || '').toString().trim().toUpperCase();
    const numDocForm = (this.form.contratanteDocumento?.value || '').toString().trim();

    let tipoDocLs = '';
    let numDocLs = '';
    try {
      const rawDatos = localStorage.getItem('datosRQ002_Contratante');
      const datosLs = rawDatos ? JSON.parse(rawDatos) : null;
      tipoDocLs = (datosLs?.tipoDocumento || '').toString().trim().toUpperCase();
      numDocLs = (datosLs?.numeroDocumento || '').toString().trim();
    } catch {
      tipoDocLs = '';
      numDocLs = '';
    }

    return esUsuarioContexto && !!tipoDocForm && !!numDocForm && tipoDocForm === tipoDocLs && numDocForm === numDocLs;
  }

  private persistirContratanteEnLocalStorageSolo(): void {
    this.persistirStorageTrasGuardarBeneficiario();
  }

  /** Tras guardar: merge ids en datosRQ002 solo si es titular/contratante */
  private persistirStorageTrasGuardarBeneficiario(): void {
    if (!this.esBeneficiarioParentescoTitular() && !this.esContextoContratanteReal()) {
      return;
    }
    this.guardarIdsCotizacionEnDatosContratante();
    this.persistirDatosContratanteEnLocalStorage();
    this.actualizarProgramasContratanteLocalStorage();
  }

  private buildCampaniasSeleccionadasActualizar(onlyChanged = false): Array<{
    ps: ProgramaSeleccionado;
    idBenPrograma: number;
    codCampComercial: string;
    nombreCampania?: string;
    detSel?: any;
  }> {
    return (this.programasSeleccionados || [])
      .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
      .map(ps => {
        const idBenPrograma = Number((ps as any).__idBenPrograma || 0);
        const cfgPrev = this.findPrevCfgForPrograma(ps);
        const lista = this.getCampaniasParaPrograma(ps);
        const codSelRaw = (ps.campana || '').toString().trim();

        let detSel = lista.find(c => this.norm((c as any)?.codigo_campania) === this.norm(codSelRaw) || this.norm((c as any)?.nombre) === this.norm(codSelRaw));


        if (!detSel && this.esFlujoInclusion && ((ps as any).inicioVigencia || (ps as any).finVigencia)) {
          const fIni = (ps as any).inicioVigencia;
          const fFin = (ps as any).finVigencia;

          // metadatos del programa base
          const baseProg = this.programasDisponibles.find(p => p.id === ps.id);
          const lineaSmp = baseProg?.lineaNegocio || '';
          const codLineaNum = String((this as any).mapLineaToNumber?.(lineaSmp) || '1');
          const tPlan = localStorage.getItem('tipoPlan') || 'F';


          detSel = {
            codigo_campania: ps.campana,
            codigoCampania: ps.campana,
            codCampComercial: ps.campana,
            nombre: ps.campanaNombre || codSelRaw,
            nombreCampania: ps.campanaNombre || codSelRaw,
            tipoCampania: 'NINGUNA',
            tipo_campania: 'NINGUNA',
            modalidad: 'NINGUNA',
            fueSeleccionada: true,
            fue_seleccionada: true,
            cuenta: '0',
            subcuenta: ps.subcuenta || '0',
            tipoPlan: tPlan,
            tipo_plan: tPlan,
            parentesco: 'TODOS',
            edadDesde: 0,
            edad_desde: 0,
            edadHasta: 130,
            edad_hasta: 130,
            cantBenefDesde: 0,
            cant_benef_desde: 0,
            cantBenefHasta: 0,
            cant_benef_hasta: 0,
            acumulable: false,
            pagoDebitoAuto: false,
            pago_debito_auto: false,
            aplicaProntoPago: false,
            aplica_pronto_pago: false,
            observaciones: 'N/A',
            usuarioActualizacion: '',
            usuario_actualizacion: '',

            // carnet
            lineaNegocio: codLineaNum,
            linea_negocio: codLineaNum,
            grupoPrograma: ps.id,
            grupo_programa: ps.id,
            programa: ps.id,
            codigo_programa: ps.id,

            // vigencias
            inicioVigencia: fIni,
            inicio_vigencia: fIni,
            finVigencia: fFin,
            fin_vigencia: fFin,

            estado: true
          } as any;
          (ps as any).campaniasDisponibles = [detSel];
        }

        const codCampComercial = ((detSel as any)?.codigo_campania || codSelRaw).toString().trim();
        const nombreCampania = (((detSel as any)?.nombre || ps.campanaNombre || codSelRaw) || '').toString().trim();
        if (!codCampComercial) return null;

        if (onlyChanged) {
          const prevCamp = (cfgPrev?.campana || '').toString().trim();
          const changed = this.norm(prevCamp) !== this.norm(codCampComercial) && this.norm(prevCamp) !== this.norm(nombreCampania);
          if (!changed) return null;
        }
        return { ps, idBenPrograma, codCampComercial, nombreCampania, detSel };
      })
      .filter(Boolean) as Array<{ ps: ProgramaSeleccionado; idBenPrograma: number; codCampComercial: string; nombreCampania?: string; detSel?: any; }>;
  }

  private applyIdCotizacionCampaniaFromPayload(programaSel: ProgramaSeleccionado, payload: any): void {
    const id = Number(payload?.idCotizacionCampania ?? payload?.id_cotizacion_campania ?? 0);
    if (Number.isFinite(id) && id > 0) {
      (programaSel as any).__idCotizacionCampania = id;
    }
  }

  private hydrateIdsCotizacionCampaniaDesdeRespuesta(
    response: any,
    refs: Array<{ ps: ProgramaSeleccionado; idBenPrograma: number; codCampComercial: string; nombreCampania?: string; detSel?: any; }>
  ): void {
    const data = response?.data;
    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.campanias)
        ? data.campanias
        : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.programas)
            ? data.programas.flatMap((p: any) =>
              Array.isArray(p?.campanias)
                ? p.campanias.map((c: any) => ({ ...c, idBenPrograma: c?.idBenPrograma ?? p?.idBenPrograma }))
                : []
            )
            : data
              ? [data]
              : [];

    items.forEach((item: any) => {
      const idBenProgramaItem = Number(item?.idBenPrograma ?? item?.id_ben_programa ?? 0);
      const codigoItem = (item?.codCampComercial ?? item?.codigo_campania ?? item?.campania ?? '').toString().trim();

      const hit = refs.find(ref =>
        (idBenProgramaItem > 0 && Number(ref.idBenPrograma) === idBenProgramaItem)
        && (!codigoItem || this.norm(ref.codCampComercial) === this.norm(codigoItem))
      ) || refs.find(ref => this.norm(ref.codCampComercial) === this.norm(codigoItem));

      if (hit) {
        this.applyIdCotizacionCampaniaFromPayload(hit.ps, item);
      }
    });
  }

  private hydrateIdsCotizacionCampaniaDesdeConsultarPrograma(programaSel: ProgramaSeleccionado, response: any): void {
    const data = response?.data;
    const campanias = Array.isArray(data?.campanias)
      ? data.campanias
      : Array.isArray(data?.items)
        ? data.items
        : Array.isArray(data?.programas)
          ? data.programas.flatMap((p: any) => Array.isArray(p?.campanias) ? p.campanias : [])
          : Array.isArray(data)
            ? data
            : Array.isArray(data?.jsonRespuesta)
              ? data.jsonRespuesta
              : [];

    if (!campanias.length) return;

    const codSelRaw = (programaSel.campana || '').toString().trim();
    const detSel = this.getCampaniasParaPrograma(programaSel).find(c =>
      this.norm((c as any)?.codigo_campania) === this.norm(codSelRaw)
      || this.norm((c as any)?.nombre) === this.norm(codSelRaw)
    );
    const codCampSel = ((detSel as any)?.codigo_campania || codSelRaw).toString().trim();
    if (!codCampSel) return;

    campanias.forEach((c: any) => {
      const idCamp = Number(c?.idCotizacionCampania ?? c?.id_cotizacion_campania ?? 0);
      if (!(idCamp > 0)) return;
      const cod = (c?.codCampComercial ?? c?.codigo_campania ?? c?.campania ?? '').toString().trim();
      if (cod && this.norm(cod) === this.norm(codCampSel)) {
        (programaSel as any).__idCotizacionCampania = idCamp;
      }
    });
  }

  private isPlanColectivo(plan: string | null | undefined): boolean {
    const p = this.normTxt(plan);
    return p === 'C' || p === 'CY' || p.includes('COLECTIV');
  }

  private isPlanAfinidad(plan: string | null | undefined): boolean {
    const p = this.normTxt(plan);
    return p === 'GA' || p === 'AG' || p.includes('AFINIDAD');
  }

  private esFlujoGruposAfinidad(): boolean {
    return this.isPlanAfinidad(this.tipoPlanLS || localStorage.getItem('tipoPlan'));
  }

  /** F/A de Afilmed vs C en pantalla (AREA→AREC, OPLF→OPLC). */
  private coincidePlanCodiAfinidad(rowPlan: string, uiPlan: string): boolean {
    const r = (rowPlan || '').toString().trim().toUpperCase();
    const u = (uiPlan || '').toString().trim().toUpperCase();
    if (!r || !u) return false;
    if (r === u) return true;
    if ((r.endsWith('F') || r.endsWith('A')) && `${r.slice(0, -1)}C` === u) {
      return true;
    }
    return false;
  }

  /**
   * En grupos de afinidad el carnet pinta el código colectivo, pero en base
   * solo debe quedar el plan de Afilmed (familiar o asociado).
   */
  private planGuardadoCoincideConProgramaUi(guardado: string, uiId: string): boolean {
    const g = (guardado || '').toString().trim().toUpperCase();
    const u = (uiId || '').toString().trim().toUpperCase();
    if (!g || !u) return false;
    if (g === u) return true;
    if ((g.endsWith('F') || g.endsWith('A')) && `${g.slice(0, -1)}C` === u) return true;
    if ((u.endsWith('F') || u.endsWith('A')) && `${u.slice(0, -1)}C` === g) return true;
    return false;
  }

  private elegirFilaAfinidad(filas: any[], codigoUi: string): any {
    if (!Array.isArray(filas) || filas.length === 0) return undefined;
    if (!this.esFlujoGruposAfinidad()) return filas[0];

    const planDe = (row: any): string => String(
      row?.plan_codi ?? row?.PLAN_CODI ?? ''
    ).trim().toUpperCase();
    const ui = (codigoUi || '').toString().trim().toUpperCase();
    const familiar = filas.find((row) => {
      const plan = planDe(row);
      if (!(plan.endsWith('F') || plan.endsWith('A'))) return false;
      return plan === ui || `${plan.slice(0, -1)}C` === ui;
    });
    return familiar;
  }

  private resolverFilaActivoAcParaTarifa(
    planCodigoUi: string,
    subcta: string,
    cuenta?: string
  ): any {
    const subcuentaActual = String(subcta || '').trim();
    const planUi = String(planCodigoUi || '')
      .trim()
      .toUpperCase();
    const cuentaActual = String(cuenta || '').trim();

    const filas = (this.datosColectivoGA || []).filter(
      (fila: any) => {
        const filaPlan = String(
          fila?.plan_codi ??
          fila?.PLAN_CODI ??
          ''
        ).trim().toUpperCase();

        const filaSubcuenta = String(
          fila?.subcta ??
          fila?.SUBCTA ??
          ''
        ).trim();

        const filaCuenta = String(
          fila?.cuenta ??
          fila?.CUENTA ??
          ''
        ).trim();

        const coincidePlan = this.coincidePlanCodiAfinidad(
          filaPlan,
          planUi
        );

        return (
          coincidePlan &&
          (!subcuentaActual ||
            filaSubcuenta === subcuentaActual) &&
          (!cuentaActual ||
            filaCuenta === cuentaActual)
        );
      }
    );
    return this.elegirFilaAfinidad(filas, planUi) || filas[0];
  }

  private isPlanFamiliarAsocEmp(plan: string | null | undefined): boolean {
    const p = this.normTxt(plan);
    return p.includes('FAMILIAR') || p.includes('ASOCIADO') || p.includes('EMPLEADO')
      || p === 'F' || p === 'FA' || p === 'EMP' || p === 'E' || p === 'A';
  }

  private shouldActualizarSubcuentas(): boolean {
    const plan = this.normTxt(this.tipoPlanLS || localStorage.getItem('tipoPlan') || '');
    return this.isPlanColectivo(plan) || this.isPlanAfinidad(plan);
  }

  private isSolicitudVN_IN(sol: string | number | null | undefined): boolean {
    const s = (sol ?? '').toString().trim();
    return s === '1' || s === '2';
  }

  // carga de datos
  getTypeDocument(): void {
    this.spinner.show();
    this.networking.getTypeDocument().subscribe(
      (response: Array<documentsType>) => { this.docuementSuccessfulNetworkingOutput(response); },
      (error) => { this.docuementtFailureNetworkingOutput(1, error.message); }
    );
  }

  docuementSuccessfulNetworkingOutput(dat: Array<documentsType>): void {
    this.typeDocument = dat;
    this.storageService.setItem('documentsType', dat as any);
    this.spinner.hide();
  }

  docuementtFailureNetworkingOutput(_errorCode: number, message: string): void {
    this.spinner.hide();
    this.setMensajeUI(
      message && message !== 'undefined' && message !== 'null' && message !== ''
        ? message
        : 'No se pudo obtener los tipos de documentos, contacte con el administrador'
    );
  }

  search(): void {
    this.networking.consultarParentescos().subscribe(
      (data: any) => { this.relationship = Array.isArray(data) ? data : (data.data || []); },
      (error) => { this.relationship = []; }
    );
  }

  getDocKind(item: { codigo: string; tipo_documento: string; }): 'RC' | 'TI' | 'CC' | 'OTRO' {
    const txt = (item?.tipo_documento || item?.codigo || '').toUpperCase().trim();
    if (txt.includes('REGISTRO') || txt === 'RC') return 'RC';
    if (txt.includes('TARJETA') || txt === 'TI') return 'TI';
    if (txt.includes('CEDULA') || txt.includes('CÉDULA') || txt === 'CC') return 'CC';
    return 'OTRO';
  }

  isAgeValidFor(kind: 'RC' | 'TI' | 'CC' | 'OTRO', edad: number): boolean {
    if (kind === 'OTRO') return true;
    const rule = this.DOC_RANGE[kind];
    return edad >= rule.min && edad <= rule.max;
  }

  getSelectedDoc(): { codigo: string; tipo_documento: string; } | undefined {
    const selectedCode = this.form.contratanteTipoDocumento.value;
    return (this.typeDocument || []).find(d => d.codigo === selectedCode);
  }

  isDocTypeDisabled(item: { codigo: string; tipo_documento: string; }): boolean {
    if (this.edad === null || Number.isNaN(Number(this.edad))) return false;
    const kind = this.getDocKind(item);
    return !this.isAgeValidFor(kind, Number(this.edad || 0));
  }

  validateDocTypeWithAge(): void {
    this.form.fechaNacimiento.messages = '';
    const doc = this.getSelectedDoc();
    if (!doc) return;
    if (this.edad === null || Number.isNaN(Number(this.edad))) return;

    const kind = this.getDocKind(doc);
    if (kind === 'OTRO') return;

    const edadNum = Number(this.edad);
    const ok = this.isAgeValidFor(kind, edadNum);
    if (!ok) {
      this.form.fechaNacimiento.messages =
        'La edad ingresada no corresponde con el tipo de documento seleccionado. Por favor verifique.';
      this.cdRef.detectChanges();
    } else {
      this.form.fechaNacimiento.messages = '';
    }
  }

  private esTipoDocumentoBebe(): boolean {
    const tipoDoc = (this.form.contratanteTipoDocumento.value || '').toUpperCase().trim();
    return tipoDoc === 'BG' || tipoDoc === 'CN';
  }

  buscarPersona() {
    if (this.datosIdentidadBeneficiarioBloqueados) {
      return;
    }
    if (this.esTipoDocumentoBebe()) {
      this.resetData = false;
      this.form.fechaNacimiento.messages = '';
      this.SnackBarService.alert('alert-info',
        'Para BG (Bebé gestante) o CN (Nacido vivo) no se realiza búsqueda. Diligencie los campos manualmente.');
      return;
    }
    if (this.formInit?.get('tipoSolicitud')?.value !== '2') {
      this.esInclusion = false;
      const tipoDoc = this.form.contratanteTipoDocumento.value;
      const numDoc = this.form.contratanteDocumento.value;
      if (tipoDoc && numDoc) {
        this.spinner.show();
        const requestData: QuotationPeopleeRequest = { tipoDocumento: tipoDoc, numeroDocumento: numDoc };
        this.networking.searchPeople(requestData)
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe(
            (response: any) => { this.searchPeopleOutputSuccessful(response); },
            error => { this.searchPeopleOutputFailure(1, error.message); }
          );
      } else {
        this.SnackBarService.alert('alert-danger', 'Tipo documento o número de documento vacío.');
      }
    }
  }

  private limpiarCamposBeneficiarioConsulta(): void {
    this.form.nombre.value = '';
    this.form.nombreSegundo.value = '';
    this.form.apellido.value = '';
    this.form.apellidoSegundo.value = '';
    this.form.genero.value = '';
    this.form.fechaNacimiento.value = '';
    this.edad = null;
    this.form.nombre.messages = '';
    this.form.nombreSegundo.messages = '';
    this.form.apellido.messages = '';
    this.form.apellidoSegundo.messages = '';
    this.form.genero.messages = '';
    this.form.fechaNacimiento.messages = '';
    this.dataBeneficiary = [];
    this.dataSourceBeneficiary.data = [];
  }

  searchPeopleOutputSuccessful(data: QuotationPeopleeResponse): void {
    this.spinner.hide();
    this.resetData = true;

    const sinInfoAFILMED =
      (data as any)?.errorAfilmed?.mensaje ||
      (!(data?.primerNombre && data.primerNombre.trim() !== '') &&
        !(data?.primerApellido && data.primerApellido.trim() !== ''));

    if (sinInfoAFILMED) {
      this.limpiarCamposBeneficiarioConsulta();

      const msg = (data as any)?.errorAfilmed?.mensaje || 'No se encontró información en AFILMED';
      this.showMessageDialog('Información', msg, 'Aceptar', '', true, 1, this.dialog, (_: any) => { });
      return;
    }

    this.form.contratanteTipoDocumento.value = data.tipoDocumento ?? '';
    this.form.contratanteDocumento.value = data.numeroDocumento ?? '';
    this.form.nombre.value = data.primerNombre ?? '';
    this.form.nombreSegundo.value = data.segundoNombre ?? '';
    this.form.apellido.value = data.primerApellido ?? '';
    this.form.apellidoSegundo.value = data.segundoApellido ?? '';
    this.form.genero.value = data.genero === 'F' ? '1' : '2';

    const d = this.parseApiDateToDate(data.fechaNacimiento ?? '');
    this.form.fechaNacimiento.value = this.formatDateToDDMMYYYY(d);
    if (d) this.calculeAge('change', { value: d } as any); else this.edad = 0;
    this.updateTableBeneficiary();
    const hayDatos = (data?.primerNombre && data.primerNombre.trim() !== '') &&
      (data?.primerApellido && data.primerApellido.trim() !== '');
    if (hayDatos) {
      this.showMessageDialog('Informacion', 'Se encontró información del usuario.',
        'Aceptar', '', true, 1, this.dialog, (_: any) => { });
    }
  }

  searchPeopleOutputFailure(_errorCode: number, message?: string): void {
    this.spinner.hide();
    this.resetData = false;
    this.limpiarCamposBeneficiarioConsulta();
    this.showMessageDialog('Error', `${message}`, 'Aceptar', '', true, 1, this.dialog, (_: any) => { });
  }

  updateTableBeneficiary() {
    let position = 0;
    this.dataBeneficiary.forEach((element) => {
      if (element) { position++; element.position = position; }
    });
    this.dataSourceBeneficiary.data = this.dataBeneficiary ?? [];
  }

  parseApiDateToDate(apiDate: string): Date | null {
    if (!apiDate) return null;
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(apiDate)) {
      const [dd, mm, yyyy] = apiDate.split('/').map(n => parseInt(n, 10));
      return new Date(yyyy, mm - 1, dd);
    }
    const norm = apiDate.replace(/\//g, '-');
    const [yyyy, mm, dd] = norm.split('-').map(n => parseInt(n, 10));
    if (!yyyy || !mm || !dd) return null;
    return new Date(yyyy, mm - 1, dd);
  }

  formatDateToDDMMYYYY(d: Date | null): string {
    if (!d) return '';
    const dd = ('0' + d.getDate()).slice(-2);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  private normalizeFechaForForm(fechaInput: any): string {
    if (fechaInput === null || fechaInput === undefined || fechaInput === '') return '';

    if (fechaInput instanceof Date && !isNaN(fechaInput.getTime())) {
      return this.formatDateToDDMMYYYY(fechaInput);
    }

    const parsed = this.parseApiDateToDate(String(fechaInput).trim());
    return this.formatDateToDDMMYYYY(parsed);
  }

  private mapDDMMYYYY_to_YYYYMMDD(fechaInput: any): string {
    if (fechaInput === null || fechaInput === undefined || fechaInput === '') return '';

    if (fechaInput instanceof Date && !isNaN(fechaInput.getTime())) {
      const yyyy = fechaInput.getFullYear();
      const mm = String(fechaInput.getMonth() + 1).padStart(2, '0');
      const dd = String(fechaInput.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }

    const fechaStr = String(fechaInput).trim();
    if (!fechaStr) return '';

    const dmy = fechaStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dmy) {
      const [, dd, mm, yyyy] = dmy;
      return `${yyyy}-${mm}-${dd}`;
    }

    const ymd = fechaStr.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
    if (ymd) {
      const [, yyyy, mm, dd] = ymd;
      return `${yyyy}-${mm}-${dd}`;
    }

    return '';
  }

  setRequiredMessage(fieldKey: keyof FormType, labelVisible?: string): void {
    const ctrl = this.form[fieldKey] as any;
    if (!ctrl) return;
    const value = ctrl.value;
    if (ctrl.required && this.isEmpty(value)) ctrl.messages = 'La información de este campo es obligatoria';
    else ctrl.messages = '';
  }

  onFechaNacimientoChange(event: MatDatepickerInputEvent<Date>) {
    const d = event.value ?? null;
    this.form.fechaNacimiento.value = this.formatDateToDDMMYYYY(d);
    this.calculeAge('change', { value: d } as any);
    this.validateDocTypeWithAge();
    this.cdRef.detectChanges();
    if ((this.programasSeleccionados?.length || 0) > 0) {
      this.bucarCampa();
    }
  }

  private formatearFechaDDMMYYYY(iso: string | null | undefined): string {
    if (!iso || !String(iso).trim()) return '';
    const s = String(iso).trim();
    const [y, m, d] = s.split('-');
    if (!d || !m || !y) return s;
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  }

  private mesesDesdeRetiro(realbaja_fecha: string | null | undefined): number | null {
    if (!realbaja_fecha || !String(realbaja_fecha).trim()) return null;
    const s = String(realbaja_fecha).trim();
    const parts = s.split('-').map(Number);
    const y = parts[0], m = parts[1], d = parts[2];
    if (!y || !m) return null;
    const fechaBaja = new Date(y, m - 1, d || 1);
    const hoy = new Date();
    let meses = (hoy.getFullYear() - fechaBaja.getFullYear()) * 12 + (hoy.getMonth() - fechaBaja.getMonth());
    if (hoy.getDate() < fechaBaja.getDate()) meses--;
    return meses;
  }

  private mapearHistorialATarjetas(items: HistorialItem[]): { tipo: 'error' | 'info' | 'success'; mensaje: string; }[] {
    const tarjetas: { tipo: 'error' | 'info' | 'success'; mensaje: string; }[] = [];
    const primerItem = items?.[0];
    if (!primerItem) return tarjetas;

    const esNegado = (primerItem.es_negado || '').trim() !== '0';
    if (esNegado && primerItem.fecha_negado) {
      const fechaNegado = this.formatearFechaDDMMYYYY(primerItem.fecha_negado);
      tarjetas.push({ tipo: 'error', mensaje: `El usuario presenta antecedentes de negación el día ${fechaNegado}.` });
    } else if (esNegado) {
      tarjetas.push({ tipo: 'error', mensaje: 'El usuario presenta antecedentes de negación.' });
    }

    if ((primerItem.realbaja_fecha || '').trim() || (primerItem.motivo_retiro || '').trim()) {
      const fecha = this.formatearFechaDDMMYYYY(primerItem.realbaja_fecha || '');
      const motivo = (primerItem.motivo_retiro || '').trim() || 'no indicado';
      tarjetas.push({ tipo: 'error', mensaje: `El usuario presenta antecedentes de retiro el día ${fecha} por motivo ${motivo}.` });
    }

    // solo bloquea_ingreso = S
    const bloqueaIngreso = (primerItem.bloquea_ingreso || '').trim().toUpperCase() === 'S';
    if (bloqueaIngreso) {
      tarjetas.push({ tipo: 'error', mensaje: this.MENSAJE_NO_BENEFICIARIO_MI });
    }

    if (primerItem.aplica_reactivacion === '1') {
      tarjetas.push({ tipo: 'success', mensaje: 'El usuario podría aplicar para reactivación.' });
    }

    const tipoSolicitud = (localStorage.getItem('tipoSolicitud') || '').trim();
    const meses = this.mesesDesdeRetiro(primerItem.realbaja_fecha);
    if (tipoSolicitud === '1' && meses !== null && meses >= 0 && meses <= 7) {
      tarjetas.push({ tipo: 'error', mensaje: this.MENSAJE_BLOQUEO_RETIRO });
    }

    return tarjetas;
  }

  getSubcuentaLabel(programaId: string, deno: string): string {
    const p = (programaId || '').trim();
    const d = (deno || '').toString().trim().toUpperCase();
    return this.mapaDenoALabelPorPrograma.get(p)?.get(d) ?? deno;
  }


  get esFlujoColectivoOGA(): boolean {
    const t = (localStorage.getItem('tipoPlan') ?? '')
      .toString()
      .trim()
      .toUpperCase();
    return t === 'C' || t === 'GA' || t === 'AG';
  }

  /** Programas del titular para el switch, sin pisar la sesión del contratante. */
  private leerProgramasContratanteParaSwitch(): any[] {
    try {
      const raw = localStorage.getItem('programas_contratante');
      if (raw) {
        const parsed = JSON.parse(raw);
        const arr = Array.isArray(parsed)
          ? parsed
          : (parsed && typeof parsed === 'object' && Array.isArray((parsed as any).programas))
            ? (parsed as any).programas
            : [];
        if (Array.isArray(arr) && arr.length > 0) {
          return arr;
        }
      }
    } catch {
    }

    const desdeDialogo = this.data?.[3]?.programasContratanteSwitch;
    return Array.isArray(desdeDialogo) ? desdeDialogo : [];
  }

  get mostrarSwitchProgramasContratante(): boolean {
    if (this.esUsuario === true) {
      return true;
    }

    if (this.leerProgramasContratanteParaSwitch().length > 0) {
      return true;
    }

    const sol = (this.tipoSolicitudLS || localStorage.getItem('tipoSolicitud') || '').toString().trim();
    if (sol === '2') {
      try {
        const rawInclusion = localStorage.getItem('programas_contratante_inclusiones');
        if (rawInclusion) {
          const parsedInclusion = JSON.parse(rawInclusion);
          if (Array.isArray(parsedInclusion) && parsedInclusion.length > 0) {
            return true;
          }
        }
      } catch (e) {
      }
    }

    try {
      const raw = localStorage.getItem('programas_contratante');
      if (!raw) return false;

      const parsed = JSON.parse(raw);
      const arr = Array.isArray(parsed)
        ? parsed
        : (parsed && typeof parsed === 'object' && Array.isArray((parsed as any).programas))
          ? (parsed as any).programas
          : [];

      return Array.isArray(arr) && arr.length > 0;
    } catch {
      return false;
    }
  }

  get esFlujoInclusion(): boolean {
    const sol = (this.tipoSolicitudLS || localStorage.getItem('tipoSolicitud') || '')
      .toString()
      .trim();
    return sol === '2';
  }

  /** Parentesco T = contratante; identidad se edita en formulario-contratante */
  esBeneficiarioParentescoTitular(): boolean {
    const val = (this.form?.parentesco?.value ?? '').toString().trim().toUpperCase();
    if (val === 'T') {
      return true;
    }
    const item = (this.relationship || []).find(
      (r: any) => String(r?.id ?? '').trim() === String(this.form?.parentesco?.value ?? '').trim()
    );
    return item ? this.esParentescoTitularItem(item) : false;
  }

  get datosIdentidadBeneficiarioBloqueados(): boolean {
    return this.esBeneficiarioParentescoTitular();
  }

  private esParentescoTitularItem(item: any): boolean {
    const id = (item?.id ?? '').toString().trim().toUpperCase();
    const label = (item?.parentesco ?? '').toString().trim().toUpperCase();
    return id === 'T' || label === 'TITULAR' || label.includes('TITULAR');
  }

  /** Sin opción T al crear; en edición de titular solo muestra la actual */
  get parentescosParaSeleccion(): relationship[] {
    const list = this.relationship || [];
    const sinTitular = list.filter((item) => !this.esParentescoTitularItem(item));

    if (this.datosIdentidadBeneficiarioBloqueados) {
      const actual = list.find(
        (item) => String(item?.id ?? '').trim() === String(this.form?.parentesco?.value ?? '').trim(),
      );
      if (actual && this.esParentescoTitularItem(actual)) {
        return [actual];
      }
    }

    return sinTitular;
  }

  private initFlujoColectivoGA(): void {
    if ((this as any)._isColectivoGALoading) {
      return;
    }
    if (this.programasDisponibles.length > 0 && this.programasSeleccionados.length > 0) {
      return;
    }

    (this as any)._isColectivoGALoading = true;
    this.cargarProgramasYPreseleccionColectivoGA();
  }

  private initFlujoInclusion(): void {
    if ((this as any)._isInclusionLoading) {
      return;
    }
    if (this.programasDisponibles.length > 0 && this.programasSeleccionados.length > 0) {
      return;
    }
    (this as any)._isInclusionLoading = true;

    this.cargarProgramasYPreseleccionInclusion();
  }

  private filtrarSubcuentasColectivoGA(planId: string, todos: any[]): any[] {
    const cuentaActual = this.cuentaColectivoGA != null ? String(this.cuentaColectivoGA).trim() : '';
    const planIdNorm = (planId || '').trim().toUpperCase();

    const obtenerCodigoComercialC = (codigo: string): string => {
      const c = (codigo || '').toString().trim().toUpperCase();
      if (c.endsWith('F') || c.endsWith('A')) {
        return c.substring(0, c.length - 1) + 'C';
      }
      return c;
    };

    const subctasColectivoMap = new Map<string, any>();
    (this.datosColectivoGA || []).forEach((row: any) => {
      const rowCuenta = String(row.cuenta ?? row.CUENTA ?? '').trim();
      const rawPlan = (row.plan_codi ?? row.PLAN_CODI ?? '').toString().trim().toUpperCase();
      const rowSub = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
      // GA: solo plan_codi crudo F/A → id UI C. No identidad C==C (eso metía AFISAO en OPLC).
      const matchPlan = this.esFlujoGruposAfinidad()
        ? this.coincidePlanCodiAfinidad(rawPlan, planIdNorm)
        : (obtenerCodigoComercialC(rawPlan) === planIdNorm);

      if (rowSub && (rowCuenta === cuentaActual || !cuentaActual) && matchPlan) {
        subctasColectivoMap.set(rowSub, row);
      }
    });

    if (subctasColectivoMap.size === 0) {
      return [];
    }

    const coincidencias = todos.filter(i => {
      const subCode = (i.subcta || i.SUBCTA || '').toString().trim();
      if (!subctasColectivoMap.has(subCode)) return false;
      if (!cuentaActual) return true;
      const iCuenta = (i.cuenta ?? i.CUENTA ?? '').toString().trim();
      return iCuenta === cuentaActual;
    });

    const esPlanCem = planIdNorm.includes('CEM');
    if (!esPlanCem && coincidencias.length > 1) {
      const sinCem = coincidencias.filter(i => {
        const subCode = (i.subcta || i.SUBCTA || '').toString().trim().toUpperCase();
        const denoName = (i.deno || i.DENO || '').toString().trim().toUpperCase();
        return !subCode.startsWith('CEM') && !denoName.startsWith('CEM');
      });
      if (sinCem.length > 0) {
        return sinCem;
      }
    }

    if (coincidencias.length > 0) {
      return coincidencias;
    }

    // fallback sintético desde consultaActivoAC
    return Array.from(subctasColectivoMap.values()).map((row: any) => {
      const subCode = (row.subcta ?? row.SUBCTA ?? '').toString().trim();
      const denoName = (
        row.nombre_fantasia ||
        row.plan_deno ||
        row.tari_deno ||
        row.descripcion_sucursal ||
        `SUBCUENTA ${subCode}`
      ).toString().trim();

      return {
        subcta: subCode,
        deno: denoName,
        cuenta: row.cuenta,
        plan_grupo: row.plan_grupo || row.grupo_programa || ''
      };
    });
  }

  private cargarProgramasYPreseleccionColectivoGA(): void {
    let documento = (localStorage.getItem('numeroDocumentoEmpresa') ?? '').trim();
    let tipoDocumento = (localStorage.getItem('tipoDocumentoEmpresa') ?? '').trim();
    const tipoPlan = (localStorage.getItem('tipoPlan') ?? 'C').trim().toUpperCase();

    if (!documento || !tipoDocumento) {
      try {
        const rawRadicado = localStorage.getItem('contrato_radicado');
        if (rawRadicado) {
          const parsed = JSON.parse(rawRadicado);
          if (!documento) documento = (parsed?.persona?.docu_nro ?? '').toString().trim();
          if (!tipoDocumento) tipoDocumento = (parsed?.persona?.docu_tipo ?? '').toString().trim();
        }
      } catch (_) { }
    }

    if (!tipoDocumento && documento) {
      tipoDocumento = 'NI';
    }

    if (!documento || !tipoDocumento) {
      (this as any)._isColectivoGALoading = false; // Liberar candado si faltan datos
      return;
    }

    this.spinner.show();

    const obtenerCodigoComercialC = (codigo: string): string => {
      const c = (codigo || '').toString().trim().toUpperCase();
      if (c.endsWith('F') || c.endsWith('A')) {
        return c.substring(0, c.length - 1) + 'C';
      }
      return c;
    };

    this.consultarSubcuentasColectivosGruposService.consultarSubcuentasColectivosGrupos({
      documento,
      tipoDocumento,
      evaluador: tipoPlan === 'GA' ? 'AC' : tipoPlan
    }).pipe(
      concatMap((colectivoGA: any) => {
        if (!colectivoGA?.status || !colectivoGA?.data?.length) {
          return of({ colectivoGA, catalogoResp: null });
        }

        this.datosColectivoGA = colectivoGA.data;
        this.cuentaColectivoGA = colectivoGA.data[0]?.cuenta ?? colectivoGA.data[0]?.CUENTA ?? null;

        const uniquePlanes = Array.from(new Set(
          colectivoGA.data.map((r: any) => obtenerCodigoComercialC(r.plan_codi))
        )).filter(Boolean) as string[];

        return this.consultarLineasService.consultarCarnets({
          lineaNegocio: ['MI', 'SAO', 'CEM'],
          tipoPlan: tipoPlan,
          programas: uniquePlanes,
          tipoSolicitud: '3',
          edad: Number(this.edad || 0)
        }).pipe(
          map(catalogoResp => ({ colectivoGA, catalogoResp })),
          catchError(() => of({ colectivoGA, catalogoResp: null }))
        );
      }),
      finalize(() => {
        this.spinner.hide();
        (this as any)._isColectivoGALoading = false;
      })
    ).subscribe({
      next: ({ colectivoGA, catalogoResp }: any) => {
        if (!colectivoGA?.status || !colectivoGA?.data?.length) {
          this.programasDisponibles = [];
          this.programasSeleccionados = [];
          this.cdRef.detectChanges();
          return;
        }

        const carnetImagesMap = new Map<string, string>();
        const carnetsArray = Array.isArray(catalogoResp) ? catalogoResp : (catalogoResp?.data?.data || catalogoResp?.data || []);
        if (Array.isArray(carnetsArray)) {
          carnetsArray.forEach((c: any) => {
            const code = (c?.code || c?.codigo || c?.id || '').toString().trim().toUpperCase();
            if (code && c?.file) carnetImagesMap.set(code, c.file);
          });
        }

        const uniquePlanesMap = new Map<string, any>();
        colectivoGA.data.forEach((row: any) => {
          const planCodi = obtenerCodigoComercialC(row.plan_codi);
          if (planCodi && !uniquePlanesMap.has(planCodi)) uniquePlanesMap.set(planCodi, row);
        });

        this.programasDisponibles = Array.from(uniquePlanesMap.values()).map((row: any) => {
          const planCodi = obtenerCodigoComercialC(row.plan_codi);
          const planDeno = (row.plan_deno || row.PLAN_DENO || planCodi).toString().trim();
          const lineaAsignada = this.mapNumberToLinea(row.linea_negocio, planCodi);

          const grupoPrograma = (
            row?.GRUPO_PROGRAMA ??
            row?.grupo_programa ??
            row?.grupoPrograma ??
            ''
          )
            .toString()
            .trim()
            .toUpperCase();

          return {
            id: planCodi,
            codigo: planCodi,
            nombre: planDeno.toUpperCase(),
            lineaNegocio: lineaAsignada,
            color: this.obtenerColorPorLinea(lineaAsignada),
            imagen: carnetImagesMap.get(planCodi) || '',
            carnet: carnetImagesMap.get(planCodi) || '',
            grupoPrograma,
            requiereAnexos: true
          };
        });

        this.lineasSeleccionadas = Array.from(new Set(this.programasDisponibles.map(p => p.lineaNegocio))) as any;

        let programasPreexistentes: any[] = [];
        const personaData = this.data?.[0];

        const coincideProgramaPrevio = (p: { id: string; nombre: string }, x: any): boolean =>
          this.planGuardadoCoincideConProgramaUi((x?.programa || x?.id || '').toString(), p.id)
          || this.norm(x?.nombre || x?.nombrePrograma) === this.norm(p.nombre);

        if (personaData) {
          programasPreexistentes = personaData?.programasConfig?.programas || [];
        } else if (this.usarProgramasContratante) {
          const desdeDialogo = Array.isArray(this.data?.[3]?.programasContratanteSwitch)
            ? this.data[3].programasContratanteSwitch
            : [];
          const desdeStorage = this.leerProgramasContratanteParaSwitch();
          const listaCoincide = (lista: any[]): boolean =>
            this.programasDisponibles.some(p => lista.some(x => coincideProgramaPrevio(p, x)));
          programasPreexistentes = listaCoincide(desdeDialogo) ? desdeDialogo : desdeStorage;
        }


        if (!personaData && !this.usarProgramasContratante) {
          this.programasSeleccionados = [];
        } else {

          this.programasSeleccionados = this.programasDisponibles
            .filter(p => programasPreexistentes.some(x => coincideProgramaPrevio(p, x)))
            .map(p => {
              const pref = programasPreexistentes.find(x => coincideProgramaPrevio(p, x));
              const filaColectivo = (colectivoGA.data || []).find((r: any) => obtenerCodigoComercialC(r.plan_codi) === p.id);
              const tarifa = (filaColectivo?.tari ?? filaColectivo?.TARI ?? '').toString().trim();
              // alta: heredar negocio del contratante, no ids BD
              const heredarIdsPersistencia = !!personaData;
              
              const tarifaRestaurada = (pref?.tarifa || pref?.nombreTarifa || '').toString().trim();
              
              let tarifaLimpiaParaGuardar = tarifa;
              if (this.usarProgramasContratante && pref?.tarifa) {
                tarifaLimpiaParaGuardar = pref.tarifa.match(/\(([^)]+)\)$/)?.[1]?.trim() || pref.tarifa;
              }
              
              const subctaCodePref = (
                pref?.subcta || pref?.codigoSubcuenta || ''
              ).toString().trim();
              const subcuentaPref = (
                pref?.subcuenta || pref?.nombreSubcuenta || ''
              ).toString().trim();
              // NC 1050: si viene código AFILMED, usarlo para matchear el combo (nombre BD puede ≠ deno).
              const subcuentaInicial = subctaCodePref || subcuentaPref;
              const subctaCandidates = Array.isArray((pref as any)?.__subctaCandidates)
                ? (pref as any).__subctaCandidates
                  .map((c: any) => (c || '').toString().trim())
                  .filter(Boolean)
                : [];

              return {
                id: p.id,
                nombre: p.nombre,
                grupoPrograma:
                  pref?.grupoPrograma ||
                  p.grupoPrograma ||
                  '',
                subcuenta: subcuentaInicial,
                tarifa: tarifaRestaurada,
                campana: (heredarIdsPersistencia || this.usarProgramasContratante)
                  ? (pref?.campana || pref?.campania || '')
                  : '',
                campanaNombre: (heredarIdsPersistencia || this.usarProgramasContratante)
                  ? (pref?.campanaNombre || '')
                  : '',
                tarifaAnexo: pref?.tarifaAnexo || '',
                requiereAnexo: pref?.requiereAnexo || null,
                subcuentasDisponibles: [],
                tarifasDisponibles: [],
                anexosDisponibles: [],
                __tarifaCodigoLimpio: tarifaLimpiaParaGuardar,
                __subctaCodeSeleccionada: subctaCodePref || undefined,
                __subctaCandidates: subctaCandidates.length
                  ? subctaCandidates
                  : (subcuentaInicial ? [subcuentaInicial] : []),
                ...(heredarIdsPersistencia ? {
                  __idBenPrograma: Number(pref?.idBenPrograma || pref?.__idBenPrograma || 0) || undefined,
                  __idSubcuenta: Number(pref?.idSubcuenta || pref?.__idSubcuenta || 0) || undefined,
                  __idCotizacionTarifa: Number(pref?.idCotizacionTarifa || pref?.__idCotizacionTarifa || 0) || undefined,
                  __idCotizacionCampania: Number(pref?.idCotizacionCampania || pref?.__idCotizacionCampania || 0) || undefined,
                } : {}),
                __errors: {}
              };
            });
        }


        this.cdRef.detectChanges();
        this.cargarSubcuentasSiFaltan();

        if (!this.esFlujoColectivoOGA || this.esFlujoInclusion) {
          this.dispararTarifasParaProgramasSeleccionados();
        }
      },
      error: () => this.spinner.hide()
    });
  }


  private cargarProgramasYPreseleccionInclusion(): void {
    let tipoDocumento = '';
    let numeroDocumento = '';
    try {
      const rawContratante = localStorage.getItem('datosRQ002_Contratante');
      if (rawContratante) {
        const datos = JSON.parse(rawContratante);
        tipoDocumento = (datos.tipoDocumento || '').toString().trim();
        numeroDocumento = (datos.numeroDocumento || '').toString().trim();
      }
    } catch (e) {
    }
    if (!tipoDocumento || !numeroDocumento) {
      return;
    }

    // preselección según rol
    let programasPreexistentes: any[] = [];
    const personaData = this.data?.[0];

    if (personaData) {
      // edición: programas propios
      programasPreexistentes = personaData?.programasConfig?.programas || [];
    } else if (this.esUsuario === true) {
      // titular creación
      try {
        const rawProgramas = localStorage.getItem('programas_contratante');
        if (rawProgramas) {
          const parsed = JSON.parse(rawProgramas);
          programasPreexistentes = Array.isArray(parsed) ? parsed : (parsed?.programas || []);
        }
      } catch (e) {
      }
    } else {
      // familiar crear: hereda del contratante
      try {
        const rawProgramas = localStorage.getItem('programas_contratante');
        if (rawProgramas) {
          const parsed = JSON.parse(rawProgramas);
          programasPreexistentes = Array.isArray(parsed) ? parsed : (parsed?.programas || []);
        }
      } catch (e) {
      }
    }

    const tipoPlanActual = (localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();

    let subcuentaContratanteRespaldo = '';
    try {
      const rawProgContratante = localStorage.getItem('programas_contratante');
      if (rawProgContratante) {
        const parsed = JSON.parse(rawProgContratante);
        const list = Array.isArray(parsed) ? parsed : (parsed?.programas || []);
        const foundSub = list.find((x: any) => !!(x.subcuenta || x.subcta));
        subcuentaContratanteRespaldo = foundSub?.subcuenta || foundSub?.subcta || '';
      }
    } catch (e) { }

    this.spinner.show();
    this.consultarProgramasInclusionService.consultarProgramasInclusion(tipoDocumento, numeroDocumento)
      .pipe(
        concatMap((inclusionResp: any) => {
          const rows = inclusionResp?.status && inclusionResp?.data?.jsonRespuesta?.length ? inclusionResp.data.jsonRespuesta : [];
          if (rows.length === 0) return of({ inclusionResp, catalogoResp: null });

          try {
            const listaAutocurada = rows.map((row: any) => {
              const pId = (row?.codigo_plan ?? '').toString().trim().toUpperCase();
              const codTarifa = (row?.tarifa ?? '').toString().trim();
              const nombreTarifa = (row?.nombre_tarifa ?? '').toString().trim();

              const subctaOriginal = (row?.subcuenta ?? '').toString().trim() || subcuentaContratanteRespaldo;

              const codLineaRaw = (row?.cod_linea ?? '').toString().trim().toUpperCase();
              const ln = codLineaRaw === '1' || codLineaRaw === 'MI' || codLineaRaw === 'SMP' ? 'MI' : (codLineaRaw === '2' || codLineaRaw === 'SO' || codLineaRaw === 'SAO' ? 'SAO' : 'CEM');

              let campanaInicial = (row?.campana || row?.campaña || '').toString().trim();
              if (campanaInicial.toLowerCase() === 'null') { campanaInicial = ''; }
              let campanaNombreInicial = row?.nombre_campana || '';
              if (campanaInicial === '999' || campanaInicial.toUpperCase().includes('NO APLICA') || !campanaInicial) {
                campanaInicial = '999';
                campanaNombreInicial = '999 - NO APLICA CAMPAÑA';
              }

              const valBaseRow = Number(row?.valor_mensual_base ?? row?.valor_tari ?? row?.VALOR_TARI ?? row?.valor ?? row?.VALOR ?? 0);
              const valIvaRow = Number(row?.valor_mensual_iva ?? row?.valor_mensual_base ?? valBaseRow);

              return {
                programa: pId,
                lineaNegocio: ln,
                tarifa: nombreTarifa || codTarifa,
                nombreTarifa: nombreTarifa || codTarifa,
                subcuenta: subctaOriginal,
                campana: campanaInicial,
                campanaNombre: campanaNombreInicial,
                tarifaAnexo: row?.tarifaAnexo || '',
                valorMensualBase: valBaseRow > 0 ? valBaseRow : undefined,
                valorMensualIva: valIvaRow > 0 ? valIvaRow : undefined,
                porcentajeIva: row?.porcentaje_iva ? Number(row.porcentaje_iva) : undefined,
                inicioVigencia: row?.inicio_vigencia || undefined,
                finVigencia: row?.fin_vigencia || undefined,
                __tarifaInclusionOriginal: codTarifa,
                __tarifaNombreOriginal: nombreTarifa || codTarifa,
                __subcuentaInclusionOriginal: subctaOriginal
              };
            });

            localStorage.setItem('programas_contratante_inclusiones', JSON.stringify(listaAutocurada));
            localStorage.setItem('programas_contratante_inclusiones_doc', numeroDocumento);
          } catch (errCache) {
          }

          const lineasExtraidas = rows.map((row: any) => {
            const cod = (row?.cod_linea ?? row?.COD_LINEA ?? '').toString().trim().toUpperCase();
            if (cod === '1' || cod === 'MI' || cod === 'SMP') return 'MI';
            if (cod === '2' || cod === 'SO' || cod === 'SAO') return 'SAO';
            return 'CEM';
          });
          const lineasUnicas = [...new Set(lineasExtraidas)].filter(Boolean) as string[];
          const lineasParamDinamicas = lineasUnicas.length ? lineasUnicas : ['MI', 'SAO', 'CEM'];
          const codigosPlanExtraidos = rows.map((r: any) => (r?.codigo_plan ?? '').toString().trim()).filter(Boolean);

          return this.consultarLineasService.consultarCarnets({
            lineaNegocio: lineasParamDinamicas,
            tipoPlan: tipoPlanActual,
            programas: codigosPlanExtraidos,
            tipoSolicitud: '2',
            edad: Number(this.edad || 0)
          }).pipe(
            map((catalogoResp: any) => ({ inclusionResp, catalogoResp }))
          );
        }),
        catchError((err: any) => {
          this.spinner.hide();
          return throwError(() => err);
        }),
        finalize(() => {
          this.spinner.hide();
          (this as any)._isInclusionLoading = false;
        })
      )
      .subscribe({
        next: ({ inclusionResp, catalogoResp }: any) => {
          if (!catalogoResp) {
            this.programasDisponibles = [];
            this.programasSeleccionados = [];
            this.lineasSeleccionadas = [];
            this.cdRef.detectChanges();
            return;
          }
          this.procesarRespuestaInclusionYCatalogo(inclusionResp, catalogoResp, programasPreexistentes);
        }
      });
  }

  private procesarRespuestaInclusionYCatalogo(inclusion: any, catalogo: any, programasPreexistentes: any[]): void {

    const rawDesc = localStorage.getItem('programas_descripciones_inclusion');
    const descripcionesInclusion = rawDesc ? JSON.parse(rawDesc) : {};
    let mapCambiado = false;
    const rows = inclusion?.status && inclusion?.data?.jsonRespuesta?.length ? inclusion.data.jsonRespuesta : [];
    if (rows.length === 0) return;
    const grupoCodToLinea = (codGrupo: string): 'MI' | 'SO' | 'CEM' => {
      const code = codGrupo.toString().trim().toUpperCase();
      if (code === '1' || code === 'MI' || code === 'SMP') return 'MI';
      if (code === '2' || code === 'SO' || code === 'SAO') return 'SO';
      return 'CEM';
    };
    let matched: any[] = [];
    const seen = new Set<string>();
    for (const row of rows) {
      const codPlan = (row?.codigo_plan ?? '').toString().trim().toUpperCase();
      const grupoCod = (row?.cod_linea ?? '').toString().trim();
      if (!codPlan) continue;
      let programa = (catalogo?.data?.data || catalogo?.data || [])
        .find((p: any) => (p?.code ?? p?.codigo ?? '').toString().trim().toUpperCase() === codPlan);
      if (!programa && catalogo?.groups) {
        programa = (catalogo.groups).flatMap((g: any) => g.programas || [])
          .find((p: any) => (p?.codigo ?? '').toString().trim().toUpperCase() === codPlan);
      }
      if (!programa && !this.esFlujoInclusion) continue;
      const gMatch = (catalogo?.grupos || []).find((g: any) => (g.programas || []).some((p: any) => (p?.codigo ?? '').toString().trim().toUpperCase() === codPlan));
      const codigoLinea = gMatch ? grupoCodToLinea((gMatch?.codigo ?? '').toString().trim()) : grupoCodToLinea(grupoCod);
      const key = `${codPlan}:${codigoLinea}`;
      if (seen.has(key)) continue;
      seen.add(key);
      const nombrePlanInclusion = (row?.planes || row?.PLANES || '').toString().trim();
      const nombreResuelto = nombrePlanInclusion || descripcionesInclusion[codPlan] || (programa?.programa || programa?.program || programa?.nombre || codPlan).toString().trim();
      if (descripcionesInclusion[codPlan] !== nombreResuelto) {
        descripcionesInclusion[codPlan] = nombreResuelto;
        mapCambiado = true;
      }
      const programaFinal = programa ? { ...programa, programa: nombreResuelto } : { codigo: codPlan, code: codPlan, programa: nombreResuelto };
      matched.push({ programa: programaFinal, codigoLinea, row });
    }
    if (mapCambiado) {
      localStorage.setItem('programas_descripciones_inclusion', JSON.stringify(descripcionesInclusion));
    }

    if (this.esFlujoInclusion) {
      try {
        const permitidos: string[] = [];
        const rawContratoRadicado = localStorage.getItem('contrato_radicado');

        if (rawContratoRadicado) {
          const parsedRadicado = JSON.parse(rawContratoRadicado);
          const contratoRows = Array.isArray(parsedRadicado?.contrato) ? parsedRadicado.contrato : [];

          contratoRows.forEach((cRow: any) => {
            const planId = (cRow?.cod_programa_afi || cRow?.COD_PROGRAMA_AFI || '').toString().trim().toUpperCase();
            if (planId && !permitidos.includes(planId)) {
              permitidos.push(planId);
            }
          });
        }

        if (permitidos.length > 0) {

          matched = matched.filter((item: any) => {
            const pId = (item.programa?.codigo || item.programa?.code || '').toString().trim().toUpperCase();
            return permitidos.includes(pId);
          });
        }
      } catch (err) {
      }
    }
    this.programasDisponibles = matched.map((item: any) => {
      const pId = (item.programa?.codigo || item.programa?.code || '').toString().trim().toUpperCase();
      const nombreResuelto = descripcionesInclusion[pId] || item.programa?.programa || pId;
      return { id: pId, codigo: pId, nombre: nombreResuelto, lineaNegocio: item.codigoLinea, color: this.obtenerColorPorLinea(item.codigoLinea), imagen: item.programa?.carnet?.file || item.programa?.file || item.programa?.imagen || '', carnet: item.programa?.carnet?.file || item.programa?.file || item.programa?.imagen || '', grupoPrograma: this.codigoGrupoUtil(item.programa?.grupoPrograma || item.programa?.grupo_programa || item.programa?.GRUPO_PROGRAMA), requiereAnexos: true };
    });
    this.lineasSeleccionadas = [...new Set(this.programasDisponibles.map(p => p.lineaNegocio))];

    // subcuenta contratante de respaldo
    let subcuentaContratanteRespaldo = '';
    try {
      const rawProgContratante = localStorage.getItem('programas_contratante');
      if (rawProgContratante) {
        const parsed = JSON.parse(rawProgContratante);
        const list = Array.isArray(parsed) ? parsed : (parsed?.programas || []);
        const foundSub = list.find((x: any) => !!(x.subcuenta || x.subcta));
        subcuentaContratanteRespaldo = foundSub?.subcuenta || foundSub?.subcta || '';
      }
    } catch (e) { }

    const isCreacionBeneficiario = !this.data?.[0] && this.esUsuario !== true;
    const esPrimeraCargaContratante = this.esUsuario === true && !localStorage.getItem('programas_contratante');
    const esEdicionDeFilaReal = this.data?.[0] != null;
    this.programasSeleccionados = matched
      .filter((item: any) => {
        const pId = (item.programa?.codigo || item.programa?.code || '').toString().trim().toUpperCase();

        // Herencia directa (switch ON)
        if (this.esFlujoInclusion && this.usarProgramasContratante) {
          const rawProg = localStorage.getItem('programas_contratante');
          if (!rawProg) return false; // sin datos titular: desmarca

          const arr = JSON.parse(rawProg);
          const programasTitular = (Array.isArray(arr) ? arr : (arr?.programas || []))
            .map((x: any) => (x?.programa || x?.id || '').toString().trim().toUpperCase());

          const match = programasTitular.includes(pId);
          return match;
        }

        // Switch OFF: carga programas propios de BD
        if (esEdicionDeFilaReal) {
          return programasPreexistentes?.some((x: any) => (x.programa || x.id || '').trim().toUpperCase() === pId);
        }

        // Alta / creación
        if (isCreacionBeneficiario || esPrimeraCargaContratante) {
          return true;
        }

        return programasPreexistentes?.some((x: any) => (x.programa || x.id || '').trim().toUpperCase() === pId);
      })
      .map((item: any) => {
        const pId = (item.programa?.codigo || item.programa?.code || '').toString().trim().toUpperCase();
        const pref = programasPreexistentes?.find((x: any) =>
          (x.programa || x.id || x.codigo || '').toString().trim().toUpperCase() === pId
        );
        const codTarifa = (pref?.tarifa || item.row?.tarifa || '').trim();
        const nombreTarifa = item.row?.nombre_tarifa || pref?.nombreTarifa || '';
        let campanaInicial = (
          pref?.campana
          || pref?.campania
          || pref?.campaniaDetalle?.codCampComercial
          || item.row?.campana
          || item.row?.campaña
          || ''
        ).toString().trim();
        if (campanaInicial.toLowerCase() === 'null') {
          campanaInicial = '';
        }
        let campanaNombreInicial = (
          pref?.campanaNombre
          || pref?.campaniaDetalle?.nombreCampania
          || item.row?.nombre_campana
          || ''
        ).toString().trim();

        const vBase = pref?.valorMensualBase ?? item.row?.valor_mensual_base ?? item.row?.VALOR_MENSUAL_BASE ?? item.row?.valorMensualBase ?? undefined;
        const vIva = pref?.valorMensualIva ?? item.row?.valor_mensual_iva ?? item.row?.VALOR_MENSUAL_IVA ?? item.row?.valorMensualIva ?? undefined;
        const pIva = pref?.porcentajeIva ?? item.row?.porcentaje_iva ?? item.row?.PORCENTAJE_IVA ?? item.row?.porcentajeIva ?? undefined;
        const fInicio = pref?.inicioVigencia || item.row?.inicio_vigencia || item.row?.INICIO_VIGENCIA || item.row?.inicioVigencia || undefined;
        const fFin = pref?.finVigencia || item.row?.fin_vigencia || item.row?.FIN_VIGENCIA || item.row?.finVigencia || undefined;

        const subctaOriginal = pref?.subcuenta || item.row?.subcuenta || subcuentaContratanteRespaldo || '';
        const tarifaAnexoEdicion = (
          pref?.tarifaAnexo
          || pref?.anexoCodigo
          || pref?.anexoDetalle?.clave
          || pref?.anexoDetalle?.tari
          || item.row?.tarifaAnexo
          || ''
        ).toString().trim();
        // Alta manual: campaña y anexo los elige el usuario.
        // Con el switch prendido se traen los del contratante, también en el alta.
        const heredarDelContratante = this.esFlujoInclusion && this.usarProgramasContratante === true;
        const vaciarEnAlta = isCreacionBeneficiario && !heredarDelContratante;

        const itemSeleccionado: any = {
          id: pId, nombre: descripcionesInclusion[pId] || item.programa?.programa ||
            pId, subcuenta: subctaOriginal,
          subcuentaDisabled: this.esFlujoInclusion,
          tarifa: nombreTarifa,
          campana: vaciarEnAlta ? '' : campanaInicial,
          campanaNombre: vaciarEnAlta ? '' : campanaNombreInicial,
          tarifaAnexo: vaciarEnAlta ? '' : tarifaAnexoEdicion,
          requiereAnexo: vaciarEnAlta
            ? null
            : this.parseRequiereAnexoValue(
              tarifaAnexoEdicion
                ? 'si'
                : (pref?.requiereAnexo ?? null)
            ),
          subcuentasDisponibles: [],
          tarifasDisponibles: [{
            tarifa: nombreTarifa, descripcion: nombreTarifa, description: nombreTarifa, programa_grupo: pId, codigo_programa_grupo: pId, programa: pId,
            valorMensualBase: vBase ? Number(vBase) : undefined,
            valorMensualIva: vIva ? Number(vIva) : undefined,
            porcentajeIva: pIva ? Number(pIva) : undefined
          }], anexosDisponibles: [], __errors: {}, inicioVigencia: fInicio, finVigencia: fFin, __tarifaInclusionOriginal: codTarifa, __tarifaNombreOriginal: nombreTarifa, __subcuentaInclusionOriginal: subctaOriginal
        };
        // inclusión alta: hereda negocio, no ids BD del titular
        // en edición de fila sí conserva ids propios
        if (this.esFlujoInclusion && pref) {
          // no usar deno/ACEMN; solo subcta corto o numérico
          // el catálogo resuelve el resto
          const prefCode = (pref.subcta || '').toString().trim();
          const prefDeno = (pref.subcuenta || '').toString().trim();
          if (prefCode && prefCode.length <= 4 && (/^\d+$/.test(prefCode) || prefCode.toUpperCase() !== prefDeno.toUpperCase())) {
            itemSeleccionado.__subctaCodeSeleccionada = prefCode;
          } else {
            itemSeleccionado.__subctaCodeSeleccionada = '';
          }
          if (esEdicionDeFilaReal) {
            itemSeleccionado.__idBenPrograma = Number(pref.idBenPrograma || pref.__idBenPrograma || 0) || undefined;
            itemSeleccionado.__idSubcuenta = Number(pref.idSubcuenta || pref.__idSubcuenta || 0) || undefined;
            itemSeleccionado.__idCotizacionTarifa = Number(pref.idCotizacionTarifa || pref.__idCotizacionTarifa || 0) || undefined;
            itemSeleccionado.__idCotizacionTarifaAnexo = Number(pref.idCotizacionTarifaAnexo || pref.__idCotizacionTarifaAnexo || 0) || undefined;
            itemSeleccionado.__idCotizacionCampania = Number(pref.idCotizacionCampania || pref.__idCotizacionCampania || 0) || undefined;
          }
        }
        return itemSeleccionado;
      }) as any;

    if (this.esFlujoInclusion) {
      (this as any)._backupInclusionInicial = JSON.parse(JSON.stringify(this.programasSeleccionados));
    }
    this.form.lineaNegocios.value = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c]).join(', ');
    this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
    this.cargarSubcuentasSiFaltan();
    this.cdRef.detectChanges();
  }
  async cargarResultadosValidacion(): Promise<void> {
    this.historialCliente = [];

    const tipoDoc = (this.form.contratanteTipoDocumento?.value || '').trim();
    const numDoc = (this.form.contratanteDocumento?.value || '').trim();

    if (!tipoDoc || !numDoc) {
      this.SnackBarService.alert('alert-danger', 'Debe ingresar tipo y número de documento.');
      return;
    }

    // cache validaciones beneficiario (o contratante si mismo doc)
    const precargado = this.validacionesBeneficiarioLs.obtenerVistaParaConsulta(tipoDoc, numDoc);
    if (precargado) {
      this.estadoEPS = precargado.estadoEPS;
      this.historialCliente = this.resolverHistorialClienteDesdeCache(
        precargado.historialCliente || [],
        tipoDoc,
        numDoc,
        true
      );
      this.yaConsultoAdres = true;
      this.tabHabilitado.showResultTab = true;
      this.maxStepReached = Math.max(this.maxStepReached, 1);
      this.selectedIndex = 1;
      this.cdRef.detectChanges();
      return;
    }

    try {
      await this.consultarEstadoEPS();
      this.yaConsultoAdres = true;
      this.tabHabilitado.showResultTab = true;
      this.maxStepReached = Math.max(this.maxStepReached, 1);
      this.selectedIndex = 1;
    } catch {
      this.yaConsultoAdres = true;
      this.tabHabilitado.showResultTab = true;
      this.selectedIndex = 1;
    } finally {
      this.spinner.hide();
    }

    this.spinner.show();

    this.consultarHistorialService.consultarHistorial({
      pty_tipo_documento: tipoDoc,
      pty_documento: numDoc
    })
      .pipe(finalize(() => {
        this.spinner.hide();
      }))
      .subscribe({
        next: (resp: any) => {
          if (resp?.status && Array.isArray(resp?.data?.jsonRespuesta) && resp.data.jsonRespuesta.length > 0) {
            const tarjetas = this.mapearHistorialATarjetas(resp.data.jsonRespuesta as HistorialItem[]);
            this.historialCliente = tarjetas.length > 0
              ? tarjetas
              : [{ tipo: 'info', mensaje: this.MENSAJE_SIN_ANTECEDENTES_AFILMED }];
          } else {
            this.historialCliente = [{ tipo: 'info', mensaje: this.MENSAJE_SIN_ANTECEDENTES_AFILMED }];
          }
          this.validacionesBeneficiarioLs.guardarConsulta(
            tipoDoc,
            numDoc,
            this.estadoEPS || [],
            this.historialParaPersistir()
          );
          this.cdRef.detectChanges();
        },
        error: (_err: any) => {
          this.historialCliente = [{
            tipo: 'error',
            mensaje: 'No fue posible consultar el historial en este momento.'
          }];
          this.validacionesBeneficiarioLs.guardarConsulta(
            tipoDoc,
            numDoc,
            this.estadoEPS || [],
            this.historialParaPersistir()
          );
          this.cdRef.detectChanges();
        }
      });
  }

  private cargarAlertaEPSDesdeLocalStorageSiAplica(): void {
    try {
      const rawDatos = localStorage.getItem('datosRQ002_Contratante');
      if (!rawDatos) return;
      const datos = JSON.parse(rawDatos || '{}') as {
        esUsuario?: boolean;
        tipoDocumento?: string;
        numeroDocumento?: string;
      };
      if (datos?.esUsuario !== true) {
        this.alertaEPSBeneficiario = [];
        return;
      }
      const rawVal = localStorage.getItem('validaciones_contratante');
      if (!rawVal) {
        this.alertaEPSBeneficiario = [];
        return;
      }
      const parsed = JSON.parse(rawVal || '{}') as { items?: Array<{ fuente?: string; descripcion?: string; }>; };
      const items = Array.isArray(parsed?.items) ? parsed.items : [];
      const adresMsgs = items
        .filter(i => {
          const fuente = (i?.fuente || '').toUpperCase();
          const desc = (i?.descripcion || '').trim();
          return fuente.includes('ADRES') &&
            desc !== 'No se pudo completar la consulta de EPS.' &&
            !desc.includes('Error en el servicio');
        })
        .map(i => (i?.descripcion || '').trim())
        .filter(Boolean);
      this.alertaEPSBeneficiario = adresMsgs.map(m => {
        const lower = m.toLowerCase();
        const esError = lower.includes('no se encontró') || lower.includes('error') || lower.includes('inactivo');
        return { tipo: esError ? 'error' as const : 'success' as const, mensaje: m };
      });

      if (!this.historialCliente?.length) {
        const tipoDoc = (this.form.contratanteTipoDocumento?.value || datos.tipoDocumento || '').trim();
        const numDoc = (this.form.contratanteDocumento?.value || datos.numeroDocumento || '').trim();
        const historialEnLs = items.some(i => (i?.fuente || '').trim() === 'Historial Afilmed');
        if (tipoDoc && numDoc && !historialEnLs && this.existeConsultaValidacionesEnCache(tipoDoc, numDoc)) {
          this.historialCliente = [{ tipo: 'info', mensaje: this.MENSAJE_SIN_ANTECEDENTES_AFILMED }];
        }
      }
    } catch (e) {
      this.alertaEPSBeneficiario = [];
    }
  }

  private consultarEstadoEPS(): Promise<void> {
    return new Promise((resolve, reject) => {
      const tipoDocumento = this.form.contratanteTipoDocumento.value;
      const numeroDocumento = this.form.contratanteDocumento.value;

      if (!tipoDocumento || !numeroDocumento) {
        this.SnackBarService.alert('alert-danger', 'Debe ingresar tipo y número de documento.');
        return reject();
      }

      this.networking
        .consultarAdres(tipoDocumento, numeroDocumento)
        .subscribe({
          next: (resp: any) => {
            if (resp?.codeStatus === '503' || resp?.message === 'Servicio inactivo' || resp?.errorMessage?.includes('desactivada')) {
              this.estadoEPS = [];
              this.cdRef.detectChanges();
              return resolve();
            }

            if (!resp || !resp.afiliacion) {
              this.estadoEPS = [{ tipo: 'error', mensaje: 'No se encontró información asociada a la EPS del usuario.' }];
              this.cdRef.detectChanges();
              return resolve();
            }

            const a = resp.afiliacion;
            this.estadoEPS = [
              { tipo: 'success', mensaje: `El usuario se encuentra ${a.estado?.toLowerCase() === 'activo' ? 'activo' : 'inactivo'} en ${a.entidad}.` },
              { tipo: 'success', mensaje: `El usuario se encuentra bajo régimen ${a.regimen?.toLowerCase()}.` }
            ];
            this.cdRef.detectChanges();
            resolve();
          },
          error: (err) => {

            const mensaje = this.mapearErrorAdres(err);
            const isHttpError = err?.status === 503 || err?.status === 500 || err?.status === 0 || err?.status === 504;
            const isBodyError = err?.error?.codeStatus === '503' || err?.error?.codeStatus === '500' || err?.error?.message === 'Servicio inactivo';

            if (isHttpError || isBodyError || mensaje === 'No se pudo completar la consulta de EPS.' || mensaje.includes('Error en el servicio')) {
              this.estadoEPS = [];
              this.cdRef.detectChanges();
              return resolve();
            }

            this.estadoEPS = [{ tipo: 'error', mensaje }];
            this.cdRef.detectChanges();
            reject(err);
          }
        });
    });
  }

  private mapearErrorAdres(err: any): string {
    try {
      const be = err?.error;

      if (be?.errorMessage) {
        const match = be.errorMessage.match(/\{\\?"message\\?"\s*:\s*\\?"([^"]+)\\?"\}/);
        if (match && match[1]) {
          return match[1];
        }
        return limpiarTecnico(be.errorMessage);
      }

      if (typeof be?.message === 'string' && be.message.trim().length > 0) {
        return be.message;
      }

      if (err?.status === 404) return 'No existe la persona buscada.';
      if (err?.status === 500) return 'Error en el servicio. Intenta más tarde.';
    } catch (_) { }

    return 'No se pudo completar la consulta de EPS.';

    function limpiarTecnico(texto: string): string {
      if (!texto) return 'Error en el servicio.';
      return texto
        .replace(/https?:\/\/\S+/g, '')
        .replace(/\b\d{3}\s*(OK|Error|Not Found)?\b/gi, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
    }
  }

  ejecutarConsultaBeneficiario() {
    if (!this.isFormValid()) return;
    if (this.validarBeneficiarios()) {
      this.cargarResultadosValidacion();
    } else {
      this.selectedIndex = 0;
    }
  }

  onElegirProgramasClick(): void {
    this.maxStepReached = Math.max(this.maxStepReached, 1);
    this.tabOption(null, 2);
  }

  onToggleUsarProgramasContratante(evt: Event): void {
    this.cacheClavesCampaMap.clear();
    const checked = (evt?.target as HTMLInputElement)?.checked === true;
    this.usarProgramasContratante = checked;

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      this.cargarProgramasYPreseleccionColectivoGA();
      return;
    }

    if (this.esFlujoInclusion) {
      this.cargarProgramasYPreseleccionInclusion();
      return;
    }

    if (!checked) {
      (this as any)._backupVisualProgramasSeleccionados = [...this.programasSeleccionados];
      (this as any)._backupVisualLineasSeleccionadas = [...this.lineasSeleccionadas];

      this.programasSeleccionados = [];
      this.lineasSeleccionadas = [];
      this.form.lineaNegocios.value = '';
      this.form.programa.value = '';
      this.form.tarifa.value = '';
      this.form.campania.value = '';
      this.cdRef.detectChanges();
      return;
    }

    // inclusión: re-encender check = heredar contratante sin red
    if (this.esFlujoInclusion) {
      this.cargarProgramasYPreseleccionInclusion();
      return;
    }

    // venta nueva regular
    const backup = (this as any)._backupVisualProgramasSeleccionados;
    if (backup && backup.length > 0) {
      this.programasSeleccionados = [...backup];
      this.lineasSeleccionadas = Array.from(
        new Set(this.programasSeleccionados.map(p => this.resolveProgramaBase(p)?.lineaNegocio).filter(Boolean))
      ) as any;
      this.form.lineaNegocios.value = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']).join(', ');
      this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
      if (this.programasSeleccionados.length > 0) {
        this.form.tarifa.value = this.programasSeleccionados[0].tarifa;
        this.form.campania.value = this.programasSeleccionados[0].campana;
      }
      this.cargarSubcuentasSiFaltan();
      this.cdRef.detectChanges();
      return;
    }

    this.cargarContextoPlanSolicitudDesdeLocalStorage();
    this.evaluarReglasPlanYSolicitud();
    this.cargarProgramasDesdeLocalStorageDelContratante().then(() => {
      this.cargarContextoPlanSolicitudDesdeLocalStorage();
      this.evaluarReglasPlanYSolicitud();
      this.cdRef.detectChanges();
    });
  }

  private async cargarProgramasDesdeLocalStorageDelContratante(): Promise<void> {
    try {
      const raw = localStorage.getItem('programas_contratante');
      if (!raw) {
        this.SnackBarService.alert('alert-info', 'No hay programas del contratante guardados.');
        return;
      }
      const parsed = JSON.parse(raw);
      const arr = Array.isArray(parsed)
        ? parsed
        : (parsed && typeof parsed === 'object' && Array.isArray((parsed as any).programas))
          ? (parsed as any).programas
          : [];
      if (!Array.isArray(arr) || arr.length === 0) {
        this.SnackBarService.alert('alert-info', 'No hay programas del contratante para cargar.');
        return;
      }
      type ItemProg = {
        lineaNegocio?: 'MI' | 'SO' | 'CEM' | string;
        programa?: string;
        subcuenta?: string;
        tarifa?: string;
        campana?: string;
        campanaNombre?: string;
        grupo?: string;
        requiereAnexo?: 'si' | 'no' | string;
        anexoCodigo?: string;
        tarifaAnexo?: string;
        anexoDetalle?: any;
        nombreTarifa?: string;
        valorMensualBase?: number;
        valorMensualIva?: number;
        porcentajeIva?: number;
        esTarifaAsociado?: boolean;
      };
      const items: ItemProg[] = arr
        .map((it: any) => ({
          lineaNegocio: this.nombreToCodigoLinea((it?.lineaNegocio || '').toString().trim()) || '',
          programa: (it?.programa || '').toString().trim(),
          subcuenta: (it?.subcuenta || '').toString().trim(),
          tarifa: (it?.tarifa || '').toString().trim(),
          campana: (it?.campana || it?.campania || it?.campanaNombre || '').toString().trim(),
          campanaNombre: (it?.campanaNombre || '').toString().trim(),
          grupo: (it?.grupo || '').toString().trim(),
          requiereAnexo: (it?.requiereAnexo || '').toString().trim().toLowerCase(),
          anexoCodigo: (it?.anexoCodigo || '').toString().trim(),
          tarifaAnexo: (it?.tarifaAnexo || '').toString().trim(),
          anexoDetalle: (it as any)?.anexoDetalle ?? null,

          nombreTarifa: it.nombreTarifa || it.tarifaDetalle?.nombreTarifa || '',
          valorMensualBase: it.valorMensualBase ?? it.tarifaDetalle?.valorMensualBase ?? undefined,
          valorMensualIva: it.valorMensualIva ?? it.tarifaDetalle?.valorMensualIva ?? undefined,
          porcentajeIva: it.porcentajeIva ?? it.tarifaDetalle?.porcentajeIva ?? undefined,
          esTarifaAsociado: it.esTarifaAsociado ?? it.tarifaDetalle?.esTarifaAsociado ?? false
        }))
        .filter(it => it.lineaNegocio && it.programa);

      if (items.length === 0) {
        this.SnackBarService.alert('alert-info', 'Los programas guardados no tienen datos suficientes para precargar.');
        return;
      }

      await this.esperarLineasDisponibles();
      const lineasUnicas = Array.from(
        new Set(
          items
            .map(i => i.lineaNegocio)
            .filter((linea): linea is 'MI' | 'SO' | 'CEM' => linea === 'MI' || linea === 'SO' || linea === 'CEM')
        )
      );
      await this.cargarProgramasFaltantesPorLineas(lineasUnicas);

      this.lineasSeleccionadas = [...lineasUnicas];
      this.programasSeleccionados = [];
      this.listDataCampania = [];
      this.campaniasConsultaRealizadaPorPrograma = {};

      items.forEach((it) => {
        const base = this.programasDisponibles.find(p => this.norm(p.codigo) === this.norm(it.programa) || this.norm(p.id) === this.norm(it.programa));
        if (!base) return;

        const SkinTarifaLimpia = (it.tarifa || '').trim();

        if (!this.programasSeleccionados.some(s => this.norm(s.id) === this.norm(base.id))) {
          const nuevoItem: any = {
            id: base.id,
            nombre: base.nombre,
            subcuenta: it.subcuenta || '',
            tarifa: SkinTarifaLimpia,
            campana: it.campana || '',
            campanaNombre: it.campanaNombre || '',
            requiereAnexo: it.requiereAnexo === 'si' ? 'si' : (it.requiereAnexo === 'no' ? 'no' : null),
            tarifaAnexo: it.anexoCodigo || it.tarifaAnexo || '',
            subcuentasDisponibles: [],
            tarifasDisponibles: this.esFlujoInclusion && SkinTarifaLimpia ? [{
              tarifa: SkinTarifaLimpia,
              descripcion: it.nombreTarifa || SkinTarifaLimpia,
              description: it.nombreTarifa || SkinTarifaLimpia,
              programa_grupo: base.id,
              codigo_programa_grupo: base.id,
              programa: base.id,
              valorMensualBase: it.valorMensualBase,
              valorMensualIva: it.valorMensualIva,
              porcentajeIva: it.porcentajeIva,
              esTarifaAsociado: it.esTarifaAsociado
            }] : []
          };

          // ids solo si editamos la misma fila
          if (this.esFlujoInclusion && this.data?.[0] != null && (it as any).idBenPrograma) {
            nuevoItem.__idBenPrograma = (it as any).idBenPrograma;
            nuevoItem.__idSubcuenta = (it as any).idSubcuenta;
            nuevoItem.__idCotizacionTarifa = (it as any).idCotizacionTarifa;
            nuevoItem.__idCotizacionTarifaAnexo = (it as any).idCotizacionTarifaAnexo;
            nuevoItem.__idCotizacionCampania = (it as any).idCotizacionCampania;

          }

          this.programasSeleccionados.push(nuevoItem);
        } else {
          const sel = this.programasSeleccionados.find(s => this.norm(s.id) === this.norm(base.id));
          if (sel) {
            if ((it.subcuenta || '').trim()) sel.subcuenta = it.subcuenta!;
            if (SkinTarifaLimpia) {
              sel.tarifa = SkinTarifaLimpia;
              if (this.esFlujoInclusion) {
                sel.tarifasDisponibles = [{
                  tarifa: SkinTarifaLimpia,
                  descripcion: it.nombreTarifa || SkinTarifaLimpia,
                  description: it.nombreTarifa || SkinTarifaLimpia,
                  programa_grupo: base.id,
                  codigo_programa_grupo: base.id,
                  programa: base.id,
                  valorMensualBase: it.valorMensualBase,
                  valorMensualIva: it.valorMensualIva,
                  porcentajeIva: it.porcentajeIva,
                  esTarifaAsociado: it.esTarifaAsociado
                }];
              }
            }
            if ((it.campana || '').trim()) sel.campana = it.campana!;
            if ((it.campanaNombre || '').trim()) sel.campanaNombre = it.campanaNombre!;
            if (it.requiereAnexo === 'si' || it.requiereAnexo === 'no') sel.requiereAnexo = it.requiereAnexo;
            if ((it.anexoCodigo || '').trim()) sel.tarifaAnexo = it.anexoCodigo!;
            else if ((it.tarifaAnexo || '').trim()) sel.tarifaAnexo = it.tarifaAnexo!;

            if (this.esFlujoInclusion && (it as any).idBenPrograma) {
              (sel as any).__idBenPrograma = (it as any).idBenPrograma;
              (sel as any).__idSubcuenta = (it as any).idSubcuenta;
              (sel as any).__idCotizacionTarifa = (it as any).idCotizacionTarifa;
              (sel as any).__idCotizacionTarifaAnexo = (it as any).idCotizacionTarifaAnexo;
              (sel as any).__idCotizacionCampania = (it as any).idCotizacionCampania;
            }
          }
        }
      });
      const nombresLineas = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c]);
      this.form.lineaNegocios.value = nombresLineas.join(', ');
      this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
      this.cargarSubcuentasSiFaltan();
      this.cdRef.detectChanges();
    } catch (e) {
      this.SnackBarService.alert('alert-danger', 'No fue posible cargar los programas del contratante.');
    }
  }

  private aplicarAutocargaProgramasContratanteSiCorresponde(): void {
    if (this._autocargaProgramasContratanteAplicada) return;
    if (this.esUsuario !== true) return;
    if (this.usarProgramasContratante !== true) return;

    this._autocargaProgramasContratanteAplicada = true;

    this.cargarProgramasDesdeLocalStorageDelContratante().then(() => {
      this.cargarContextoPlanSolicitudDesdeLocalStorage();
      this.evaluarReglasPlanYSolicitud();
      this.cdRef.detectChanges();
    });
  }

  private async esperarLineasDisponibles(): Promise<void> {
    if (Array.isArray(this.lineasNegocioDisponibles) && this.lineasNegocioDisponibles.length > 0) return;
    const maxWaitMs = 3000;
    const step = 150;
    let waited = 0;
    while (waited < maxWaitMs) {
      await new Promise(r => setTimeout(r, step));
      waited += step;
      if (Array.isArray(this.lineasNegocioDisponibles) && this.lineasNegocioDisponibles.length > 0) return;
    }
  }

  private async cargarProgramasFaltantesPorLineas(lineas: ('MI' | 'SO' | 'CEM')[]): Promise<void> {
    const pendientes: ('MI' | 'SO' | 'CEM')[] = [];
    lineas.forEach(cod => {
      const yaHay = this.programasDisponibles.some(p => p.lineaNegocio === cod);
      if (!yaHay) pendientes.push(cod);
    });
    if (pendientes.length === 0) return;

    const tareas = pendientes.map(codLinea => {
      const ln = this.lineasNegocioDisponibles.find(l => l.codigo === codLinea);

      const idLineaGenuino = ln ? ln.lineaOriginal.cod : this.mapLineaToNumber(codLinea);

      return new Promise<void>((resolve) => {
        this.spinner.show();
        const tipoPlanActual = (localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();
        this.consultarLineasService.consultarProgramasCompletosPorParametroPorLinea(idLineaGenuino, false, tipoPlanActual, Number(this.edad || 0))
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe({
            next: (response: any) => {
              const nuevos: Programa[] = [];
              response.grupos.forEach((grupo: any) => {
                (grupo.programas || []).forEach((pg: any) => {
                  const p: Programa = {
                    id: pg.codigo.trim(),
                    codigo: pg.codigo.trim(),
                    nombre: pg.programa,
                    lineaNegocio: codLinea,
                    color: this.obtenerColorPorLinea(codLinea),
                    imagen: pg.carnet?.file,
                    carnet: pg.carnet?.file,
                    grupoPrograma: grupo.codigo,
                    requiereAnexos: true,
                  };
                  nuevos.push(p);
                });
              });
              const existentes = new Set(this.programasDisponibles.map(p => p.id));
              const soloNuevos = nuevos.filter(p => !existentes.has(p.id));
              this.programasDisponibles = [...this.programasDisponibles, ...soloNuevos];
              resolve();
            },
            error: _ => resolve()
          });
      });
    });

    await Promise.all(tareas);
  }

  private mergeUnicos<T>(base: T[], add: T[]): T[] {
    const set = new Set(base);
    add.forEach(x => set.add(x));
    return Array.from(set);
  }

  cargarLineasNegocio(): void {
    this.spinner.show();
    this.consultarLineasService.consultarLineasNegocio()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (response) => {
          if (response.status && response.data?.jsonRespuesta) {
            this.lineasNegocioDisponibles = response.data.jsonRespuesta
              .filter(linea => linea.baja_fecha === null)
              .map(linea => {
                let codigo: 'MI' | 'SO' | 'CEM' = 'MI';

                const partes = linea.linea_negocio.split('-');
                const nombre = partes.length > 1 ? partes.slice(1).join('-').trim() : linea.linea_negocio;

                if (linea.linea_negocio.startsWith('SMP') || linea.linea_negocio.includes('MEDICINA')) {
                  codigo = 'MI';
                } else if (linea.linea_negocio.startsWith('SAO') || linea.linea_negocio.includes('SALUD ORAL')) {
                  codigo = 'SO';
                } else if (linea.linea_negocio.startsWith('CEM') || linea.linea_negocio.includes('EMERGENCIA')) {
                  codigo = 'CEM';
                }

                return {
                  codigo: codigo,
                  nombre: nombre,
                  lineaOriginal: linea
                };
              })
              .filter((linea, index, self) =>
                index === self.findIndex(l => l.codigo === linea.codigo)
              );
          }
        },
        error: (error) => {
        }
      });
  }

  nombreToCodigoLinea(nombre: string): 'MI' | 'SO' | 'CEM' | null {
    const n = this.norm(nombre);

    if (n === 'MI' || n === 'SO' || n === 'CEM') return n as 'MI' | 'SO' | 'CEM';
    if (n === 'SAO') return 'SO';

    const mapEntries = Object.entries(this.LINEA_MAP) as Array<['MI' | 'SO' | 'CEM', string]>;
    const foundExact = mapEntries.find(([code, nom]) => this.norm(nom) === n);
    if (foundExact) return foundExact[0];
    if (n.includes('MEDICINA')) return 'MI';
    if (n.includes('SALUD ORAL')) return 'SO';
    if (n.includes('EMERGENCIA') || n.includes('CEM')) return 'CEM';

    return null;
  }

  toggleLinea(linea: 'MI' | 'SO' | 'CEM'): void {
    const index = this.lineasSeleccionadas.indexOf(linea);
    if (index >= 0) {
      this.lineasSeleccionadas.splice(index, 1);
      // al quitar línea: limpia programas/tarifas/anexos/campañas de esa línea
      this.limpiarSeleccionPorLinea(linea);
    } else {
      this.lineasSeleccionadas.push(linea);

      if (this.esFlujoColectivoOGA || this.esFlujoInclusion) {
        this.sincronizarFormCamposPrograma();
        this.cdRef.detectChanges();
        return;
      }

      const lineaDisponible = this.lineasNegocioDisponibles.find(l => l.codigo === linea);
      if (lineaDisponible && lineaDisponible.lineaOriginal) {
        const codigoLinea = lineaDisponible.lineaOriginal.cod;
        this.cargarProgramasPorLinea(codigoLinea, linea);
      }
    }
    this.sincronizarFormCamposPrograma();
    this.cdRef.detectChanges();
  }

  /** Quita programas de una línea (subcuenta/tarifas/anexos/campañas van con el ítem) */
  private limpiarSeleccionPorLinea(linea: 'MI' | 'SO' | 'CEM'): void {
    const idsDeLinea = new Set(
      (this.programasDisponibles || [])
        .filter(p => p.lineaNegocio === linea)
        .map(p => this.norm(p.id))
    );

    const removidos = (this.programasSeleccionados || []).filter(ps => {
      if (idsDeLinea.has(this.norm(ps.id))) return true;
      return this.resolveProgramaBase(ps)?.lineaNegocio === linea;
    });

    if (!removidos.length) return;

    const idsRemovidos = new Set(removidos.map(ps => ps.id));
    this.programasSeleccionados = this.programasSeleccionados.filter(ps => !idsRemovidos.has(ps.id));

    for (const ps of removidos) {
      this.cacheClavesCampaMap.delete(ps.id);
      this.mapaDenoALabelPorPrograma.delete(ps.id);
      if (this.campaniasConsultaRealizadaPorPrograma) {
        this.campaniasConsultaRealizadaPorPrograma[ps.id] = false;
      }
    }

    if (linea === 'CEM' && !this.anyCemFullSelected()) {
      this.coberturaCemValida = false;
    }
  }

  private sincronizarFormCamposPrograma(): void {
    this.form.lineaNegocios.value = (this.lineasSeleccionadas || [])
      .map(c => this.LINEA_MAP[c])
      .join(', ');
    this.form.programa.value = (this.programasSeleccionados || []).map(p => p.id).join(', ');

    if (!this.programasSeleccionados?.length) {
      this.form.tarifa.value = '';
      this.form.campania.value = '';
      return;
    }

    this.form.tarifa.value = this.programasSeleccionados[0].tarifa || '';
    this.form.campania.value = this.programasSeleccionados[0].campana || '';
  }

  esLineaSeleccionada(linea: 'MI' | 'SO' | 'CEM'): boolean {
    return this.lineasSeleccionadas.includes(linea);
  }

  get programasAgrupadosPorLinea(): { linea: 'MI' | 'SO' | 'CEM', nombre: string, programas: Programa[]; }[] {
    const grupos: { linea: 'MI' | 'SO' | 'CEM', nombre: string, programas: Programa[]; }[] = [];

    this.lineasNegocioDisponibles.forEach(lineaDisponible => {
      if (this.lineasSeleccionadas.includes(lineaDisponible.codigo)) {
        const programas = this.programasDisponibles.filter(p => p.lineaNegocio === lineaDisponible.codigo);
        if (programas.length > 0) {
          grupos.push({
            linea: lineaDisponible.codigo,
            nombre: lineaDisponible.nombre,
            programas: programas
          });
        }
      }
    });

    return grupos;
  }

  public get hayLineasSeleccionadas(): boolean {
    return Array.isArray(this.lineasSeleccionadas) && this.lineasSeleccionadas.length > 0;
  }

  esProgramaSeleccionado(programaId: string): boolean {
    const pid = this.norm(programaId);
    return this.programasSeleccionados.some(sel => this.norm(sel.id) === pid);
  }

  trackByProgramaId(_: number, p: { id: string; }): string {
    return p.id;
  }

  private cargarContextoPlanSolicitudDesdeLocalStorage(): void {
    try {
      this.tipoPlanLS = (localStorage.getItem('tipoPlan') || '').toUpperCase().trim() || null;
      this.tipoSolicitudLS = (localStorage.getItem('tipoSolicitud') || '').toString().trim() || null;
    } catch {
      this.tipoPlanLS = null;
      this.tipoSolicitudLS = null;
    }
  }

  private evaluarReglasPlanYSolicitud(): void {
    const plan = this.normTxt(this.tipoPlanLS || localStorage.getItem('tipoPlan') || '');
    const sol = (this.tipoSolicitudLS || localStorage.getItem('tipoSolicitud') || '').toString().trim();

    const esColectivo = this.isPlanColectivo(plan);
    const esAfinidad = this.isPlanAfinidad(plan);
    const esFamAsocEmp = this.isPlanFamiliarAsocEmp(plan);
    const esVN_IN = this.isSolicitudVN_IN(sol);

    if (esVN_IN) {
      if (esColectivo || esAfinidad) {
        this.debeMostrarSubcuenta = true;
      } else if (esFamAsocEmp) {
        this.debeMostrarSubcuenta = false;
      } else {
        this.debeMostrarSubcuenta = false;
      }
    } else {
      this.debeMostrarSubcuenta = (esColectivo || esAfinidad);
    }

    if (!this.debeMostrarSubcuenta) {
      (this.programasSeleccionados || []).forEach(ps => {
        ps.subcuenta = '';
      });
    }

    this.cdRef.detectChanges();
  }

  toggleProgramaSeleccion(programa: Programa): void {
    const index = this.programasSeleccionados.findIndex(p => p.id === programa.id);
    if (index >= 0) {
      this.programasSeleccionados.splice(index, 1);
      this.cacheClavesCampaMap.delete(programa.id);
      if (this.campaniasConsultaRealizadaPorPrograma) {
        this.campaniasConsultaRealizadaPorPrograma[programa.id] = false;
      }
      this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
      if (this.programasSeleccionados.length === 0) {
        this.form.tarifa.value = '';
        this.form.campania.value = '';
      }
      this.cdRef.detectChanges();
      return;
    }

    let hitPref: any = null;
    let tarifaInicial = '';
    let tarifasDisponiblesInicial: any[] = [];
    let campanaInicial = '';
    let campanaNombreInicial = '';
    let subcuentaInicial = '';
    let subcuentasDisponiblesInicial: any[] = [];
    let campaniasDisponiblesInicial: any[] = [];
    let anexosDisponiblesInicial: any[] = [];

    if (this.esFlujoInclusion) {
      try {
        const targetId = (programa.id || '').toString().trim().toUpperCase();

        // 1) respaldo en memoria (match estricto)
        const backupInclusion = (this as any)._backupInclusionInicial ?? [];
        hitPref = backupInclusion.find((x: any) => {
          const cId = (x.programa || x.id || '').toString().trim().toUpperCase();
          return cId === targetId;
        });

        // 2) config previa de la fila
        if (!hitPref) {
          const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
          hitPref = prevCfg.find((x: any) => {
            const cId = (x.programa || x.id || '').toString().trim().toUpperCase();
            return cId === targetId;
          });
        }

        // 3) portafolio maestro inclusiones
        if (!hitPref) {
          const rawInclusiones = localStorage.getItem('programas_contratante_inclusiones');
          const listaInclusiones = rawInclusiones ? JSON.parse(rawInclusiones) : [];
          hitPref = listaInclusiones?.find((x: any) => {
            const cId = (x.programa || x.id || '').toString().trim().toUpperCase();
            return cId === targetId;
          });
        }

        if (hitPref) {
          tarifaInicial = hitPref.tarifa ? String(hitPref.tarifa).trim() : '';
          let nomTar = hitPref.nombre_tarifa || hitPref.nombreTarifa || hitPref.tarifasDisponibles?.[0]?.descripcion || hitPref.tarifasDisponibles?.[0]?.description || tarifaInicial;
          if (tarifaInicial && nomTar && !String(nomTar).includes('(') && nomTar !== tarifaInicial) {
            nomTar = `${tarifaInicial} (${nomTar})`;
          }
          const campanaRaw = hitPref.campana || hitPref.campaña || '';
          const campanaClean = campanaRaw != null ? String(campanaRaw).trim() : '';
          if (campanaClean === '999' || campanaClean.toUpperCase().includes('NO APLICA') || campanaClean === '' || campanaClean.toLowerCase() === 'null') {
            campanaInicial = '999';
            campanaNombreInicial = '999 - NO APLICA CAMPAÑA';
          } else {
            campanaInicial = campanaClean;
            campanaNombreInicial = hitPref.campanaNombre || hitPref.nombre_campana || campanaInicial;
          }
          if (typeof campanaNombreInicial === 'string' && campanaNombreInicial.endsWith(' - NINGUNA')) {
            campanaNombreInicial = campanaNombreInicial.replace(' - NINGUNA', '');
          }
          subcuentaInicial = hitPref.subcuenta || hitPref.subcta || '';

          const vBase = hitPref.valorMensualBase ?? hitPref.tarifaDetalle?.valorMensualBase ?? undefined;
          const vIva = hitPref.valorMensualIva ?? hitPref.tarifaDetalle?.valorMensualIva ?? undefined;
          const pIva = hitPref.porcentajeIva ?? hitPref.tarifaDetalle?.porcentajeIva ?? undefined;

          if (Array.isArray(hitPref.tarifasDisponibles) && hitPref.tarifasDisponibles.length > 0) {
            tarifasDisponiblesInicial = JSON.parse(JSON.stringify(hitPref.tarifasDisponibles));
            tarifasDisponiblesInicial.forEach(t => {
              if (t.valorMensualBase === undefined && vBase !== undefined) t.valorMensualBase = vBase;
              if (t.valorMensualIva === undefined && vIva !== undefined) t.valorMensualIva = vIva;
              if (t.porcentajeIva === undefined && pIva !== undefined) t.porcentajeIva = pIva;
            });
          } else if (tarifaInicial) {
            tarifasDisponiblesInicial = [{
              tarifa: tarifaInicial,
              descripcion: nomTar,
              description: nomTar,
              programa_grupo: programa.id,
              codigo_programa_grupo: programa.id,
              programa: programa.id,
              valorMensualBase: vBase ? Number(vBase) : undefined,
              valorMensualIva: vIva ? Number(vIva) : undefined,
              porcentajeIva: pIva ? Number(pIva) : undefined
            }];
          }
          if (Array.isArray(hitPref.subcuentasDisponibles)) {
            subcuentasDisponiblesInicial = JSON.parse(JSON.stringify(hitPref.subcuentasDisponibles));
          }
          if (Array.isArray((hitPref as any).campaniasDisponibles)) {
            campaniasDisponiblesInicial = JSON.parse(JSON.stringify((hitPref as any).campaniasDisponibles));
          }
          if (Array.isArray(hitPref.anexosDisponibles)) {
            anexosDisponiblesInicial = JSON.parse(JSON.stringify(hitPref.anexosDisponibles));
          }
        }
      } catch (e) {
      }
    }

    const nuevoPrograma: ProgramaSeleccionado = {
      id: programa.id,
      nombre: programa.nombre,
      grupoPrograma: programa.grupoPrograma || '',
      subcuenta: subcuentaInicial,
      tarifa: tarifaInicial,
      campana: campanaInicial,
      campanaNombre: campanaNombreInicial,
      subcuentasDisponibles: subcuentasDisponiblesInicial,
      tarifasDisponibles: tarifasDisponiblesInicial,
      tarifasConsultaRealizada: this.esFlujoInclusion,
      anexosDisponibles: anexosDisponiblesInicial,
      __errors: {}
    };

    if (this.esFlujoInclusion) {
      (nuevoPrograma as any).campaniasDisponibles = campaniasDisponiblesInicial;
      (nuevoPrograma as any).campaniasConsultaRealizada = this.esFlujoInclusion;

      const poolConFechas = this.programasSeleccionados.find(x => (x as any).inicioVigencia) ||
        ((this as any)._backupInclusionInicial || []).find((x: any) => x.inicioVigencia);

      (nuevoPrograma as any).inicioVigencia = (hitPref as any)?.inicioVigencia || (poolConFechas as any)?.inicioVigencia || undefined;
      (nuevoPrograma as any).finVigencia = (hitPref as any)?.finVigencia || (poolConFechas as any)?.finVigencia || undefined;

      (nuevoPrograma as any).valorMensualBase = hitPref?.valorMensualBase ?? hitPref?.tarifaDetalle?.valorMensualBase;
      (nuevoPrograma as any).valorMensualIva = hitPref?.valorMensualIva ?? hitPref?.tarifaDetalle?.valorMensualIva;
      (nuevoPrograma as any).porcentajeIva = hitPref?.porcentajeIva ?? hitPref?.tarifaDetalle?.porcentajeIva;
      (nuevoPrograma as any).__tarifaInclusionOriginal = hitPref?.__tarifaInclusionOriginal || (tarifaInicial.includes(' - ') ? tarifaInicial.split(' - ')[0].trim() : tarifaInicial);
      (nuevoPrograma as any).__tarifaNombreOriginal = hitPref?.__tarifaNombreOriginal || hitPref?.nombreTarifa || hitPref?.tarifa || tarifaInicial;
      (nuevoPrograma as any).__subcuentaInclusionOriginal = hitPref?.__subcuentaInclusionOriginal || subcuentaInicial;
    }
    this.programasSeleccionados.push(nuevoPrograma);
    this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');

    if (this.esFlujoInclusion && tarifaInicial) {
      this.form.tarifa.value = tarifaInicial;
      this.form.campania.value = campanaInicial || campanaNombreInicial;
    }

    const base = this.programasDisponibles.find(p => p.id === programa.id);
    if (!base) return;
    if (this.shouldActualizarSubcuentas() || this.esFlujoInclusion) {
      this.cargarSubcuentasOrquestado(nuevoPrograma, base);
    } else {
      this.buscarTarifa(nuevoPrograma);
      this.bucarCampa();
      if (this.usarTarifaColectivaPorTipoPlan()) {
        this.consultarAnexosParaPrograma(nuevoPrograma);
      }
    }
    // colectivo/GA: anexos cuando ya hay subcuenta
    this.cdRef.detectChanges();
  }

  toggleAnexo(an: any, checked: boolean): void {
    if (checked) {
      if (!this.anexosSeleccionados.some(x => x.id === an.id)) {
        this.anexosSeleccionados = [...this.anexosSeleccionados, an];
      }
    } else {
      this.anexosSeleccionados = this.anexosSeleccionados.filter(x => x.id !== an.id);
    }
    this.cdRef.detectChanges();
  }

  isAnexoChecked(an: any): boolean {
    return (this.anexosSeleccionados?.some(x => x?.id === an?.id)) ?? false;
  }

  onAnexoCheckboxChange(an: any, checked: boolean): void {
    if (checked) {
      if (!this.anexosSeleccionados.some(x => x?.id === an?.id)) {
        this.anexosSeleccionados = [...this.anexosSeleccionados, an];
      }
    } else {
      this.anexosSeleccionados = this.anexosSeleccionados.filter(x => x?.id !== an?.id);
    }
    this.cdRef?.detectChanges();
  }

  trackByAnexoId(_i: number, an: any): string {
    return (an?.id ?? _i).toString();
  }

  private esPlanColectivoActual(): boolean {
    const plan = (this.tipoPlanLS || localStorage.getItem('tipoPlan') || '').toUpperCase().trim();
    return plan === 'C' || plan === 'CY' || plan.includes('COLECTIV');
  }

  private cargarSubcuentasOrquestado(
    programaSel: ProgramaSeleccionado,
    basePrograma: { id: string; codigo: string; nombre: string; lineaNegocio: 'MI' | 'SO' | 'CEM'; },
    preservarValores = false
  ): void {
    let tipoDoc = (this.form.contratanteTipoDocumento.value || '').trim();
    let numDoc = (this.form.contratanteDocumento.value || '').trim();

    if (this.esFlujoInclusion) {
      try {
        const rawContrato = localStorage.getItem('contrato_radicado');
        if (rawContrato) {
          const parsed = JSON.parse(rawContrato);
          const tDocTitular = (parsed.tipoDocumento || parsed.tipo_documento || '').toString().trim();
          const nDocTitular = (parsed.numeroDocumento || parsed.num_documento || '').toString().trim();
          if (tDocTitular && nDocTitular) {
            tipoDoc = tDocTitular;
            numDoc = nDocTitular;
          }
        }
      } catch (e) {
      }
    }
    const programaCodigo = (basePrograma?.codigo || basePrograma?.id || '').trim();
    if (!programaSel || !programaCodigo) return;

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const cuentaActual =
        this.cuentaColectivoGA != null
          ? String(this.cuentaColectivoGA).trim()
          : '';

      const filaPlanActivo = (
        this.datosColectivoGA || []
      ).find((fila: any) => {
        const filaPlan = String(
          fila?.plan_codi ??
          fila?.PLAN_CODI ??
          ''
        ).trim().toUpperCase();

        const filaCuenta = String(
          fila?.cuenta ??
          fila?.CUENTA ??
          ''
        ).trim();

        const coincidePlan = this.coincidePlanCodiAfinidad(
          filaPlan,
          programaCodigo
        );

        return (
          coincidePlan &&
          (!cuentaActual || filaCuenta === cuentaActual)
        );
      });

      const planCodigoConsulta = String(
        filaPlanActivo?.plan_codi ??
        filaPlanActivo?.PLAN_CODI ??
        programaCodigo
      ).trim().toUpperCase();

      this.networking
        .getSubcuentasConColectivoPrimero(planCodigoConsulta, tipoDoc, numDoc, true)
        .subscribe({
          next: ({ rawIndividual }) => {
            const sel = this.programasSeleccionados.find(p => p.id === programaSel.id);
            if (!sel) return;

            const rows = rawIndividual || [];
            (sel as any).__subcuentasRaw = rows;
            let filtradas = this.filtrarSubcuentasColectivoGA(programaCodigo, rows);

            // no fusionar subcuentas distintas con mismo deno
            const seenSub = new Set<string>();
            filtradas = (filtradas || []).filter((r: any) => {
              const subCode = (r.subcta ?? r.SUBCTA ?? '').toString().trim();
              if (!subCode || seenSub.has(subCode)) return false;
              seenSub.add(subCode);
              return true;
            });

            const denoCount = new Map<string, number>();
            filtradas.forEach((r: any) => {
              const denoName = (r.deno || '').toString().trim();
              if (denoName) denoCount.set(denoName, (denoCount.get(denoName) || 0) + 1);
            });

            const optionKeyOf = (r: any): string => {
              const denoName = (r.deno || '').toString().trim();
              const subCode = (r.subcta ?? r.SUBCTA ?? '').toString().trim();
              if (!denoName) return '';
              if (subCode && (denoCount.get(denoName) || 0) > 1) {
                return `${denoName}||${subCode}`;
              }
              return denoName;
            };

            const denos = Array.from(new Set(filtradas.map(optionKeyOf))).filter(Boolean);
            sel.subcuentasDisponibles = denos;

            const mapDenoToCode = new Map<string, string>();
            const mapDenoAPlanGrupo = new Map<string, string>();
            const mapDenoALabel = new Map<string, string>();

            filtradas.forEach((r: any) => {
              const subCode = (r.subcta ?? r.SUBCTA ?? '').toString().trim();
              const denoName = (r.deno || '').toString().trim();
              const planGrupo = (r.plan_grupo || '').toString().trim();
              const optionKey = optionKeyOf(r);

              if (optionKey && subCode) {
                mapDenoToCode.set(optionKey.toUpperCase(), subCode);
                mapDenoToCode.set(subCode.toUpperCase(), subCode);
                if (planGrupo) mapDenoAPlanGrupo.set(optionKey.toUpperCase(), planGrupo);
                mapDenoALabel.set(optionKey, `${planCodigoConsulta} (ID:${subCode} - ${denoName})`);
              }
            });

            (sel as any).__mapDenoToCode = mapDenoToCode;
            (sel as any).__mapDenoAPlanGrupo = mapDenoAPlanGrupo;
            this.mapaDenoALabelPorPrograma.set(sel.id, mapDenoALabel);

            const candidateValues = [
              sel.subcuenta,
              (sel as any).__subctaCodeSeleccionada,
              (sel as any).subcta,
              ...((Array.isArray((sel as any).__subctaCandidates)
                ? (sel as any).__subctaCandidates
                : []) as any[]),
            ]
              .map((v) => (v || '').toString().trim().toUpperCase())
              .filter(Boolean)
              .filter((v, idx, arr) => arr.indexOf(v) === idx);

            // Recorre candidatos en orden (más reciente primero) hasta hallar uno en el catálogo.
            let hitSubcuenta: any = null;
            for (const candidate of candidateValues) {
              hitSubcuenta = filtradas.find((r: any) => {
                const subCode = (r.subcta ?? r.SUBCTA ?? '').toString().trim().toUpperCase();
                const denoName = (r.deno || '').toString().trim().toUpperCase();
                const optKey = optionKeyOf(r).toUpperCase();
                return candidate === subCode || candidate === denoName || candidate === optKey;
              });
              if (hitSubcuenta) {
                break;
              }
            }

            if (hitSubcuenta) {
              sel.subcuenta = optionKeyOf(hitSubcuenta);
              (sel as any).__subctaCodeSeleccionada = (hitSubcuenta.subcta ?? hitSubcuenta.SUBCTA ?? '').toString().trim();
            } else if (!sel.subcuenta && denos.length === 1) {
              sel.subcuenta = denos[0];
              (sel as any).__subctaCodeSeleccionada = mapDenoToCode.get(denos[0].toUpperCase()) || '';
            } else if (denos.length > 1 && !hitSubcuenta) {
              // Varias subcuentas distintas: no autoelegir (evita colapsar a una incorrecta).
              sel.subcuenta = '';
              (sel as any).__subctaCodeSeleccionada = '';
            }

            if (sel.subcuenta) {
              this.buscarTarifa(sel);
              this.bucarCampa();
              // Anexos se disparan al terminar tarifas (colectivo/GA), no aquí: evita doble/triple llamada.
            }

            this.cdRef.detectChanges();
          },
          error: (err) => {}
        });
      return;
    }

    const tieneDatosPrecargados = !!(programaSel.subcuenta || programaSel.tarifa || programaSel.campana);
    const emularPreservacion = preservarValores || tieneDatosPrecargados;
    const subcuentaPreservada = emularPreservacion ? (programaSel.subcuenta || '') : '';
    const tarifaPreservada = emularPreservacion ? (programaSel.tarifa || '') : '';
    const campanaPreservada = emularPreservacion ? (programaSel.campana || '') : '';
    const tarifaAnexoPreservada = emularPreservacion ? (programaSel.tarifaAnexo || '') : '';
    const esColectivo = this.esPlanColectivoActual();

    this.networking
      .getSubcuentasConColectivoPrimero(programaCodigo, tipoDoc, numDoc, esColectivo)
      .subscribe(({ cuenta, subctaSugerida, planCodiColectivo, rawIndividual, denoFromColectivo }) => {
        const sel = this.programasSeleccionados.find(p => p.id === programaSel.id);
        if (!sel) return;

        if (Number.isFinite(cuenta)) {
          (sel as any).__cuentaFromColectivo = Number(cuenta);
        }
        (sel as any).__subctaFromColectivo = (subctaSugerida || '').toString().trim();
        (sel as any).__planCodiColectivo = (planCodiColectivo || '').toString().trim();

        let codCuentaInclusion = '';
        try {
          const rawContratoRadicado = localStorage.getItem('contrato_radicado');
          if (rawContratoRadicado) {
            const parsedRadicado = JSON.parse(rawContratoRadicado);
            const contratoRows = Array.isArray(parsedRadicado?.contrato) ? parsedRadicado.contrato : [];
            const hitContrato = contratoRows.find((cRow: any) => {
              const planId = (cRow?.cod_programa_afi || cRow?.COD_PROGRAMA_AFI || '').toString().trim().toUpperCase();
              return planId === sel.id.trim().toUpperCase();
            });
            codCuentaInclusion = (hitContrato?.cod_cuenta ?? hitContrato?.COD_CUENTA ?? '').toString().trim();
          }
        } catch (err) {
        }

        if (!codCuentaInclusion) {
          codCuentaInclusion = String((programaSel as any).__cuentaFromColectivo || this.dataCampania?.cuenta || this.data?.[1]?.cuenta || '').trim();
        }
        let registrosSubcuentas = rawIndividual || [];

        if (this.esFlujoInclusion) {
          if (!codCuentaInclusion && cuenta) {
            codCuentaInclusion = String(cuenta).trim();
          }


          if (codCuentaInclusion) {
            const filtradas = registrosSubcuentas.filter((r: any) => (r?.cuenta ?? r?.CUENTA ?? '').toString().trim() === codCuentaInclusion.toString().trim());
            if (filtradas.length > 0) {
              registrosSubcuentas = filtradas;
            }
          }
        }

        if (!this.mapaDenoALabelPorPrograma.has(sel.id)) {
          this.mapaDenoALabelPorPrograma.set(sel.id, new Map<string, string>());
        }

        const subMap = this.mapaDenoALabelPorPrograma.get(sel.id)!;

        registrosSubcuentas.forEach((r: any) => {
          const code = (r?.subcta || '').toString().trim();
          const name = (r?.deno || '').toString().trim();
          if (name) {
            subMap.set(name.toUpperCase(), `${sel.id} (ID:${code} - ${name})`);
          }
        });

        (sel as any).__subcuentasRaw = registrosSubcuentas;
        const denos: string[] = registrosSubcuentas
          .map((r: any) => (r?.deno || '').toString().trim())
          .filter(Boolean);

        sel.subcuentasDisponibles = [...new Set(denos)];

        const mapDenoToCode = new Map<string, string>(
          registrosSubcuentas.map((r: any) => [this.norm(r?.deno || ''), (r?.subcta || '').toString().trim()])
        );
        (sel as any).__mapDenoToCode = mapDenoToCode;


        if (this.esFlujoInclusion) {

          let subcuentaInclusionCode = '';
          try {
            const rawContrato = localStorage.getItem('contrato_radicado');
            if (rawContrato) {
              const parsed = JSON.parse(rawContrato);
              const contratoRows = Array.isArray(parsed?.contrato) ? parsed.contrato : [];
              const hitContrato = contratoRows.find((cRow: any) =>
                (cRow?.cod_programa_afi || cRow?.COD_PROGRAMA_AFI || '').toString().trim().toUpperCase() === sel.id.trim().toUpperCase()
              );
              subcuentaInclusionCode = (hitContrato?.subcuenta || hitContrato?.cod_subcuenta || hitContrato?.codigoSubcuenta || '').toString().trim();
            }
          } catch (e) { }

          const targetSubcuentaCode = (subcuentaInclusionCode || subctaSugerida || subcuentaPreservada || '').toString().trim().toUpperCase();

          const matchRow = registrosSubcuentas.find((r: any) =>
            (r?.subcta || '').toString().trim().toUpperCase() === targetSubcuentaCode ||
            (r?.deno || '').toString().trim().toUpperCase() === targetSubcuentaCode
          );

          if (matchRow) {
            sel.subcuenta = (matchRow.deno || '').toString().trim();
            (sel as any).__subctaCodeSeleccionada = (matchRow.subcta || '').toString().trim();
          } else if (registrosSubcuentas.length > 0) {
            sel.subcuenta = (registrosSubcuentas[0].deno || '').toString().trim();
            (sel as any).__subctaCodeSeleccionada = (registrosSubcuentas[0].subcta || '').toString().trim();
          } else {
            sel.subcuenta = subcuentaPreservada;
          }

          if (tarifaPreservada) sel.tarifa = tarifaPreservada;
          if (campanaPreservada) sel.campana = campanaPreservada;
          if (tarifaAnexoPreservada) sel.tarifaAnexo = tarifaAnexoPreservada;

          const hitCode = (sel as any).__subctaCodeSeleccionada || mapDenoToCode.get(this.norm(sel.subcuenta)) || '';
          if (hitCode) {
            (sel as any).__subctaCodeSeleccionada = hitCode;
          }

          this.buscarTarifa(sel, true);
          this.bucarCampa();
          this.consultarAnexosParaPrograma(sel);
          this.cdRef.detectChanges();
          return;
        }

        if (emularPreservacion && subcuentaPreservada) {
          sel.subcuenta = subcuentaPreservada;
          if (tarifaPreservada) sel.tarifa = tarifaPreservada;
          if (campanaPreservada) sel.campana = campanaPreservada;
          if (tarifaAnexoPreservada) sel.tarifaAnexo = tarifaAnexoPreservada;

          const hitCode = (sel as any).__subctaCodeSeleccionada || mapDenoToCode.get(this.norm(sel.subcuenta)) || registrosSubcuentas.find((r: any) => this.norm(r?.deno) === this.norm(sel.subcuenta) || this.norm(r?.subcta) === this.norm(sel.subcuenta))?.subcta?.toString().trim() || '';
          if (hitCode) {
            (sel as any).__subctaCodeSeleccionada = hitCode;
          }
          this.buscarTarifa(sel);
          this.bucarCampa();
          this.cdRef.detectChanges();
          return;
        }

        if (subctaSugerida && denoFromColectivo && registrosSubcuentas.some(r => r.subcta?.toString().trim() === subctaSugerida)) {
          sel.subcuenta = denoFromColectivo;
          (sel as any).__subctaCodeSeleccionada = subctaSugerida;
        }

        if (!sel.subcuenta && denos.length >= 1 && !(sel as any).__subctaCodeSeleccionada) {
          sel.subcuenta = denos[0];
          const code = (sel as any).__mapDenoToCode?.get(this.norm(sel.subcuenta));
          if (code) {
            (sel as any).__subctaCodeSeleccionada = code;
          }
          this.buscarTarifa(sel);
          this.bucarCampa();
        }

        if (sel.subcuenta && Array.isArray(registrosSubcuentas) && registrosSubcuentas.length > 0 && !(sel as any).__subctaCodeSeleccionada) {
          const hit = registrosSubcuentas.find(r => this.norm(r?.deno) === this.norm(sel.subcuenta));
          if (hit?.subcta) {
            (sel as any).__subctaCodeSeleccionada = hit.subcta.toString().trim();
          }
        }

        const subctaCode = this.getSubctaCodeFor(sel);
        if (subctaCode || (sel.subcuenta && sel.subcuenta.trim() !== '')) {
          this.buscarTarifa(sel);
          this.bucarCampa();
        }
        this.cdRef.detectChanges();
      });
  }

  private cargarSubcuentasSiFaltan(): void {

    if (!this.shouldActualizarSubcuentas() && !this.esFlujoInclusion) {
      (this.programasSeleccionados || []).forEach(p => this.buscarTarifa(p));
      this.bucarCampa();
      return;
    }

    const esEdicion = this.guardar === false;
    this.programasSeleccionados.forEach(p => {
      const isConsulta = (p as any).subcuentasConsultaRealizada === true;

      if (this.esFlujoInclusion && isConsulta) {
        return;
      }
      const faltan = !Array.isArray((p as any).subcuentasDisponibles) || (p as any).subcuentasDisponibles.length === 0;
      const base = this.programasDisponibles.find(pp => pp.id === p.id);
      if (!base) return;
      const codigoPrograma = ((base.codigo || base.id || '') as string).trim();
      if (!codigoPrograma) return;
      if (faltan || esEdicion) {
        if (this.esFlujoInclusion) {
          (p as any).subcuentasConsultaRealizada = true;
        }
        this.cargarSubcuentasOrquestado(p, base, esEdicion);
      } else {
        if ((p.subcuenta || '').trim() !== '') {
          this.buscarTarifa(p);
        }
        // al volver al tab, subcuentas/tarifas ya están
        // desde orquestado y hay que forzar campañas si se perdieron en rehidratación.
        const sinCampanias = ((p as any).campaniasDisponibles?.length ?? 0) === 0;
        if (sinCampanias) {
          this.bucarCampa();
        }
      }
    });
  }
  cargarProgramasPorLinea(lineaCodigo: number, codigoLinea: 'MI' | 'SO' | 'CEM'): void {

    if (this.esFlujoInclusion) {
      return;
    }

    const programasExistentes = this.programasDisponibles.filter(p => p.lineaNegocio === codigoLinea);
    if (programasExistentes.length > 0) {
      return;
    }
    this.spinner.show();
    const tipoPlanActual = (localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();
    this.consultarLineasService.consultarProgramasCompletosPorParametroPorLinea(lineaCodigo, false, tipoPlanActual, Number(this.edad || 0))
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (response) => {
          const nuevosProgramas: Programa[] = [];
          response.grupos.forEach((grupo: any) => {
            grupo.programas.forEach((programaCompleto: any) => {
              const programa: Programa = { id: programaCompleto.codigo.trim(), codigo: programaCompleto.codigo.trim(), nombre: programaCompleto.programa, lineaNegocio: codigoLinea, color: this.obtenerColorPorLinea(codigoLinea), imagen: programaCompleto.carnet?.file, carnet: programaCompleto.carnet?.file, grupoPrograma: grupo.codigo, planGroup: "PREF", requiereAnexos: true };
              nuevosProgramas.push(programa);
            });
          });
          const codigosExistentes = new Set(this.programasDisponibles.map(p => p.id));
          const programasNuevos = nuevosProgramas.filter(p => !codigosExistentes.has(p.id));
          this.programasDisponibles = [...this.programasDisponibles, ...programasNuevos];
        },
        error: (error) => {
        }
      });
  }

  private obtenerColorPorLinea(linea: 'MI' | 'SO' | 'CEM'): string {
    const colores: { [key: string]: string; } = {
      'MI': 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
      'SO': 'linear-gradient(135deg, #00bfff 0%, #1e90ff 100%)',
      'CEM': 'linear-gradient(135deg, #0372b9 0%, #025a8f 100%)'
    };
    return colores[linea] || colores['MI'];
  }

  cargarTiposVia() {
    this.spinner.show();
    this.networking.consultarTiposVia()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (lista: TipoViaItem[]) => {
          this.tipoVias = lista;
        },
        error: (err: Error) => {
          this.tipoVias = [];
          this.SnackBarService.alert('alert-danger', err.message);
        }
      });
  }

  cargarCiudades(): void {
    this.spinner.show();
    this.consultarCiudadesService.consultarCiudades()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (response) => {
          if (response.status && response.data?.jsonRespuesta) {
            this.ciudades = response.data.jsonRespuesta;
          } else {
            this.ciudades = [];
          }
        },
        error: (error) => {
          this.ciudades = [];
        }
      });
  }

  validarCobertura(): void {
    if (!this.form.tipoVia?.value || !this.form.numero?.value || !this.form.placaUno?.value || !this.form.placaDos?.value || !this.form.ciudad?.value) {
      this.mostrarMensaje('Error', 'Por favor complete todos los campos requeridos', 'error');
      return;
    }

    const direccion = this.concatenarDireccion();
    const ciudad = this.obtenerNombreCiudad();

    if (!direccion || !ciudad) {
      this.mostrarMensaje('Error', 'No se pudo construir la dirección o ciudad', 'error');
      return;
    }

    const request: ConsultarCoberturasRequest = {
      nombreClave: 'validarCoberturaWs',
      queryParams: null,
      pathVariables: null,
      body: {
        direccion: direccion,
        ciudad: ciudad
      }
    };

    this.spinner.show();
    this.consultarCoberturasService.validarCobertura(request).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.status && response.data) {
          if (response.data.aprobado === 'S') {
            this.coberturaCemValida = true;
            this.mostrarMensaje('Validación Exitosa', 'Cobertura disponible en la dirección especificada.', 'success');
          } else if (response.data.aprobado === 'N') {
            const textoConLink = `¡Este programa no tiene cobertura en la dirección especificada!.`;
            //const textoConLink = `¡Este programa no tiene cobertura en la dirección especificada! Para ver el mapa de coberturas haga <a href="${this.cemCoberturaUrl}" target="_blank" rel="noopener noreferrer">clic aquí</a>.`;
            this.coberturaCemValida = false;
            this.mostrarMensaje('Cobertura No Válida', textoConLink, 'error');
            //this.deseleccionarProgramasCem();
            this.coberturaInvalida.emit();
          }
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.coberturaCemValida = false;
        this.mostrarMensaje(
          'Error',
          'Ocurrió un error al validar la cobertura. Por favor intente nuevamente.',
          'error'
        );

        this.coberturaInvalida.emit();
      }
    });
  }

  private deseleccionarProgramasCem(): void {
    if (!Array.isArray(this.programasSeleccionados) || this.programasSeleccionados.length === 0) return;

    const antes = this.programasSeleccionados.length;
    this.programasSeleccionados = this.programasSeleccionados.filter(sel => {
      const base = this.programasDisponibles.find(p => p.id === sel.id);
      return base?.lineaNegocio !== 'CEM';
    });

    if (this.programasSeleccionados.length !== antes) {
      this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
      this.cdRef.detectChanges();
    }
  }

  obtenerNombreCiudad(): string {
    const codigo = this.form.ciudad?.value;
    if (!codigo) return '';

    const ciudad = this.ciudades.find(c => c.codigo === codigo);
    return ciudad ? ciudad.municipio : '';
  }

  concatenarDireccion(): string {
    const tipoVia = (this.form.tipoVia?.value || '').toString().trim();
    const numeroVia = (this.form.numero?.value || '').toString().trim();
    const placa1 = (this.form.placaUno?.value || '').toString().trim();
    const placa2 = (this.form.placaDos?.value || '').toString().trim();

    const partes: string[] = [];

    if (tipoVia) partes.push(tipoVia);
    if (numeroVia) partes.push(numeroVia);

    if (placa1 && placa2) {
      partes.push(`# ${placa1} - ${placa2}`);
    } else if (placa1) {
      partes.push(`# ${placa1}`);
    }

    return partes.join(' ').trim();
  }

  private mostrarMensaje(titulo: string, texto: string, tipo: 'success' | 'error' | 'warning' | 'info'): void {
    this.dialog.open(PopUpMensajeComponent, {
      width: '500px',
      maxWidth: '90vw',
      disableClose: false,
      data: {
        titulo: titulo,
        texto: texto,
        tipoIcono: tipo,
        textoBoton: 'ACEPTAR'
      } as PopUpMensajeData
    });
  }

  private hasAnexosDisponibles(progSel: ProgramaSeleccionado): boolean {
    const lista = Array.isArray(progSel?.anexosDisponibles) ? progSel.anexosDisponibles : [];
    return lista.some((an: any) => {
      const planCod1 = (an?.plan_cod1 ?? '').toString().trim();
      const planDesc = (an?.plan_desc ?? '').toString().trim();
      const tari = (an?.tari ?? '').toString().trim();
      const valor = (an?.valor ?? '').toString().trim();
      return !!planCod1 && !!planDesc && (!!tari || !!valor);
    });
  }

  shouldShowRequiereAnexo(progSel: ProgramaSeleccionado): boolean {
    // Alta: solo si hay catálogo. Edición de fila: también si ya hay anexo persistido.
    // Inclusión con el switch: se muestra lo que ya trae el contratante.
    const esEdicionFila = this.data?.[0] != null || this.guardar === false;
    const heredaInclusion = this.esFlujoInclusion && this.usarProgramasContratante === true;
    if ((esEdicionFila || heredaInclusion)
      && (progSel?.requiereAnexo === 'si' || progSel?.requiereAnexo === 'no' || !!(progSel?.tarifaAnexo || '').toString().trim())) {
      return true;
    }
    return this.hasAnexosDisponibles(progSel);
  }

  shouldShowTarifaAnexo(progSel: ProgramaSeleccionado): boolean {
    return this.shouldShowRequiereAnexo(progSel) && progSel.requiereAnexo === 'si';
  }

  anyCemFullSelected(): boolean {
    // solo por línea. no usar includes('CEM') en código/nombre
    // DECEMP (DENTAL ELITE EMPLEADOS) contiene la subcadena "CEM" y daba falso positivo.
    return this.programasSeleccionados.some(sel => {
      const base = this.programasDisponibles.find(p => p.id === sel.id);
      return base?.lineaNegocio === 'CEM';
    });
  }

  public get mostrarAnexos(): boolean {
    return (this.programasSeleccionados || []).some(p => this.shouldShowRequiereAnexo(p));
  }

  /** Si hay datos EPS para mostrar la sección */
  get mostrarSeccionEPS(): boolean {
    return (
      (Array.isArray(this.estadoEPS) && this.estadoEPS.length > 0) ||
      (Array.isArray(this.alertaEPSBeneficiario) && this.alertaEPSBeneficiario.length > 0)
    );
  }

  public get tituloEstadoEPS(): string {
    const esEdicionBeneficiario = this.guardar === false;
    return this.esUsuario === true && esEdicionBeneficiario
      ? 'Estado en EPS (del contratante):'
      : 'Estado en EPS:';
  }

  onCambioSubcuenta(programaSel: ProgramaSeleccionado): void {
    const mapDenoToCode: Map<string, string> = (programaSel as any).__mapDenoToCode || new Map();
    const rawSub = (programaSel.subcuenta || '').trim();
    let code = mapDenoToCode.get(this.norm(rawSub)) || mapDenoToCode.get(rawSub.toUpperCase()) || '';
    if (!code && rawSub.includes('||')) {
      code = (rawSub.split('||')[1] || '').trim();
    }

    if (code) {
      (programaSel as any).__subctaCodeSeleccionada = code;
    } else {
      (programaSel as any).__subctaCodeSeleccionada = '';
    }
    if (this.esFlujoInclusion && code) {
      (programaSel as any).__subcuentaInclusionOriginal = code;
    }

    programaSel.anexosDisponibles = [];
    programaSel.requiereAnexo = null;
    programaSel.tarifaAnexo = '';
    programaSel.tarifa = '';
    programaSel.tarifasDisponibles = [];
    programaSel.tarifasConsultaRealizada = false;
    programaSel.campana = '';
    programaSel.campanaNombre = '';

    this.listDataCampania = [];
    this.campaniasConsultaRealizadaPorPrograma[programaSel.id] = false;
    if (this.esFlujoInclusion) {

      this.buscarTarifa(programaSel, true);
    } else {
      (programaSel as any).__lastTarifaRequestKey = null;
      (programaSel as any).__lastTarifaRequestId = null;
      (programaSel as any).__loadingTarifasColectivo = false;
      this.buscarTarifa(programaSel);
    }
    this.bucarCampa();
  }

  private mapLineaToNumber(code: 'MI' | 'SO' | 'CEM' | string): number {
    const normalized = (code || '').toString().trim().toUpperCase();
    switch (normalized) {
      case 'MI': return 1;
      case 'ASO':
      case 'SAO':
      case 'SO': return 2;
      case 'CEM': return 3;
      default: return 0;
    }
  }

  private faltaSubcuentaVisible(programaSel: ProgramaSeleccionado): boolean {
    if (!this.debeMostrarSubcuenta) return false;
    const tieneOpciones = (programaSel?.subcuentasDisponibles?.length ?? 0) > 0;
    return tieneOpciones && !(programaSel?.subcuenta || '').toString().trim();
  }

  isTarifaSelectDisabled(programaSel: ProgramaSeleccionado): boolean {
    if (this.faltaSubcuentaVisible(programaSel)) return true;

    const noHayTarifas = (programaSel?.tarifasDisponibles?.length ?? 0) === 0;
    if (programaSel?.tarifasConsultaRealizada && noHayTarifas) return true;

    return false;
  }

  isTarifaProgramaLocked(programaSel: ProgramaSeleccionado): boolean {
    return (programaSel?.tarifasDisponibles?.length ?? 0) === 1;
  }

  isTarifaAnexoLocked(programaSel: ProgramaSeleccionado): boolean {
    return (programaSel?.anexosDisponibles?.length ?? 0) === 1;
  }

  private conservarTarifaProgramaSeleccionada(programaSel: ProgramaSeleccionado): void {
    if (!(programaSel?.tarifa || '').toString().trim()) {
      programaSel.tarifa = '';
    }
  }

  private applyTarifaProgramaAutoSelection(programaSel: ProgramaSeleccionado): void {
    if (this.usarProgramasContratante && programaSel.tarifa) {
      if (!programaSel.tarifasDisponibles) {
        programaSel.tarifasDisponibles = [];
      }
      const existe = programaSel.tarifasDisponibles.some(t => t.tarifa === programaSel.tarifa);
      if (!existe) {
        programaSel.tarifasDisponibles.push({
          tarifa: programaSel.tarifa,
          descripcion: programaSel.tarifa,
          description: programaSel.tarifa,
          programa_grupo: programaSel.id,
          codigo_programa_grupo: programaSel.id,
          programa: programaSel.id
        });
      }
      return;
    }

    const opciones = Array.isArray(programaSel?.tarifasDisponibles) ? programaSel.tarifasDisponibles : [];
    const opcionesValidas = opciones
      .map(t => (t?.tarifa ?? '').toString().trim())
      .filter(Boolean);

    const actual = (programaSel?.tarifa ?? '').toString().trim();
    const codigoActual = this.obtenerCodigoTarifa(actual).toUpperCase();
    const match = opciones.find((t) => {
      const valor = (t?.tarifa ?? '').toString().trim();
      if (!valor) return false;
      if (actual && this.norm(valor) === this.norm(actual)) return true;
      const codigoOpcion = this.obtenerCodigoTarifa(valor).toUpperCase();
      return !!codigoActual && codigoOpcion === codigoActual;
    });

    if (match) {
      programaSel.tarifa = (match.tarifa || '').toString().trim();
      return;
    }

    if (opcionesValidas.length === 1 && !actual) {
      programaSel.tarifa = opcionesValidas[0];
      return;
    }

    if (actual) {
      return;
    }

    programaSel.tarifa = '';
  }

  private applyTarifaAnexoAutoSelection(programaSel: ProgramaSeleccionado): void {
    const esEdicionFila = this.data?.[0] != null || this.guardar === false;
    const tarifaAnexoPersistida = (programaSel?.tarifaAnexo || '').toString().trim();

    // NC 1078: edición de fila — preservar/rematch anexo guardado (cualquier carnet).
    // Alta: no entra aquí salvo usarProgramasContratante con tarifaAnexo ya seteada.
    if ((esEdicionFila || this.usarProgramasContratante) && tarifaAnexoPersistida) {
      if (!programaSel.anexosDisponibles) {
        programaSel.anexosDisponibles = [];
      }

      const realMatch = programaSel.anexosDisponibles.find(an => this.matchAnexoSeleccion(an, tarifaAnexoPersistida));
      if (realMatch) {
        programaSel.tarifaAnexo = this.getAnexoOptionValue(realMatch);
      } else if (!programaSel.anexosDisponibles.some(an => this.matchAnexoSeleccion(an, tarifaAnexoPersistida))) {
        programaSel.anexosDisponibles.push({
          plan_desc: tarifaAnexoPersistida,
          plan_cod1: tarifaAnexoPersistida
        });
      }
      if ((esEdicionFila || this.usarProgramasContratante) && programaSel.requiereAnexo !== 'si') {
        programaSel.requiereAnexo = 'si';
      }
      return;
    }

    const opciones = Array.isArray(programaSel?.anexosDisponibles) ? programaSel.anexosDisponibles : [];
    const opcionesValidas = opciones
      .map(an => this.getAnexoOptionValue(an))
      .filter(Boolean);

    const actual = (programaSel?.tarifaAnexo ?? '').toString().trim();
    const matchIdx = opciones.findIndex(an => this.matchAnexoSeleccion(an, actual));

    if (matchIdx >= 0) {
      programaSel.tarifaAnexo = this.getAnexoOptionValue(opciones[matchIdx]);
      return;
    }

    if (opcionesValidas.length === 1 && !actual) {
      programaSel.tarifaAnexo = opcionesValidas[0];
      return;
    }

    if (opcionesValidas.length > 1) {
      const actualMulti = (programaSel?.tarifaAnexo ?? '').toString().trim();
      const matchIdxMulti = opciones.findIndex(an => this.matchAnexoSeleccion(an, actualMulti));

      if (!actualMulti || matchIdxMulti === -1) {
        // Edición NC1078: no borrar valor persistido si aún no matchea el catálogo.
        if (!(esEdicionFila && actualMulti)) {
          programaSel.tarifaAnexo = '';
        }
      } else if (!opcionesValidas.includes(actualMulti)) {
        programaSel.tarifaAnexo = opcionesValidas[matchIdxMulti];
      }
      return;
    }

    // NC-1096: si hay valor actual no listado, inyectarlo para que el mat-select lo muestre
    // (switch programas contratante / valores heredados fuera de catálogo).
    if (actual) {
      const yaVisible = opciones.some(an => this.getAnexoOptionValue(an) === actual);
      if (!yaVisible) {
        programaSel.anexosDisponibles = [
          ...opciones,
          {
            plan_cod1: actual,
            plan_desc: actual
          }
        ];
      }
      return;
    }

    if (!(esEdicionFila && tarifaAnexoPersistida)) {
      programaSel.tarifaAnexo = '';
    }
  }

  getAnexoOptionValue(an: any): string {
    const planCod1 = (an?.plan_cod1 ?? an?.plan_codi ?? '').toString().trim();
    const tari = (an?.tari ?? '').toString().trim();
    const valor = (an?.valor ?? '').toString().trim();
    if (planCod1 && tari) return `${planCod1}|${tari}|${valor}`;
    if (tari) return tari;
    return planCod1;
  }

  private matchAnexoSeleccion(an: any, selected: unknown): boolean {
    const sel = (selected ?? '').toString().trim().toUpperCase();
    if (!sel) return false;

    const planCod1 = (an?.plan_cod1 ?? an?.plan_codi ?? '').toString().trim().toUpperCase().replace(/\s+/g, '');
    const planCod2 = (an?.plan_cod2 ?? an?.plan_codi_adi ?? '').toString().trim().toUpperCase().replace(/\s+/g, '');
    const tari = (an?.tari ?? '').toString().trim().toUpperCase().replace(/\s+/g, '');
    const keyFull = this.getAnexoOptionValue(an).toUpperCase().replace(/\s+/g, '');
    const selNorm = this.norm(sel).replace(/\s+/g, '');

    // match exacto del mat-option (plan|tari|valor)
    if (selNorm && keyFull && selNorm === this.norm(keyFull).replace(/\s+/g, '')) {
      return true;
    }

    // Clave compuesta: si trae tari, plan+tari deben coincidir (evita tomar el 1er anexo con mismo plan_codi)
    if (sel.includes('|')) {
      const partes = sel.split('|').map(p => p.trim().toUpperCase().replace(/\s+/g, ''));
      const selPlan = partes[0] || '';
      const selTari = partes[1] || '';
      if (selTari) {
        const planOk = !selPlan || selPlan === planCod1 || selPlan === planCod2;
        return planOk && !!tari && selTari === tari;
      }
      return !!selPlan && (selPlan === planCod1 || selPlan === planCod2);
    }

    // Selección por código de tarifa del anexo o plan_codi_adi
    if (tari && selNorm === tari) return true;
    if (planCod2 && selNorm === planCod2) return true;

    const codigoSel = this.obtenerCodigoTarifa(sel).toUpperCase().replace(/\s+/g, '');
    if (codigoSel && tari && codigoSel === tari) return true;
    if (codigoSel && planCod2 && codigoSel === planCod2) return true;

    return false;
  }

  private applyCampaniaAutoSelection(programaSel: ProgramaSeleccionado): void {
    const campanaActual = (programaSel?.campana ?? '').toString().trim();
    const campanaNombreActual = (programaSel?.campanaNombre ?? '').toString().trim();

    const opciones = this.getCampaniasParaPrograma(programaSel);
    const opcionesValidas = opciones
      .map(c => ({
        codigo: (c?.codigo_campania ?? '').toString().trim(),
        nombre: (c?.nombre ?? '').toString().trim()
      }))
      .filter(c => !!c.codigo);

    if (opcionesValidas.length === 1) {
      programaSel.campana = opcionesValidas[0].codigo;
      programaSel.campanaNombre = opcionesValidas[0].nombre;
      return;
    }

    if (opcionesValidas.length > 1) {
      const actual = campanaActual;
      const existeActual = opcionesValidas.some(op =>
        op.codigo === actual || this.norm(op.nombre) === this.norm(actual)
      );

      if (!existeActual) {
        // edición: conservar campaña ya cargada
        // mientras el usuario decide cambiarla manualmente.
        if (actual || campanaNombreActual) {
          return;
        }
        programaSel.campana = '';
        programaSel.campanaNombre = '';
      }
      return;
    }

    if (campanaActual || campanaNombreActual) {
      return;
    }

    programaSel.campana = '';
    programaSel.campanaNombre = '';
  }

  getTarifaHintMessage(programaSel: ProgramaSeleccionado): string | null {
    if (this.faltaSubcuentaVisible(programaSel)) return 'Seleccione primero una subcuenta';
    if (programaSel?.tarifasConsultaRealizada && (programaSel?.tarifasDisponibles?.length ?? 0) === 0) {
      return 'No se encontraron tarifas para este programa';
    }
    return null;
  }

  isCampanaSelectDisabled(programaSel: ProgramaSeleccionado): boolean {

    if (this.esFlujoInclusion) {
      return false;
    }
    if (this.faltaSubcuentaVisible(programaSel)) return true;

    const consultaHecha = !!this.campaniasConsultaRealizadaPorPrograma[programaSel.id];
    const campanias = this.getCampaniasParaPrograma(programaSel);
    const noHayCampanias = campanias.length === 0;
    if (consultaHecha && noHayCampanias) return true;
    if (campanias.length === 1) return true;

    return false;
  }

  getCampanaHintMessage(programaSel: ProgramaSeleccionado): string | null {
    if (programaSel?.campana) return null;

    if (this.faltaSubcuentaVisible(programaSel)) return 'Seleccione primero una subcuenta';
    const consultaHecha = !!this.campaniasConsultaRealizadaPorPrograma[programaSel.id];
    if (consultaHecha && this.getCampaniasParaPrograma(programaSel).length === 0) {
      return 'No se encontraron campañas para este programa';
    }
    return null;
  }

  getCampaniasParaPrograma(programaSel: ProgramaSeleccionado): campanias[] {
    const propias = Array.isArray((programaSel as any)?.campaniasDisponibles)
      ? (programaSel as any).campaniasDisponibles
      : [];
    if (propias.length > 0) return propias;
    return Array.isArray(this.listDataCampania) ? this.listDataCampania : [];
  }

  tarifaProgramaFueraDeCatalogo(programaSel: ProgramaSeleccionado): boolean {
    const tarifa = (programaSel?.tarifa || '').toString().trim();
    if (!tarifa) return false;
    return !(programaSel?.tarifasDisponibles || []).some((t) =>
      this.norm((t as any)?.tarifa) === this.norm(tarifa)
    );
  }

  hasCampaniaSeleccionadaFueraDeLista(programaSel: ProgramaSeleccionado): boolean {
    const campana = (programaSel?.campana || '').toString().trim();
    if (!campana) return false;
    return !this.getCampaniasParaPrograma(programaSel)
      .some(c => {
        const cod = (c?.codigo_campania || '').toString().trim();
        const nombre = (c?.nombre || '').toString().trim();
        return cod === campana || this.norm(nombre) === this.norm(campana);
      });
  }

  getCampaniaNombreVisible(programaSel: ProgramaSeleccionado): string {
    const seleccionada = this.getCampaniaSeleccionada(programaSel);
    if ((seleccionada?.nombre || '').toString().trim()) {
      return (seleccionada?.nombre || '').toString().trim();
    }
    if ((programaSel?.campanaNombre || '').toString().trim()) {
      return (programaSel.campanaNombre || '').toString().trim();
    }
    return (programaSel?.campana || '').toString().trim();
  }

  /** Tooltip: observaciones de la campaña */
  getCampaniaTooltip(programaSel: ProgramaSeleccionado): string {
    const c = this.getCampaniaSeleccionada(programaSel);
    if (!c) return '';
    return `Observaciones: ${this.normalizarValorTooltip((c as any)?.observaciones)}`;
  }

  /** Campaña seleccionada en el programa */
  private getCampaniaSeleccionada(programaSel: ProgramaSeleccionado): campanias | null {
    if (!programaSel?.campana) return null;
    return this.getCampaniasParaPrograma(programaSel)?.find(
      c => {
        const sel = (programaSel.campana || '').trim();
        const cod = (c.codigo_campania || '').trim();
        const nombre = (c.nombre || '').trim();
        return cod === sel || this.norm(nombre) === this.norm(sel);
      }
    ) ?? null;
  }

  /** Tooltip: null/vacío → N/A */
  private normalizarValorTooltip(value: unknown): string {
    const raw = (value ?? '').toString().trim();
    if (!raw || raw.toLowerCase() === 'null' || raw.toLowerCase() === 'undefined') return 'N/A';
    return raw;
  }

  private parseRequiereAnexoValue(value: unknown): 'si' | 'no' | null {
    const v = this.normalizarValorTooltip(value).toUpperCase();
    if (v === 'SI' || v === 'S' || v === 'TRUE' || v === '1') return 'si';
    if (v === 'NO' || v === 'N' || v === 'FALSE' || v === '0') return 'no';
    return null;
  }

  actualizarProgramasContratanteLocalStorage(): void {
    if (!this.puedePersistirContratanteStorage()) {
      return;
    }
    if (!this.esContextoContratanteReal()) {
      return;
    }
    try {
      const payload = (this.programasSeleccionados || []).map(ps => {
        const base = this.programasDisponibles.find(p => p.id === ps.id);
        const esCem = base?.lineaNegocio === 'CEM';
        const programaCodigoRaw = (this.resolveProgramaCodigo(ps) || base?.codigo || ps.id || '').toString().trim();
        const programaCodigo = programaCodigoRaw.split('|')[0].trim();
        const lineaBase = (base?.lineaNegocio || this.resolveProgramaBase(ps)?.lineaNegocio || '').toString().trim().toUpperCase();
        const lineaNegocioStorage = lineaBase === 'SO' ? 'SAO' : lineaBase;

        // tarifa
        const tarifaRaw = (ps.tarifa || '').trim();
        const codDesdeTexto = tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
        const tarifaDet = (ps.tarifasDisponibles as IListTarifaFull[])?.find(
          t => this.norm(t?.tarifa) === this.norm(codDesdeTexto)
        );

        let codigoTarifa = (tarifaDet?.tarifa || codDesdeTexto || '').trim();
        let valorTarifaBase = Number.isFinite(Number(tarifaDet?.valorMensualBase)) ? Number(tarifaDet?.valorMensualBase) : (Number.isFinite(Number(tarifaDet?.valorMensualIva)) ? Number(tarifaDet?.valorMensualIva) : null);
        let valorTarifaIva = Number.isFinite(Number(tarifaDet?.valorMensualIva)) ? Number(tarifaDet?.valorMensualIva) : valorTarifaBase;
        let nombreTarifaResuelta = (tarifaDet?.descripcion || ps.tarifa || '').toString().trim() || null;

        if (this.esFlujoInclusion) {
          const valInclusionRescatado = Number(
            tarifaDet?.valorMensualIva ??
            tarifaDet?.valorMensualBase ??
            (ps as any)?.valorMensualIva ??
            (ps as any)?.valorMensualBase ??
            (ps as any)?.valor_mensual_iva ??
            (ps as any)?.valor_mensual_base ??
            (ps as any)?.valor_tari ??
            (ps as any)?.VALOR_TARI ??
            (ps as any)?.valor ??
            0
          );
          if (valInclusionRescatado > 0) {
            valorTarifaBase = valInclusionRescatado;
            valorTarifaIva = valInclusionRescatado;
          }
        }

        if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
          const filaColectivo = (this.datosColectivoGA || []).find((r: any) => {
            const rPlan = (r.plan_codi ?? r.PLAN_CODI ?? '').toString().trim().toUpperCase();
            return rPlan === (ps.id || '').trim().toUpperCase();
          });
          const valNum = Number(tarifaDet?.valorMensualBase ?? tarifaDet?.valorMensualIva ?? filaColectivo?.valor_tari ?? filaColectivo?.VALOR_TARI ?? 0);
          if (valNum > 0) {
            valorTarifaBase = valNum;
            valorTarifaIva = valNum;
          }
          codigoTarifa = (ps as any).__tarifaCodigoLimpio || this.obtenerCodigoTarifa(tarifaRaw);
          nombreTarifaResuelta = (tarifaDet?.descripcion || filaColectivo?.tari_deno || filaColectivo?.plan_deno || ps.nombre || '').toString().trim();
        }

        const tarifaDetalle: any = codigoTarifa ? {
          tari: codigoTarifa,
          nombreTarifa: nombreTarifaResuelta,
          valorMensualBase: valorTarifaBase,
          valorMensualIva: valorTarifaIva,
          porcentajeIva: tarifaDet?.porcentajeIva ?? null,
          esTarifaAsociado: tarifaDet?.esTarifaAsociado ?? null,
          fueSeleccionada: true,
          esAnexo: false,
        } : null;

        // campaña
        const codigoCampana = (ps.campana || '').toString().trim();
        const campaniaSeleccionada = this.getCampaniasParaPrograma(ps).find(
          c => {
            const cod = (c?.codigo_campania || '').toString().trim();
            const nombre = (c?.nombre || '').toString().trim();
            return cod === codigoCampana || this.norm(nombre) === this.norm(codigoCampana);
          }
        );

        const campaniaDetalle: any = campaniaSeleccionada ? {
          codCampComercial: (campaniaSeleccionada.codigo_campania ?? '').toString().trim(),
          nombreCampania: (campaniaSeleccionada.nombre ?? '').toString().trim(),
          fueSeleccionada: true,
          idCampania: campaniaSeleccionada.id_campania,
          tipoCampania: campaniaSeleccionada.tipo_campania,
          modalidad: campaniaSeleccionada.modalidad,
          cuenta: campaniaSeleccionada.cuenta,
          subcuenta: campaniaSeleccionada.subcuenta,
          tipoPlan: campaniaSeleccionada.tipo_plan,
          parentesco: campaniaSeleccionada.parentesco,
          edadDesde: campaniaSeleccionada.edad_desde,
          edadHasta: campaniaSeleccionada.edad_hasta,
          cantBenefDesde: campaniaSeleccionada.cant_benef_desde,
          cantBenefHasta: campaniaSeleccionada.cant_benef_hasta,
          acumulable: campaniaSeleccionada.acumulable,
          pagoDebitoAuto: campaniaSeleccionada.pago_debito_auto,
          aplicaProntoPago: campaniaSeleccionada.aplica_pronto_pago,
          observaciones: campaniaSeleccionada.observaciones,
          usuarioActualizacion: (campaniaSeleccionada as any).usuario_actualizacion ?? '',
          lineaNegocio: campaniaSeleccionada.linea_negocio,
          grupoPrograma: campaniaSeleccionada.grupo_programa,
          programa: campaniaSeleccionada.programa,
          inicioVigencia: campaniaSeleccionada.inicio_vigencia,
          finVigencia: campaniaSeleccionada.fin_vigencia,
          estado: campaniaSeleccionada.estado,
        } : null;

        // anexo
        const codAnexoSel = (ps.tarifaAnexo || '').trim();
        const anexoSel = (ps.anexosDisponibles || []).find(an => this.matchAnexoSeleccion(an, codAnexoSel)) || (ps as any).anexoDetalle;
        const codTarifaAnexo = (anexoSel?.tari || codAnexoSel || '').toString().trim();
        const anexoCodigoNormalizado = (() => {
          if (!anexoSel && !codAnexoSel) return '';
          return programaCodigo;
        })();
        const valorAnexoNumRaw = Number((anexoSel?.valor ?? anexoSel?.valorMensualIva ?? '').toString().trim());
        const valorAnexoNum = Number.isFinite(valorAnexoNumRaw) ? valorAnexoNumRaw : null;
        const anexoDetalle: any = anexoSel ? {
          clave: programaCodigo,
          tari: (anexoSel.tari || '').trim(),
          nombreTarifa: (anexoSel.plan_desc || anexoSel.nombreTarifa || '').toString().trim(),
          valorMensualIva: valorAnexoNum,
          valorMensualBase: valorAnexoNum,
          porcentajeIva: null,
          esTarifaAsociado: null,
          fueSeleccionada: true,
          esAnexo: true,
        } : null;

        // item store
        const subctaNum = this.getSubctaCodeFor(ps) || (ps as any).__subctaCodeSeleccionada || (ps as any).__subcuentaInclusionOriginal || '';

        const grupoPrograma =
          this.resolverGrupoProgramaParaGuardar(ps, base);

        if (!grupoPrograma) {
          console.error(
            '[GRUPO-PROGRAMA] No fue posible resolver el grupo',
            {
              tipoPlan: localStorage.getItem('tipoPlan'),
              programa: this.codigoProgramaParaGuardar(ps),
              nombrePrograma: base?.nombre ?? ps.nombre,
              lineaNegocio: base?.lineaNegocio,
              programaSeleccionado: ps,
              programaBase: base
            }
          );
        }

        const item: any = {
          lineaNegocio: lineaNegocioStorage,
          grupo: base?.grupoPrograma ?? '',
          grupoPrograma: grupoPrograma,
          programa: this.esFlujoGruposAfinidad()
            ? this.codigoProgramaParaGuardar(ps)
            : programaCodigo,
          nombrePrograma: (base?.nombre || ps.nombre || '').toString().trim(),
          subcta: subctaNum,
          subcuenta: ps.subcuenta ?? '',
          nombreSubcuenta: ps.subcuenta ?? '',
          tarifa: codigoTarifa,
          nombreTarifa: nombreTarifaResuelta,
          valorMensualBase: valorTarifaBase ?? (ps as any)?.valorMensualBase ?? undefined,
          valorMensualIva: valorTarifaIva ?? (ps as any)?.valorMensualIva ?? undefined,
          porcentajeIva: tarifaDet?.porcentajeIva ?? undefined,

          tarifaDetalle,
          anexoCodigo: anexoCodigoNormalizado,
          tarifaAnexo: codTarifaAnexo,
          anexoDetalle,
          requiereAnexo: ps.requiereAnexo ?? null,
          campana: codigoCampana,
          campaniaDetalle,
        };

        if (this.esFlujoInclusion) {
          item.idBenPrograma = Number((ps as any).__idBenPrograma || 0) || undefined;
          item.idSubcuenta = Number((ps as any).__idSubcuenta || 0) || undefined;
          item.idCotizacionTarifa = Number((ps as any).__idCotizacionTarifa || 0) || undefined;
          item.idCotizacionCampania = Number((ps as any).__idCotizacionCampania || 0) || undefined;
          item.inicioVigencia = (ps as any).inicioVigencia || undefined;
          item.finVigencia = (ps as any).finVigencia || undefined;
          item.campanaNombre = ps.campanaNombre || undefined;
        }

        if (esCem) {
          item.coberturaValida = this.coberturaCemValida === true;
        }

        return item;
      });

      localStorage.setItem('programas_contratante', JSON.stringify(payload));
      this.programaSeleccionStore.guardar({
        idCotizacion: Number(this.idCotizacionContext || 0) || undefined as any,
        tipoDocumento: (this.form.contratanteTipoDocumento?.value || '').toString().trim(),
        numeroDocumento: (this.form.contratanteDocumento?.value || '').toString().trim(),
        savedAt: new Date().toISOString(),
        programas: payload as any
      });
      this.beneficiarioLocalStorage.sincronizarProgramasDesdeContratante(payload as any);
    } catch (_) {
      // no-op
    }
  }

  private codigoGrupoUtil(valor: unknown): string {
    const grupo = (valor ?? '')
      .toString()
      .split('|')[0]
      .trim()
      .toUpperCase();
    if (!grupo) {
      return '';
    }
    if (grupo === 'MI' || grupo === 'SO' || grupo === 'SAO' || grupo === 'CEM' || grupo === 'SMP' || grupo === '1' || grupo === '2' || grupo === '3') {
      return '';
    }
    return grupo;
  }

  private grupoInclusionGuardado(codigoPrograma: string): string {
    const codigo = (codigoPrograma || '').toString().trim().toUpperCase();
    if (!codigo) {
      return '';
    }
    try {
      const rawProgramas = localStorage.getItem('programas_grupo_inclusion');
      if (rawProgramas) {
        const programas = JSON.parse(rawProgramas);
        const encontrado = Array.isArray(programas)
          ? programas.find((item: any) => (item?.programa || '').toString().trim().toUpperCase() === codigo)
          : null;
        const grupo = this.codigoGrupoUtil(encontrado?.grupoPrograma);
        if (grupo) {
          return grupo;
        }
      }
      const rawContrato = localStorage.getItem('contrato_radicado');
      if (!rawContrato) {
        return '';
      }
      const contratos = JSON.parse(rawContrato)?.contrato;
      const lista = Array.isArray(contratos) ? contratos : [];
      const contrato = lista.find((item: any) =>
        (item?.cod_programa_afi || item?.programa || item?.code || '').toString().trim().toUpperCase() === codigo
      );
      return this.codigoGrupoUtil(contrato?.GRUPO_PROGRAMA || contrato?.grupo_programa || contrato?.grupoPrograma);
    } catch {
      return '';
    }
  }

  private resolverGrupoProgramaParaGuardar(
    ps: ProgramaSeleccionado,
    base?: Programa
  ): string {
    const codigoPrograma = (
      base?.codigo ||
      base?.id ||
      ps?.id ||
      ''
    )
      .toString()
      .trim()
      .toUpperCase();

    const candidatos: unknown[] = [];

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const filaColectivo = this.resolverFilaActivoAcParaTarifa(codigoPrograma, '');
      candidatos.push(
        filaColectivo?.GRUPO_PROGRAMA,
        filaColectivo?.grupo_programa,
        filaColectivo?.grupoPrograma,
        filaColectivo?.plan_grupo,
        filaColectivo?.PLAN_GRUPO
      );
    }

    if (this.esFlujoInclusion) {
      candidatos.push(this.grupoInclusionGuardado(codigoPrograma));
    }

    const tarifaConGrupo = (ps.tarifasDisponibles || []).find((tarifa: any) =>
      !!this.codigoGrupoUtil(tarifa?.grupoPrograma || tarifa?.grupo_programa || tarifa?.GRUPO_PROGRAMA)
    ) as any;

    candidatos.push(
      tarifaConGrupo?.grupoPrograma,
      tarifaConGrupo?.grupo_programa,
      tarifaConGrupo?.GRUPO_PROGRAMA,
      ps.grupoPrograma,
      base?.grupoPrograma
    );

    for (const candidato of candidatos) {
      const grupo = this.codigoGrupoUtil(candidato);
      if (grupo) {
        return grupo;
      }
    }
    return '';
  }

  private completarGruposProgramaSeleccionados(): Observable<void> {
    const pendientes = (this.programasSeleccionados || []).filter((ps) => {
      const base = this.programasDisponibles.find((p) => p.id === ps.id);
      return !this.resolverGrupoProgramaParaGuardar(ps, base);
    });
    if (!pendientes.length) {
      return of(undefined);
    }

    return forkJoin(pendientes.map((ps) => {
      const codigo = this.codigoProgramaParaGuardar(ps);
      if (!codigo) {
        return of(null);
      }
      return this.consultarCotizacionService.consultarGrupoProgramaXPrograma({ programa: codigo }).pipe(
        map((resp) => {
          const grupo = this.codigoGrupoUtil(resp?.data?.jsonRespuesta?.[0]?.grupo_programa);
          if (!grupo) {
            return null;
          }
          ps.grupoPrograma = grupo;
          const base = this.programasDisponibles.find((p) => p.id === ps.id);
          if (base) {
            base.grupoPrograma = grupo;
          }
          return grupo;
        }),
        catchError(() => of(null))
      );
    })).pipe(map(() => undefined));
  }

  private buildTarifaRequestForIndividual(programaSel: ProgramaSeleccionado): IDataTarifa | null {
    const subcta = this.getSubctaCodeFor(programaSel);
    const base = this.programasDisponibles.find(p => p.id === programaSel.id);
    if (!base) return null;
    const lineaNegocioNumero = this.mapLineaToNumber(base.lineaNegocio);
    let codigoPrograma = (base.codigo || '').trim();
    if (!lineaNegocioNumero || !codigoPrograma) return null;

    const cuenta = Number((programaSel as any).__cuentaFromColectivo) || Number(this.dataCampania?.cuenta) || 1;
    const cuentaValida = Number.isFinite(cuenta) && cuenta > 0 ? cuenta : 1;
    const parentesco = (this.form.parentesco.value || '').toString().trim();
    const edad = Number.isFinite(Number(this.edad)) ? String(Number(this.edad)) : '';
    const generoRaw = (this.form.genero.value || '').toString().trim().toUpperCase();
    const sexo = generoRaw === '1' ? 'F' : (generoRaw === '2' ? 'M' : (generoRaw || 'A'));

    let tarifaSeleccionada = (programaSel.tarifa || '').toString().trim() || (this.form.tarifa.value || '').toString().trim() || (this.form.contratanteTarifa.value || '').toString().trim();
    let subcuentaTecnica = (subcta || '').toString().trim();
    let cuentaFinal = cuentaValida;

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {

      if (this.cuentaColectivoGA != null && Number(this.cuentaColectivoGA) > 0) {
        cuentaFinal = Number(this.cuentaColectivoGA);
      }

      let tarifaLimpia = (programaSel as any).__tarifaCodigoLimpio || '';
      if (!tarifaLimpia) {
        const raw = (programaSel.tarifa || '').toString().trim();
        tarifaLimpia = raw.match(/\(([^)]+)\)$/)?.[1]?.trim() || (raw.includes(' - ') ? raw.split(' - ')[0].trim() : raw);
      }

      const planCodigo = (programaSel.id || '').trim().toUpperCase();
      const filaRef: any = this.resolverFilaActivoAcParaTarifa(planCodigo, subcuentaTecnica);
      if (!tarifaLimpia || tarifaLimpia.includes(' ')) {
        tarifaLimpia = (filaRef?.tari ?? filaRef?.TARI ?? '').toString().trim();
      }
      if (this.esFlujoGruposAfinidad()) {
        const planOriginal = (filaRef?.plan_codi ?? filaRef?.PLAN_CODI ?? '').toString().trim().toUpperCase();
        if (planOriginal) {
          codigoPrograma = planOriginal;
        }
      }

      tarifaSeleccionada = tarifaLimpia;
    }
    else if (this.esFlujoInclusion) {
      const tipoPlan = (localStorage.getItem('tipoPlan') || '').toUpperCase().trim();
      cuentaFinal = (tipoPlan === 'A' || tipoPlan === 'AS') ? 1 : 2;

      if (!subcuentaTecnica) {
        subcuentaTecnica = (programaSel as any).__subcuentaInclusionOriginal || '';
      }

      if (!tarifaSeleccionada || tarifaSeleccionada.includes(' - ')) {
        tarifaSeleccionada = (programaSel as any).__tarifaInclusionOriginal || tarifaSeleccionada;
        if (tarifaSeleccionada.includes(' - ')) {
          tarifaSeleccionada = tarifaSeleccionada.split(' - ')[0].trim();
        } else if (tarifaSeleccionada.match(/\(([^)]+)\)$/)) {
          tarifaSeleccionada = tarifaSeleccionada.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaSeleccionada;
        }
      }
    }

    const resultadoDTO = {
      cuenta: cuentaFinal,
      modelo_negocio: [{
        subcuenta: subcuentaTecnica,
        linea_negocio: lineaNegocioNumero,
        programa: [codigoPrograma]
      }],
      prm_tari: tarifaSeleccionada.trim(),
      prm_edad: edad,
      prm_fecha: '',
      vigen_desde: '',
      prm_paren: parentesco || 'T',
      prm_sexo: sexo,
      prm_inte_tipo: 'I',
      cant_inte: ''
    };

    return resultadoDTO;
  }

  /** Tarifa colectiva/GA: pide código; valor $0 ok (ej. Bebé Gestante) */
  private esTarifaColectivaConValorValido(t: IListTarifa): boolean {
    const tarifaTxt = (t?.tarifa || '').toString().trim();
    const cod = tarifaTxt.match(/\(([^)]+)\)\s*$/)?.[1]?.trim() || '';
    if (!cod) return false;
    const valor = Number(t?.valorMensualIva ?? t?.valorMensualBase);
    return Number.isFinite(valor);
  }

  private usarTarifaColectivaPorTipoPlan(): boolean {
    const plan = this.normTxt(this.tipoPlanLS || localStorage.getItem('tipoPlan') || '');
    return this.isPlanColectivo(plan) || this.isPlanAfinidad(plan);
  }

  /** Tarifas individuales (legacy + valores). Incluye valor $0 */
  buscarTarifa(programaSel?: ProgramaSeleccionado, forzarConsultaServidor = false) {

    if (this.esFlujoInclusion && !forzarConsultaServidor) {
      if (programaSel) {
        programaSel.tarifasConsultaRealizada = true;
        if (programaSel.subcuenta && (!programaSel.subcuentasDisponibles || programaSel.subcuentasDisponibles.length === 0)) {
          programaSel.subcuentasDisponibles = [programaSel.subcuenta];
        }

        const tienePreciosValidos = Array.isArray(programaSel.tarifasDisponibles) &&
          programaSel.tarifasDisponibles.length > 0 &&
          programaSel.tarifasDisponibles.some(t =>
            Number.isFinite(Number(t?.valorMensualIva ?? t?.valorMensualBase))
          );

        if (tienePreciosValidos) {
          this.consultarAnexosParaPrograma(programaSel);
          this.cdRef.detectChanges();
        }

      }
    }
    const target = programaSel;
    if (!target) return;

    const esTarifaColectiva = this.usarTarifaColectivaPorTipoPlan();

    // RAMA COLECTIVA (Venta Nueva 3): Exige subcuenta resuelta y aplica Candado Antibucle
    if (esTarifaColectiva && !this.esFlujoInclusion) {
      const subctaCodeSelected =
        this.getSubctaCodeFor(target);

      const planCodigoUi = (
        target.id || ''
      ).trim().toUpperCase();

      const cuentaActual =
        this.cuentaColectivoGA != null
          ? String(this.cuentaColectivoGA).trim()
          : '';

      if (
        !subctaCodeSelected ||
        !planCodigoUi ||
        !cuentaActual
      ) {
        target.tarifasDisponibles = [];
        target.tarifasConsultaRealizada = false;
        this.conservarTarifaProgramaSeleccionada(target);
        return;
      }

      /*
      * Recuperar el código original de AFILMED.
      * Ejemplo: OPLC en UI, OPLF en servicios.
      */
      const filaActivo = this.resolverFilaActivoAcParaTarifa(
        planCodigoUi,
        subctaCodeSelected,
        cuentaActual
      );

      const planCodiServicio = String(
        filaActivo?.plan_codi ??
        filaActivo?.PLAN_CODI ??
        planCodigoUi
      ).trim().toUpperCase();

      const fuentesTarifa = (
        this.datosColectivoGA || []
      ).filter((fila: any) => {
        const filaCuenta = String(
          fila?.cuenta ??
          fila?.CUENTA ??
          ''
        ).trim();

        const filaSubcuenta = String(
          fila?.subcta ??
          fila?.SUBCTA ??
          ''
        ).trim();

        const filaPlan = String(
          fila?.plan_codi ??
          fila?.PLAN_CODI ??
          ''
        ).trim().toUpperCase();

        return (
          filaCuenta === cuentaActual &&
          filaSubcuenta === subctaCodeSelected &&
          filaPlan === planCodiServicio
        );
      });

      const referencias = Array.from(
        new Map<string, any>(
          fuentesTarifa
            .map((fila: any) => {
              const codigo = String(
                fila?.tari ??
                fila?.TARI ??
                ''
              ).trim();

              return [codigo, fila] as [string, any];
            })
            .filter(([codigo]) => !!codigo)
        ).values()
      );

      console.log(
        '[Beneficiario-Tarifas] Tarifas de getConsultaActivoAc',
        {
          programaUI: planCodigoUi,
          programaServicio: planCodiServicio,
          cuenta: cuentaActual,
          subcuenta: subctaCodeSelected,
          cantidad: referencias.length,
          tarifas: referencias
        }
      );

      if (referencias.length === 0) {
        (target as any).__loadingTarifasColectivo = false;
        target.tarifasDisponibles = [];
        target.tarifasConsultaRealizada = true;
        this.conservarTarifaProgramaSeleccionada(target);
        this.cdRef.detectChanges();
        return;
      }

      const requestKey = [
        cuentaActual,
        subctaCodeSelected,
        planCodiServicio,
        this.edad,
        this.form.genero.value,
        this.form.parentesco.value
      ].join(':');

      const mismaConsulta =
        (target as any).__lastTarifaRequestKey ===
        requestKey;

      if (
        mismaConsulta &&
        (
          (target as any).__loadingTarifasColectivo ||
          (
            target.tarifasConsultaRealizada &&
            (target.tarifasDisponibles?.length ?? 0) > 0
          )
        )
      ) {
        return;
      }

      const requestId = `${Date.now()}-${Math.random()}`;

      (target as any).__lastTarifaRequestKey =
        requestKey;

      (target as any).__lastTarifaRequestId =
        requestId;

      (target as any).__loadingTarifasColectivo =
        true;

          const payloadBase =
            this.buildTarifaRequestForIndividual(target);

          if (!payloadBase?.modelo_negocio?.length) {
            (target as any).__loadingTarifasColectivo =
              false;

            target.tarifasDisponibles = [];
            target.tarifasConsultaRealizada = true;
            this.conservarTarifaProgramaSeleccionada(target);

            this.cdRef.detectChanges();
            return;
          }

          const consultasValores = referencias.map(
            (fila: any) => {
              const codigoTarifa = String(
                fila?.tarifa_codigo ??
                fila?.TARIFA_CODIGO ??
                fila?.tari ??
                fila?.TARI ??
                ''
              ).trim();

              const payloadTarifa: IDataTarifa = {
                ...payloadBase,
                prm_tari: codigoTarifa,
                modelo_negocio:
                  payloadBase.modelo_negocio.map(
                    modelo => ({
                      ...modelo,
                      programa: [planCodiServicio]
                    })
                  )
              };

              return this.networking
                .bucarTarifas(payloadTarifa, true)
                .pipe(
                  map((lista: any) => ({
                    fila,
                    codigoTarifa,
                    lista: Array.isArray(lista)
                      ? lista
                      : []
                  })),
                  catchError(error => {
                    console.warn(
                      `[Beneficiario-Tarifas] Error consultando ${codigoTarifa}`,
                      error
                    );

                    return of({
                      fila,
                      codigoTarifa,
                      lista: [] as any[]
                    });
                  })
                );
            }
          );

          forkJoin(consultasValores).subscribe({
            next: resultados => {
              if (
                (target as any).__lastTarifaRequestId !==
                requestId
              ) {
                return;
              }

              const tarifas: IListTarifa[] = [];

              resultados.forEach(resultado => {
                const descripcionCatalogo = String(
                  resultado.fila?.tarifa_nombre ??
                  resultado.fila?.TARIFA_NOMBRE ??
                  resultado.fila?.tari_deno ??
                  resultado.fila?.TARI_DENO ??
                  ''
                ).trim();

                resultado.lista.forEach((item: any) => {
                  const codigo = String(
                    item?.tarifa ??
                    item?.tari ??
                    item?.TARI ??
                    resultado.codigoTarifa
                  ).trim();

                  const descripcionValores = String(
                    item?.descripcion ??
                    item?.description ??
                    item?.tarifa_nombre ??
                    item?.TARIFA_NOMBRE ??
                    ''
                  ).trim();

                  const nombreTarifa = (
                    descripcionCatalogo ||
                    descripcionValores ||
                    this.resolverDescripcionTarifaColectivo(
                      resultado.fila,
                      codigo
                    ) ||
                    codigo
                  )
                    .replace(codigo, '')
                    .trim() || codigo;

                  const descripcionCompleta =
                    nombreTarifa !== codigo
                      ? `${nombreTarifa} (${codigo})`
                      : codigo;

                  const valor = Number(
                    item?.valorMensualIva ??
                    item?.valorMensualBase ??
                    item?.valor_iva ??
                    item?.VALOR_IVA ??
                    item?.valor ??
                    item?.VALOR
                  );

                  if (!codigo || !Number.isFinite(valor)) {
                    return;
                  }

                  tarifas.push({
                    // Valor que se guarda y se envía a los servicios
                    tarifa: codigo,
                    // Texto que se muestra en el selector
                    descripcion: descripcionCompleta,
                    description: descripcionCompleta,
                    programa_grupo: target.id,
                    codigo_programa_grupo: target.id,
                    programa: target.id,
                    valorMensualBase: valor,
                    valorMensualIva: valor,
                    porcentajeIva: Number(
                      item?.porcentajeIva ??
                      item?.porcentaje_iva ??
                      item?.PORCENTAJE_IVA ??
                      0
                    ),
                    esTarifaAsociado: false
                  });
                });
              });

              /*
              * Deduplicar por código técnico.
              */
              const mapaTarifas =
                new Map<string, IListTarifa>();

              tarifas.forEach(tarifa => {
                const codigo =
                  this.obtenerCodigoTarifa(
                    tarifa.tarifa
                  ).toUpperCase();

                if (
                  codigo &&
                  !mapaTarifas.has(codigo)
                ) {
                  mapaTarifas.set(
                    codigo,
                    tarifa
                  );
                }
              });

              target.tarifasDisponibles =
                Array.from(mapaTarifas.values());

              target.tarifasConsultaRealizada =
                true;

              (target as any).__loadingTarifasColectivo =
                false;

              /*
              * Una tarifa: preseleccionarla.
              * Varias: dejar el selector disponible.
              */
              this.applyTarifaProgramaAutoSelection(
                target
              );

              console.log(
                '[Beneficiario-Tarifas] Lista final',
                target.tarifasDisponibles
              );

              this.consultarAnexosParaPrograma(target);
              this.cdRef.detectChanges();
            },
            error: error => {
              if (
                (target as any).__lastTarifaRequestId !==
                requestId
              ) {
                return;
              }

              console.error(
                '[Beneficiario-Tarifas] Error procesando tarifas',
                error
              );

              (target as any).__loadingTarifasColectivo =
                false;

              target.tarifasDisponibles = [];
              target.tarifasConsultaRealizada = true;
              this.conservarTarifaProgramaSeleccionada(target);

              this.cdRef.detectChanges();
            }
          });

      return;
    }

    target.tarifasConsultaRealizada = false;
    const payloadIndividual = this.buildTarifaRequestForIndividual(target);
    if (!payloadIndividual?.modelo_negocio?.length) return;

    this.networking.bucarTarifas(payloadIndividual, this.esFlujoInclusion).subscribe({
      next: (lista) => {
        const arr = Array.isArray(lista) ? lista : [];
        const grupoProgramaTarifa = (
          arr.find(
            (tarifa: IListTarifa) =>
              !!tarifa?.grupoPrograma
          )?.grupoPrograma ?? ''
        ).toString().trim();

        if (this.codigoGrupoUtil(grupoProgramaTarifa)) {
          target.grupoPrograma = this.codigoGrupoUtil(grupoProgramaTarifa);

          const base = this.programasDisponibles.find(
            programa => programa.id === target.id
          );

          if (base) {
            base.grupoPrograma = this.codigoGrupoUtil(grupoProgramaTarifa);
          }
        }
        if (this.esFlujoInclusion) {

          if (arr.length === 0) {
            target.tarifasDisponibles = [];
            target.tarifa = '';
            target.requiereAnexo = null;
            target.tarifaAnexo = '';
            target.anexosDisponibles = [];
          } else {
            target.tarifasDisponibles = arr.map((t: any) => {
              const cod = (t?.tarifa || t?.tari || t?.TARI || (target as any).__tarifaInclusionOriginal || '').toString().trim();
              let desc = (t?.descripcion || t?.description || t?.tarifa_nombre || t?.TARIFA_NOMBRE || t?.nombreTarifa || '').toString().trim();
              const valorIva = t?.valor ?? t?.valorMensualIva ?? 0;
              if (!desc || desc.toLowerCase() === 'null' || desc === cod) {
                desc = (target as any).__tarifaNombreOriginal || (target as any).__tarifaInclusionOriginal || cod;
              }
              if (cod && desc && !desc.includes(cod)) {
                desc = `${cod} - ${desc}`;
              }
              return { ...t, tarifa: desc, descripcion: desc, description: desc, valorMensualIva: valorIva };
            });

            if (target.tarifasDisponibles.length > 0) {
              const actualTarifaLimpia = (target.tarifa || '').split(' - ')[0].trim().toUpperCase();
              const match = target.tarifasDisponibles.find(t => t.tarifa.split(' - ')[0].trim().toUpperCase() === actualTarifaLimpia || t.tarifa.toUpperCase() === target.tarifa.toUpperCase());
              if (match) {
                target.tarifa = match.tarifa;
              } else {
                target.tarifa = target.tarifasDisponibles[0].tarifa;
              }
            }
          }
        } else {
          // Venta Nueva Regular Individual: Recibe la lista plana nativa sin transformaciones (Intacto)
          target.tarifasDisponibles = arr;
        }

        target.tarifasConsultaRealizada = true;
        this.applyTarifaProgramaAutoSelection(target);

        // Inclusión: anexos solo si el carné trae precio base real
        if (!this.esFlujoInclusion || target.tarifasDisponibles.length > 0) {
          this.consultarAnexosParaPrograma(target);
        }

        this.cdRef.detectChanges();
      },
      error: (err) => {
        if (this.esFlujoInclusion) {
          target.tarifasDisponibles = [];
          target.tarifa = '';
          target.requiereAnexo = null;
          target.tarifaAnexo = '';
          target.anexosDisponibles = [];
          target.tarifasConsultaRealizada = true;
          this.applyTarifaProgramaAutoSelection(target);
        } else {
          target.tarifasDisponibles = [];
          target.tarifasConsultaRealizada = true;
          this.SnackBarService.alert('alert-danger', err.message || 'Error consultando tarifas');
        }
        this.cdRef.detectChanges();
      }
    });
  }

  private consultarAnexosParaPrograma(programaSel: ProgramaSeleccionado): void {
    const base = this.programasDisponibles.find(p => p.id === programaSel.id);
    if (!base || !base.requiereAnexos) return;

    let cuenta = '1';
    let subctaDeno = '';
    let planGroup = '';
    let planCodi = '';

    // Venta nueva colectivo / OGA (mismo criterio que contratante)
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const aCodigoComercialC = (codigo: string): string => {
        const c = (codigo || '').toString().trim().toUpperCase();
        if (c.endsWith('F') || c.endsWith('A')) {
          return c.substring(0, c.length - 1) + 'C';
        }
        return c;
      };
      const esLineaNegocioNoGrupo = (valor: string): boolean => {
        const u = (valor || '').toString().trim().toUpperCase();
        return !u || u === 'MI' || u === 'SO' || u === 'CEM' || u === '1' || u === '2' || u === '3';
      };

      const cuentaColectivo = (this.cuentaColectivoGA != null && Number(this.cuentaColectivoGA) > 0)
        ? String(this.cuentaColectivoGA).trim()
        : String(
          this.datosColectivoGA?.[0]?.cuenta
          ?? this.datosColectivoGA?.[0]?.CUENTA
          ?? Number((programaSel as any).__cuentaFromColectivo)
          ?? Number(this.dataCampania?.cuenta)
          ?? 1
        ).trim();

      const filaCol: any = (this.datosColectivoGA || []).find((r: any) => {
        const rowPlan = aCodigoComercialC(r?.plan_codi ?? r?.PLAN_CODI ?? '');
        const rowCuenta = String(r?.cuenta ?? r?.CUENTA ?? '').trim();
        return rowPlan === planCodiNorm && (!cuentaColectivo || rowCuenta === cuentaColectivo);
      });

      const planOriginal = (filaCol?.plan_codi ?? filaCol?.PLAN_CODI ?? '').toString().trim().toUpperCase();
      const deno = (programaSel.subcuenta || '').trim();
      const subActivo = (filaCol?.subcta ?? filaCol?.SUBCTA ?? '').toString().trim();
      const mapCode: Map<string, string> | undefined = (programaSel as any).__mapDenoToCode;
      let subctaColectivo = '';
      if (mapCode && deno) {
        subctaColectivo = (
          mapCode.get(deno.toUpperCase())
          || mapCode.get(this.norm(deno))
          || ''
        ).toString().trim();
      }
      if (!subctaColectivo) {
        subctaColectivo = ((programaSel as any).__subctaCodeSeleccionada || '').toString().trim();
      }
      if (!subctaColectivo) {
        subctaColectivo = subActivo;
      }

      // Validación: grupo comercial (OPL), nunca línea MI/SO/CEM.
      let planGrupoColectivo = '';
      const mapGrupo: Map<string, string> | undefined = (programaSel as any).__mapDenoAPlanGrupo;
      if (mapGrupo && deno) {
        planGrupoColectivo = (mapGrupo.get(deno.toUpperCase()) || mapGrupo.get(this.norm(deno)) || '').toString().trim();
      }
      if (esLineaNegocioNoGrupo(planGrupoColectivo)) {
        planGrupoColectivo = (
          filaCol?.plan_grupo
          ?? filaCol?.PLAN_GRUPO
          ?? filaCol?.grupo_programa
          ?? filaCol?.GRUPO_PROGRAMA
          ?? ''
        ).toString().trim();
      }

      const edadBeneficiarioColectivo = this.edad != null ? String(this.edad) : '0';
      const generoRawColectivo = (this.form.genero.value || '').toString().trim().toUpperCase();
      const sexoBeneficiarioColectivo = generoRawColectivo === '1' ? 'F' : (generoRawColectivo === '2' ? 'M' : '');

      const aplicarResultadoAnexos = (lista: any[]) => {
        const listaValida = (Array.isArray(lista) ? lista : []).filter((it: any) => {
          const planCod1 = (it?.plan_cod1 ?? '').toString().trim();
          const planDesc = (it?.plan_desc ?? '').toString().trim();
          const tari = (it?.tari ?? '').toString().trim();
          const valor = (it?.valor ?? '').toString().trim();
          const tieneCodiAdi = (it?.plan_codi_adi ?? '').toString().trim() !== '';
          return !!planCod1 && !!planDesc && (!!tari || !!valor) && !tieneCodiAdi;
        });
        programaSel.anexosDisponibles = listaValida;
        // NC1078 + NC-1096: no limpiar si hay anexo persistido (edición) o tarifaAnexo ya seteada (switch).
        if (!listaValida.length) {
          const tienePersistido = !!(programaSel.tarifaAnexo || '').toString().trim()
            || programaSel.requiereAnexo === 'si';
          if (!tienePersistido) {
            programaSel.requiereAnexo = null;
            programaSel.tarifaAnexo = '';
          }
        }
        this.applyTarifaAnexoAutoSelection(programaSel);
        this.cdRef.detectChanges();
      };

      const abortAnexosColectivo = () => {
        if ((programaSel.tarifaAnexo || '').toString().trim()) {
          this.applyTarifaAnexoAutoSelection(programaSel);
          this.cdRef.detectChanges();
          return;
        }
        programaSel.anexosDisponibles = [];
        const esEdicionFila = this.data?.[0] != null || this.guardar === false;
        const tienePersistido = !!(programaSel.tarifaAnexo || '').toString().trim()
          || programaSel.requiereAnexo === 'si';
        if (!(esEdicionFila && tienePersistido)) {
          programaSel.requiereAnexo = null;
          programaSel.tarifaAnexo = '';
        } else {
          this.applyTarifaAnexoAutoSelection(programaSel);
        }
        this.cdRef.detectChanges();
      };

      const dispararAnexos = (planGrupo: string, subcta: string) => {
        if (deno && !esLineaNegocioNoGrupo(planGrupo)) {
          const grupoMap: Map<string, string> = (programaSel as any).__mapDenoAPlanGrupo || new Map<string, string>();
          grupoMap.set(deno.toUpperCase(), planGrupo);
          (programaSel as any).__mapDenoAPlanGrupo = grupoMap;
        }
        this.networking.consultarAnexos(
          cuentaColectivo,
          subcta,
          planGrupo,
          '',
          edadBeneficiarioColectivo,
          sexoBeneficiarioColectivo
        ).subscribe({
          next: lista => aplicarResultadoAnexos(lista),
          error: () => abortAnexosColectivo()
        });
      };

      if (!cuentaColectivo || !subctaColectivo) {
        abortAnexosColectivo();
        return;
      }

      if (!esLineaNegocioNoGrupo(planGrupoColectivo)) {
        dispararAnexos(planGrupoColectivo, subctaColectivo);
        return;
      }

      if (!planOriginal) {
        abortAnexosColectivo();
        return;
      }

      this.networking.consultarSubcuentas(planOriginal).subscribe({
        next: (response: any) => {
          const rows: any[] = response?.data?.jsonRespuesta || response?.data?.JSONRESPUESTA || [];
          const subNorm = subctaColectivo.toUpperCase();
          const subActivoNorm = subActivo.toUpperCase();
          let grupoResuelto = '';
          let grupoFallback = '';
          let subctaResuelta = subctaColectivo;

          for (const r of rows) {
            if (String(r?.cuenta ?? r?.CUENTA ?? '').trim() !== cuentaColectivo) {
              continue;
            }
            const g = (r?.plan_grupo ?? r?.PLAN_GRUPO ?? '').toString().trim();
            if (esLineaNegocioNoGrupo(g)) {
              continue;
            }
            const rSub = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim().toUpperCase();
            if (subNorm && rSub === subNorm) {
              grupoResuelto = g;
              subctaResuelta = (r?.subcta ?? r?.SUBCTA ?? subctaColectivo).toString().trim();
              break;
            }
            if (!grupoFallback) {
              if (subActivoNorm && rSub === subActivoNorm) {
                grupoFallback = g;
              } else {
                grupoFallback = g;
              }
            }
          }

          if (!grupoResuelto) {
            grupoResuelto = grupoFallback;
          }

          if (!grupoResuelto) {
            abortAnexosColectivo();
            return;
          }
          dispararAnexos(grupoResuelto, subctaResuelta);
        },
        error: () => abortAnexosColectivo()
      });
      return;
    }

    // Inclusión
    else if (this.esFlujoInclusion) {
      const esInclusionColectivoOAfinidad = this.usarTarifaColectivaPorTipoPlan();
      cuenta = String(Number((programaSel as any).__cuentaFromColectivo) || Number(this.dataCampania?.cuenta) || 1);
      try {
        const rawContratoRadicado = localStorage.getItem('contrato_radicado');
        if (rawContratoRadicado) {
          const parsedRadicado = JSON.parse(rawContratoRadicado);
          const contratoRows = Array.isArray(parsedRadicado?.contrato) ? parsedRadicado.contrato : [];
          const hitContrato = contratoRows.find((cRow: any) =>
            (cRow?.cod_programa_afi || cRow?.COD_PROGRAMA_AFI || '').toString().trim().toUpperCase() === programaSel.id.trim().toUpperCase()
          );
          const codCuentaPref = (hitContrato?.cod_cuenta ?? hitContrato?.COD_CUENTA ?? '').toString().trim();
          if (codCuentaPref) cuenta = codCuentaPref;
        }
      } catch (_) { }
      // Individual (A/F/E): cuenta catálogo 1/2. Colectivo/GA: conservar cuenta del contrato (como contratante).
      if (!esInclusionColectivoOAfinidad) {
        if (!cuenta || (cuenta !== '1' && cuenta !== '2')) {
          const tipoPlan = (localStorage.getItem('tipoPlan') || '').toUpperCase().trim();
          cuenta = (tipoPlan === 'A' || tipoPlan === 'AS') ? '1' : '2';
        }
      }

      if (esInclusionColectivoOAfinidad) {
        // Misma prioridad que contratante: código técnico de subcuenta, no solo deno UI.
        subctaDeno = (
          (programaSel as any).__subctaCodeSeleccionada
          || ''
        ).toString().trim();
        if (!subctaDeno) {
          const raw: any[] = (programaSel as any).__subcuentasRaw || [];
          const denoSel = this.getSubctaDenoForAnexo(programaSel);
          const hit = raw.find((r: any) => this.norm(r?.deno) === this.norm(denoSel));
          subctaDeno = (hit?.subcta || denoSel || '').toString().trim();
        }
        planGroup = this.getPlanGrupoForAnexo(programaSel);
      } else {
        planCodi = ((programaSel as any).__planCodiColectivo || base.codigo || base.id || '').toString().trim();
        const tipoPlan = localStorage.getItem('tipoPlan') || '';
        const lineaCode = base.lineaNegocio === 'MI' ? 'SMP' : (base.lineaNegocio === 'SO' ? 'SAO' : 'CEM');
        subctaDeno = (tipoPlan + lineaCode).trim().toUpperCase();
      }
    }

    else {
      cuenta = String(Number((programaSel as any).__cuentaFromColectivo) || Number(this.dataCampania?.cuenta) || 1);
      if (this.usarTarifaColectivaPorTipoPlan()) {
        subctaDeno = this.getSubctaDenoForAnexo(programaSel);
        planGroup = this.getPlanGrupoForAnexo(programaSel);
      } else {
        planCodi = ((programaSel as any).__planCodiColectivo || base.codigo || base.id || '').toString().trim();
        const tipoPlan = localStorage.getItem('tipoPlan') || '';
        const lineaCode = base.lineaNegocio === 'MI' ? 'SMP' : (base.lineaNegocio === 'SO' ? 'SAO' : 'CEM');
        subctaDeno = (tipoPlan + lineaCode).trim().toUpperCase();
      }
    }

    const edadBeneficiario = this.edad != null ? String(this.edad) : "0";
    const generoRaw = (this.form.genero.value || '').toString().trim().toUpperCase();
    const sexoBeneficiario = generoRaw === '1' ? 'F' : (generoRaw === '2' ? 'M' : '');

    this.networking.consultarAnexos(
      cuenta,
      subctaDeno,
      planGroup,
      planCodi,
      edadBeneficiario,
      sexoBeneficiario
    ).subscribe({
      next: lista => {
        const listaValida = (Array.isArray(lista) ? lista : []).filter((it: any) => {
          const planCod1 = (it?.plan_cod1 ?? '').toString().trim();
          const planDesc = (it?.plan_desc ?? '').toString().trim();
          const tari = (it?.tari ?? '').toString().trim();
          const valor = (it?.valor ?? '').toString().trim();
          const tieneCodiAdi = (it?.plan_codi_adi ?? '').toString().trim() !== '';
          return !!planCod1 && !!planDesc && (!!tari || !!valor) && !tieneCodiAdi;
        });
        programaSel.anexosDisponibles = listaValida;
        // NC1078 + NC-1096: no limpiar si hay anexo persistido (edición) o tarifaAnexo ya seteada (switch).
        if (!listaValida.length) {
          const tienePersistido = !!(programaSel.tarifaAnexo || '').toString().trim()
            || programaSel.requiereAnexo === 'si';
          if (!tienePersistido) {
            programaSel.requiereAnexo = null;
            programaSel.tarifaAnexo = '';
          }
        }
        this.applyTarifaAnexoAutoSelection(programaSel);
        this.cdRef.detectChanges();
      },
      error: () => {
        programaSel.anexosDisponibles = [];
        const tienePersistido = !!(programaSel.tarifaAnexo || '').toString().trim()
          || programaSel.requiereAnexo === 'si';
        if (!tienePersistido) {
          programaSel.requiereAnexo = null;
          programaSel.tarifaAnexo = '';
        } else {
          this.applyTarifaAnexoAutoSelection(programaSel);
        }
      }
    });
  }
  private dispararTarifasParaProgramasSeleccionados(): void {

    if (this.esFlujoInclusion) {
      return;
    }

    if (!Array.isArray(this.programasSeleccionados)) return;
    this.programasSeleccionados.forEach((p) => {
      if ((p.subcuenta || '').trim() !== '') {
        this.buscarTarifa(p);
      }
    });
  }

  /** Sin tarifa/campaña (y anexo/subcuenta si aplica) no se habilita GUARDAR */
  puedeGuardarProgramasSeleccionados(): boolean {
    if (!Array.isArray(this.programasSeleccionados) || this.programasSeleccionados.length === 0) {
      return false;
    }
    if (this.anyCemFullSelected() && !this.coberturaCemValida) {
      return false;
    }
    return this.programasSeleccionados.every(p => {
      const tieneOpcionesSubcuenta = Array.isArray((p as any).subcuentasDisponibles) && (p as any).subcuentasDisponibles.length > 0;
      const requiereSubcuenta = this.debeMostrarSubcuenta && tieneOpcionesSubcuenta;
      if (requiereSubcuenta && !(p.subcuenta || '').toString().trim()) return false;
      if (
        !this.esFlujoColectivoOGA &&
        !this.esFlujoInclusion &&
        p.tarifasConsultaRealizada !== true
      ) {
        return false;
      }
      if (!(p.tarifa || '').toString().trim()) return false;
      if (!(p.campana || '').toString().trim()) return false;
      if (this.shouldShowTarifaAnexo(p) && !(p.tarifaAnexo || '').toString().trim()) return false;
      return true;
    });
  }

  isFormValid(): boolean {
    const doc = this.getSelectedDoc();
    if (doc && this.edad !== null && !Number.isNaN(Number(this.edad))) {
      const kind = this.getDocKind(doc);
      if (kind !== 'OTRO' && !this.isAgeValidFor(kind, Number(this.edad))) {
        this.form.fechaNacimiento.messages =
          'La edad ingresada no corresponde con el tipo de documento seleccionado. Por favor verifique.';
        return false;
      }
    }
    return (
      !!this.form.parentesco.value &&
      !!this.form.contratanteTipoDocumento.value &&
      !!this.form.contratanteDocumento.value &&
      !!this.form.nombre.value &&
      !!this.form.apellido.value &&
      !!this.form.genero.value &&
      !!this.form.fechaNacimiento.value
    );
  }

  tabOption(event: any, option: any) {
    const nextIndex = event ? event.index : parseInt(option);
    const esEdicion = this.guardar === false || !!this.data?.[3]?.isEditMode;

    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      if (nextIndex === 2 && this.selectedIndex === 2) {
        return;
      }
    }

    // edición: tabs ya habilitados
    if (!esEdicion && nextIndex !== 2 && nextIndex > this.maxStepReached + 1) {
      this.selectedIndex = this.maxStepReached;
      return;
    }

    switch (nextIndex) {
      case 0:
        this.selectedIndex = 0;
        break;
      case 1:
        if (esEdicion || this.yaConsultoAdres === true) {
          this.tabHabilitado.showResultTab = true;
          this.yaConsultoAdres = true;
          this.maxStepReached = Math.max(this.maxStepReached, 1);
          this.selectedIndex = 1;
          if (!this.historialCliente?.length) {
            this.precargarResultadosValidacionEdicion();
          }
        } else {
          this.selectedIndex = 0;
        }
        break;
      case 2:
        this.cargarContextoPlanSolicitudDesdeLocalStorage();
        this.evaluarReglasPlanYSolicitud();
        this.cdRef.detectChanges();
        this.tabHabilitado.showProgramTab = true;
        this.maxStepReached = Math.max(this.maxStepReached, 2);
        this.selectedIndex = 2;

        if (this.esFlujoInclusion) {
          this.initFlujoInclusion();
          this.reintentarCampaniasSiFaltan();
        } else if (this.esFlujoColectivoOGA === true && !this.esFlujoInclusion) {
          this.initFlujoColectivoGA();
          this.aplicarAutocargaProgramasContratanteSiCorresponde();
        } else {
          this.ensureProgramasYRehidratar();
          this.aplicarAutocargaProgramasContratanteSiCorresponde();
        }
        break;
    }
  }

  validarBeneficiarios(): boolean {
    return this.isFormValid();
  }

  onRequiereAnexoChange(programaSel: ProgramaSeleccionado): void {
    if (!this.shouldShowRequiereAnexo(programaSel)) {
      programaSel.requiereAnexo = null;
      programaSel.tarifaAnexo = '';
      this.cdRef.detectChanges();
      return;
    }

    if (programaSel.requiereAnexo !== 'si') {
      programaSel.requiereAnexo = 'no';
      programaSel.tarifaAnexo = '';
    } else if (programaSel.requiereAnexo === 'si') {
      this.consultarAnexosParaPrograma(programaSel);
    }

    this.cdRef.detectChanges();
  }

  onAnexoSeleccionadoChange(): void {
    this.syncTarifaAnexoCuandoCambiaAnexo();
  }

  private syncTarifaAnexoCuandoCambiaAnexo(): void {
    if (!Array.isArray(this.programasSeleccionados)) return;
    this.programasSeleccionados.forEach(p => {
      if (!this.shouldShowTarifaAnexo(p)) {
        p.tarifaAnexo = '';
        if ((p as any).__errors) delete (p as any).__errors.tarifaAnexo;
      }
    });
  };

  onActualizarBeneficiario(): void {
    this.agregar(true);
  }

  private buildProgramasConfigSnapshotActual(): any {

    return {
      usarProgramasContratante: this.usarProgramasContratante === true,
      lineasSeleccionadas: (this.lineasSeleccionadas ?? []).map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']),
      programas: (this.programasSeleccionados || []).map(p => {
        const base = this.resolveProgramaBase(p);
        const linea = base?.lineaNegocio ?? null;
        const programaCodigo = this.resolveProgramaCodigo(p);

        const tarifaDet = (p.tarifasDisponibles || []).find(t => this.norm(t.tarifa) === this.norm(p.tarifa));

        // Extraemos las vigencias almacenadas en la memoria del carnet
        const iniVig = (p as any).inicioVigencia || undefined;
        const finVig = (p as any).finVigencia || undefined;


        let programaPersistencia = programaCodigo;
        if (this.esFlujoGruposAfinidad()) {
          try {
            const afilmed = this.codigoProgramaParaGuardar(p);
            if (afilmed && !afilmed.endsWith('C')) {
              programaPersistencia = afilmed;
            }
          } catch {
            // Sin subcuenta todavía no se puede resolver el plan de Afilmed.
          }
        }

        return {
          id: p.id,
          programa: programaPersistencia,
          idBenPrograma: Number((p as any).__idBenPrograma || 0) || undefined,
          idSubcuenta: Number((p as any).__idSubcuenta || 0) || undefined,
          idCotizacionTarifa: Number((p as any).__idCotizacionTarifa || 0) || undefined,
          idCotizacionTarifaAnexo: Number((p as any).__idCotizacionTarifaAnexo || 0) || undefined,
          idCotizacionCampania: Number((p as any).__idCotizacionCampania || 0) || undefined,
          nombre: p.nombre,
          lineaNegocio: linea,
          lineaNegocioNombre: linea ? this.LINEA_MAP[linea as 'MI' | 'SO' | 'CEM'] : null,
          grupoPrograma:
            this.resolverGrupoProgramaParaGuardar(p, base),
          subcuenta: p.subcuenta,
          nombreSubcuenta: p.subcuenta,
          subcta: this.getSubctaCodeFor(p) || (p as any).__subctaCodeSeleccionada || (p as any).__subcuentaInclusionOriginal || undefined,
          tarifa: p.tarifa,
          nombreTarifa: tarifaDet?.descripcion || tarifaDet?.description || p.tarifa || '',
          valorMensualBase: tarifaDet?.valorMensualBase ?? undefined,
          valorMensualIva: tarifaDet?.valorMensualIva ?? undefined,
          porcentajeIva: tarifaDet?.porcentajeIva ?? undefined,
          campana: p.campana,
          campanaNombre: p.campanaNombre || '',

          inicioVigencia: iniVig,
          finVigencia: finVig,
          inicio_vigencia: iniVig,
          fin_vigencia: finVig,

          requiereAnexo: this.shouldShowRequiereAnexo(p) ? (p.requiereAnexo ?? null) : null,
          tarifaAnexo: this.shouldShowTarifaAnexo(p) ? (p.tarifaAnexo ?? null) : null
        };
      }),
      anexos: null
    };
  }

  private refreshPersonSalidaProgramas(person: any): void {
    (person as any).programasConfig = this.buildProgramasConfigSnapshotActual();
    (person as any).programIds = (this.programasSeleccionados || []).map(p => p.id);
  }

  agregar(forzarActualizar = false) {
    const requiereCEM = this.anyCemFullSelected();
    this.form.tipoVia.required = requiereCEM;
    this.form.numero.required = requiereCEM;
    this.form.placaUno.required = requiereCEM;
    this.form.placaDos.required = requiereCEM;
    this.form.ciudad.required = requiereCEM;

    if (!requiereCEM) {
      this.form.tipoVia.messages = '';
      this.form.numero.messages = '';
      this.form.placaUno.messages = '';
      this.form.placaDos.messages = '';
      this.form.ciudad.messages = '';
    }

    if ((!this.form.lineaNegocios.value || this.form.lineaNegocios.value.trim() === '') && this.lineasSeleccionadas.length) {
      const nombres = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']);
      this.form.lineaNegocios.value = nombres.join(', ');
      this.form.lineaNegocios.messages = '';
    }

    if ((!this.form.programa.value || this.form.programa.value.trim() === '') && this.programasSeleccionados.length) {
      this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
      this.form.programa.messages = '';
    }

    const reqBackup = { subcuenta: this.form.subcuenta.required, tarifa: this.form.tarifa.required, campania: this.form.campania.required };
    this.form.subcuenta.required = false;
    this.form.tarifa.required = false;
    this.form.campania.required = false;

    const t = new ValidationService(this.SnackBarService);
    const input = t.validateEmptyFields(this.form, true, 'Obligatorio');
    this.form = input.data;
    this.form.subcuenta.required = reqBackup.subcuenta;
    this.form.tarifa.required = reqBackup.tarifa;
    this.form.campania.required = reqBackup.campania;

    if (!input.success) {
      return;
    }

    if (Array.isArray(this.programasSeleccionados) && this.programasSeleccionados.length > 0) {
      let algunoInvalido = false;
      this.programasSeleccionados.forEach(p => {
        (p as any).__errors = {};
        const tieneOpcionesSubcuenta = Array.isArray((p as any).subcuentasDisponibles) && (p as any).subcuentasDisponibles.length > 0;
        const requiereSubcuenta = this.debeMostrarSubcuenta && tieneOpcionesSubcuenta;
        if (requiereSubcuenta && !p.subcuenta) {
          (p as any).__errors.subcuenta = 'La subcuenta es obligatoria para este programa';
          algunoInvalido = true;
        }
        if (!p.tarifa) {
          (p as any).__errors.tarifa = 'La tarifa es obligatoria para este programa';
          algunoInvalido = true;
        }
        if (!p.campana) {
          (p as any).__errors.campana = 'La campaña es obligatoria para este programa';
          algunoInvalido = true;
        }
        if (this.shouldShowTarifaAnexo(p) && !p.tarifaAnexo) {
          (p as any).__errors.tarifaAnexo = 'La tarifa del anexo es obligatoria para este programa';
          algunoInvalido = true;
        }
      });
      if (algunoInvalido) {
        this.SnackBarService.alert('alert-danger', 'Completa los campos requeridos en cada programa seleccionado.');
        return;
      }
    }

    const programasPendientesDeTarifa =
    (this.programasSeleccionados || []).filter(
      programa =>
        !this.esFlujoColectivoOGA &&
        !this.esFlujoInclusion &&
        programa.tarifasConsultaRealizada !== true
    );

    if (programasPendientesDeTarifa.length > 0) {
      console.warn(
        '[GRUPO-PROGRAMA] Guardado detenido: existen consultas de tarifas pendientes',
        programasPendientesDeTarifa.map(programa => ({
          programa: programa.id,
          grupoPrograma: programa.grupoPrograma,
          tarifasConsultaRealizada:
            programa.tarifasConsultaRealizada
        }))
      );

      this.SnackBarService.alert(
        'alert-warning',
        'Espera un momento mientras se termina de cargar la información de los programas.'
      );

      programasPendientesDeTarifa.forEach(programa => {
        this.buscarTarifa(programa);
      });

      return;
    }

    const objPersona = new BeneficiariosModel();
    if (this.form.parentesco && this.form.parentesco.value) {
      objPersona.parentesco_id = this.form.parentesco.value;
      const result = this.relationship.filter((b: any) => b.id == this.form.parentesco.value);
      if (result.length > 0) {
        objPersona.typeDescripcion = result[0].parentesco;
      }
    }
    if (this.form.campania && this.form.campania.value) {
      objPersona.campania = this.form.campania.value;
    }
    if (this.form.contratanteTipoDocumento && this.form.contratanteTipoDocumento.value) {
      objPersona.tipo_documento = this.form.contratanteTipoDocumento.value;
    }
    if (this.form.contratanteDocumento && this.form.contratanteDocumento.value) {
      objPersona.num_documento = this.form.contratanteDocumento.value;
    }
    if (this.form.nombre && this.form.nombre.value) {
      objPersona.primer_nombre = this.form.nombre.value;
    }
    if (this.form.nombreSegundo) {
      objPersona.segundo_nombre = this.form.nombreSegundo.value || '';
    }
    if (this.form.apellido && this.form.apellido.value) {
      objPersona.primer_apellido = this.form.apellido.value;
    }
    if (this.form.apellidoSegundo) {
      objPersona.segundo_apellido = this.form.apellidoSegundo.value || '';
    }
    if (this.form.genero && this.form.genero.value) {
      objPersona.genero = this.form.genero.value;
    }
    if (this.form.contratanteTarifa) {
      objPersona.tarifa = this.form.contratanteTarifa.value || '';
    }

    const fechaOriginalEdicion = this.data?.[0]?.fecha_nacimiento ?? this.data?.[0]?.fechaNacimiento ?? this.data?.[0]?.datebirth ?? '';
    const fechaNormalizadaForm = this.mapDDMMYYYY_to_YYYYMMDD(this.form.fechaNacimiento?.value as any);
    const fechaNormalizadaOriginal = this.mapDDMMYYYY_to_YYYYMMDD(fechaOriginalEdicion as any);
    const fechaFinal = fechaNormalizadaForm || fechaNormalizadaOriginal;

    if (fechaFinal) {
      objPersona.fecha_nacimiento = fechaFinal;
      if (this.edad === null || Number.isNaN(Number(this.edad))) {
        this.form.fechaNacimiento.messages = 'Debe ingresar una fecha de nacimiento válida para calcular la edad.';
        return;
      }
      objPersona.edad = String(this.edad);
    }
    objPersona.position = this.form.position.value ?? 0;
    this.validateDocTypeWithAge();
    if (this.form.fechaNacimiento.messages) return;

    if (this.form.lineaNegocios && this.form.lineaNegocios.value) {
      objPersona.lineOfBusiness = this.form.lineaNegocios.value;
    } else {
      const nombres = (this.lineasSeleccionadas ?? []).map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']);
      objPersona.lineOfBusiness = nombres.join(', ');
    }

    if (Array.isArray(this.programasSeleccionados) && this.programasSeleccionados.length > 0) {
      (objPersona as any).programasConfig = {
        usarProgramasContratante: this.usarProgramasContratante === true,
        lineasSeleccionadas: (this.lineasSeleccionadas ?? []).map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']),
        programas: this.programasSeleccionados.map(p => {
          const base = this.resolveProgramaBase(p);
          const linea = base?.lineaNegocio ?? null;
          const programaCodigo = this.resolveProgramaCodigo(p);
          return {
            id: p.id,
            programa: programaCodigo,
            idBenPrograma: Number((p as any).__idBenPrograma || 0) || undefined,
            idSubcuenta: Number((p as any).__idSubcuenta || 0) || undefined,
            idCotizacionTarifa: Number((p as any).__idCotizacionTarifa || 0) || undefined,
            idCotizacionTarifaAnexo: Number((p as any).__idCotizacionTarifaAnexo || 0) || undefined,
            idCotizacionCampania: Number((p as any).__idCotizacionCampania || 0) || undefined,
            nombre: p.nombre,
            lineaNegocio: linea,
            lineaNegocioNombre: linea ? this.LINEA_MAP[linea as 'MI' | 'SO' | 'CEM'] : null,
            subcuenta: p.subcuenta,
            subcta: this.getSubctaCodeFor(p) || undefined,
            tarifa: p.tarifa,
            campana: p.campana,
            campanaNombre: p.campanaNombre || '',
            requiereAnexo: this.shouldShowRequiereAnexo(p) ? (p.requiereAnexo ?? null) : null,
            tarifaAnexo: this.shouldShowTarifaAnexo(p) ? (p.tarifaAnexo ?? null) : null
          };
        }),
        anexos: null
      };
      objPersona.program = this.programasSeleccionados.map(p => p.nombre).join(', ');
      (objPersona as any).programIds = this.programasSeleccionados.map(p => p.id);
    }

    if (this.form.tipoVia && this.form.tipoVia.value) {
      (objPersona as any).tipoVia = this.form.tipoVia.value;
    }
    if (this.form.numero && this.form.numero.value) {
      (objPersona as any).numero = this.form.numero.value;
    }
    if (this.form.placaUno && this.form.placaUno.value) {
      (objPersona as any).placaUno = this.form.placaUno.value;
    }
    if (this.form.placaDos && this.form.placaDos.value) {
      (objPersona as any).placaDos = this.form.placaDos.value;
    }
    if (this.form.ciudad && this.form.ciudad.value) {
      (objPersona as any).ciudad = this.form.ciudad.value;
    }

    const tv = this.form.tipoVia.value ?? '';
    const num = this.form.numero.value ?? '';
    const p1 = this.form.placaUno.value ?? '';
    const p2 = this.form.placaDos.value ?? '';
    if (tv && num && p1 && p2) {
      (objPersona as any).direccion = `${tv} ${num} # ${p1} - ${p2}`;
    } else {
      (objPersona as any).direccion = '';
    }

    if (this.form.subcuenta && this.form.subcuenta.value) {
      objPersona.subcuenta = this.getSubcuentaDenoValue(this.form.subcuenta.value);
    }
    if (this.form.tarifa && this.form.tarifa.value) {
      objPersona.tarifa = this.form.tarifa.value;
    }
    if (this.form.tarifaAnexo && this.form.tarifaAnexo.value) {
      (objPersona as any).tarifaAnexo = this.form.tarifaAnexo.value;
    }

    const person: PersonBeneficiary = BeneficiariosModel.toPersons(objPersona) as any;
    (person as any).programasConfig = (objPersona as any).programasConfig;
    (person as any).programIds = (objPersona as any).programIds;
    // Bandera de vinculación al titular: depende del switch, no de esUsuario del contratante.
    (person as any).usarProgramasContratante = this.usarProgramasContratante === true;
    (person as any).tipoVia = (objPersona as any).tipoVia;
    (person as any).numero = (objPersona as any).numero;
    (person as any).placaUno = (objPersona as any).placaUno;
    (person as any).placaDos = (objPersona as any).placaDos;
    (person as any).ciudad = (objPersona as any).ciudad;

    this.capturarSnapshotInicial();

    if (this.esFlujoInclusion && this.esUsuario === true) {
      this.spinner.show();
      this.ejecutarLimpiezaProgramasRemovidosInclusion$().subscribe({
        next: () => {
          this.spinner.hide();

          this.permitirPersistenciaContratanteStorage = true;
          try {
            this.actualizarProgramasContratanteLocalStorage();
          } catch (e) {
          } finally {
            this.permitirPersistenciaContratanteStorage = false;
          }
          (person as any).__edicionContratanteLocal = true;
          this.refreshPersonSalidaProgramas(person);
          this.dialogRef.close(person);
        },
        error: (err) => {
          this.spinner.hide();

          this.permitirPersistenciaContratanteStorage = true;
          try { this.actualizarProgramasContratanteLocalStorage(); } catch (_) { } finally { this.permitirPersistenciaContratanteStorage = false; }

          this.refreshPersonSalidaProgramas(person);
          this.dialogRef.close(person);
        }
      });
      return;
    }

    if (this.esContextoContratanteReal()) {
      this.permitirPersistenciaContratanteStorage = true;
      try {
        this.persistirContratanteEnLocalStorageSolo();
      } finally {
        this.permitirPersistenciaContratanteStorage = false;
      }
      (person as any).__edicionContratanteLocal = true;
      this.refreshPersonSalidaProgramas(person);
      this.dialogRef.close(person);
      return;
    }

    const isEditModeDialog = !!this.data?.[3]?.isEditMode;

    let idBeneficiarioData = null;

    if (this.esFlujoInclusion) {
      idBeneficiarioData = this.data?.[0]?.id ??
        this.data?.[3]?.idBeneficiario ??
        this.data?.[0]?.id_beneficiario ??
        this.data?.[0]?.id_beneficiario_guardado ??
        this.data?.[0]?.idBeneficiario ??
        this.data?.[0]?.idBeneficiarioGuardado ??
        this.data?.[0]?._edicionItem?.idBeneficiario ??
        this.data?.[0]?._edicionItem?.id_beneficiario ??
        this.data?.[0]?._edicionItem?.idBeneficiario ?? null;
    } else {
      idBeneficiarioData = this.data?.[3]?.idBeneficiario ?? this.data?.[0]?.id_beneficiario ?? this.data?.[0]?.id_beneficiario_guardado ?? this.data?.[0]?.idBeneficiario ?? this.data?.[0]?.idBeneficiarioGuardado ?? this.data?.[0]?._edicionItem?.idBeneficiario ?? this.data?.[0]?._edicionItem?.id_beneficiario ?? this.data?.[0]?._edicionItem?.idBeneficiario ?? null;
    }


    let idBeneficiarioEdicion: number | null = Number(idBeneficiarioData) > 0 ? Number(idBeneficiarioData) : null;

    if (!(Number(idBeneficiarioEdicion || 0) > 0)) {
      try {
        const rawContratante = localStorage.getItem('datosRQ002_Contratante');
        const parsedContratante = rawContratante ? JSON.parse(rawContratante) : null;
        const idFromStorage = Number(parsedContratante?.idBeneficiario ?? parsedContratante?.id_beneficiario_guardado ?? 0);
        const docForm = (this.form.contratanteDocumento?.value || '').toString().trim();
        const docStorage = (parsedContratante?.numeroDocumento || '').toString().trim();
        const tipoForm = (this.form.contratanteTipoDocumento?.value || '').toString().trim().toUpperCase();
        const tipoStorage = (parsedContratante?.tipoDocumento || '').toString().trim().toUpperCase();
        if (idFromStorage > 0 && docForm && docForm === docStorage && tipoForm && tipoForm === tipoStorage) {
          idBeneficiarioEdicion = idFromStorage;
        }
      } catch {
        // no-op
      }
    }

    if (forzarActualizar) {
      if (this.debeActualizarBeneficiarioSoloLocal(isEditModeDialog, idBeneficiarioEdicion)) {
        const ok = this.actualizarBeneficiarioEnLocalStorage(person, objPersona);
        if (!ok) {
          this.SnackBarService.alert('alert-danger', 'No fue posible identificar el beneficiario a actualizar en localStorage.');
          return;
        }
        this.refreshPersonSalidaProgramas(person);
        this.dialogRef.close(person);
        return;
      }
      this.guardarBeneficiarioYTodoEditMode(idBeneficiarioEdicion, (idGuardado: number) => {
        (person as any).idBeneficiarioGuardado = idGuardado;
        this.refreshPersonSalidaProgramas(person);
        this.dialogRef.close(person);
      }, true);
      return;
    }

    if (isEditModeDialog) {
      this.guardarBeneficiarioYTodoEditMode(idBeneficiarioEdicion, (idGuardado: number) => {
        (person as any).idBeneficiarioGuardado = idGuardado;
        this.refreshPersonSalidaProgramas(person);
        this.dialogRef.close(person);
      });
    } else {
      const esEdicion = (this.data?.[0] != null) || (this.guardar === false);
      if (esEdicion) {
        if (this.debeActualizarBeneficiarioSoloLocal(false, idBeneficiarioEdicion)) {
          const ok = this.actualizarBeneficiarioEnLocalStorage(person, objPersona);
          if (!ok) {
            this.SnackBarService.alert('alert-danger', 'No fue posible identificar el beneficiario a actualizar en localStorage.');
            return;
          }
          this.refreshPersonSalidaProgramas(person);
          this.dialogRef.close(person);
          return;
        }
        const idBeneficiarioLocal = Number(idBeneficiarioEdicion || 0);
        if (idBeneficiarioLocal > 0) {
          this.guardarBeneficiarioYTodoEditMode(idBeneficiarioLocal, (idGuardado: number) => {
            (person as any).idBeneficiarioGuardado = idGuardado;
            this.refreshPersonSalidaProgramas(person);
            this.dialogRef.close(person);
          });
          return;
        }
        this.SnackBarService.alert('alert-danger', 'No fue posible identificar el beneficiario a actualizar.');
        return;
      } else {
        // Creación nueva: persistir en localStorage (sin llamar servicios backend)
        this.guardarBeneficiarioNuevoEnLocalStorage(person, objPersona);
        this.refreshPersonSalidaProgramas(person);
        this.dialogRef.close(person);
      }
    }
  }

  /** ACTUALIZAR solo LS; flecha persiste BD. Mis Cotizaciones/contratante/inclusión con id → HTTP */
  private debeActualizarBeneficiarioSoloLocal(
    isEditModeDialog: boolean,
    idBeneficiarioEdicion: number | null
  ): boolean {
    if (isEditModeDialog) return false;
    if (this.esContextoContratanteReal()) return false;
    if (this.esFlujoInclusion && Number(idBeneficiarioEdicion || 0) > 0) return false;
    return true;
  }

  /** Alta en datosRQ003 + programas_beneficiario (sin HTTP) */
  private guardarBeneficiarioNuevoEnLocalStorage(person: PersonBeneficiary, objPersona: BeneficiariosModel): void {
    const localId = this.beneficiarioLocalStorage.generarLocalId();
    const { datos, envelope } = this.buildPayloadBeneficiarioLocal(person, objPersona, localId);
    this.beneficiarioLocalStorage.guardarBeneficiarioNuevo(datos, envelope);
    (person as any).localId = localId;
  }

  /** Update en datosRQ003 + programas_beneficiario (sin HTTP) */
  private actualizarBeneficiarioEnLocalStorage(person: PersonBeneficiary, objPersona: BeneficiariosModel): boolean {
    const match: BeneficiarioLocalMatchKey = {
      localId: (
        this._matchBeneficiarioLocal?.localId ||
        this.data?.[3]?.localId ||
        (this.data?.[0] as any)?.localId ||
        (person as any)?.localId ||
        ''
      ).toString().trim() || undefined,
      tipoDocumento: this._matchBeneficiarioLocal?.tipoDocumento,
      numeroDocumento: this._matchBeneficiarioLocal?.numeroDocumento,
      parentesco: this._matchBeneficiarioLocal?.parentesco
    };

    const localId = (match.localId || this.beneficiarioLocalStorage.generarLocalId()).toString().trim();
    const { datos, envelope } = this.buildPayloadBeneficiarioLocal(person, objPersona, localId);
    const ok = this.beneficiarioLocalStorage.actualizarBeneficiario(match, datos, envelope);
    if (ok) {
      (person as any).localId = localId;
      this._matchBeneficiarioLocal = {
        localId,
        tipoDocumento: datos.contratanteTipoDocumento,
        numeroDocumento: datos.contratanteDocumento,
        parentesco: datos.parentesco
      };
    }
    return ok;
  }

  private buildPayloadBeneficiarioLocal(
    person: PersonBeneficiary,
    objPersona: BeneficiariosModel,
    localId: string
  ): { datos: DatosBeneficiarioLocal; envelope: ProgramasBeneficiarioEnvelope } {
    const idCotizacion = Number(this.getIdCotizacionFromLocal() || 0) || 0;
    const tipoDocumento = (objPersona.tipo_documento || person.tipoDocumento || '').toString().trim();
    const numeroDocumento = (objPersona.num_documento || person.documento || '').toString().trim();
    const parentesco = (objPersona.parentesco_id || this.form.parentesco?.value || '').toString().trim();
    const savedAt = new Date().toISOString();

    const fechaForm =
      (this.form.fechaNacimiento?.value || '').toString().trim() ||
      this.normalizeFechaForForm(objPersona.fecha_nacimiento || '');

    const lineaNegocios =
      (objPersona.lineOfBusiness || this.form.lineaNegocios?.value || '').toString().trim() ||
      (this.lineasSeleccionadas ?? []).map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']).join(', ');

    const programaIds = (this.programasSeleccionados || [])
      .map(p => this.resolveProgramaCodigo(p) || p.id)
      .filter(Boolean)
      .join(', ');

    const datos: DatosBeneficiarioLocal = {
      localId,
      parentesco: parentesco || undefined,
      contratanteTipoDocumento: tipoDocumento,
      contratanteDocumento: numeroDocumento,
      nombre: (objPersona.primer_nombre || '').toString().trim() || undefined,
      nombreSegundo: (objPersona.segundo_nombre || '').toString().trim() || undefined,
      apellido: (objPersona.primer_apellido || '').toString().trim() || undefined,
      apellidoSegundo: (objPersona.segundo_apellido || '').toString().trim() || undefined,
      genero: (objPersona.genero || '').toString().trim() || undefined,
      fechaNacimiento: fechaForm || undefined,
      edad: (this.edad != null && !Number.isNaN(Number(this.edad))
        ? String(this.edad)
        : (objPersona.edad || '').toString().trim()) || undefined,
      lineaNegocios: lineaNegocios || undefined,
      programa: programaIds || (this.form.programa?.value || '').toString().trim() || undefined,
      tipoVia: ((objPersona as any).tipoVia || this.form.tipoVia?.value || '').toString().trim() || undefined,
      numero: ((objPersona as any).numero || this.form.numero?.value || '').toString().trim() || undefined,
      placaUno: ((objPersona as any).placaUno || this.form.placaUno?.value || '').toString().trim() || undefined,
      placaDos: ((objPersona as any).placaDos || this.form.placaDos?.value || '').toString().trim() || undefined,
      ciudad: ((objPersona as any).ciudad || this.form.ciudad?.value || '').toString().trim() || undefined,
      usarProgramasContratante: (person as any).usarProgramasContratante === true
    };

    let programas: ProgramaItemStore[] = [];
    try {
      programas = this.buildProgramasBeneficiarioItems();
    } catch {
      programas = [];
    }

    const envelope: ProgramasBeneficiarioEnvelope = {
      localId,
      idCotizacion,
      tipoDocumento,
      numeroDocumento,
      parentesco: parentesco || undefined,
      savedAt,
      programas
    };

    return { datos, envelope };
  }

  /** Misma forma que programas_contratante */
  private buildProgramasBeneficiarioItems(): ProgramaItemStore[] {
    return (this.programasSeleccionados || []).map(ps => {
      const base = this.programasDisponibles.find(p => p.id === ps.id);
      const esCem = base?.lineaNegocio === 'CEM';
      const programaCodigoRaw = (this.resolveProgramaCodigo(ps) || base?.codigo || ps.id || '').toString().trim();
      const programaCodigo = programaCodigoRaw.split('|')[0].trim();
      const lineaBase = (base?.lineaNegocio || this.resolveProgramaBase(ps)?.lineaNegocio || '').toString().trim().toUpperCase();
      const lineaNegocioStorage = lineaBase === 'SO' ? 'SAO' : lineaBase;

      const tarifaRaw = (ps.tarifa || '').trim();
      const codInclusionOriginal = this.obtenerCodigoTarifa(
        ((ps as any).__tarifaInclusionOriginal || '').toString()
      );
      const codDesdeTexto = this.obtenerCodigoTarifa(tarifaRaw)
        || tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim()
        || tarifaRaw;
      const tarifaDet = (ps.tarifasDisponibles as any[])?.find(
        (t: any) => {
          const tCod = this.obtenerCodigoTarifa((t?.tarifa || '').toString());
          if (codInclusionOriginal && this.norm(tCod) === this.norm(codInclusionOriginal)) {
            return true;
          }
          return this.norm(t?.tarifa) === this.norm(codDesdeTexto) || this.norm(t?.tarifa) === this.norm(tarifaRaw);
        }
      );

      let codigoTarifa = (
        codInclusionOriginal ||
        (tarifaDet?.tarifa ? this.obtenerCodigoTarifa(tarifaDet.tarifa) : '') ||
        this.obtenerCodigoTarifa(tarifaRaw) ||
        codDesdeTexto ||
        ''
      ).toString().trim();
      let valorTarifaBase = Number.isFinite(Number(tarifaDet?.valorMensualBase))
        ? Number(tarifaDet?.valorMensualBase)
        : (Number.isFinite(Number(tarifaDet?.valorMensualIva)) ? Number(tarifaDet?.valorMensualIva) : null);
      let valorTarifaIva = Number.isFinite(Number(tarifaDet?.valorMensualIva))
        ? Number(tarifaDet?.valorMensualIva)
        : valorTarifaBase;
      let nombreTarifaResuelta = (
        tarifaDet?.descripcion
        || tarifaDet?.description
        || (ps as any).__tarifaNombreOriginal
        || ps.tarifa
        || ''
      ).toString().trim() || null;

      if (this.esFlujoInclusion && codInclusionOriginal && !codigoTarifa) {
        codigoTarifa = codInclusionOriginal;
      }

      if ((ps as any).__tarifaCodigoLimpio) {
        codigoTarifa = (ps as any).__tarifaCodigoLimpio;
      }

      const tarifaDetalle = codigoTarifa ? {
        tari: codigoTarifa,
        nombreTarifa: nombreTarifaResuelta,
        valorMensualBase: valorTarifaBase ?? (ps as any)?.valorMensualBase ?? null,
        valorMensualIva: valorTarifaIva ?? (ps as any)?.valorMensualIva ?? null,
        porcentajeIva: tarifaDet?.porcentajeIva ?? null,
        esTarifaAsociado: tarifaDet?.esTarifaAsociado ?? null,
        fueSeleccionada: true as const,
        esAnexo: false as const,
        tariTipo: (tarifaDet?.tariTipo ?? null) as 'I' | 'C' | null,
      } : null;

      const codigoCampana = (ps.campana || '').toString().trim();
      const campaniaSeleccionada = this.getCampaniasParaPrograma(ps).find(
        c => {
          const cod = (c?.codigo_campania || '').toString().trim();
          const nombre = (c?.nombre || '').toString().trim();
          return cod === codigoCampana || this.norm(nombre) === this.norm(codigoCampana);
        }
      );

      const campaniaDetalle = campaniaSeleccionada ? {
        codCampComercial: (campaniaSeleccionada.codigo_campania ?? '').toString().trim(),
        nombreCampania: (campaniaSeleccionada.nombre ?? '').toString().trim(),
        fueSeleccionada: true as const,
        idCampania: campaniaSeleccionada.id_campania,
        tipoCampania: campaniaSeleccionada.tipo_campania,
        modalidad: campaniaSeleccionada.modalidad,
        cuenta: campaniaSeleccionada.cuenta,
        subcuenta: campaniaSeleccionada.subcuenta,
        tipoPlan: campaniaSeleccionada.tipo_plan,
        parentesco: campaniaSeleccionada.parentesco,
        edadDesde: campaniaSeleccionada.edad_desde,
        edadHasta: campaniaSeleccionada.edad_hasta,
        cantBenefDesde: campaniaSeleccionada.cant_benef_desde,
        cantBenefHasta: campaniaSeleccionada.cant_benef_hasta,
        acumulable: campaniaSeleccionada.acumulable,
        pagoDebitoAuto: campaniaSeleccionada.pago_debito_auto,
        aplicaProntoPago: (campaniaSeleccionada as any).aplica_pronto_pago,
        observaciones: campaniaSeleccionada.observaciones,
        usuarioActualizacion: (campaniaSeleccionada as any).usuario_actualizacion ?? '',
        lineaNegocio: campaniaSeleccionada.linea_negocio,
        grupoPrograma: campaniaSeleccionada.grupo_programa,
        programa: campaniaSeleccionada.programa,
        inicioVigencia: campaniaSeleccionada.inicio_vigencia,
        finVigencia: campaniaSeleccionada.fin_vigencia,
        estado: campaniaSeleccionada.estado,
      } : null;

      const codAnexoSel = (ps.tarifaAnexo || '').trim();
      const anexoSel = (ps.anexosDisponibles || []).find(an => this.matchAnexoSeleccion(an, codAnexoSel)) || (ps as any).anexoDetalle;
      const valorAnexoNumRaw = Number((anexoSel?.valor ?? anexoSel?.valorMensualIva ?? '').toString().trim());
      const valorAnexoNum = Number.isFinite(valorAnexoNumRaw) ? valorAnexoNumRaw : null;
      const anexoCodigoNormalizado = (!anexoSel && !codAnexoSel) ? '' : programaCodigo;
      const anexoDetalle = anexoSel ? {
        clave: programaCodigo,
        tari: (anexoSel.tari || '').trim(),
        nombreTarifa: (anexoSel.plan_desc || anexoSel.nombreTarifa || '').toString().trim(),
        valorMensualIva: valorAnexoNum,
        valorMensualBase: null as null,
        porcentajeIva: null as null,
        esTarifaAsociado: null as null,
        fueSeleccionada: true as const,
        esAnexo: true as const,
      } : null;

      const subctaNum = this.getSubctaCodeFor(ps) || (ps as any).__subctaCodeSeleccionada || (ps as any).__subcuentaInclusionOriginal || '';

      const grupoPrograma =
        this.resolverGrupoProgramaParaGuardar(ps, base);  

      const item: ProgramaItemStore = {
        lineaNegocio: lineaNegocioStorage,
        grupo: base?.grupoPrograma ?? '',
        grupoPrograma: grupoPrograma,
        programa: programaCodigo,
        nombrePrograma: (base?.nombre || ps.nombre || '').toString().trim(),
        subcta: subctaNum,
        subcuenta: ps.subcuenta ?? '',
        tarifa: codigoTarifa,
        tarifaDetalle,
        tariTipo: tarifaDetalle?.tariTipo ?? null,
        anexoCodigo: anexoCodigoNormalizado,
        anexoDetalle,
        requiereAnexo: ps.requiereAnexo ?? null,
        campana: codigoCampana,
        campaniaDetalle,
        idBenPrograma: Number((ps as any).__idBenPrograma || 0) || undefined,
        idCotizacionTarifa: Number((ps as any).__idCotizacionTarifa || 0) || undefined,
        idCotizacionTarifaAnexo: Number((ps as any).__idCotizacionTarifaAnexo || 0) || undefined,
        idBenCampania: Number((ps as any).__idCotizacionCampania || (ps as any).__idBenCampania || 0) || undefined,
      };
      (item as any).idSubcuenta = Number((ps as any).__idSubcuenta || 0) || undefined;
      (item as any).idCotizacionCampania = Number((ps as any).__idCotizacionCampania || 0) || undefined;
      (item as any).__idBenPrograma = (item as any).idBenPrograma;
      (item as any).__idSubcuenta = (item as any).idSubcuenta;
      (item as any).__idCotizacionTarifa = item.idCotizacionTarifa;
      (item as any).__idCotizacionTarifaAnexo = item.idCotizacionTarifaAnexo;
      (item as any).__idCotizacionCampania = (item as any).idCotizacionCampania;

      if (esCem) {
        item.coberturaValida = this.coberturaCemValida === true;
      }

      return item;
    });
  }

  private getIdCotizacionFromLocal(): number | null {

    if (this.esFlujoInclusion) {
      try {
        const raw = localStorage.getItem('cotizacion_cargada');
        if (raw) {
          const parsed = JSON.parse(raw);
          const id = Number(parsed?.idCotizacion || 0);
          if (Number.isFinite(id) && id > 0) return id;
        }
      } catch { }

      try {
        const rawCreada = localStorage.getItem('cotizacion_creada_desde_contratante');
        if (rawCreada) {
          const parsedCreada = JSON.parse(rawCreada);
          const enRaiz = Number(parsedCreada?.idCotizacion || 0);
          const enData = Number(parsedCreada?.data?.idCotizacion || 0);
          const idCreada = enRaiz > 0 ? enRaiz : enData;
          if (Number.isFinite(idCreada) && idCreada > 0) return idCreada;
        }
      } catch { }

      const fromData =
        Number(this.data?.[3]?.idCotizacion || 0) ||
        Number(this.data?.[0]?.idCotizacion || 0) ||
        Number(this.data?.[0]?.id_cotizacion || 0);

      if (Number.isFinite(fromData) && fromData > 0) return fromData;

      return null;
    }


    // Venta nueva / flujo normal: priorizar keys del contratante antes que cotizacion_cargada (edición).
    try {
      const rawCreada = localStorage.getItem('cotizacion_creada_desde_contratante');
      if (rawCreada) {
        const parsedCreada = JSON.parse(rawCreada);
        const enRaiz = Number(parsedCreada?.idCotizacion || 0);
        const enData = Number(parsedCreada?.data?.idCotizacion || 0);
        const idCreada = enRaiz > 0 ? enRaiz : enData;
        if (Number.isFinite(idCreada) && idCreada > 0) {
          return idCreada;
        }
      }
    } catch { }

    try {
      const rawPrecargada = localStorage.getItem('cotizacion_precargada');
      if (rawPrecargada) {
        const parsedPrecargada = JSON.parse(rawPrecargada);
        const idPrecargada = Number(parsedPrecargada?.idCotizacion || 0);
        if (Number.isFinite(idPrecargada) && idPrecargada > 0) {
          return idPrecargada;
        }
      }
    } catch { }

    // cotizacion_cargada solo aplica en edición; en venta nueva ignorarla aunque quede residual.
    if (this.esContextoEdicionBeneficiario()) {
      try {
        const raw = localStorage.getItem('cotizacion_cargada');
        if (raw) {
          const parsed = JSON.parse(raw);
          const id = Number(parsed?.idCotizacion || 0);
          if (Number.isFinite(id) && id > 0) {
            return id;
          }
        }
      } catch { }
    }

    const fromData =
      Number(this.data?.[3]?.idCotizacion || 0) ||
      Number(this.data?.idCotizacion || 0);

    if (Number.isFinite(fromData) && fromData > 0) {
      return fromData;
    }

    const legacy = Number(localStorage.getItem('idCotizacion') || 0);
    if (Number.isFinite(legacy) && legacy > 0) {
      return legacy;
    }

    return null;
  }

  /** true solo en edición (cotizacion_cargada no cuenta en venta nueva) */
  private esContextoEdicionBeneficiario(): boolean {
    if (this.data?.[3]?.isEditMode === true) {
      return true;
    }
    try {
      if (localStorage.getItem('cotizacion_edicion_contratante')) {
        return true;
      }
      const rawPrec = localStorage.getItem('cotizacion_precargada');
      if (rawPrec) {
        const prec = JSON.parse(rawPrec);
        if (prec?.editMode === true) {
          return true;
        }
      }
    } catch { /* no-op */ }
    return false;
  }

  private buildBeneficiariosParaGuardarTab1(): Beneficiarios {
    const m = new BeneficiariosModel();
    const idCot = this.getIdCotizacionFromLocal() ?? (
      Number(localStorage.getItem('idCotizacion') || 0) ||
      Number((this as any).id_cotizacion || 0) ||
      Number(this.data?.idCotizacion || 0) ||
      0
    );
    m.id_cotizacion = idCot;


    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const esTitularParentesco = (this.form.parentesco?.value ?? '').toString().trim().toUpperCase() === 'T';
      m.es_contratante = this.esBeneficiarioParentescoTitular() || this.esContextoContratanteReal();
    } else {
      const esUsuLocal = this.obtenerEsUsuarioDesdeLocal();
      const esUsu = (this.esUsuario !== null && this.esUsuario !== undefined) ? this.esUsuario : esUsuLocal;
      m.es_contratante = (esUsu === true);
    }
    try {
      const raw = localStorage.getItem('cotizacion_creada_desde_contratante');
      const parsed = raw ? JSON.parse(raw) : null;
      const idContratanteLS = Number(parsed?.data?.idContratante || 0) || null;
      if (idContratanteLS != null) {
        (m as any).idContratante = idContratanteLS;
      }
    } catch (_) { }

    m.parentesco_id = (this.form.parentesco.value || '').toString();
    m.tipo_documento = (this.form.contratanteTipoDocumento.value || '').toString();
    m.num_documento = (this.form.contratanteDocumento.value || '').toString();
    m.primer_nombre = (this.form.nombre.value || '').toString();
    m.segundo_nombre = (this.form.nombreSegundo.value || '').toString();
    m.primer_apellido = (this.form.apellido.value || '').toString();
    m.segundo_apellido = (this.form.apellidoSegundo.value || '').toString();
    m.genero = (this.form.genero.value || '').toString();
    m.fecha_nacimiento = this.mapDDMMYYYY_to_YYYYMMDD(this.form.fechaNacimiento.value || '');
    if (!m.fecha_nacimiento) {
      m.fecha_nacimiento = this.mapDDMMYYYY_to_YYYYMMDD(
        this.data?.[0]?.fecha_nacimiento ?? this.data?.[0]?.fechaNacimiento ?? this.data?.[0]?.datebirth ?? ''
      );
    }
    m.edad = (this.edad != null ? String(this.edad) : '');
    m.lineOfBusiness = '';
    m.program = '';
    m.tarifa = '';
    m.descriptionTarifa = '';
    m.email = '';
    m.movilNumber = '';
    m.phone = '';
    m.codigo_campania = '';
    m.campania = '';
    m.tipoVia = '';
    m.numero = '';
    m.placaUno = '';
    m.placaDos = '';
    m.ciudad = '';
    m.direccion = '';
    m.anexo = '';
    m.subcuenta = '';
    m.tarifaAnexo = '';

    return m;
  }

  private extractIdBeneficiarioFromResponse(resp: any): number {
    const candidates = [
      resp?.data?.idBeneficiario,
      resp?.data?.id_beneficiario,
      resp?.idBeneficiario,
      resp?.id_beneficiario,
      resp?.data?.beneficiario?.idBeneficiario,
      resp?.data?.beneficiario?.id_beneficiario,
      Array.isArray(resp?.data) ? resp.data?.[0]?.idBeneficiario : null,
      Array.isArray(resp?.data) ? resp.data?.[0]?.id_beneficiario : null,
      resp?.data?.jsonRespuesta?.idBeneficiario,
      resp?.data?.jsonRespuesta?.id_beneficiario,
      Array.isArray(resp?.data?.jsonRespuesta) ? resp.data?.jsonRespuesta?.[0]?.idBeneficiario : null,
      Array.isArray(resp?.data?.jsonRespuesta) ? resp.data?.jsonRespuesta?.[0]?.id_beneficiario : null
    ];

    for (const value of candidates) {
      const n = Number(value);
      if (Number.isFinite(n) && n > 0) return n;
    }

    return 0;
  }

  private esRespuestaDuplicadoBeneficiario(response?: any, error?: any): boolean {
    const payload = error?.error || error || response || null;
    const message = (payload?.errorMessage || payload?.message || error?.message || '').toString().toUpperCase();
    return (
      payload?.status === false
      || !!error
    ) && (
      message.includes('DUPLICADO')
      || message.includes('YA EXISTE')
      || message.includes('(IDCOTIZACION, PARENTESCOID, TIPODOCUMENTO, NUMDOCUMENTO)')
    );
  }

  /** Lookup local ante anti-dup (backend data:null). Sin DELETE */
  private resolverIdBeneficiarioExistenteLocal(payload: Beneficiarios): number {
    const candidates = [
      this.data?.[0]?.id_beneficiario,
      this.data?.[0]?.idBeneficiario,
      this.data?.[0]?.idBeneficiarioGuardado,
      this.data?.[0]?.id,
      this.data?.[3]?.idBeneficiario,
      this.data?.[0]?._edicionItem?.idBeneficiario,
      this.data?.[0]?._edicionItem?.id_beneficiario,
    ];
    for (const c of candidates) {
      const id = Number(c || 0);
      if (id > 0) return id;
    }

    const tipo = (payload?.tipo_documento || '').toString().trim().toUpperCase();
    const num = (payload?.num_documento || '').toString().trim();
    if (!num) return 0;

    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (raw) {
        const parsed = JSON.parse(raw);
        const lsNum = (parsed?.numeroDocumento || '').toString().trim();
        const lsTipo = (parsed?.tipoDocumento || '').toString().trim().toUpperCase();
        if (lsNum === num && (!tipo || !lsTipo || lsTipo === tipo)) {
          const id = Number(parsed?.idBeneficiario || parsed?.id_beneficiario_guardado || 0);
          if (id > 0) return id;
        }
      }
    } catch {
      // no-op
    }

    return 0;
  }

  private guardarBeneficiarioYTodo(force = false, onOk?: (id?: number) => void): void {
    const esValido = this.isFormValid();
    if (!esValido && !force) {
      this.SnackBarService.alert(
        'alert-danger',
        'Completa los campos obligatorios del beneficiario.'
      );
      this.selectedIndex = 0;
      return;
    }

    const idCotizacion = this.idCotizacionContext;
    if (!idCotizacion || idCotizacion <= 0) {
      this.SnackBarService.alert(
        'alert-danger',
        'No se encontró la cotización activa para guardar.'
      );
      return;
    }

    const b = this.buildBeneficiariosParaGuardarTab1();
    b.id_cotizacion = idCotizacion;

    const esUsuLocal = this.obtenerEsUsuarioDesdeLocal();
    b.es_contratante =
      typeof this.esUsuario === 'boolean'
        ? this.esUsuario
        : !!esUsuLocal;

    let idBeneficiarioGuardado = 0;

    this.spinner.show();

    this.networking.guardarDatosBeneficiarios(b).pipe(
      concatMap((resp: any) => {
        let idFromResp = this.extractIdBeneficiarioFromResponse(resp);
        if (idFromResp <= 0 && this.esFlujoInclusion && this.esRespuestaDuplicadoBeneficiario(resp)) {
          idFromResp = this.resolverIdBeneficiarioExistenteLocal(b);
        }
        if (idFromResp <= 0) {
          const backendMessage =
            resp?.message ||
            resp?.errorMessage ||
            resp?.data?.message ||
            resp?.data?.mensaje ||
            '';

          throw new Error(backendMessage || 'No se obtuvo idBeneficiario.');
        }
        idBeneficiarioGuardado = idFromResp;
        return of(idBeneficiarioGuardado);
      }),

      concatMap(() => this.completarGruposProgramaSeleccionados()),
      concatMap(() => {
        const items = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);
          return {
            lineaNegocio: base?.lineaNegocio ?? '',
            programa: this.codigoProgramaParaGuardar(ps),
            nombrePrograma: base?.nombre ?? ps.nombre,
            grupoPrograma:
              this.resolverGrupoProgramaParaGuardar(ps, base),
            esAnexo: this.shouldShowRequiereAnexo(ps) ? ps.requiereAnexo === 'si' : false
          };
        });

        if (!items.length) return of({});

        return this.networking.guardarBeneficiarioProgramas({
          idCotizacion,
          idBeneficiario: idBeneficiarioGuardado,
          items
        });
      }),

      concatMap(() => {
        if (!this.shouldActualizarSubcuentas()) {
          return of(true);
        }
        const esFlujoColectivoBenef = this.esFlujoColectivoOGA && !this.esFlujoInclusion;
        const subcuentas = this.programasSeleccionados
          .map(ps => {
            if (this.esFlujoInclusion) {
              const resolved = this.resolverSubctaDesdeCatalogoInclusion(ps);
              if (!resolved) return null;
              return {
                subcta: resolved.subcta,
                nombreSubcuenta: resolved.nombreSubcuenta,
                planCodi: (ps.id || '').toString().trim().toUpperCase()
              };
            }

            const code = ((ps as any).__subctaCodeSeleccionada || (ps as any).__subctaFromColectivo || (ps as any).__subcuentaInclusionOriginal || this.getSubctaCodeFor(ps) || ps.subcuenta || '').toString().trim();
            if (!code) return null;

            const rawList: any[] = (ps as any).__subcuentasRaw || [];
            const match = rawList.find(r => (r?.subcta ?? r?.SUBCTA ?? '').toString().trim() === code);
            const rawDeno = (match?.deno ?? match?.DENO ?? ps.subcuenta ?? code).toString().trim();
            const planCodiUi = (ps.id || '').toString().trim().toUpperCase();
            let planCodi = planCodiUi;
            if (this.esFlujoGruposAfinidad()) {
              try {
                const afilmed = this.codigoProgramaParaGuardar(ps);
                if (afilmed && !afilmed.endsWith('C')) {
                  planCodi = afilmed;
                }
              } catch {
                planCodi = planCodiUi;
              }
            }

            let nombreSubcuentaFinal = rawDeno;

            if (esFlujoColectivoBenef) {
              const esFraseLarga = !rawDeno || rawDeno.includes(' ') || rawDeno.length > 15 || rawDeno.toUpperCase().includes('CAMPAÑA') || rawDeno.toUpperCase().includes('NUMERO DE USUARIOS');
              if (esFraseLarga) {
                nombreSubcuentaFinal = `${planCodi}${code}`;
              } else {
                nombreSubcuentaFinal = rawDeno.toUpperCase();
              }
            }

            return {
              subcta: code,
              nombreSubcuenta: nombreSubcuentaFinal || code,
              planCodi: planCodi
            };
          })
          .filter(Boolean) as any[];

        if (!subcuentas.length) return of(true);
        return this.networking.guardarSubcuentas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, subcuentas });
      }),

      concatMap(() => {
        const consultas = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);

          return this.networking.consultarBeneficiarioPrograma({
            idCotizacion,
            idBeneficiario: idBeneficiarioGuardado,
            programa: this.codigoProgramaParaGuardar(ps)
          }).pipe(
            map(resp => {
              if (resp?.data?.idBenPrograma) {
                (ps as any).__idBenPrograma = resp.data.idBenPrograma;
              }
              return resp;
            })
          );
        });

        if (!consultas.length) {
          return of(true);
        }

        return forkJoin(consultas);
      }),

      concatMap(() => {
        const tarifasSel = this.buildTarifasSeleccionadasActualizar(false);
        if (!tarifasSel.length) {
          return of(true);
        }

        const programas = tarifasSel.reduce((acc: any[], ref) => {
          let target = acc.find(item => Number(item.idBenPrograma) === Number(ref.idBenPrograma || 0));
          if (!target) {
            target = { idBenPrograma: Number(ref.idBenPrograma || 0), tarifas: [] };
            acc.push(target);
          }

          let valBaseFinal = ref.valorMensualBase ?? null;
          let valIvaFinal = ref.valorMensualIva ?? valBaseFinal;

          if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
            if (ref.valorMensualBase != null && Number.isFinite(Number(ref.valorMensualBase))) {
              valBaseFinal = Number(ref.valorMensualBase);
              valIvaFinal = Number(ref.valorMensualIva ?? ref.valorMensualBase);
            }
          }

          target.tarifas.push({
            tari: this.obtenerCodigoTarifa(ref.tari),
            nombreTarifa: ref.nombreTarifa ?? null,
            esTarifaAsociado: ref.esTarifaAsociado ?? null,
            fueSeleccionada: ref.fueSeleccionada,
            esAnexo: ref.esAnexo,
            valorMensualBase: valBaseFinal,
            valorMensualIva: valIvaFinal,
            porcentajeIva: ref.porcentajeIva ?? null
          });

          return acc;
        }, [] as any[]);

        return this.networking.guardarTarifas({
          idCotizacion,
          idBeneficiario: idBeneficiarioGuardado,
          programas
        }).pipe(
          concatMap(resp => {
            this.hydrateIdsCotizacionTarifaDesdeRespuesta(resp, tarifasSel);
            const consultas = this.programasSeleccionados
              .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
              .map(ps => this.networking.consultarBeneficiarioPrograma({
                idCotizacion,
                idBeneficiario: idBeneficiarioGuardado,
                programa: this.codigoProgramaParaGuardar(ps)
              }).pipe(
                map(r => {
                  this.hydrateIdsCotizacionTarifaDesdeConsultarPrograma(ps, r);
                  return r;
                }),
                catchError(() => of(null))
              ));

            if (!consultas.length) {
              return of(resp);
            }

            return forkJoin(consultas).pipe(map(() => resp));
          })
        );
      }),

      concatMap(() => {
        const campaniasSel = this.buildCampaniasSeleccionadasActualizar(false);

        return this.networking.guardarCampanias({
          idCotizacion,
          idBeneficiario: idBeneficiarioGuardado,
          programasSeleccionados: this.programasSeleccionados as any
        }).pipe(
          concatMap(resp => {
            this.hydrateIdsCotizacionCampaniaDesdeRespuesta(resp, campaniasSel);

            const consultas = this.programasSeleccionados
              .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
              .map(ps => this.networking.consultarBeneficiarioPrograma({
                idCotizacion,
                idBeneficiario: idBeneficiarioGuardado,
                programa: this.codigoProgramaParaGuardar(ps)
              }).pipe(
                map(r => {
                  this.hydrateIdsCotizacionCampaniaDesdeConsultarPrograma(ps, r);
                  return r;
                }),
                catchError(() => of(null))
              ));

            if (!consultas.length) {
              return of(resp);
            }

            return forkJoin(consultas).pipe(map(() => resp));
          }),
          catchError(() => of(null))
        );
      })

    ).subscribe({
      next: () => {
        this.spinner.hide();
        this.SnackBarService.alert(
          'alert-success',
          'Beneficiario guardado correctamente.'
        );
        // Persist contratante programas only AFTER successful network save
        try {
          this.permitirPersistenciaContratanteStorage = true;
          this.persistirContratanteEnLocalStorageSolo();
        } finally {
          this.permitirPersistenciaContratanteStorage = false;
        }
        this.limpiarDraftLocalStorage();
        onOk?.(idBeneficiarioGuardado);
      },
      error: err => {
        this.spinner.hide();
        this.SnackBarService.alert(
          'alert-danger',
          err.message || 'Error guardando beneficiario.'
        );
      }
    });
  }

  /** Guarda/actualiza en edición (Mis Cotizaciones / Inclusión con id). UPDATE si id > 0 */
  private guardarBeneficiarioYTodoEditMode(idBeneficiarioEdicion: number | null, onOk?: (id: number) => void, forzarActualizar = false): void {
    const esValido = this.isFormValid();
    if (!esValido) {
      this.SnackBarService.alert('alert-danger', 'Completa los campos obligatorios del beneficiario.');
      this.selectedIndex = 0;
      return;
    }

    const idCotizacion = this.idCotizacionContext;
    if (!idCotizacion || idCotizacion <= 0) {
      this.SnackBarService.alert('alert-danger', 'No se encontró la cotización activa para guardar.');
      return;
    }

    const b = this.buildBeneficiariosParaGuardarTab1();
    b.id_cotizacion = idCotizacion;
    const esUsuLocal = this.obtenerEsUsuarioDesdeLocal();
    b.es_contratante = typeof this.esUsuario === 'boolean' ? this.esUsuario : !!esUsuLocal;
    const isUpdate = forzarActualizar || (idBeneficiarioEdicion != null && Number(idBeneficiarioEdicion) > 0);
    let idBeneficiarioGuardado = 0;

    this.spinner.show();

    const persistBeneficiario$ = (() => {
      if (!forzarActualizar) {
        return isUpdate ? this.networking.actualizarDatosBeneficiarios(Number(idBeneficiarioEdicion), b) : this.networking.guardarDatosBeneficiarios(b);
      }
      const idDirecto = Number(idBeneficiarioEdicion || 0);
      if (idDirecto > 0) {
        return this.networking.actualizarDatosBeneficiarios(idDirecto, b).pipe(
          map((updateResp: any) => ({ updateResp, resolvedId: idDirecto }))
        );
      }
      return this.networking.guardarDatosBeneficiarios(b);
    })();

    persistBeneficiario$.pipe(
      concatMap((resp: any) => {
        const payloadResp = resp?.updateResp ?? resp;
        const resolvedIdFromWrapper = Number(resp?.resolvedId || 0);
        let idFromResp = this.extractIdBeneficiarioFromResponse(payloadResp);
        if (idFromResp <= 0 && this.esFlujoInclusion && !isUpdate && this.esRespuestaDuplicadoBeneficiario(payloadResp)) {
          idFromResp = this.resolverIdBeneficiarioExistenteLocal(b);
        }
        const resolvedId = resolvedIdFromWrapper > 0 ? resolvedIdFromWrapper : (idFromResp > 0 ? idFromResp : (idBeneficiarioEdicion != null && Number(idBeneficiarioEdicion) > 0 ? Number(idBeneficiarioEdicion) : 0));

        if (resolvedId <= 0) {
          const backendMessage = payloadResp?.message || payloadResp?.errorMessage || payloadResp?.data?.message || payloadResp?.data?.mensaje || '';
          throw new Error(backendMessage || 'No se obtuvo idBeneficiario.');
        }
        idBeneficiarioGuardado = resolvedId;
        return of(idBeneficiarioGuardado);
      }),
      concatMap(() => {
        if (!(forzarActualizar || isUpdate)) {
          return of(true);
        }
        return this.eliminarProgramasRemovidosAntesDeActualizar();
      }),
      concatMap(() => this.completarGruposProgramaSeleccionados()),
      concatMap(() => {
        if (forzarActualizar || isUpdate) {
          const ops = this.programasSeleccionados.map(ps => {
            const base = this.resolveProgramaBase(ps);
            const programmeCod = this.codigoProgramaParaGuardar(ps);
            const programaConsulta = this.resolveProgramaCodigoParaConsulta(ps);
            const payload = {
              lineaNegocio: (base?.lineaNegocio ?? '').toString(),
              programa: programmeCod,
              nombrePrograma: (base?.nombre ?? ps.nombre ?? '').toString(),
              grupoPrograma:
                this.resolverGrupoProgramaParaGuardar(ps, base),
              esAnexo: this.shouldShowRequiereAnexo(ps) ? ps.requiereAnexo === 'si' : false
            };

            const idBenProgramaActual = Number((ps as any).__idBenPrograma || 0);
            const idBenProgramaReemplazoSimple = this.resolveIdBenProgramaReemplazoSimple(ps);

            const resolveId$ = idBenProgramaActual > 0
              ? of(idBenProgramaActual)
              : idBenProgramaReemplazoSimple > 0
                ? of(idBenProgramaReemplazoSimple)
                : this.networking.consultarBeneficiarioPrograma({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programa: programaConsulta }).pipe(
                  map(resp => Number(resp?.data?.idBenPrograma || 0)),
                  catchError(() => of(0))
                );

            return resolveId$.pipe(
              map((idBenPrograma) => {
                const idResuelto = Number(idBenPrograma || 0);
                if (idResuelto > 0) {
                  (ps as any).__idBenPrograma = idResuelto;
                }
                return { ps, payload, programaConsulta, idBenPrograma: idResuelto };
              })
            );
          });

          return (ops.length ? forkJoin(ops) : of([])).pipe(
            concatMap((resueltos) => {
              const existentes = resueltos.filter(r => r.idBenPrograma > 0);
              const faltantes = resueltos.filter(r => !(r.idBenPrograma > 0));

              const actualizarExistentes$ = existentes.length
                ? forkJoin(existentes.map(r => this.networking.actualizarBeneficiarioPrograma(r.idBenPrograma, r.payload)))
                : of([]);

              if (!faltantes.length) {
                return actualizarExistentes$;
              }

              return actualizarExistentes$.pipe(
                concatMap(() => this.networking.guardarBeneficiarioProgramas({
                  idCotizacion,
                  idBeneficiario: idBeneficiarioGuardado,
                  items: faltantes.map(f => ({ ...f.payload }))
                })),
                concatMap(() => {
                  const consultas = faltantes.map(f => this.networking.consultarBeneficiarioPrograma({
                    idCotizacion,
                    idBeneficiario: idBeneficiarioGuardado,
                    programa: f.payload.programa
                  }).pipe(
                    map(r => {
                      const idResuelto = Number(r?.data?.idBenPrograma || 0);
                      if (idResuelto > 0) {
                        (f.ps as any).__idBenPrograma = idResuelto;
                      }
                      return idResuelto;
                    }),
                    catchError(() => of(0))
                  ));
                  return consultas.length ? forkJoin(consultas) : of([]);
                })
              );
            })
          );
        }
        const items = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);

          return { 
            lineaNegocio: base?.lineaNegocio ?? '', 
            programa: this.codigoProgramaParaGuardar(ps), 
            nombrePrograma: base?.nombre ?? ps.nombre, 
            grupoPrograma:
              this.resolverGrupoProgramaParaGuardar(ps, base),
            esAnexo: this.shouldShowRequiereAnexo(ps) 
              ? ps.requiereAnexo === 'si' 
              : false 
          };
        });
        if (!items.length) return of({});
        return this.networking.guardarBeneficiarioProgramas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, items });
      }),
      concatMap(() => {
        const subcuentasSel = this.buildSubcuentasSeleccionadas();
        if (!subcuentasSel.length) return of(true);
        if (!this.shouldActualizarSubcuentas()) {
          return of(true);
        }
        if (forzarActualizar || isUpdate) {
          if (!this.shouldActualizarSubcuentas()) {
            return of(true);
          }
          const existentes = subcuentasSel
            .map(ref => ({ ref, idSubcuenta: this.resolveIdSubcuenta(ref.ps) }))
            .filter(item => item.idSubcuenta > 0);
          const faltantes = subcuentasSel.filter(ref => !(this.resolveIdSubcuenta(ref.ps) > 0));

          const actualizarExistentes = () => {
            if (!existentes.length) {
              return of(true);
            }
            return forkJoin(existentes.map(({ ref, idSubcuenta }) =>
              this.networking.actualizarSubcuentas(idSubcuenta, {
                subcta: ref.subcta,
                nombreSubcuenta: ref.nombreSubcuenta,
                planCodi: ref.planCodi
              }).pipe(
                map(resp => {
                  this.applyIdSubcuentaFromPayload(ref.ps, resp?.data ?? resp);
                  return resp;
                })
              )
            ));
          };

          if (!faltantes.length) {
            return actualizarExistentes();
          }

          if (!existentes.length) {
            return this.networking.guardarSubcuentas({
              idCotizacion,
              idBeneficiario: idBeneficiarioGuardado,
              subcuentas: faltantes.map(({ ps: _ps, ...dto }) => dto)
            }).pipe(
              map(resp => {
                this.hydrateIdsSubcuentaDesdeRespuesta(resp, faltantes);
                return resp;
              })
            );
          }

          return forkJoin(existentes.map(({ ref, idSubcuenta }) =>
            this.networking.actualizarSubcuentas(idSubcuenta, {
              subcta: ref.subcta,
              nombreSubcuenta: ref.nombreSubcuenta,
              planCodi: ref.planCodi
            }).pipe(
              map(resp => {
                this.applyIdSubcuentaFromPayload(ref.ps, resp?.data ?? resp);
                return resp;
              })
            )
          )).pipe(
            concatMap(() => this.networking.guardarSubcuentas({
              idCotizacion,
              idBeneficiario: idBeneficiarioGuardado,
              subcuentas: faltantes.map(({ ps: _ps, ...dto }) => dto)
            })),
            map(resp => {
              this.hydrateIdsSubcuentaDesdeRespuesta(resp, faltantes);
              return resp;
            })
          );
        }
        return this.networking.guardarSubcuentas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, subcuentas: subcuentasSel.map(({ ps: _ps, ...dto }) => dto) }).pipe(
          map(resp => {
            this.hydrateIdsSubcuentaDesdeRespuesta(resp, subcuentasSel);
            return resp;
          })
        );
      }),
      concatMap(() => {
        if (forzarActualizar) {
          return of(true);
        }
        if (isUpdate) return of(true);
        const consultas = this.programasSeleccionados.map(ps => {
          const base = this.programasDisponibles.find(p => p.id === ps.id);
          return this.networking.consultarBeneficiarioPrograma({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programa: this.codigoProgramaParaGuardar(ps) }).pipe(
            map(resp => {
              if (resp?.data?.idBenPrograma) {
                (ps as any).__idBenPrograma = resp.data.idBenPrograma;
              }
              return resp;
            })
          );
        });
        if (!consultas.length) return of(true);
        return forkJoin(consultas);
      }),
      concatMap(() => {
        const tarifasSel = this.buildTarifasSeleccionadasActualizar(forzarActualizar || isUpdate);
        if (!tarifasSel.length) return of(true);
        if (forzarActualizar || isUpdate) {
          const existentes = tarifasSel
            .map(ref => ({ ref, idCotizacionTarifa: this.resolveIdCotizacionTarifa(ref.ps, ref.esAnexo) }))
            .filter(item => item.idCotizacionTarifa > 0);
          const faltantes = tarifasSel.filter(ref => !(this.resolveIdCotizacionTarifa(ref.ps, ref.esAnexo) > 0));

          if (!faltantes.length) {
            if (!existentes.length) {
              return of(true);
            }
            return forkJoin(existentes.map(({ ref, idCotizacionTarifa }) =>
              this.networking.actualizarTarifas(idCotizacionTarifa, {
                tari: this.obtenerCodigoTarifa(ref.tari),
                nombreTarifa: ref.nombreTarifa,
                valorMensualBase: ref.valorMensualBase,
                valorMensualIva: ref.valorMensualIva,
                porcentajeIva: ref.porcentajeIva,
                esTarifaAsociado: ref.esTarifaAsociado,
                fueSeleccionada: ref.fueSeleccionada,
                esAnexo: ref.esAnexo
              }).pipe(
                map(resp => {
                  this.applyIdCotizacionTarifaFromPayload(ref.ps, resp?.data ?? resp);
                  return resp;
                })
              )
            ));
          }

          const programasFaltantes = faltantes.reduce((acc: any[], ref) => {
            const idBenPrograma = Number(ref.idBenPrograma || 0);
            if (!(idBenPrograma > 0)) {
              throw new Error(`No se encontró idBenPrograma para guardar la tarifa ${ref.nombreTarifa || ref.tari}.`);
            }
            let target = acc.find(item => Number(item.idBenPrograma) === idBenPrograma);
            if (!target) {
              target = { idBenPrograma, tarifas: [] };
              acc.push(target);
            }

            let valBaseEdit = ref.valorMensualBase ?? null;
            let valIvaEdit = ref.valorMensualIva ?? null;

            if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
              if (ref.valorMensualBase != null && Number.isFinite(Number(ref.valorMensualBase))) {
                valBaseEdit = Number(ref.valorMensualBase);
                valIvaEdit = Number(ref.valorMensualIva ?? ref.valorMensualBase);
              }
            }

            target.tarifas.push({
              tari: ref.tari,
              nombreTarifa: ref.nombreTarifa ?? null,
              esTarifaAsociado: ref.esTarifaAsociado ?? null,
              fueSeleccionada: ref.fueSeleccionada,
              esAnexo: ref.esAnexo,
              valorMensualBase: valBaseEdit,
              valorMensualIva: valIvaEdit,
              porcentajeIva: ref.porcentajeIva ?? null
            });
            return acc;
          }, [] as any[]);

          const guardarFaltantesTarifas$ = this.networking.guardarTarifas({
            idCotizacion,
            idBeneficiario: idBeneficiarioGuardado,
            programas: programasFaltantes
          }).pipe(
            concatMap(resp => {
              this.hydrateIdsCotizacionTarifaDesdeRespuesta(resp, faltantes);
              const consultas = this.programasSeleccionados
                .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
                .map(ps => this.networking.consultarBeneficiarioPrograma({
                  idCotizacion,
                  idBeneficiario: idBeneficiarioGuardado,
                  programa: this.codigoProgramaParaGuardar(ps)
                }).pipe(
                  map(r => {
                    this.hydrateIdsCotizacionTarifaDesdeConsultarPrograma(ps, r);
                    return r;
                  }),
                  catchError(() => of(null))
                ));
              if (!consultas.length) {
                return of(resp);
              }
              return forkJoin(consultas).pipe(map(() => resp));
            })
          );

          if (!existentes.length) {
            return guardarFaltantesTarifas$;
          }

          return forkJoin(existentes.map(({ ref, idCotizacionTarifa }) =>
            this.networking.actualizarTarifas(idCotizacionTarifa, {
              tari: ref.tari,
              nombreTarifa: ref.nombreTarifa,
              valorMensualBase: ref.valorMensualBase,
              valorMensualIva: ref.valorMensualIva,
              porcentajeIva: ref.porcentajeIva,
              esTarifaAsociado: ref.esTarifaAsociado,
              fueSeleccionada: ref.fueSeleccionada,
              esAnexo: ref.esAnexo
            }).pipe(
              map(resp => {
                this.applyIdCotizacionTarifaFromPayload(ref.ps, resp?.data ?? resp);
                return resp;
              })
            )
          )).pipe(
            concatMap(() => this.networking.guardarTarifas({
              idCotizacion,
              idBeneficiario: idBeneficiarioGuardado,
              programas: programasFaltantes
            })),
            concatMap(resp => {
              this.hydrateIdsCotizacionTarifaDesdeRespuesta(resp, faltantes);
              const consultas = this.programasSeleccionados
                .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
                .map(ps => this.networking.consultarBeneficiarioPrograma({
                  idCotizacion,
                  idBeneficiario: idBeneficiarioGuardado,
                  programa: this.codigoProgramaParaGuardar(ps)
                }).pipe(
                  map(r => {
                    this.hydrateIdsCotizacionTarifaDesdeConsultarPrograma(ps, r);
                    return r;
                  }),
                  catchError(() => of(null))
                ));
              if (!consultas.length) {
                return of(resp);
              }
              return forkJoin(consultas).pipe(map(() => resp));
            })
          );
        }
        const programas = tarifasSel.reduce((acc: any[], ref) => {
          let target = acc.find(item => Number(item.idBenPrograma) === Number(ref.idBenPrograma || 0));
          if (!target) {
            target = { idBenPrograma: Number(ref.idBenPrograma || 0), tarifas: [] };
            acc.push(target);
          }
          target.tarifas.push({ tari: ref.tari, nombreTarifa: ref.nombreTarifa ?? null, esTarifaAsociado: ref.esTarifaAsociado ?? null, fueSeleccionada: ref.fueSeleccionada, esAnexo: ref.esAnexo, valorMensualBase: ref.valorMensualBase ?? null, valorMensualIva: ref.valorMensualIva ?? null, porcentajeIva: ref.porcentajeIva ?? null });
          return acc;
        }, [] as any[]);
        if (!programas.length) return of(true);
        return this.networking.guardarTarifas({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programas }).pipe(
          concatMap(resp => {
            this.hydrateIdsCotizacionTarifaDesdeRespuesta(resp, tarifasSel);
            const consultas = this.programasSeleccionados
              .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
              .map(ps => this.networking.consultarBeneficiarioPrograma({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programa: this.codigoProgramaParaGuardar(ps) }).pipe(
                map(r => {
                  this.hydrateIdsCotizacionTarifaDesdeConsultarPrograma(ps, r);
                  return r;
                }),
                catchError(() => of(null))
              ));
            if (!consultas.length) {
              return of(resp);
            }
            return forkJoin(consultas).pipe(map(() => resp));
          })
        );
      }),
      concatMap(() => {
        if (forzarActualizar || isUpdate) {
          const campaniasSel = this.buildCampaniasSeleccionadasActualizar(true);
          if (!campaniasSel.length) {
            return of(null);
          }
          const existentes = campaniasSel
            .map(ref => ({ ref, idCotizacionCampania: this.resolveIdCotizacionCampania(ref.ps) }))
            .filter(item => item.idCotizacionCampania > 0);
          const faltantes = campaniasSel.filter(ref => !(this.resolveIdCotizacionCampania(ref.ps) > 0));

          if (!faltantes.length) {
            if (!existentes.length) {
              return of(null);
            }
            return forkJoin(existentes.map(({ ref, idCotizacionCampania }) => {
              const det = ref.detSel as any;
              return this.networking.actualizarCampanias(idCotizacionCampania, { codCampComercial: ref.codCampComercial, nombreCampania: ref.nombreCampania, tipoCampania: (det?.tipo_campania || '').toString().trim() || undefined, modalidad: (det?.modalidad || '').toString().trim() || undefined, fueSeleccionada: true, cuenta: (det?.cuenta ?? '').toString().trim() || undefined, subcuenta: (det?.subcuenta ?? '').toString().trim() || undefined, tipoPlan: (det?.tipo_plan ?? '').toString().trim() || undefined, parentesco: (det?.parentesco ?? '').toString().trim() || undefined, edadDesde: Number.isFinite(Number(det?.edad_desde)) ? Number(det?.edad_desde) : undefined, edadHasta: Number.isFinite(Number(det?.edad_hasta)) ? Number(det?.edad_hasta) : undefined, cantBenefDesde: Number.isFinite(Number(det?.cant_benef_desde)) ? Number(det?.cant_benef_desde) : undefined, cantBenefHasta: Number.isFinite(Number(det?.cant_benef_hasta)) ? Number(det?.cant_benef_hasta) : undefined, acumulable: det?.acumulable === true, pagoDebitoAuto: det?.pago_debito_auto === true, aplicaProntoPago: det?.aplica_pronto_pago === true, observaciones: (det?.observaciones ?? '').toString().trim() || undefined, usuarioActualizacion: (det?.usuario_actualizacion ?? '').toString().trim() || undefined, lineaNegocio: (det?.linea_negocio ?? '').toString().trim() || undefined, grupoPrograma: (det?.grupo_programa ?? '').toString().trim() || undefined, programa: (det?.programa ?? '').toString().trim() || undefined, inicioVigencia: (det?.inicio_vigencia ?? '').toString().trim() || undefined, finVigencia: (det?.fin_vigencia ?? '').toString().trim() || undefined, estado: det?.estado === true }).pipe(
                map(resp => {
                  this.applyIdCotizacionCampaniaFromPayload(ref.ps, resp?.data ?? resp);
                  return resp;
                })
              );
            }));
          }

          const faltantesProgramas = Array.from(
            new Map(faltantes.map(ref => [String(ref.ps.id || ''), ref.ps])).values()
          );

          const guardarFaltantesCampanias$ = this.networking.guardarCampanias({
            idCotizacion,
            idBeneficiario: idBeneficiarioGuardado,
            programasSeleccionados: faltantesProgramas as any
          }).pipe(
            concatMap(resp => {
              this.hydrateIdsCotizacionCampaniaDesdeRespuesta(resp, faltantes);
              const consultas = faltantesProgramas
                .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
                .map(ps => this.networking.consultarBeneficiarioPrograma({
                  idCotizacion,
                  idBeneficiario: idBeneficiarioGuardado,
                  programa: this.codigoProgramaParaGuardar(ps)
                }).pipe(
                  map(r => {
                    this.hydrateIdsCotizacionCampaniaDesdeConsultarPrograma(ps, r);
                    return r;
                  }),
                  catchError(() => of(null))
                ));
              if (!consultas.length) {
                return of(resp);
              }
              return forkJoin(consultas).pipe(map(() => resp));
            }),
            catchError(() => of(null))
          );

          if (!existentes.length) {
            return guardarFaltantesCampanias$;
          }

          return forkJoin(existentes.map(({ ref, idCotizacionCampania }) => {
            const det = ref.detSel as any;
            return this.networking.actualizarCampanias(idCotizacionCampania, { codCampComercial: ref.codCampComercial, nombreCampania: ref.nombreCampania, tipoCampania: (det?.tipo_campania || '').toString().trim() || undefined, modalidad: (det?.modalidad || '').toString().trim() || undefined, fueSeleccionada: true, cuenta: (det?.cuenta ?? '').toString().trim() || undefined, subcuenta: (det?.subcuenta ?? '').toString().trim() || undefined, tipoPlan: (det?.tipo_plan ?? '').toString().trim() || undefined, parentesco: (det?.parentesco ?? '').toString().trim() || undefined, edadDesde: Number.isFinite(Number(det?.edad_desde)) ? Number(det?.edad_desde) : undefined, edadHasta: Number.isFinite(Number(det?.edad_hasta)) ? Number(det?.edad_hasta) : undefined, cantBenefDesde: Number.isFinite(Number(det?.cant_benef_desde)) ? Number(det?.cant_benef_desde) : undefined, cantBenefHasta: Number.isFinite(Number(det?.cant_benef_hasta)) ? Number(det?.cant_benef_hasta) : undefined, acumulable: det?.acumulable === true, pagoDebitoAuto: det?.pago_debito_auto === true, aplicaProntoPago: det?.aplica_pronto_pago === true, observaciones: (det?.observaciones ?? '').toString().trim() || undefined, usuarioActualizacion: (det?.usuario_actualizacion ?? '').toString().trim() || undefined, lineaNegocio: (det?.linea_negocio ?? '').toString().trim() || undefined, grupoPrograma: (det?.grupo_programa ?? '').toString().trim() || undefined, programa: (det?.programa ?? '').toString().trim() || undefined, inicioVigencia: (det?.inicio_vigencia ?? '').toString().trim() || undefined, finVigencia: (det?.fin_vigencia ?? '').toString().trim() || undefined, estado: det?.estado === true }).pipe(
              map(resp => {
                this.applyIdCotizacionCampaniaFromPayload(ref.ps, resp?.data ?? resp);
                return resp;
              })
            );
          })).pipe(
            concatMap(() => this.networking.guardarCampanias({
              idCotizacion,
              idBeneficiario: idBeneficiarioGuardado,
              programasSeleccionados: faltantesProgramas as any
            })),
            concatMap(resp => {
              this.hydrateIdsCotizacionCampaniaDesdeRespuesta(resp, faltantes);
              const consultas = faltantesProgramas
                .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
                .map(ps => this.networking.consultarBeneficiarioPrograma({
                  idCotizacion,
                  idBeneficiario: idBeneficiarioGuardado,
                  programa: this.codigoProgramaParaGuardar(ps)
                }).pipe(
                  map(r => {
                    this.hydrateIdsCotizacionCampaniaDesdeConsultarPrograma(ps, r);
                    return r;
                  }),
                  catchError(() => of(null))
                ));
              if (!consultas.length) {
                return of(resp);
              }
              return forkJoin(consultas).pipe(map(() => resp));
            }),
            catchError(() => of(null))
          );
        }
        return this.networking.guardarCampanias({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programasSeleccionados: this.programasSeleccionados as any }).pipe(
          concatMap(resp => {
            const campaniasSel = this.buildCampaniasSeleccionadasActualizar(false);
            this.hydrateIdsCotizacionCampaniaDesdeRespuesta(resp, campaniasSel);
            const consultas = this.programasSeleccionados
              .filter(ps => Number((ps as any).__idBenPrograma || 0) > 0)
              .map(ps => this.networking.consultarBeneficiarioPrograma({ idCotizacion, idBeneficiario: idBeneficiarioGuardado, programa: this.codigoProgramaParaGuardar(ps) }).pipe(
                map(r => {
                  this.hydrateIdsCotizacionCampaniaDesdeConsultarPrograma(ps, r);
                  return r;
                }),
                catchError(() => of(null))
              ));
            if (!consultas.length) {
              return of(resp);
            }
            return forkJoin(consultas).pipe(map(() => resp));
          }),
          catchError(() => of(null))
        );
      })
    ).subscribe({
      next: () => {
        this.spinner.hide();
        setTimeout(() => {
          this.SnackBarService.alert('alert-success', 'Beneficiario guardado correctamente.');
          try {
            this.permitirPersistenciaContratanteStorage = true;
            this.persistirContratanteEnLocalStorageSolo();
          } finally {
            this.permitirPersistenciaContratanteStorage = false;
          }
          this.limpiarDraftLocalStorage();
          onOk?.(idBeneficiarioGuardado);
        }, 0);
      },
      error: err => {
        this.spinner.hide();
        this.SnackBarService.alert('alert-danger', err.message || 'Error guardando beneficiario.');
      }
    });
  }

  calculeAge(_type: string, event: MatDatepickerInputEvent<Date>) {
    let menor = null;
    switch (this.form.parentesco.value) {
      case '0':
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case 'H':
      case 'N':
        menor = true;
        break;
      case 'A':
      case 'O':
      case 'S':
      case 'P':
        menor = false;
        break;
      default:
        menor = null;
        break;
    }
    const t = new ValidationService(this.SnackBarService);
    const result = t.calculateAge(event.value);
    this.form.fechaNacimiento.messages = '';
    if (result >= 0) {
      this.edad = result;
      if (menor && result >= parseInt(this.datePerson)) {
        this.listDataCampania = [];
        this.form.campaniaContratante.value = '';
        this.form.fechaNacimiento.value = '';
        this.form.fechaNacimiento.messages = 'Fecha de nacimiento debe ser menor que la del contratante.';
        return;
      }
      if (menor === false && result <= parseInt(this.datePerson)) {
        this.listDataCampania = [];
        this.form.campaniaContratante.value = '';
        this.form.fechaNacimiento.value = '';
        this.form.fechaNacimiento.messages = 'Fecha de nacimiento debe ser mayor que la del contratante.';
        return;
      }
    } else {
      this.listDataCampania = [];
      this.form.campaniaContratante.value = '';
      this.form.fechaNacimiento.value = '';
      this.form.fechaNacimiento.messages = 'Fecha de nacimiento es incorrecta.';
    }
    this.validateDocTypeWithAge();
  }

  checkPattern(event: Event, e: keyof FormType) {

    const input = event.target as HTMLInputElement;

    const fieldsWithSpace = ['nombre', 'nombreSegundo', 'apellido', 'apellidoSegundo'];
    const allowSpace = fieldsWithSpace.includes(e);

    let value = input.value;

    // Quitar tildes
    value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    // Mayúsculas
    value = value.toUpperCase();

    // Permitir solo letras, números y espacio
    value = allowSpace
      ? value.replace(/[^A-Z0-9 ]/g, '')
      : value.replace(/[^A-Z0-9]/g, '');

    // Actualizar input y modelo
    input.value = value;
    this.form[e].value = value;
  }

  /** Inclusión: subcta del catálogo (max 4), no ACEMN/deno. VN no usa esto */
  private resolverSubctaDesdeCatalogoInclusion(ps: ProgramaSeleccionado): { subcta: string; nombreSubcuenta: string } | null {
    if (!this.esFlujoInclusion) {
      return null;
    }
    const rawList: any[] = Array.isArray((ps as any).__subcuentasRaw) ? (ps as any).__subcuentasRaw : [];
    const pickFromRow = (r: any): { subcta: string; nombreSubcuenta: string } | null => {
      const code = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim();
      if (!code || code.length > 4) return null;
      const deno = (r?.deno ?? r?.DENO ?? ps.subcuenta ?? code).toString().trim();
      return { subcta: code, nombreSubcuenta: deno || code };
    };
    const findInRaw = (candidato: string): { subcta: string; nombreSubcuenta: string } | null => {
      const key = (candidato || '').toString().trim().toUpperCase();
      if (!key || !rawList.length) return null;
      const hit = rawList.find((r: any) => {
        const code = (r?.subcta ?? r?.SUBCTA ?? '').toString().trim().toUpperCase();
        const deno = (r?.deno ?? r?.DENO ?? '').toString().trim().toUpperCase();
        return code === key || deno === key;
      });
      return hit ? pickFromRow(hit) : null;
    };

    const candidatos = [
      (ps as any).__subctaCodeSeleccionada,
      this.getSubctaCodeFor(ps),
      (ps as any).__subctaFromColectivo,
      ps.subcuenta,
      (ps as any).__subcuentaInclusionOriginal
    ];
    for (const c of candidatos) {
      const resolved = findInRaw((c || '').toString());
      if (resolved) {
        (ps as any).__subctaCodeSeleccionada = resolved.subcta;
        return resolved;
      }
    }
    // Catálogo filtrado a 1 fila (cuenta contrato): usar esa — nunca inventar ACEMN.
    if (rawList.length === 1) {
      const only = pickFromRow(rawList[0]);
      if (only) {
        (ps as any).__subctaCodeSeleccionada = only.subcta;
        if (!ps.subcuenta) ps.subcuenta = only.nombreSubcuenta;
        return only;
      }
    }
    return null;
  }

  private getSubctaCodeFor(programaSel: ProgramaSeleccionado): string {
    const codeSel = (programaSel as any).__subctaCodeSeleccionada;
    if (codeSel) return codeSel;

    const base = this.programasDisponibles.find(p => p.id === programaSel.id);
    if (base?.lineaNegocio !== 'CEM') return '';

    const col = (programaSel as any).__subctaFromColectivo;
    return (col || '').toString().trim();
  }

  private getSubctaDenoForAnexo(programaSel: ProgramaSeleccionado): string {
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      if (programaSel.subcuenta && programaSel.subcuenta.trim()) {
        return programaSel.subcuenta.trim();
      }
      const raw: any[] = (programaSel as any).__subcuentasRaw || [];
      const hit = raw.find(
        r => this.norm(r?.subcta) === this.norm((programaSel as any).__subctaCodeSeleccionada)
      );
      if (hit?.deno) return (hit.deno || '').toString().trim();

      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const filaColectivo: any = (this.datosColectivoGA || []).find((r: any) => {
        const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
        return rPlan === planCodiNorm;
      });
      const denoColectivo = (filaColectivo?.tari_deno || filaColectivo?.plan_deno || filaColectivo?.nombre_fantasia || '').toString().trim();
      return denoColectivo;
    }

    if (programaSel.subcuenta && programaSel.subcuenta.trim()) {
      return programaSel.subcuenta.trim();
    }
    const raw: any[] = (programaSel as any).__subcuentasRaw || [];
    const hit = raw.find(
      r => this.norm(r?.subcta) === this.norm((programaSel as any).__subctaCodeSeleccionada)
    );
    return (hit?.deno || '').toString().trim();
  }

  private getPlanGrupoForAnexo(programaSel: ProgramaSeleccionado): string {
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      const raw: any[] = (programaSel as any).__subcuentasRaw || [];
      const subctaDeno = this.getSubctaDenoForAnexo(programaSel);
      const subctaCode = ((programaSel as any).__subctaCodeSeleccionada || '').toString().trim();

      const hit = raw.find(r => this.norm(r?.deno) === this.norm(subctaDeno) || this.norm(r?.subcta) === this.norm(subctaCode));
      if (hit?.plan_grupo) return (hit.plan_grupo || '').toString().trim();

      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const filaColectivo: any = (this.datosColectivoGA || []).find((r: any) => {
        const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
        return rPlan === planCodiNorm;
      });

      const planGrupoColectivo = (filaColectivo?.plan_grupo ?? filaColectivo?.grupo_programa ?? filaColectivo?.linea_negocio ?? raw[0]?.plan_grupo ?? '').toString().trim();
      return planGrupoColectivo;
    }

    const raw: any[] = (programaSel as any).__subcuentasRaw || [];
    if (!Array.isArray(raw) || raw.length === 0) return '';
    const subctaDeno = this.getSubctaDenoForAnexo(programaSel);
    const subctaCode = ((programaSel as any).__subctaCodeSeleccionada || '').toString().trim();
    const hit = raw.find(r => this.norm(r?.deno) === this.norm(subctaDeno) || this.norm(r?.subcta) === this.norm(subctaCode)) || raw[0];
    return (hit?.plan_grupo || raw[0]?.plan_grupo || '').toString().trim();
  }

  /** Grupo comercial (OPL, PREF…) para campañas colectivo/GA */
  private resolveGrupoProgramaParaCampania(programaSel: ProgramaSeleccionado): string {
    const esLineaNegocioNoGrupo = (valor: string): boolean => {
      const u = (valor || '').toString().trim().toUpperCase();
      return !u || u === 'MI' || u === 'SO' || u === 'CEM' || u === '1' || u === '2' || u === '3';
    };

    const deno = (programaSel.subcuenta || '').toString().trim();
    const mapGrupo: Map<string, string> | undefined = (programaSel as any).__mapDenoAPlanGrupo;
    let planGrupo = '';
    if (mapGrupo && deno) {
      planGrupo = (mapGrupo.get(deno.toUpperCase()) || mapGrupo.get(this.norm(deno)) || '').toString().trim();
    }

    if (esLineaNegocioNoGrupo(planGrupo)) {
      planGrupo = this.getPlanGrupoForAnexo(programaSel);
    }

    if (esLineaNegocioNoGrupo(planGrupo)) {
      const planCodiNorm = (programaSel.id || '').trim().toUpperCase();
      const filaCol: any = (this.datosColectivoGA || []).find((r: any) => {
        const rPlan = (r?.plan_codi ?? r?.PLAN_CODI ?? '').toString().trim().toUpperCase();
        return rPlan === planCodiNorm;
      });
      planGrupo = (
        filaCol?.plan_grupo
        ?? filaCol?.PLAN_GRUPO
        ?? filaCol?.grupo_programa
        ?? filaCol?.GRUPO_PROGRAMA
        ?? ''
      ).toString().trim();
    }

    return esLineaNegocioNoGrupo(planGrupo) ? '' : planGrupo;
  }

  private getCuentaFromRawSubcuentas(programaSel: ProgramaSeleccionado): number {
    const raw: any[] = (programaSel as any).__subcuentasRaw || [];
    if (!Array.isArray(raw) || raw.length === 0) return 0;

    const subctaDeno = this.getSubctaDenoForAnexo(programaSel);
    const subctaCode = ((programaSel as any).__subctaCodeSeleccionada || '').toString().trim();

    const hit = raw.find(r =>
      this.norm(r?.deno) === this.norm(subctaDeno) ||
      this.norm(r?.subcta) === this.norm(subctaCode)
    ) || raw[0];

    const cuentaRaw = hit?.cuenta ?? hit?.CUENTA ?? hit?.cta ?? hit?.CTA;
    const cuenta = Number(cuentaRaw);
    return Number.isFinite(cuenta) && cuenta > 0 ? cuenta : 0;
  }

  private reintentarCampaniasSiFaltan(): void {
    if (!this.form?.genero?.value) return;
    if (this.form?.fechaNacimiento?.messages) return;
    if ((this.edad ?? -1) < 0) return;
    if (!Array.isArray(this.programasSeleccionados) || this.programasSeleccionados.length === 0) return;

    const faltaAlguna = this.programasSeleccionados.some((ps) => {
      const lista = (ps as any)?.campaniasDisponibles;
      return !Array.isArray(lista) || lista.length === 0;
    });
    if (!faltaAlguna) return;

    if (this.esFlujoInclusion) {
      const catalogoListo = this.programasSeleccionados.some((ps) => {
        const raw = (ps as any).__subcuentasRaw;
        const code = ((ps as any).__subctaCodeSeleccionada || '').toString().trim();
        return code.length > 0 || (Array.isArray(raw) && raw.length > 0);
      });
      if (!catalogoListo) return;
    }

    this.bucarCampa();
  }

  bucarCampa(): void {

    if (!this.form.genero.value) return;
    if (this.form.fechaNacimiento.messages) return;
    if ((this.edad ?? -1) < 0) return;
    if (!Array.isArray(this.programasSeleccionados) || this.programasSeleccionados.length === 0) {
      return;
    }
    const generoCore = (this.form.genero.value === '2' ? 'M' : 'F');
    const edadCore = Number(this.edad ?? 0);
    const tipoPlan = (localStorage.getItem('tipoPlan') || this.tipoPlanLS || '').toUpperCase().trim();
    const tipoSolicitud = Number(localStorage.getItem('tipoSolicitud')) || Number(this.tipoSolicitud) || 0;

    this.programasSeleccionados.forEach((ps: any) => {
      const base = this.programasDisponibles.find(p => p.id === ps.id);
      if (!base) return;


      const esColectivoOAfinidad = tipoPlan === 'C' || tipoPlan === 'CY' || tipoPlan === 'GA' || tipoPlan === 'AG' || tipoPlan.includes('COLECTIV') || tipoPlan.includes('AFINIDAD');
      let subcuentaFinal = '';
      if (this.esFlujoInclusion) {
        // Misma regla que guardarSubcuentas: código de catálogo, nunca matriz ACEMN.
        const resolved = this.resolverSubctaDesdeCatalogoInclusion(ps);
        subcuentaFinal = (resolved?.subcta || (ps as any).__subctaCodeSeleccionada || this.getSubctaCodeFor(ps) || '').toString().trim();
        if (subcuentaFinal.length > 4) {
          subcuentaFinal = '';
        }
      } else if (esColectivoOAfinidad) {
        const denoTxt = (ps.subcuenta || '').toString().trim();
        const mapDenoToCode: Map<string, string> = (ps as any).__mapDenoToCode;
        subcuentaFinal = mapDenoToCode ? (mapDenoToCode.get(this.norm(denoTxt)) || '') : '';
        if (!subcuentaFinal) {
          subcuentaFinal = ((ps as any).__subctaCodeSeleccionada || (ps as any).__subctaFromColectivo || '').toString().trim();
        }
      } else {
        const subctaPasada = ((ps as any).__subctaCodeSeleccionada || ps.subcuenta || '').toString().trim().toUpperCase();
        const subcuentasValidas = ['ASMP', 'EMSMP', 'FSMP', 'ASAO', 'FSAO', 'EMSAO', 'ACEMN', 'EMCMN', 'FCEMN'];
        if (subctaPasada && subcuentasValidas.includes(subctaPasada)) {
          subcuentaFinal = subctaPasada;
        } else {
          const planCodi = (ps.id || base.codigo || '').toString().trim().toUpperCase();
          let linea = 'SMP';
          if (planCodi.startsWith('DE') || planCodi.includes('SAO') || planCodi.includes('SO')) {
            linea = 'SAO';
          } else if (planCodi.includes('CEM')) {
            linea = 'CEM';
          }
          let tipo = 'F';
          if (tipoPlan === 'A' || tipoPlan === 'AS' || tipoPlan.includes('ASOCIADO')) tipo = 'A';
          else if (tipoPlan === 'E' || tipoPlan === 'EMP' || tipoPlan.includes('EMPLEADO')) tipo = 'E';
          const matrizSubcuentas: Record<string, Record<string, string>> = {
            'SMP': { 'A': 'ASMP', 'F': 'FSMP', 'E': 'EMSMP' },
            'SAO': { 'A': 'ASAO', 'F': 'FSAO', 'E': 'EMSAO' },
            'CEM': { 'A': 'ACEMN', 'F': 'FCEMN', 'E': 'EMCMN' }
          };
          subcuentaFinal = matrizSubcuentas[linea]?.[tipo] || 'FSMP';
        }
      }

      // const cuentaPorPrograma = Number((ps as any).__cuentaFromColectivo) || this.getCuentaFromRawSubcuentas(ps) || Number(this.dataCampania?.cuenta) || 1;

      let cuentaPorPrograma = 1;
      let tarifaCodigo = '';
      if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
        if (!subcuentaFinal) {
          return;
        }

        cuentaPorPrograma = (this.cuentaColectivoGA != null && Number(this.cuentaColectivoGA) > 0)
          ? Number(this.cuentaColectivoGA)
          : (Number((ps as any).__cuentaFromColectivo) || 1);

        tarifaCodigo = (ps as any).__tarifaCodigoLimpio || this.obtenerCodigoTarifa(ps.tarifa || '');

      }
      else if (this.esFlujoInclusion) {
        cuentaPorPrograma = Number((ps as any).__cuentaFromColectivo) || this.getCuentaFromRawSubcuentas(ps) || Number(this.dataCampania?.cuenta) || 1;
        tarifaCodigo = '';
      }
      else {
        cuentaPorPrograma = Number((ps as any).__cuentaFromColectivo) || this.getCuentaFromRawSubcuentas(ps) || Number(this.dataCampania?.cuenta) || 1;
        const tarifaRaw = (ps.tarifa || '').toString().trim();
        tarifaCodigo = tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
      }


      if (Number.isFinite(cuentaPorPrograma) && cuentaPorPrograma > 0) {
        (ps as any).__cuentaFromColectivo = cuentaPorPrograma;
      }
      //const tarifaRaw = (ps.tarifa || '').toString().trim();
      //const tarifaCodigo = tarifaRaw.match(/\(([^)]+)\)$/)?.[1]?.trim() || tarifaRaw;
      const lineaNegocioNumero = this.mapLineaToNumber(base.lineaNegocio);
      const planGrupoCampania = esColectivoOAfinidad ? this.resolveGrupoProgramaParaCampania(ps) : '';
      const uiPrograma = (ps.id || base.codigo || '').trim();
      let vcPrograma = uiPrograma;
      if (esColectivoOAfinidad && !this.esFlujoInclusion && subcuentaFinal) {
        const filaActivo = this.resolverFilaActivoAcParaTarifa(uiPrograma, subcuentaFinal);
        const planOriginal = (filaActivo?.plan_codi ?? filaActivo?.PLAN_CODI ?? '').toString().trim().toUpperCase();
        if (planOriginal) {
          vcPrograma = planOriginal;
        }
      }
      const coreKey = [generoCore, edadCore, ps.id, vcPrograma, subcuentaFinal, cuentaPorPrograma, tarifaCodigo, planGrupoCampania].join('|');
      const yaTieneCampanias = ((ps as any).campaniasDisponibles?.length ?? 0) > 0;
      // si se perdieron campañas al cambiar tab, volver a consultar
      if (this.cacheClavesCampaMap.get(ps.id) === coreKey && yaTieneCampanias) return;
      this.cacheClavesCampaMap.set(ps.id, coreKey);
      this.campaniasConsultaRealizadaPorPrograma[ps.id] = false;

      const payload: any = {
        cuenta: cuentaPorPrograma,
        tipo_solicitud: tipoSolicitud,
        codigo_sucursal: '',
        codigo_tipo_plan: tipoPlan,
        tarifa: tarifaCodigo || '',
        vc_cod_tarifa: tarifaCodigo || '',
        vc_subcuenta: subcuentaFinal,
        descripcionTarifa: '',
        edad: edadCore,
        sexo: generoCore + ',A',
        modelo_negocio: [
          {
            subcuenta: subcuentaFinal,
            linea_negocio: lineaNegocioNumero,
            programa: [vcPrograma],
            ...(planGrupoCampania ? { grupo_programa: planGrupoCampania, grupoPrograma: planGrupoCampania } : {})
          }
        ],
        vc_parentesco: (this.form.parentesco.value || '').toString().trim()
      };
      if (planGrupoCampania) {
        payload.vc_grupoPrograma = planGrupoCampania;
        payload.grupo_programa = planGrupoCampania;
      }
      if (this.esFlujoInclusion) {
        payload.tarifa = '';
        payload.vc_cod_tarifa = '';
      }


      this.spinner.show();
      this._isCampaInFlight = true;
      this.networking.bucarCampa(payload)
        .pipe(finalize(() => {
          this.spinner.hide();
          this._isCampaInFlight = false;
        }))
        .subscribe({
          next: lista => {
            const listaOriginal = (Array.isArray(lista) ? lista : []).map((c: any) => {
              if (c) {
                if (this.esFlujoInclusion) {
                  const codCamp = c.codigo_campania ?? c.COD_CAMP_COMERCIAL ?? c.id_campania ?? c.ID_CAMPANIA;
                  c.codigo_campania = codCamp ? codCamp.toString().trim() : '';
                  const nomCamp = c.nombre ?? c.nombre_campania ?? c.NOMBRE_CAMPANIA ?? '';
                  c.nombre = nomCamp.toString().trim();
                  c.inicioVigencia = c.inicioVigencia ?? c.inicio_vigencia ?? c.INICIO_VIGENCIA ?? '';
                  c.finVigencia = c.finVigencia ?? c.fin_vigencia ?? c.FIN_VIGENCIA ?? '';
                } else {
                  if (c.codigo_campania) c.codigo_campania = c.codigo_campania.toString().trim();
                  if (c.nombre) {
                    let nombreLimpio = c.nombre.toString().trim();
                    if (nombreLimpio.endsWith(' - NINGUNA')) {
                      nombreLimpio = nombreLimpio.replace(' - NINGUNA', '');
                    }
                    c.nombre = nombreLimpio;
                  }
                }
              }
              return c;
            });

            const codigosVistos = new Set<string>();
            const listaUnica = listaOriginal.filter((c: any) => {
              const cod = (c?.codigo_campania || '').toString().trim();
              const key = cod || this.norm(c?.nombre || '');
              if (!key || codigosVistos.has(key)) return false;
              codigosVistos.add(key);
              return true;
            });

            (ps as any).campaniasDisponibles = listaUnica;
            this.listDataCampania = (ps as any).campaniasDisponibles;
            let campanaABuscar = (ps.campana || '').toString().trim();
            if (this.esFlujoInclusion && campanaABuscar.toLowerCase() === 'null') {
              campanaABuscar = '';
              ps.campana = '';
            }
            if (campanaABuscar) {
              const seleccion = listaUnica.find((c: any) => {
                const cod = (c?.codigo_campania || '').toString().trim();
                const nombre = (c?.nombre || '').toString().trim();
                return cod === campanaABuscar || this.norm(nombre) === this.norm(campanaABuscar);
              });
              if (seleccion?.codigo_campania) {
                ps.campana = (seleccion.codigo_campania || '').toString().trim();
                ps.campanaNombre = (seleccion?.nombre || '').toString().trim();

                if (this.esFlujoInclusion) {
                  ps.inicioVigencia = seleccion.inicioVigencia;
                  ps.finVigencia = seleccion.finVigencia;
                }
              }
            }
            if (this.esFlujoInclusion) {
              // Alta con ≥2 campañas: no autoelegir; el usuario debe escoger.
              // Solo autoelige si hay exactamente 1, o en edición (fallback 999/primera).
              const esAltaBeneficiario = !this.data?.[0];
              if (!ps.campana && listaUnica.length > 0) {
                const debeAutoelegir =
                  listaUnica.length === 1 || !esAltaBeneficiario;
                if (debeAutoelegir) {
                  const match999 = listaUnica.find((c: any) => c.codigo_campania === '999');
                  const targetRow = match999 || listaUnica[0];

                  ps.campana = (targetRow?.codigo_campania || '').toString().trim();
                  ps.campanaNombre = (targetRow?.nombre || '').toString().trim();
                  ps.inicioVigencia = targetRow?.inicioVigencia;
                  ps.finVigencia = targetRow?.finVigencia;
                }
              }
            } else {
              if (!ps.campana && listaUnica.length === 1) {
                ps.campana = (listaUnica[0]?.codigo_campania || '').toString().trim();
                ps.campanaNombre = (listaUnica[0]?.nombre || '').toString().trim();
              }
            }
            if (typeof ps.campanaNombre === 'string' && ps.campanaNombre.endsWith(' - NINGUNA')) {
              ps.campanaNombre = ps.campanaNombre.replace(' - NINGUNA', '');
            }

            this.applyCampaniaAutoSelection(ps);

            if (this.esFlujoInclusion) {
              this.actualizarProgramasContratanteLocalStorage();
            }

            this.campaniasConsultaRealizadaPorPrograma[ps.id] = true;
            this.cdRef.detectChanges();
          },
          error: err => {
            (ps as any).campaniasDisponibles = [];
            this.campaniasConsultaRealizadaPorPrograma[ps.id] = true;
            this.SnackBarService.alert('alert-danger', err.message || 'Error consultando campañas');
          }
        });
    });
  }

  selectParentesco() {
    this.listDataCampania = [];
    this.form.campaniaContratante.value = '';
    this.form.fechaNacimiento.value = '';
  }

  private hydrateSeleccionDesdeForm(): void {
    this.lineasSeleccionadas = [];
    const lineasStr = (this.form.lineaNegocios.value || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
    lineasStr.forEach(nom => {
      const cod = this.nombreToCodigoLinea(nom);
      if (cod && !this.lineasSeleccionadas.includes(cod)) {
        this.lineasSeleccionadas.push(cod);
      }
    });

    this.programasSeleccionados = [];

    const tokens = (this.form.programa.value ?? '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];

    tokens.forEach(tok => {
      let p = this.programasDisponibles.find(pp => pp.id === tok);
      if (!p) {
        p = this.programasDisponibles.find(
          pp =>
            pp.nombre.toUpperCase() === tok.toUpperCase() ||
            pp.codigo.toUpperCase() === tok.toUpperCase()
            || this.planGuardadoCoincideConProgramaUi(tok, pp.id)
            || this.planGuardadoCoincideConProgramaUi(tok, pp.codigo)
        );
      }
      if (p && !this.programasSeleccionados.some(sel => sel.id === p.id)) {
        const cfg = prevCfg.find(c =>
          this.norm(c?.id) === this.norm(p.id)
          || this.norm(c?.nombre) === this.norm(p.nombre)
          || this.norm((c as any)?.programa) === this.norm(p.codigo)
        ) ?? {};
        const sel = {
          id: p.id,
          nombre: p.nombre,
          subcuenta: cfg.subcuenta ?? '',
          tarifa: cfg.tarifa ?? '',
          campana: cfg.campana ?? '',
          campanaNombre: cfg.campanaNombre ?? '',
          requiereAnexo: this.parseRequiereAnexoValue(cfg.requiereAnexo ?? (cfg as any)?.esAnexo),
          tarifaAnexo: cfg.tarifaAnexo ?? '',
          subcuentasDisponibles: Array.isArray(cfg.subcuentasDisponibles) ? cfg.subcuentasDisponibles : [],
          tarifasDisponibles: []
        } as ProgramaSeleccionado;
        (sel as any).__programaCodigo = ((cfg as any)?.programa || p.codigo || p.id || '').toString().trim();
        (sel as any).__programaCodigoOriginal = ((cfg as any)?.programa || '').toString().trim();
        const idSubcuentaCfg = Number((cfg as any)?.idSubcuenta ?? (cfg as any)?.__idSubcuenta ?? 0);
        if (idSubcuentaCfg > 0) {
          (sel as any).__idSubcuenta = idSubcuentaCfg;
        }
        const idCotizacionTarifaCfg = Number((cfg as any)?.idCotizacionTarifa ?? (cfg as any)?.__idCotizacionTarifa ?? 0);
        if (idCotizacionTarifaCfg > 0) {
          (sel as any).__idCotizacionTarifa = idCotizacionTarifaCfg;
        }
        const idCotizacionTarifaAnexoCfg = Number((cfg as any)?.idCotizacionTarifaAnexo ?? (cfg as any)?.__idCotizacionTarifaAnexo ?? 0);
        if (idCotizacionTarifaAnexoCfg > 0) {
          (sel as any).__idCotizacionTarifaAnexo = idCotizacionTarifaAnexoCfg;
        }
        const idCotizacionCampaniaCfg = Number((cfg as any)?.idCotizacionCampania ?? (cfg as any)?.__idCotizacionCampania ?? 0);
        if (idCotizacionCampaniaCfg > 0) {
          (sel as any).__idCotizacionCampania = idCotizacionCampaniaCfg;
        }
        if ((cfg as any)?.subcta) {
          (sel as any).__subctaCodeSeleccionada = ((cfg as any).subcta || '').toString().trim();
        }
        if (Array.isArray((cfg as any)?.campaniasDisponibles) && (cfg as any).campaniasDisponibles.length > 0) {
          (sel as any).campaniasDisponibles = JSON.parse(JSON.stringify((cfg as any).campaniasDisponibles));
        } else {
          this.cacheClavesCampaMap.delete(sel.id);
          this.campaniasConsultaRealizadaPorPrograma[sel.id] = false;
        }
        this.programasSeleccionados.push(sel);
        if (!this.lineasSeleccionadas.includes(p.lineaNegocio)) {
          this.lineasSeleccionadas.push(p.lineaNegocio);
        }
      }
    });

    const nombresLineas = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c]);
    this.form.lineaNegocios.value = nombresLineas.join(', ');
    this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
    this.form.lineaNegocios.messages = this.form.lineaNegocios.value ? '' : this.form.lineaNegocios.messages;
    this.form.programa.messages = this.form.programa.value ? '' : this.form.programa.messages;

    const cfgAnexos: any = (this as any)._programasCfgAnexosPrevios;
    if (cfgAnexos) {
      this.requiereAnexo = cfgAnexos.requiereAnexo ?? this.requiereAnexo;
      this.anexoSeleccionado = cfgAnexos.anexoSeleccionado ?? this.anexoSeleccionado;
    }

    this.dispararTarifasParaProgramasSeleccionados();
  }

  private rehidratarProgramasDesdeCfg(): void {
    const prevCfg: any[] = (this as any)._programasConfigPrevios ?? [];
    if (!prevCfg.length) {
      this.hydrateSeleccionDesdeForm();
      this.cdRef.detectChanges();
      return;
    }
    this.programasSeleccionados = [];

    prevCfg.forEach(cfg => {
      let base = this.programasDisponibles.find(pp => this.norm(pp.id) === this.norm(cfg.id));
      if (!base) { base = this.programasDisponibles.find(pp => this.norm(pp.nombre) === this.norm(cfg.nombre)); }
      if (!base) { base = this.programasDisponibles.find(pp => this.norm(pp.codigo) === this.norm(cfg.id)); }
      if (!base) { base = this.programasDisponibles.find(pp => this.norm(pp.codigo) === this.norm((cfg as any)?.programa)); }
      if (!base) {
        base = this.programasDisponibles.find(pp =>
          this.planGuardadoCoincideConProgramaUi((cfg as any)?.programa || cfg?.id || '', pp.id)
          || this.planGuardadoCoincideConProgramaUi((cfg as any)?.programa || cfg?.id || '', pp.codigo)
          || this.norm(pp.nombre) === this.norm((cfg as any)?.nombrePrograma)
        );
      }

      if (base && !this.programasSeleccionados.some(sel => this.norm(sel.id) === this.norm(base.id) || this.norm(sel.nombre) === this.norm(base.nombre))) {
        const sel: ProgramaSeleccionado = {
          id: base.id,
          nombre: base.nombre,
          subcuenta: cfg.subcuenta ?? '',
          tarifa: cfg.tarifa ?? '',
          campana: cfg.campana ?? '',
          campanaNombre: cfg.campanaNombre ?? '',
          requiereAnexo: this.parseRequiereAnexoValue(cfg.requiereAnexo ?? (cfg as any)?.esAnexo),
          tarifaAnexo: cfg.tarifaAnexo ?? '',
          subcuentasDisponibles: Array.isArray(cfg.subcuentasDisponibles) ? cfg.subcuentasDisponibles : [],
          tarifasDisponibles: []
        };

        const idBenProgramaCfg = Number((cfg as any)?.idBenPrograma ?? (cfg as any)?.__idBenPrograma ?? 0);
        if (idBenProgramaCfg > 0) { (sel as any).__idBenPrograma = idBenProgramaCfg; }
        const idSubcuentaCfg = Number((cfg as any)?.idSubcuenta ?? (cfg as any)?.__idSubcuenta ?? 0);
        if (idSubcuentaCfg > 0) { (sel as any).__idSubcuenta = idSubcuentaCfg; }
        const idCotizacionTarifaCfg = Number((cfg as any)?.idCotizacionTarifa ?? (cfg as any)?.__idCotizacionTarifa ?? 0);
        if (idCotizacionTarifaCfg > 0) { (sel as any).__idCotizacionTarifa = idCotizacionTarifaCfg; }
        const idCotizacionTarifaAnexoCfg = Number((cfg as any)?.idCotizacionTarifaAnexo ?? (cfg as any)?.__idCotizacionTarifaAnexo ?? 0);
        if (idCotizacionTarifaAnexoCfg > 0) { (sel as any).__idCotizacionTarifaAnexo = idCotizacionTarifaAnexoCfg; }
        const idCotizacionCampaniaCfg = Number((cfg as any)?.idCotizacionCampania ?? (cfg as any)?.__idCotizacionCampania ?? 0);
        if (idCotizacionCampaniaCfg > 0) { (sel as any).__idCotizacionCampania = idCotizacionCampaniaCfg; }

        (sel as any).__programaCodigo = ((cfg as any)?.programa || base.codigo || base.id || '').toString().trim();
        (sel as any).__programaCodigoOriginal = ((cfg as any)?.programa || '').toString().trim();

        if ((cfg as any)?.subcta) {
          (sel as any).__subctaCodeSeleccionada = ((cfg as any).subcta || '').toString().trim();
        }

        if (Array.isArray((cfg as any)?.campaniasDisponibles) && (cfg as any).campaniasDisponibles.length > 0) {
          (sel as any).campaniasDisponibles = JSON.parse(JSON.stringify((cfg as any).campaniasDisponibles));
        } else {
          // Rehidratación sin lista de campañas: invalidar cache para permitir consultarCampanias.
          this.cacheClavesCampaMap.delete(sel.id);
          this.campaniasConsultaRealizadaPorPrograma[sel.id] = false;
        }

        this.programasSeleccionados.push(sel);
      }
    });

    this.lineasSeleccionadas = Array.from(
      new Set(this.programasSeleccionados.map((p: any) => this.resolveProgramaBase(p)?.lineaNegocio).filter(Boolean))
    ) as any;

    this.form.lineaNegocios.value = this.lineasSeleccionadas.map(c => this.LINEA_MAP[c as 'MI' | 'SO' | 'CEM']).join(', ');
    this.form.programa.value = this.programasSeleccionados.map(p => p.id).join(', ');
    this.cdRef.detectChanges();
  }
  private async ensureProgramasYRehidratar(): Promise<void> {
    if (!this.lineasSeleccionadas?.length) {
      const tokens = (this.form.lineaNegocios.value ?? '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      tokens.forEach(nom => {
        const cod = this.nombreToCodigoLinea(nom);
        if (cod && !this.lineasSeleccionadas.includes(cod)) this.lineasSeleccionadas.push(cod);
      });
    }

    if (!this.lineasNegocioDisponibles || this.lineasNegocioDisponibles.length === 0) {
      setTimeout(() => this.ensureProgramasYRehidratar(), 120);
      return;
    }

    if (!this.lineasSeleccionadas?.length) {
      const tokens = (this.form.lineaNegocios.value ?? '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      tokens.forEach(nom => {
        const cod = this.nombreToCodigoLinea(nom);
        if (cod && !this.lineasSeleccionadas.includes(cod)) this.lineasSeleccionadas.push(cod);
      });
    }

    const pendientes: ('MI' | 'SO' | 'CEM')[] = [];
    this.lineasSeleccionadas.forEach(codigoLinea => {
      const yaHay = this.programasDisponibles.some(p => p.lineaNegocio === codigoLinea);
      if (!yaHay) pendientes.push(codigoLinea);
    });

    const cargas: Promise<void>[] = pendientes.map(codigoLinea => {
      const ln = this.lineasNegocioDisponibles.find(l => l.codigo === codigoLinea);
      if (!ln) return Promise.resolve();

      return new Promise<void>((resolve) => {
        this.spinner.show();
        const tipoPlanActual = (localStorage.getItem('tipoPlan') || 'C').toString().trim().toUpperCase();
        this.consultarLineasService.consultarProgramasCompletosPorParametroPorLinea(ln.lineaOriginal.cod, false, tipoPlanActual, Number(this.edad || 0))
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe({
            next: (response) => {
              const nuevos: any[] = [];
              response.grupos.forEach((grupo: any) => {
                grupo.programas.forEach((pg: any) => {
                  const programa = {
                    id: pg.codigo.trim(),
                    codigo: pg.codigo.trim(),
                    nombre: pg.programa,
                    lineaNegocio: codigoLinea,
                    color: this.obtenerColorPorLinea(codigoLinea),
                    imagen: pg.carnet?.file,
                    carnet: pg.carnet?.file,
                    grupoPrograma: grupo.codigo,
                    requiereAnexos: true,
                  };
                  nuevos.push(programa);
                });
              });
              const existentes = new Set(this.programasDisponibles.map(p => p.id));
              const soloNuevos = nuevos.filter(p => !existentes.has(p.id));
              this.programasDisponibles = [...this.programasDisponibles, ...soloNuevos];
              resolve();
            },
            error: _ => resolve()
          });
      });
    });

    if (cargas.length) {
      await Promise.all(cargas);
    }

    this.rehidratarProgramasDesdeCfg();

    const cem = (this as any)._cemBackup || null;
    if (cem) {
      this.form.tipoVia.value = cem.tipoVia;
      this.form.numero.value = cem.numero;
      this.form.placaUno.value = cem.placaUno;
      this.form.placaDos.value = cem.placaDos;
      this.form.ciudad.value = cem.ciudad;
    }

    this.cargarSubcuentasSiFaltan();
    this.dispararTarifasParaProgramasSeleccionados();

    this.programasSeleccionados.forEach(ps => {
      // Colectivo/GA: anexos se cargan una sola vez al terminar tarifas (buscarTarifa).
      if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
        return;
      }
      const veniaConAnexo = ps.requiereAnexo === 'si' || ps.requiereAnexo === 'no' || ((ps.tarifaAnexo || '').trim() !== '');
      const sinListaAnexos = (ps.anexosDisponibles?.length ?? 0) === 0;
      if (veniaConAnexo && sinListaAnexos) {
        this.consultarAnexosParaPrograma(ps);
      }
    });

    this.cdRef.detectChanges();
    if (this._pendienteSnapshotTrasRehidratar) {
      // esperar tarifas/anexos auto antes del baseline
      this.programarFinalizarBaselineEdicion(700);
    }
  }

  /** Fija snapshot de edición */
  private finalizarBaselineEdicion(): void {
    this._pendienteSnapshotTrasRehidratar = false;
    this.capturarSnapshotInicial();
    if (this._baselineEditTimer) {
      clearTimeout(this._baselineEditTimer);
      this._baselineEditTimer = null;
    }
  }

  private obtenerEsUsuarioDesdeLocal(): boolean | null {
    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (!raw) return null;
      const parsed = JSON.parse(raw || '{}');
      return typeof parsed?.esUsuario === 'boolean' ? parsed.esUsuario : null;
    } catch {
      return null;
    }
  }

  private cargarContratanteDeLocalStorageSiAplica(): void {
    if (this.guardar === true || this._hidratadoDesdeContratante) return;
    if (this.data?.[0] != null) return;
    try {
      const raw = localStorage.getItem('datosRQ002_Contratante');
      if (!raw) return;
      const datos = JSON.parse(raw || '{}') as {
        esUsuario?: boolean;
        tipoDocumento?: string;
        numeroDocumento?: string;
        primerNombre?: string;
        segundoNombre?: string;
        primerApellido?: string;
        segundoApellido?: string;
        genero?: 'F' | 'M' | string;
        fechaNacimiento?: string | Date;
        edad?: number;
      };
      if (datos?.esUsuario !== true) return;
      let fechaNacDate: Date | null = null;
      if (datos.fechaNacimiento) {
        fechaNacDate = this.parseApiDateToDate(
          typeof datos.fechaNacimiento === 'string' ? datos.fechaNacimiento : (datos.fechaNacimiento as Date).toString()
        );
      }
      const fechaNacDDMMYYYY = this.formatDateToDDMMYYYY(fechaNacDate);
      const generoMap = (g: string | undefined) => {
        const up = (g || '').toUpperCase().trim();
        if (up === 'F') return '1';
        if (up === 'M') return '2';
        if (up === '1' || up === '2') return up;
        return '';
      };
      this.form.contratanteTipoDocumento.value = (datos.tipoDocumento || '').trim();
      this.form.contratanteDocumento.value = (datos.numeroDocumento || '').trim();
      this.form.nombre.value = (datos.primerNombre || '').trim();
      this.form.nombreSegundo.value = (datos.segundoNombre || '').trim();
      this.form.apellido.value = (datos.primerApellido || '').trim();
      this.form.apellidoSegundo.value = (datos.segundoApellido || '').trim();
      this.form.genero.value = generoMap(datos.genero as any);
      this.form.fechaNacimiento.value = fechaNacDDMMYYYY;
      if (typeof datos.edad === 'number' && Number.isFinite(datos.edad)) {
        this.edad = datos.edad;
      } else if (fechaNacDate) {
        this.calculeAge('change', { value: fechaNacDate } as any);
      }
      this.form.contratanteTipoDocumento.messages = '';
      this.form.contratanteDocumento.messages = '';
      this.form.nombre.messages = '';
      this.form.apellido.messages = '';
      this.form.genero.messages = '';
      this.form.fechaNacimiento.messages = '';
      this.validateDocTypeWithAge();
      this.cdRef.detectChanges();
      this._hidratadoDesdeContratante = true;
    } catch (err) {
    }
  }

  private _buildSnapshotActual(): any {
    return {
      parentesco: this.form.parentesco?.value ?? '',
      tipoDoc: this.form.contratanteTipoDocumento?.value ?? '',
      numDoc: this.form.contratanteDocumento?.value ?? '',
      nombre1: this.form.nombre?.value ?? '',
      nombre2: this.form.nombreSegundo?.value ?? '',
      apellido1: this.form.apellido?.value ?? '',
      apellido2: this.form.apellidoSegundo?.value ?? '',
      genero: this.form.genero?.value ?? '',
      fecha: this.form.fechaNacimiento?.value ?? '',
      tipoVia: this.form.tipoVia?.value ?? '',
      numero: this.form.numero?.value ?? '',
      placaUno: this.form.placaUno?.value ?? '',
      placaDos: this.form.placaDos?.value ?? '',
      ciudad: this.form.ciudad?.value ?? '',
      lineaNegocios: this.form.lineaNegocios?.value ?? '',
      programa: this.form.programa?.value ?? '',
      subcuenta: this.form.subcuenta?.value ?? '',
      tarifa: this.form.tarifa?.value ?? '',
      tarifaAnexo: this.form.tarifaAnexo?.value ?? '',
      campania: this.form.campania?.value ?? '',
      usarProgramasContratante: this.usarProgramasContratante === true,
      lineasSel: [...(this.lineasSeleccionadas ?? [])],
      programasSel: (this.programasSeleccionados ?? []).map(p => ({
        id: p.id,
        subcuenta: (p.subcuenta || '').toString().trim(),
        tarifa: (p.tarifa || '').toString().trim(),
        campana: (p.campana || '').toString().trim(),
        requiereAnexo: p.requiereAnexo ?? null,
        tarifaAnexo: (p.tarifaAnexo || '').toString().trim()
        // anexosCount omitido: cambia al cargar anexos async y genera falsos positivos
      })),
      estadoEPS: (this.estadoEPS || []).map((t: any) => ({
        tipo: t?.tipo ?? '',
        mensaje: (t?.mensaje || '').toString().trim()
      })),
      historialCliente: (this.historialCliente || []).map((t: any) => ({
        tipo: t?.tipo ?? '',
        mensaje: (t?.mensaje || '').toString().trim()
      })),
      requiereAnexo: null,
      anexoSeleccionado: null,
    };
  }

  private _igualSnapshot(a: any, b: any): boolean {
    try {
      const ordena = (x: any) => {
        const y = JSON.parse(JSON.stringify(x));
        y.lineasSel = (y.lineasSel || []).slice().sort();
        y.programasSel = (y.programasSel || []).slice()
          .sort((p: any, q: any) => ((p?.id || '').localeCompare(q?.id || '')));
        y.estadoEPS = (y.estadoEPS || []).slice()
          .sort((p: any, q: any) => ((p?.mensaje || '').localeCompare(q?.mensaje || '')));
        y.historialCliente = (y.historialCliente || []).slice()
          .sort((p: any, q: any) => ((p?.mensaje || '').localeCompare(q?.mensaje || '')));
        return y;
      };
      return JSON.stringify(ordena(a)) === JSON.stringify(ordena(b));
    } catch {
      return false;
    }
  }

  /** Pop-up salida solo si hubo cambios vs baseline */
  private tieneCambiosSinGuardar(): boolean {
    const esEdicion = this.guardar === false || !!this.data?.[3]?.isEditMode;

    // edición cargando: campos llenos no cuentan como cambio
    if (esEdicion && (this._pendienteSnapshotTrasRehidratar || !this._snapshotInicial)) {
      return false;
    }

    const actual = this._buildSnapshotActual();
    if (!this._snapshotInicial) {
      return this._snapshotTieneInteraccionUsuario(actual);
    }
    return !this._igualSnapshot(actual, this._snapshotInicial);
  }

  /** Alta sin baseline: algo digitado/seleccionado */
  private _snapshotTieneInteraccionUsuario(v: any): boolean {
    const campos = [
      v?.parentesco, v?.tipoDoc, v?.numDoc, v?.nombre1, v?.nombre2,
      v?.apellido1, v?.apellido2, v?.genero, v?.fecha,
      v?.tipoVia, v?.numero, v?.placaUno, v?.placaDos, v?.ciudad,
      v?.lineaNegocios, v?.programa, v?.subcuenta, v?.tarifa, v?.tarifaAnexo, v?.campania
    ];
    if (campos.some(val => (val || '').toString().trim() !== '')) {
      return true;
    }
    if (Array.isArray(v?.lineasSel) && v.lineasSel.length > 0) {
      return true;
    }
    if (Array.isArray(v?.programasSel) && v.programasSel.length > 0) {
      return true;
    }
    if (Array.isArray(v?.estadoEPS) && v.estadoEPS.length > 0) {
      return true;
    }
    if (Array.isArray(v?.historialCliente) && v.historialCliente.length > 0) {
      return true;
    }
    return false;
  }

  private capturarSnapshotInicial(): void {
    this._snapshotInicial = this._buildSnapshotActual();
  }

  cerrar(): void {
    if (this.tieneCambiosSinGuardar()) {
      const dialogRefConfirmacion = this.dialog.open(PopUpConfirmacionComponent, {
        data: {
          titulo: 'Confirmación de Salida',
          texto: '¿Deseas salir sin guardar la información actual? Los datos ingresados podrían perderse.',
          textoBotonSi: 'Guardar y salir',
          textoBotonNo: 'Salir sin guardar'
        } as PopUpConfirmacionData,
        width: '500px',
        maxWidth: '90vw',
        disableClose: true,
        panelClass: 'pop-up-confirmacion'
      });

      dialogRefConfirmacion.afterClosed().subscribe((resultado: boolean | null) => {
        if (resultado === true) {
          if (this.guardar === false) {
            this.onActualizarBeneficiario();
          } else {
            this.agregar();
          }
        } else if (resultado === false) {
          this.cacheClavesCampaMap.clear();
          localStorage.removeItem('datosRQ003_Beneficiarios');
          this.dialogRef.close(null);
        }
      });
    } else {
      this.dialogRef.close(null);
    }
  }

  private parseSubcuentaOptionValue(value: string): { cuenta: string; subcta: string; deno: string; } | null {
    const raw = (value || '').toString();
    if (!raw.includes('|||')) return null;
    const [cuenta = '', subcta = '', deno = ''] = raw.split('|||');
    return { cuenta: cuenta.trim(), subcta: subcta.trim(), deno: deno.trim() };
  }

  private getSubcuentaDenoValue(value: string): string {
    const parsed = this.parseSubcuentaOptionValue((value || '').toString());
    return parsed?.deno || (value || '').toString().trim();
  }

  public onTarifaBeneficiarioChange(programaSel: any): void {
    this.bucarCampa();
  }

  private ejecutarLimpiezaProgramasRemovidosInclusion$(): import('rxjs').Observable<boolean> {
    if (!(localStorage.getItem('tipoSolicitud') === '2')) {
      return of(true);
    }

    try {
      const prevCfg: any[] = Array.isArray((this as any)._programasConfigPrevios) ? (this as any)._programasConfigPrevios : [];
      const actualesRaw = localStorage.getItem('programas_contratante');
      const actuales: any[] = actualesRaw ? JSON.parse(actualesRaw) : [];

      if (!prevCfg.length || !actuales.length) return of(true);

      const idsActuales = new Set(actuales.map(p => (p.id || p.programa || '').toString().trim().toUpperCase()));
      const removidos = prevCfg.filter(p => {
        const idPrevio = (p.id || p.programa || '').toString().trim().toUpperCase();
        return !idsActuales.has(idPrevio);
      });

      if (removidos.length === 0) {
        return of(true);
      }


      let cadena$ = of(true);
      removidos.forEach(plan => {
        const idBenProg = Number(plan?.idBenPrograma || plan?.__idBenPrograma || 0);
        if (idBenProg > 0) {
          cadena$ = cadena$.pipe(
            concatMap(() => this.networking.eliminarBeneficiarioPrograma(idBenProg).pipe(
              map(() => true),
              catchError(err => {
                return of(true);
              })
            ))
          );
        }
      });

      return cadena$;
    } catch (e) {
      return of(true);
    }
  }

  public isSubcuentaDisabled(programaSel: ProgramaSeleccionado): boolean {
    if (this.esFlujoInclusion) {
      return true;
    }

    return programaSel?.subcuentasDisponibles?.length === 1 || !!(programaSel as any)?.subcuentaDisabled;
  }

  private obtenerCodigoTarifa(tari: string): string {
    if (!tari) return '';

    // Venta nueva colectivo
    if (this.esFlujoColectivoOGA && !this.esFlujoInclusion) {
      let limpio = tari.toString().trim();

      const matchParens = limpio.match(/\(([^)]+)\)$/);
      if (matchParens && matchParens[1]) {
        limpio = matchParens[1].trim();
      }
      else if (limpio.includes(' - ')) {
        limpio = limpio.split(' - ')[0].trim();
      }

      const codigoLimpioFinal = limpio.split(' ')[0].trim();
      return codigoLimpioFinal;
    }

    // Inclusiones
    else if (this.esFlujoInclusion) {
      let limpio = tari.includes(' - ') ? tari.split(' - ')[0].trim() : tari;
      if (limpio.match(/\(([^)]+)\)$/)) {
        limpio = limpio.match(/\(([^)]+)\)$/)?.[1]?.trim() || limpio;
      }
      return limpio.trim();
    }

    // Venta nueva individual (default)
    return tari;
  }

  private mapNumberToLinea(linea: any, planCodi: string): 'MI' | 'SO' | 'CEM' {
    const l = String(linea ?? '').trim().toUpperCase();
    if (l === '1' || l === 'MI' || l === 'SMP') return 'MI';
    if (l === '2' || l === 'SO' || l === 'SAO') return 'SO';
    if (l === '3' || l === 'CEM') return 'CEM';
    return this.deducirLineaDesdePlan(planCodi);
  }

  private deducirLineaDesdePlan(planCodi: string): 'MI' | 'SO' | 'CEM' {
    const c = (planCodi || '').toString().trim().toUpperCase();
    if (c.startsWith('DE') || c.startsWith('SO') || c.startsWith('SAO') ||  c === 'SAOB' || c === 'CLEAR') {
      return 'SO';
    }
    if (c.startsWith('CEM') || c === 'FULL' || c === 'FULC') {
      return 'CEM';
    }
    return 'MI';
  }

  private resolverDescripcionTarifaColectivo(row: any, tCodigo: string): string {
    if (!row) return '';
    const tDenoRaw = (row?.tari_deno ?? row?.TARI_DENO ?? '').toString().trim();
    const planDeno = (row?.plan_deno ?? row?.PLAN_DENO ?? '').toString().trim();
    const fantasia = (row?.nombre_fantasia ?? row?.NOMBRE_FANTASIA ?? '').toString().trim();

    let cleanDesc = tDenoRaw.replace(tCodigo, '').trim();

    if (!cleanDesc || cleanDesc.length <= 3 || cleanDesc.toUpperCase() === fantasia.toUpperCase()) {
      if (planDeno) {
        cleanDesc = planDeno;
      } else if (tDenoRaw) {
        cleanDesc = tDenoRaw;
      }
    }
    return cleanDesc || 'TARIFA COLECTIVA';
  }

}
